angular.module('Fullarm', [
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'pascalprecht.translate',
  'ngJsTree',
  'Fullarm.theme',
  'com.2fdevs.videogular',
  'com.2fdevs.videogular.plugins.buffering',
  'com.2fdevs.videogular.plugins.controls',
  'com.2fdevs.videogular.plugins.hls',
  'timer',
  'ngFileUpload',
  'naif.base64',
  'angularAudioRecorder',
  'ngCookies',
  'de.devjs.angular.spotlight'
])
.factory('ConfigsRequest', function($q, $http, constant){
  
  var setGlobals = function(configs){

    window.plataform = configs.plataform;
    window.userOption = configs.userOption;
    window.configMqtt = configs.configMqtt;
    window.permissoes = configs.permissoes;
    window.monitoramento_config = configs.monitoramento_config;
    window.configAwsSdk = configs.configAwsSdk;
    window.configMqttFtalk = configs.configMqttFtalk
    window.fc_adm_url = configs.fc_adm_url;
    window.tempo_lembrete = configs.tempo_lembrete;
    window.som_lembrete = configs.som_lembrete;
    window.is_condhouse = configs.is_condhouse;

  }
  
  return {
    loadConfigs:function() {
      
      var deferred = $q.defer();
      
      $http({
          url : constant.BASE_URL + '/api/v1/fullcenter/configs',
          method : "GET",
      }).then(function(resp){
          var configs = resp.data;
          setGlobals(configs);
          deferred.resolve(configs)
      }, function(e){
        var error = {code: 1, description:'Unknown'}
        deferred.reject(error);
      });

      return deferred.promise;
    }
  }
})
.service('Auth', function($cookies){

  return {
      isAuth: function(){
        var fullcenterCookie = $cookies.get('FullarmAdmWeb');
        return fullcenterCookie !== undefined;
      }
  }

})
.config(function($urlRouterProvider, $stateProvider, $httpProvider, constantTraducao, $translateProvider, AngularSpotlightProvider, constant){

    $httpProvider.defaults.withCredentials = true;
    $translateProvider.translations('pt-BR', constantTraducao.pt);
    $translateProvider.translations('es', constantTraducao.es);
    $translateProvider.translations('en', constantTraducao.en);
    $translateProvider.preferredLanguage('pt-BR');
    $translateProvider.useSanitizeValueStrategy('escape');

    function configSpotlight(AngularSpotlightProvider){

        spotlightConfig();
        function spotlightConfig(){

            var toggleKey = 70; // Letter F
            //if(permissoes.gerar_evento_manual){
                AngularSpotlightProvider.setSearchInputInfoSearching("ocorrencia_search_buscar_buscando");
                AngularSpotlightProvider.setSearchInputInfoNoResults("ocorrencia_search_nenhum_resultado_encontrado");
                AngularSpotlightProvider.setSpotlightPlaceholder("ocorrencia_search_buscar_sistema");
                AngularSpotlightProvider.setSpotlightToggleCtrlKey(toggleKey); // Ctrl + toggleKey
            //}
        }

        searchOrchestrationGithubWiki();

        function searchOrchestrationGithubWiki() {
            AngularSpotlightProvider.search = function ($http, $q) {
                return function (term) {
                    var url = constant.BASE_URL;
                    var sistemas = $http.get(url+'/api/v1/sistema/busca/sistema_monitoramento/'+term);

                    return $q.all([sistemas])
                        .then(function (responses) {
                            var searchResults = [];

                            processWikiSearch(responses[0].data, searchResults);
                            return searchResults;
                        });

                    function processWikiSearch(resp, searchResults) {
                        if (resp) {
                            resp.forEach(function (result) {
                                if(result != null){
                                    result.wordcount = result.length;
                                    var resultItem = extractsistemasData(result);
                                    var key = resultItem.descricao[0].toUpperCase();
                                    var category = searchResults.filter(function (result) {
                                        return result.name === key;
                                    })[0];

                                    if (category) {
                                        category.items.push(resultItem);
                                    } else {
                                        category = {name: key, items: []};
                                        category.items.push(resultItem);
                                        searchResults.push(category);
                                    }
                                }
                            });
                        }

                        function extractsistemasData(result) {
                            return {
                                id: result.id,
                                painel_virtual: result.painel_virtual,
                                name: result.referencia+ '-' + result.descricao,
                                em_manutencao: result.em_manutencao,
                                descricao: jQuery('<div>' + result.descricao + '</div>').text(),
                                wordcount: result.wordcount,
                                referencia: result.referencia,
                                type: 'sistemas',
                                href: '#/abc'
                            }
                        }
                    }
                }
            };
            addCustomIcons();
            addCustomTemplates();
        }

        function addCustomTemplates() {
            AngularSpotlightProvider.addTemplates({
                'sistemas': 'app/theme/templates/busca_sistemas.html'
            });
        }

        function addCustomIcons() {
            AngularSpotlightProvider.addIcons({
                'sistemas': ''


            });
        }
    }
    configSpotlight(AngularSpotlightProvider);
    setTimeout(function () {
        $(".ng-spotlight-input").attr('id', 'busca_por_sistema');
    }, 1000);

    $urlRouterProvider.otherwise('/entrypoint');
  
    $stateProvider.state('ocorrencias', {
      url: '/ocorrencias',
      templateUrl: 'app/pages/Monitoramento/monitoramento.html',
      controller:'MonitoramentoController',
      resolve: {
        'configs': ['ConfigsRequest','$state',function(ConfigsRequest, $state){      
          return ConfigsRequest.loadConfigs()
          .then(function(configs){
              return configs;
          }).catch(function(e){
              $state.go('login');
              return false;
          })
        }]
      }
    });

})
.run(function ($rootScope, $state, Auth) {
  
  $rootScope.$on('$stateChangeStart', function(event, newState) {
      
      var notAllowAnonymous = newState.allowAnonymous == false;
      var notAuthenticated  = Auth.isAuth() == false;
      var haveToRedirectToLogin = notAllowAnonymous && notAuthenticated
      
      if ( haveToRedirectToLogin ) {
          $state.go('login');
          event.preventDefault();
      }
  });
});
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'Fullarm.theme.components',
      'Fullarm.theme.inputs'
  ]);

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.inputs', []);

})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';



  angular.module('Fullarm.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#333',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('Fullarm.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };



    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('Fullarm.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(0)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 0);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('Fullarm.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    //var blurClass = is_condhouse ? 'blur-theme fundo_ch' : baConfig.theme.blur ? 'blur-theme' : 'fundo_fc';

    var blurClass = baConfig.theme.blur ? 'blur-theme' : 'fundo_fc';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
angular.module('Fullarm').factory('MapaFactory', function (RequestFactory) {
        return{
            getAdressByLatLong:function(lat,long, s, e) {
                var URL  = '/api/v1/endereco/latitude/'+lat+'/longitude/' + long ;
                var METODO = "GET";
                RequestFactory.createRequest(URL, METODO, s, e);
            },

        };
});
angular.module('Fullarm').service('MapaService', function ($timeout, $filter, MapaFactory) {
    var _scope = {};
    var $this;
    var map;
    var markersGroup;
    var mapId;
    var button = {};
    var configRotas =
        {
            "delay": 800,
            "dashArray": [1, 87],
            "weight": 8,
            "color": "#0000FF",
            "pulseColor": "#FFFFFF",
            "paused": false,
            "reverse": false
        };
    return{

        setScope: function(scope){
            _scope = scope;
            $this = this;
            _scope.buttonMapFpatrolExists = false;
        },

        setData: function(_data){
            _scope.data = _data;
        },

        setMapId: function(_id){
            mapId = _id;
        },

        setObjSistema: function(_sistema){
            _scope.objSistema = _sistema;
        },

        setMapPositions: function () {
            $this.initMap();
            if(_scope.data.length > 0){
                $timeout(function () {
                    $this.setMarkers(_scope.data, false);
                    var marker = $this.createMarkerSystem();
                    $(marker._icon).append($this.createMarkerLabelSystem(_scope.objSistema));
                }, 100);
                $this.stopSpinMap();
            }else{
                $this.stopSpinMap();
            }
        },

        initMap: function () {
            $this.clearLears();
            $this.startSpinMap();
            if (map == null) {
                map = L.map(document.getElementById(mapId));
            }
            L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">Fulltrack Mapa</a>'
            }).addTo(map);

            markersGroup = L.layerGroup().addTo(map);

            map.setView([-22.215403, -49.654070], 12);
        },

        setMarkers: function (localizacoes, deveCriarRotas) {
            $this.clearLears();
            var rotas = [];
            angular.forEach(localizacoes, function (localizacao) {
                if (localizacao != null) {
                    var cor = $this.getStateColor(localizacao);
                    var marker = $this.createMaker(localizacao, cor);
                    $(marker._icon).append($this.createMarkerLabel(localizacao, cor, deveCriarRotas, localizacoes.length));
                    map.setView([localizacao.latitude, localizacao.longitude], 12);
                    rotas.push([Number(localizacao.latitude), Number(localizacao.longitude)]);
                }
            });

            if (deveCriarRotas) {
                $this.criarRotas(rotas);
            }
        },

        clearLears: function () {
            if(markersGroup != null){
                markersGroup.clearLayers();
            }
        },

        startSpinMap: function(){
            _scope.mapaIsLoader = true;
        },

        stopSpinMap: function () {
            _scope.mapaIsLoader = false;
        },

        removeMap:function (_mapId) {
            var mapaHtml = document.getElementById(_mapId);
            if(!angular.isUndefined(map) && map != null){
                map.remove();
                if(!angular.isUndefined(mapaHtml)){
                    mapaHtml.innerHTML = "";
                }
                map = null;
            }
        },

        createMaker: function (localizacao, cor) {
            return L.marker([localizacao.latitude, localizacao.longitude], {
                icon: L.AwesomeMarkers.icon({
                    icon: localizacao.status_ronda == 0 ? 'car' : 'ban',
                    markerColor: cor,
                    prefix: 'fa'
                })
            }).addTo(markersGroup).bindPopup($this.createPopupByCar(localizacao, cor)).on('popupopen', function (popup) {
                $("."+button.class).on("click", e => {
                    e.preventDefault();
                    button.action(localizacao, e);
                });
                $this.getAddressByLatLong(popup.popup._latlng.lat, popup.popup._latlng.lng, popup.popup._container);
            });
        },

        createMarkerSystem: function () {
            if(_scope.objSistema.endereco != []){
                return L.marker([_scope.objSistema.endereco.latitude, _scope.objSistema.endereco.longitude], {
                    icon: L.AwesomeMarkers.icon({
                        icon: 'home',
                        markerColor: 'black',
                        prefix: 'fa'
                    })
                }).addTo(markersGroup).bindPopup($this.createPopupBySystem()).on('popupopen', function (popup) {

                });
            }
        },

        getStateColor: function (veiculo) {
            var cor = "";
            switch (veiculo.estado_veiculo) {
                case 1:
                    cor = "red";
                    break;
                case 2:
                    cor = "green";
                    break;
                case 3:
                    cor = "blue";
                    break;
            }
            return cor;
        },

        createMarkerLabel: function (veiculo, cor, deveCriarRotas, qtnPosicoes) {
            var label = "";

            if (qtnPosicoes == 1 || !deveCriarRotas) {
                label = '<div class="marker_div_proximos"><span class="marker_div_proximos_' + cor + '"> ' + veiculo.descricao + '</span></div>';
            }
            return label;
        },

        createMarkerLabelSystem: function (sistema) {
            var label = "";
            label = '<div class="marker_div_proximos"><span class="marker_div_proximos_black">' + sistema.descricao + '</span></div>';

            return label;
        },

        getAddressByLatLong: function(lat,long, popup){
            MapaFactory.getAdressByLatLong(lat, long, function (data) {
                var adress = data.data;
                if(adress != ""){
                    $(popup).find('.pop_up_datails').append(
                        '<div class="info-marker">' +
                            '<span>' +
                                '<i class="fa fa-map-marker"></i> '+$filter('translate')('ocorrencia_label_endereco')+': ' +
                            '</span>' +
                            '<strong>'+adress+'</strong>' +
                        '</div>');
                }

            },function (error) {});
        },

        setButtonProps: function(_button){
            button = _button;
        },

        setButtonMapExists: function(exists){
            _scope.buttonMapFpatrolExists = exists;
        },

        resizeMapa: function(){
            setTimeout(function() {
                map.invalidateSize();
            }, 10);
        },

        createPopupByCar: function (veiculo, cor) {
            var mapaHtml = "";
            var butttonHtml = "";
            var display = button.exibir && veiculo.status_ronda == 0 ? '' : 'none';
            if(!angular.isUndefined(button.id)){
                button.id = button.id+""+veiculo.login_id;
                butttonHtml = "<button style='display: "+display+"' class='btn btn-default "+button.class+"' id='"+button.id+"'>"+button.label+"</button>"
            }

            veiculo.contato_motorista = veiculo.contato_motorista == 0 ? $filter("translate")("ocorrencia_label_contato_nao_cadastrado") : veiculo.contato_motorista;

            mapaHtml += '<div class="row">\n' +
                '    <div class="col-md-10 col-sm-10 col-xs-10 descricao-rastreado">\n' +
                '        <span>' + veiculo.descricao + '</span>\n' +
                '        <br>\n' +
                '        <span>' + $filter("translate")("ocorrencias_label_identificador")+ ': ' + veiculo.placa + '</span>\n' +
                '    </div>\n' +
                '    <div class="col-md-12 col-sm-12 col-xs-12">\n' +
                '        <hr style="margin-top: 5px; margin-bottom: 5px;">\n' +
                '    </div>\n' +
                '    <div class="pop_up_datails">';
            if(veiculo.tipo_veiculo != 7){
                mapaHtml +='<div class="info-marker"><span><i class="fa fa-user"></i>' + $filter("translate")("ocorrencia_label_nome_motorista") + ': <strong>' + veiculo.nome_motorista + '</strong></span></div>';
            }else{
                mapaHtml +='<div class="info-marker"><span><i class="fa fa-user"></i>' + $filter("translate")("ocorrencia_label_usuario") + ': <strong>' + veiculo.nome_motorista + '</strong></span></div>';
            }
            mapaHtml +='<div class="info-marker"><span><i class="fa fa-phone"></i>' + $filter("translate")("ocorrencia_label_contato_motorista") + ': <strong>' + veiculo.contato_motorista + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-calendar"></i>' + $filter("translate")("ocorrencia_label_data_localizacao") + ': <strong>' + veiculo.data_gps + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-calendar"></i>' + $filter("translate")("ocorrencia_label_data_comunicacao") + ': <strong>' + veiculo.data_enviado + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' +  $filter("translate")("ocorrencia_label_latitude") + ': <strong>' + veiculo.latitude + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' +  $filter("translate")("ocorrencia_label_longitude") + ': <strong>' + veiculo.longitude + '</strong></span></div>\n';
            if(veiculo.tipo_veiculo != 7){
                mapaHtml +=     '        <div class="info-marker"><span><i class="fa fa-tachometer"></i>' +  $filter("translate")("ocorrencia_label_velocidade") + ': <strong>' + veiculo.velocidade + ' km/h</strong></span></div>\n' +
                    '        <div class="info-marker"><span><i class="fa fa-circle-o-notch"></i>' +  $filter("translate")("ocorrencia_label_status") + ': </span><strong>' + $filter('translate')('status_veiculo_por_cor_' + cor) + ' </strong></div>\n';
            }
            mapaHtml += '    </div>\n' +
                '    <div class="info-tabs popup_div_botoes">\n' +
                '        <div class="tab-content">\n' +
                '            <div id="buttonsMap" role="tabpanel" class="tab-pane active">\n' +
                '                <a class="btn btn-default" target="_blank"  href="https://www.google.com/maps/search/' + veiculo.latitude + ',' + veiculo.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no google maps"><i class="fa fa-google fa-2x"></i></a>\n' +
                '                <a class="btn btn-default" target="_blank" href="http://maps.google.com/maps?q=&layer=c&cbll=' + veiculo.latitude + ',' + veiculo.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no Google Street View"><i class="fa fa-street-view fa-2x"></i></a>\n' +
                '                '+butttonHtml+'\n' +
                '            </div>\n' +
                '        </div>\n' +
                '    </div>\n' +
                '</div>';
            return mapaHtml;
        },

        createPopupBySystem: function () {
            var endereco =  _scope.objSistema.endereco.logradouro +", "+ _scope.objSistema.endereco.numero +" - "+ _scope.objSistema.endereco.bairro +' '+ _scope.objSistema.endereco.cidade+' / '+ _scope.objSistema.endereco.estado;
            return '<div class="row">\n' +
                '    <div class="col-md-10 col-sm-10 col-xs-10 descricao-rastreado">\n' +
                '        <span>' + _scope.objSistema.descricao + '</span>\n' +
                '    </div>\n' +
                '    <div class="col-md-12 col-sm-12 col-xs-12">\n' +
                '        <hr style="margin-top: 5px; margin-bottom: 5px;">\n' +
                '    </div>\n' +
                '    <div class="pop_up_rastreados_detalhes">\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' + $filter("translate")("ocorrencia_label_latitude") + ': <strong>' + _scope.objSistema.endereco.latitude + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' + $filter("translate")("ocorrencia_label_longitude") + ': <strong>' + _scope.objSistema.endereco.longitude + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-map-marker"></i> '+ $filter('translate')('ocorrencia_label_endereco')+': </span><strong>'+endereco+'</strong></div>\n' +
                '    </div>\n' +
                '    <div class="info-tabs popup_div_botoes">\n' +
                '        <div class="tab-content">\n' +
                '            <div role="tabpanel" class="tab-pane active">\n' +
                '                <a class="btn btn-default" target="_blank"  href="https://www.google.com/maps/search/' + _scope.objSistema.endereco.latitude + ',' + _scope.objSistema.endereco.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no google maps"><i class="fa fa-google fa-2x"></i></a>\n' +
                '                <a class="btn btn-default" target="_blank" href="http://maps.google.com/maps?q=&layer=c&cbll=' + _scope.objSistema.endereco.latitude + ',' + _scope.objSistema.endereco.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no Google Street View"><i class="fa fa-street-view fa-2x"></i></a>\n' +
                '            </div>                        \n' +
                '        </div>\n' +
                '    </div>\n' +
                '</div>'
        },
    }



});



angular.module("Fullarm").factory("RequestFactory", function($q, $http, constant){

    return {
        createRequestLocal : function ($url, $metodo, $s, $e) {
            $http({
                url : $url,
                method : $metodo,
            }).then(function successCallback(response) {
                $s(response);
            }, function errorCallback(error) {
                if($e){ $e(error) };
            });
        },

        createRequest : function ($url, $metodo, $s, $e) {
            $http({
                url : constant.BASE_URL + $url,
                method : $metodo,
            }).then(function successCallback(response) {
                $s(response);
            }, function errorCallback(error) {
                if($e){ $e(error) };
            });
        },
        createRequestWithParams : function ($url, $metodo, $data, $s, $e){
            $http({
                url : constant.BASE_URL + $url,
                method : $metodo,
                data: $.param($data),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function successCallback(response) {
                $s(response);
            }, function errorCallback(error) {
                if($e){ $e(error) };
            });
        }
    }
});

angular.module('Fullarm').factory('debounce', ['$rootScope', '$browser', '$q', '$exceptionHandler',
  function($rootScope,   $browser,   $q,   $exceptionHandler) {
      var deferreds = {},
          methods = {},
          uuid = 0;
  
      function debounce(fn, delay, invokeApply) {
          var deferred = $q.defer(),
              promise = deferred.promise,
              skipApply = (angular.isDefined(invokeApply) && !invokeApply),
              timeoutId, cleanup,
              methodId, bouncing = false;
  
          // check we dont have this method already registered
          angular.forEach(methods, function(value, key) {
              if(angular.equals(methods[key].fn, fn)) {
                  bouncing = true;
                  methodId = key;
              }
          });
  
          // not bouncing, then register new instance
          if(!bouncing) {
              methodId = uuid++;
              methods[methodId] = {fn: fn};
          } else {
              // clear the old timeout
              deferreds[methods[methodId].timeoutId].reject('bounced');
              $browser.defer.cancel(methods[methodId].timeoutId);
          }
  
          var debounced = function() {
              // actually executing? clean method bank
              delete methods[methodId];
  
              try {
                  deferred.resolve(fn());
              } catch(e) {
                  deferred.reject(e);
                  $exceptionHandler(e);
              }
  
              if (!skipApply) $rootScope.$apply();
          };
  
          timeoutId = $browser.defer(debounced, delay);
  
          // track id with method
          methods[methodId].timeoutId = timeoutId;
  
          cleanup = function(reason) {
              delete deferreds[promise.$$timeoutId];
          };
  
          promise.$$timeoutId = timeoutId;
          deferreds[timeoutId] = deferred;
          promise.then(cleanup, cleanup);
  
          return promise;
      }
  
  
      // similar to angular's $timeout cancel
      debounce.cancel = function(promise) {
          if (promise && promise.$$timeoutId in deferreds) {
              deferreds[promise.$$timeoutId].reject('canceled');
              return $browser.defer.cancel(promise.$$timeoutId);
          }
          return false;
      };
  
      return debounce;
  }]);;
angular.module("Fullarm").factory('httpInterceptor', ['$q', '$rootScope',
    function ($q, $rootScope) {
        var loadingCount = 0;

        return {
            request: function (config) {
                if(++loadingCount === 1) $rootScope.$broadcast('loading:progress');
                return config || $q.when(config);
            },

            response: function (response) {
                if(--loadingCount === 0) $rootScope.$broadcast('loading:finish');
                return response || $q.when(response);
            },

            responseError: function (response) {
                if(--loadingCount === 0) $rootScope.$broadcast('loading:finish');
                return $q.reject(response);
            }
        };
    }
]).config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('httpInterceptor');
}]);
angular.module('Fullarm')
.service('playerService', function ($http, $q, $timeout, encodeCamera) {

	var _camera    = null;
	var _intervalo = null;
	var _canceller = null;
	var _looper    = null;
	var _rodando   = false; 
	var _contRequest = 0;

	var _notificarSucesso = function(){};
	var _notificarFalha   = function(){};

    var INTERVALO_MAX  = 5000;
    var INTERVALO_MIN  = 100;
    var INTERVALO_DE_FALHA = 500;

    var FATOR_INCREMENTO_INTERVALO = +20;
    var FATOR_DECREMENTO_INTERVALO = -10;

    var ERRO_FRAME_VAZIO         = "FRAMEVAZIO";
    var ERRO_CAMERA_INDISPONIVEL = "CAMERAINDISPONIVEL";
    var ERRO_ACESSO_NEGADO       = "ACESSONEGADO";

	var _atualizarIntervalo = function (increment) {
		
		_intervalo += increment; 
		
		if(_intervalo < INTERVALO_MIN){
			_intervalo = INTERVALO_MIN;
		}

		if(_intervalo > INTERVALO_MAX){
			_intervalo = INTERVALO_MAX;
		}
	}

	var _sucessoRequestFrame = function(resp){

		var contentType = resp.headers('Content-type');
		var isImage     = contentType.indexOf("image/jpeg") > -1;
		var isText      = contentType.indexOf("text/plain") > -1;
		var errorText   = '';

		if (isImage) {			
			var bytes = resp.data;
			var imagem = encodeCamera.arrayBufferToBase64(bytes);	
			
			_atualizarIntervalo(FATOR_DECREMENTO_INTERVALO);
		    _notificarSucesso(imagem,_camera,(_contRequest == 0));
			_looper = $timeout(_requestFrame, _intervalo);
			_contRequest++;
		} 

		if (isText){
			errorText = encodeCamera.arrayBufferToString( resp.data );
			_atualizarIntervalo(FATOR_INCREMENTO_INTERVALO);
		}
	    if( isText && errorText == ERRO_FRAME_VAZIO && _intervalo >= INTERVALO_DE_FALHA){
    		_notificarFalha(ERRO_FRAME_VAZIO);
    		_looper = $timeout(_requestFrame, _intervalo);
    	} else if( isText && errorText == ERRO_FRAME_VAZIO){
    		_looper = $timeout(_requestFrame, _intervalo);
    	}else if(isText){
    		_notificarFalha(errorText);
    	}
		
	}

	var _falhaRequestFrame = function(error){
		var cancelPromise = error.config.timeout;
		if( cancelPromise.$$state.status == 0){
			_notificarFalha(ERRO_CAMERA_INDISPONIVEL)
		}
	}

	var _requestFrame = function(){
		if(_rodando){
			_canceller = $q.defer();
			var request = $http({
						method: 'GET',
						url: _camera.thumb,
						responseType:"arraybuffer",
						timeout:_canceller.promise,
                		withCredentials : false,
					});
			request.then(_sucessoRequestFrame,_falhaRequestFrame);
		}
	}

	var _setNotificarSucesso = function(notificarSucesso){
		_notificarSucesso = notificarSucesso;
	}

	var _setNotificarFalha   = function(notificarFalha){
		_notificarFalha   = notificarFalha;
	}
	
	var _setCamera = function ( camera ) {
		_camera = camera;
	};

	var _stop = function () {
		if(_rodando){
			_canceller.resolve('passei');
			$timeout.cancel(_looper);
		}
		
		_intervalo = INTERVALO_MIN;
		_contRequest = 0;
		_rodando = false;
	};

	var _play = function () {
		_intervalo = INTERVALO_MIN;
		_rodando   = true;
		_requestFrame();
	};

	return{
		setNotificationSucesso:_setNotificarSucesso,
		setNotificationFalha:_setNotificarFalha,
		setCamera: _setCamera,
		stop: _stop,
		play: _play
	};
});
angular.module('Fullarm').directive('buttonProcessing', function ($rootScope) {
    return {
        link: function (scope, element) {
            var onButtonClick = function () {
                element.button("loading");
                $rootScope.buttonClicked = element;
                element.disabled = true;
            };
            element.on('click', onButtonClick);
        }
    }
});
angular.module('Fullarm').directive('includeReplace', function () {
    return {
        require: 'ngInclude',
        restrict: 'A', /* optional */
        link: function (scope, el, attrs) {
            el.replaceWith(el.children());
        }
    };
});
angular.module('Fullarm')
    .constant('constant',{
        BASE_URL : 'https://adm.dev.fullarm.com',
        IMAGE_URL : 'https://dev-imagem.fullarm.com/imagens/',
        TIPO_PGM:{
                LIGA_DESLIGA : 1,
                INVERTER: 2,
                SEMPRE_ACIONAR: 3
        },
        COMANDOS_PGM:{
                LIGA:5,
                DESLIGA:6
        },
        COMANDOS_SONOFF:{
                LIGA:47,
                DESLIGA:48
        },
        COMANDOS_EWELINK:{
                LIGA:41,
                DESLIGA:42
        },
        STATUS:{
                EM_ESPERA:1,
                EM_ATENDIMENTO:2,
                EM_OBSERVACAO:3,
                FINALIZADO:4,
                AGUARDANDO_RONDA:6,
                RONDA_A_CAMINHO:7,
                RONDA_NO_LOCAL:8,
                RONDA_FINALIZADA:9,
                RONDA_RECUSADA:10,
                RONDA_CANCELADA:11
        },
        STATUS_OPERADOR_RONDA:{
                  DISPONIVEL:0,
                  OCUPADO:1,
                  PENDENTE:2,
        },
        ESTADO_TABELA_HORARIO:{
                HORARIO_EXCEDIDO:1,
                PERMISSAO_NEGADA:2,
                HORARIO_VALIDO:3
        },
        PRIORIDADE:{
                ALTA:1,
                MEDIA:2,
                BAIXA:3,
        },
        CODIGOS_CONDHOUSE:[90, 91, 92, 93],
        FULLCOND_TIPO:{
                INTERFONE:1,
                PESSOA:2,
                GRUPO:3
        }

    });

angular.module('Fullarm')
    .constant('painelConstants',{
        StatusComando :{
            0: "ENVIOU_PARA_FILA",
            1: "ENVIOU_PARA_THREAD_DE_EXECUCAO",
            2: "executando",
            3: "comando_enviado_com_sucesso",
            4: "falha_comando_painel_desconectado",
            5: "falha_timeout_comando",
            6: "falha_erro_gerenerico",
            7: "falha_arme_setor_aberto_nao_listado",
            8: "falha_inibir_zona_nao_inibido",
            9: "falha_de_arme_todas_as_zonas_inibidas",
            10: "falha_inibir_zona_particao_armada",
            11: "falha_de_arme_zonas_desabilitada",
            12: "falha_stay_zona_aberta",
            13: "falha_de_arme_particao_ja_armado",
            14: "falha_de_arme_zonas_nao_inibivel",
            15: "falha_desinibir_zona_nao_desinibido", //Depreciado
            16: "falha_arme_tempo_saida", // Depreciado
            17: "falha_senha_incorreta",
            18: "falha_comando_invalido",
            19: "falha_central_nao_particionada",
            20: "falha_zonas_nao_cadastradas_abertas",
            21: "falha_comando_descontinuado",
            22: "falha_de_desarme_particao_ja_desarmada",
            23: "falha_arme_stay_recusado_zonas_externas_abertas",
            24: "falha_spirit_nao_responde",
            25: "falha_spirit_sensor_nao_encontrada",
            26: "falha_spirit_sensor_nao_responde",
            27: "falha_spirit_nao_monitorada",
            28: "falha_spirit_nao_existe",
            29: "falha_pgm_desabilitada",
            30: "falha_arme_inibindo_setor_recusado_zonas_abertas",
            31: "falha_arme_stay_inibindo_setor_recusado_zonas_abertas",
            32: "falha_portao_ja_aberto",
            33: "falha_portao_ja_fechado",
            34: "falha_falha_arme_tamper",
            35: "falha_arme_inibindo_tamper",
            36: "falha_arme_stay_tamper",
            37: "falha_arme_stay_inibindo_tamper",
            38: "falha_sensor_offline",
            39: "falha_inibindo_setores_setor_offline",
            40: "falha_stay_sensor_offline",
            41: "falha_arme_stay_inibindo_offline",
            47: "falha_pgm_ja_acionada", //"O dispositivo já está ativado.";
            48: "falha_pgm_ja_desligada", //"O dispositivo já está desativado.";
            49: "usuario_sem_permissao_inibir",
            50: "usuario_sem_permissao_desarme",
            51: "inibicao_nao_permitida_pois_central_esta_armada",
            52: "powermanage_painel_desconectado"
        },
        Comandos: {
            ARMAR: 1,
            DESARMAR: 2,
            ARMAR_INIBINDO_SETORES: 3,
            ARMAR_STAY: 4,
            ACIONAR_PGM: 5,
            DESACIONAR_PGM: 6,
            ABRIR_PORTAO: 9,
            FECHAR_PORTAO: 10,
            ARMAR_STAY_SEM_CHECAGEM: 25,
            ARMAR_SEM_CHECAGEM: 26,
            ARMAR_STAY_INIBINDO_SETORES: 37,
            ARMAR_INIBINDO_SETORES_SEM_CHECAGEM: 38,
            ARMAR_STAY_INIBINDO_SETORES_SEM_CHECAGEM: 39,
            DESARMAR_SOBE_COACAO: 40,
            LIGAR_TOMADA: 41,
            DESLIGAR_TOMADA:42,
            DESARMAR_ACIDENTAL: 43,
            ACIONAR_SONOFF: 47,
            DESACIONAR_SONOFF: 48,
            ACIONAR_SIRENE: 56,
            DESACIONAR_SIRENE: 57
        }
    }
);
angular.module('Fullarm')

    .constant('constantTraducao', {
            'pt': {

                    /* Genéricas */
                        'nenhum_registro_encontrado':'Nenhum registro encontrado',
                        'relatorios': 'Relatórios',
                    /* Genéricas */

                    'ocorrencia_acao_atender':                      'Atender',
                    'ocorrencia_acao_observar':                     'Observar',
                    'ocorrencia_acao_observar_sem_retorno':         'Observar sem tempo de retorno',
                    'ocorrencia_acao_finalizar':                    'Finalizar',
                    'ocorrencia_acao_visualizar':                   'Visualizar',
                    'ocorrencia_acao_processo':                     'Processo',
                    'ocorrencia_label_inicio':                      'Início',
                    'ocorrencia_label_tolerancia':                  'Tolerância',
                    'ocorrencia_label_horario_arme':                'Horário de arme',
                    'ocorrencia_label_horario_desarme':             'Horário de desarme',
                    'ocorrencia_label_trocar_usuario':              'Trocar usuário',
                    'ocorrencia_label_mostrar_localizacao':         'Mostrar localização',
                    'ocorrencia_label_localizacao':                 'Localização',
                    'ocorrencia_label_enviar':                      'Enviar',
                    'ocorrencia_label_aguardar':                    'Aguardar',
                    'ocorrencia_label_confirmar':                   'Confirmar',
                    'ocorrencia_label_problema':                    'Problema',
                    'ocorrencia_label_colocada_em_processo':        'Colocado em processo por ',
                    'ocorrencia_label_cliente':                     'Cliente',
                    'ocorrencia_label_iniciado_em':                 'Atendimento iniciado em:',
                    'ocorrencia_label_tempo_atendimento':           'Tempo de atendimento:',
                    'ocorrencia_label_contatos':                    'Contatos',
                    'ocorrencia_label_setores':                     'Setores',
                    'ocorrencia_label_inibir_setor':                'Inibir',
                    'ocorrencia_label_inibir_os_setores':           'Inibir os setores',
                    'ocorrencia_label_cameras':                     'Câmeras',
                    'ocorrencia_label_painel' :                     'Painel',
                    'ocorrencia_label_codigo':                      'Código',
                    'ocorrencia_label_setor':                       'Setor/Usuário',
                    'ocorrencia_label_data_hora':                   'Data/Hora',
                    'ocorrencia_label_descricao':                   'Descrição',
                    'ocorrencia_label_numero':                      'Número',
                    'ocorrencia_label_anotacao':                    'Anotação',
                    'ocorrencia_label_anotacao_providencia':        'Providência',
                    'ocorrencia_label_modelo':                      'Modelo',
                    'ocorrencia_label_fabricante':                  'Fabricante',
                    'ocorrencia_label_novo':                        'Novo',
                    'ocorrencia_label_novas':                       'Em Espera',
                    'ocorrencia_label_anotacao_observacao':         'Observação',
                    'ocorrencia_label_data_hora_disparo':           'Ocorrido em',
                    'ocorrencia_label_tipo':                        'Tipo',
                    'ocorrencia_label_tipo_evento':                 'Tipo de Evento',
                    'ocorrencia_label_anual':                       'Anual',
                    'ocorrencia_label_dias':                        'Dias',
                    'ocorrencia_label_horas':                       'Horas',
                    'ocorrencia_label_minutos':                     'Minutos',
                    'ocorrencia_label_segundos':                    'Segundos',
                    'ocorrencia_label_operador':                    'Operador',
                    'ocorrencia_label_sistema':                     'Sistema',
                    'ocorrencia_label_imagem_local_disparo':        'Imagem gerada no local do disparo',
                    'ocorrencia_label_video_pre_alarme':            'Vídeo capturado no Pré Alarme',
                    'ocorrencia_label_veiculos':                    'Veículos',
                    'ocorrencia_label_veiculo':                     'Veículo',
                    'ocorrencia_label_anotacoes':                   'Anotações temporárias',
                    'ocorrencia_label_placa_veiculo':               'Placa',
                    'ocorrencia_label_data':                        'Data',
                    'ocorrencia_label_latitude':                    'Latitude',
                    'ocorrencia_label_longitude':                   'Longitude',
                    'ocorrencia_label_velocidade':                  'Velocidade',
                    'ocorrencia_label_status':                      'Status',
                    'ocorrencia_label_nome_motorista':              'Motorista',
                    'ocorrencia_label_contato_motorista':           'Contato',
                    'ocorrencia_label_sair':                        'Sair',
                    'ocorrencia_label_logs_ocorrencia':             'Logs da ocorrência',
                    'ocorrencia_label_prioridade_alta':             'Prioridade - Alta',
                    'ocorrencia_label_prioridade_baixa':            'Prioridade - Baixa',
                    'ocorrencia_label_prioridade_media':            'Prioridade - Média',
                    'ocorrencia_label_em_atendimento_por':          'Ocorrência em atendimento por: ',
                    'ocorrencia_label_observacao':                  'Ocorrência em observação',
                    'ocorrencia_label_informe_um_motivo':           'Informe um motivo para finalizar',
                    'ocorrencia_label_historico_de_eventos':        'Histórico de eventos',
                    'ocorrencia_label_historico':                   'Histórico',
                    'ocorrencia_label_providencias':                'Providências',
                    'ocorrencia_label_providencia_como_agir':       'Como agir',
                    'ocorrencia_label_mensagem_padrao':             'Mensagens padrão',
                    'ocorrencia_label_ordem_servico':               'Ordem de serviço',
                    'ocorrencia_label_senha':                       'Senha',
                    'ocorrencia_label_senha_resposta':              'Contra senha',
                    'ocorrencia_label_senha_coacao':                'Senha de coação',
                    'ocorrencia_label_sucesso':                     'Sucesso',
                    'ocorrencia_label_sem_resposta':                'Sem resposta',
                    'ocorrencia_label_ocupado':                     'Ocupado',
                    'ocorrencia_label_caixa_postal':                'Caixa postal',
                    'ocorrencia_label_numero_nao_existe':           'Número não existe',
                    'ocorrencia_label_iniciar_contato_whatsapp':    'Iniciar contato por whatsapp',
                    'ocorrencia_label_prioridade':                  'Prioridade',
                    'ocorrencia_label_dados':                       'Dados',
                    'ocorrencia_label_comentario_log':              'COMENTÁRIO SOBRE A OCORRÊNCIA',
                    'ocorrencia_label_abrir_nova_aba':              'Abrir em nova aba',
                    'ocorrencia_label_prioridade_contato':          'Prioritário',
                    'ocorrencia_label_nivel_risco':                 'Nivel de risco',
                    'ocorrencia_label_funcao_contato':              'Relacionamento',
                    'ocorrencia_label_pergunta_finalizar':          'Deseja finalizar a ocorrência?',
                    'ocorrencia_label_info_motivo_disparo':         'Informe o motivo do disparo',
                    'ocorrencia_label_telefone':                    'Telefones',
                    'ocorrencia_label_mensagem_chamada_aberta':     'Existe tentativa de contato aberta',
                    'ocorrencia_label_ultimo_keep_alive':           'Último keepalive',
                    'ocorrencia_label_veiculos_proximos':           'Veículos Próximos',
                    'ocorrencia_label_endereco':                    'Endereço',
                    'ocorrencia_label_data_localizacao':            'Data localização',
                    'ocorrencia_label_data_comunicacao':            'Data comunicação',
                    'ocorrencia_label_ver_endereco':                'Ver endereço',
                    'ocorrencia_label_local_nao_encontrado':        'Localização não encontrada',
                    'ocorrencia_label_assumir':                     'Assumir atendimento',
                    'ocorrencia_label_assumir_observacao':          'Assumir observação',
                    'ocorrencia_label_nao_contem_anotacao':         'Não contém anotação temporária',
                    'ocorrencia_label_todos_rastreados':            'Última posição de todos os rastreados',
                    'ocorrencia_label_postergar':                   'Postergar',
                    'ocorrencia_label_postergar_para':              'Postergar para',
                    'ocorrencia_label_postergar_inicio_para':       'Postergar horário início para',
                    'ocorrencia_label_postergar_fim_para':          'Postergar horário fim para',
                    'ocorrencia_label_postergar_finalizar':         'Postergar e finalizar',
                    'ocorrencia_label_postergar_arme':              'Postergar arme',
                    'ocorrencia_label_postergar_desarme':           'Postergar desarme',
                    'ocorrencia_label_comentario':                  'Comentário',
                    'ocorrencia_label_contato_nao_cadastrado':      'Não há contato cadastrado',
                    'ocorrencia_label_video_nao_cadastrado':        'Não há câmera cadastrada',
                    'ocorrencia_label_painel_nao_cadastrado':       'Não há painel cadastrado',
                    'ocorrencia_label_rastreado_nao_cadastrado':    'Não há rastreado cadastrado',
                    'ocorrencia_label_veiculo_nao_cadastrado':      'Não há veículo cadastrado',
                    'ocorrencia_label_providencia_nao_cadastrado':  'Não há providência cadastrada',
                    'ocorrencia_label_cadastrar_contato':           'Cadastrar contato',
                    'ocorrencia_label_cadastrar_video':             'Cadastrar câmera',
                    'ocorrencia_label_cadastrar_rastreado':         'Cadastrar rastreado',
                    'ocorrencia_label_cadastrar_providencia':       'Cadastrar providência',
                    'ocorrencia_label_cadastrar_painel':            'Cadastrar painel',
                    'ocorrencia_label_configuracao_sucesso':        'Configuração salva com sucesso!',
                    'ocorrencia_label_configuracao_erro':           'Erro no envio dos dados',
                    'ocorrencia_label_ler_mais':                    'Ler mais',
                    'ocorrencia_label_motivo_disparo':              'Motivos do disparo',
                    'ocorrencia_label_nao_existe_veiculo_proximo':  'Não há veículo dentro do Limite (raio) configurado.',
                    'ocorrencia_label_nao_existe_viatura_vinculada':'Nenhum registro encontrado.',
                    'ocorrencia_label_usuario':                     'Usuário',
                    'ocorrencia_label_rastreados':                  'Rastreados',
                    'ocorrencia_label_teclas_atalho':               'Teclas de atalho',
                    'ocorrencia_label_botoes_atendimento':          'Botões de atendimento',
                    'ocorrencia_label_ocorrencia_anteior':          'Seleciona ocorrência anterior',
                    'ocorrencia_label_proxima_ocorrencia':          'Seleciona próxima ocorrência',
                    'ocorrencia_label_aba_esquerda':                'Seleciona abas a esquerda',
                    'ocorrencia_label_aba_direita':                 'Seleciona abas a direita',
                    'ocorrencia_label_ir_para_comentario':          'Ir para o campo de comentário',
                    'ocorrencia_label_enter_comentario':            'Enter após comentário digitado',
                    'ocorrencia_label_insere_comentario':           'Insere o comentário e abre tela para finalizar',
                    'ocorrencia_label_enter_tela_finalizacao':      'Enter na tela de finalização',
                    'ocorrencia_label_finaliza_ou_cancela':         'Finaliza a ocorrência ou cancela ação',
                    'ocorrencia_label_left_rigth_finalizacao':      'Left e Rigth na tela de Finalização',
                    'ocorrencia_label_botoes_cancelar_finalizar':   'Seleciona os botões Cancelar e Finalizar respectivamente',
                    'ocorrencia_label_outros_atalhos':              'Outros atalhos',
                    'ocorrencia_label_deseja_finalizar':            'Deseja finalizar a ocorrência',
                    'ocorrencia_label_carregamento_ocorrencia':     'Carregamento automático da ocorrência',
                    'ocorrencia_label_carregamento_finalizar':      'Opção finalizar após inserir o log',
                    'ocorrencia_label_habilitado':                  'Habilitado',
                    'ocorrencia_label_desabilitado':                'Desabilitado',
                    'ocorrencia_label_configuracao':                'Configuração',
                    'ocorrencia_label_menu_usuario':                'Menu do usuário',
                    'ocorrencia_label_automacao':                   'Automação',
                    'ocorrencia_label_portao':                      'Portão',
                    'ocorrencia_label_ligada':                      'Ligada',
                    'ocorrencia_label_desligada':                   'Desligada',
                    'ocorrencia_label_abrir':                       'Abrir',
                    'ocorrencia_label_fechar':                      'Fechar',
                    'ocorrencia_label_operadora':                   'Operadora',
                    'ocorrencia_label_pre_visualizar':              'Pré-visualizar',
                    'ocorrencia_label_adicionar_legenda':           'Adicionar uma legenda',
                    'ocorrencia_label_comandos':                    'Comandos',
                    'ocorrencia_label_acionamento_sirene':          'Acionamento Sirene',
                    'ocorrencia_label_tempo_acionamento':           'Tempo de acionamento em segundos',
                    'ocorrencia_label_tempo_acionamento_validacao': 'Informe um tempo de acionamento maior que zero.',
                    'ocorrencia_label_nao_possui_comando':          'Este modelo não possui este tipo de comando.',
                    'ocorrencia_label_desconectado_validacao':      'O painel está desconectado.',
                    'ocorrencia_label_permissao_comando_validacao': 'Você não tem permissão para enviar comandos.',
                    'ocorrencia_label_sirene':                      'Sirene',
                    'ocorrencia_label_proximo':                     'Próximo',
                    'ocorrencia_label_anterior':                    'Anterior',
                    'ocorrencia_label_imagens':                     'Imagens',
                    'ocorrencia_label_grupo_atendimento':           'Grupo de atendimento',
                    'ocorrencia_label_nome':                        'Nome',
                    'ocorrencia_label_fpatrol':                     'Fpatrol',
                    'ocorrencia_label_solicitar_patrulha':          'Solicitar patrulhamento',
                    'ocorrencia_label_operador_solicitado':         'Solicitação pendente',
                    'ocorrencia_label_operador_disponivel':         'Disponível',
                    'ocorrencia_label_operador_ocupado':            'Ocupado',
                    'ocorrencia_label_cancelar_patrulha':           'Cancelar solicitação',
                    'ocorrencia_label_cadastro_alterado':           'Cadastro alterado',
                    'ocorrencia_label_idioma_portugues':            'Português do Brasil',
                    'ocorrencia_label_idioma_espanhol':             'Español',
                    'ocorrencia_label_idioma_ingles':               'English',
                    'ocorrencia_label_idioma':                      'Português do Brasil',
                    'ocorrencia_label_por':                         'por',
                    'ocorrencia_label_expandir':                    'Expandir',
                    'ocorrencia_label_encolher':                    'Encolher',
                    'ocorrencia_label_tempo_observacao':            'Mover para observação',
                    'ocorrencia_label_aguardar_observcao':          'Aguardar em observação por',
                    'ocorrencias_label_tipo_alarme_arme':           'Arme',
                    'ocorrencias_label_tipo_alarme_desarme':        'Desarme',
                    'ocorrencias_label_tipo_alarme_alarme':         'Alarme',
                    'ocorrencias_label_tipo_alarme_panico':         'Pânico/Emergência',
                    'ocorrencias_label_tipo_alarme_problemas':      'Problemas e falhas',
                    'ocorrencias_label_tipo_alarme_abertura':       'Abertura/Fechamento Portão',
                    'ocorrencias_label_tipo_alarme_outros':         'Outros',
                    'ocorrencias_label_tipo_alarme_ronda':          'Ronda',
                    'ocorrencias_label_msg_desconhecida':           'Tipo descinhecido',
                    'ocorrencias_label_ampliar':                    'Ampliar',
                    'ocorrencias_label_empresa':                    'Empresa',
                    'ocorrencias_label_cor_mensagem':               'Cor da mensagem',
                    'ocorrencias_label_cor_fundo_mensagem':         'Cor do fundo da Mensagem',
                    'ocorrencias_label_cor_fundo_chat':             'Cor de fundo do Chat',
                    'ocorrencias_label_font_size':                  'Tamanho da fonte',
                    'ocorrencias_label_configuracao_chat':          'Configuração do chat',
                    'ocorrencias_label_informacoes_ocorrencia':     'INFORMAÇÕES DA OCORRÊNCIA',
                    'ocorrencias_label_ver_no_mapa':                'Ver no mapa',
                    'ocorrencias_label_ver_na_lista':               'Ver na lista',
                    'ocorrencias_label_identificador':              'Identificador',
                    'ocorrencias_label_voltar':                     'Voltar',
                    'ocorrencias_label_chat_desabilitado':          'Chat desabilitado para esse cliente',
                    'ocorrencias_label_tipo_destinatario_fpatrol':  'Operador externo',
                    'ocorrencias_label_tipo_destinatario_cliente':  'Cliente',
                    'ocorrencias_label_sistema_manutencao':         'Sistema em manutenção, tempo restante',
                    'ocorrencia_label_atendimento_por':             'Em atendimento por',
                    'ocorrencia_label_observacao_por':              'Em observação por',
                    'ocorrencia_label_evento_manual':               'Evento Manual',
                    'ocorrencia_label_log_enviado_cliente':         'Enviado para o cliente',
                    'ocorrencia_label_editar_sistema':              'Editar Sistema',
                    'ocorrencia_label_manutencao':                  'Manutenção',
                    'ocorrencia_label_manutencao_title':            'Selecionar a quantidade de horas de manutenção',
                    'ocorrencia_label_iniciar_manutencao':          'Iniciar manutenção',
                    'ocorrencia_label_revogar_manutencao':          'Revogar',
                    'ocorrencia_label_prorrogar_manutencao':        'Prorrogar',
                    'ocorrencia_label_tempo_restante':              'Tempo restante',
                    'ocorrencia_label_tempo_invalido':              'O tempo mínimo permitido é de 01:00',
                    'ocorrencia_label_habilitar_manutencao':        'Habilitar manutenção',
                    'ocorrencia_label_confirma_revogacao':          'Você deseja revogar a manutenção do sistema abaixo?',
                    'ocorrencia_label_revogar_prorrogar':           'Revogar/Prorrogar',
                    'ocorrencia_label_sim':                         'Sim',
                    'ocorrencia_label_nao':                         'Não',
                    'ocorrencia_label_exemplo_manutencao':          'Exemplo. Se a manutenção for demorar três horas o valor será 03:00',

                    'ocorrencia_label_error_401':                   'Não autorizado! Verifique seu login e senha',
                    'ocorrencia_label_error_400':                   'Não foi possível realizar a requisição',
                    'ocorrencia_label_error_500':                   'Erro interno. Não foi possível realizar a requisição',
                    'ocorrencia_label_error_0':                     'Você está off-line',
                    'ocorrencia_label_hoje':                        'Hoje',
                    'ocorrencia_label_processando':                 'Processando...',
                    'ocorrencia_status_novos':                      'Aguardando atendimento',
                    'ocorrencia_status_em_atendimento':             'Em atendimento',
                    'ocorrencia_status_em_observacao':              'Em observação',
                    'ocorrencia_status_finalizado':                 'Finalizado',
                    'ocorrencia_status_em_processo':                'Em processo',
                    'ocorrencia_status_aguardando_ronda':           'Aguardando patrulha',
                    'ocorrencia_status_roda_a_caminho':             'Patrulha a caminho',
                    'ocorrencia_status_ronda_no_local':             'Patrulha no local',
                    'ocorrencia_status_ronda_finalizada':           'Patrulha finalizada',
                    'ocorrencia_tab_geral_atendimento':             'Em Atendimento',
                    'ocorrencia_tab_geral_observacao':              'Em Observação',
                    'ocorrencia_tab_geral_processo':                'Em Processo',
                    'ocorrencia_status_alterado_para':              'Status alterado para',
                    'ocorrencia_informacao_particao_armada':        'Armada',
                    'ocorrencia_informacao_particao_armada_stay':   'Armada Stay',
                    'ocorrencia_informacao_particao_desarmada':     'Desarmada',
                    'ocorrencia_informacao_painel_conectado':       'Conectado',
                    'ocorrencia_informacao_painel_desconectado':    'Desconectado',
                    'ocorrencia_informacao_status_desconhecido':    'Status desconhecido',
                    'ocorrencia_informacao_label_feriado':          'Feriado',
                    'ocorrencia_informacao_label_de':               'de',
                    'ocorrencia_informacao_feriado_municipal':      'Municipal',
                    'ocorrencia_informacao_feriado_estadual':       'Estado',
                    'ocorrencia_informacao_feriado_internacional':  'Internacional',
                    'ocorrencia_informacao_feriado_nacional':       'Nacional',
                    'ocorrencia_informacao_feriado':                'Hoje é feriado para o cliente',
                    'ocorrencia_informacao_feriado_anual':          'acontece anualmente',
                    'ocorrencia_informacao_feriado_nao_anual':      'acontece apenas este ano',
                    'ocorrencia_informacao_chave_no_local':         'Possui chaves no local',
                    'ocorrencias_informacao_modal_advertencias_log':'Insira um comentário válido',
                    'ocorrencia_informacao_colocar_atendimento':    'Coloque a ocorrência em atendimento antes de finalizar',
                    'ocorrencia_informacao_nivel_risco_baixo':      'Cliente com nível de risco Baixo',
                    'ocorrencia_informacao_nivel_risco_medio':      'Cliente com nível de risco Médio',
                    'ocorrencia_informacao_nivel_risco_alto':       'Cliente com nível de risco Alto',
                    'ocorrencia_title_modal_status_painel':         'Status do Painel',
                    'ocorrencia_title_modal_status_particao':       'Status da Partição',
                    'ocorrencias_title_modal_advertencias':         'Atenção',
                    'ocorrencias_titulo_modal_chaves':              'Possui chaves no local',
                    'ocorrencias_modal_numero_chaveiro':            'Número do Chaveiro',
                    'ocorrencia_botao_mostrar_mais':                'Mostrar mais',
                    'ocorrencia_botao_mostrar_menos':               'Mostrar menos',
                    'ocorrencia_botao_gerar_log':                   'Gerar Comentário',
                    'ocorrencia_botao_gerar_os':                    'Solicitar OS',
                    'ocorrencia_botao_finalizar':                   'Finalizar',
                    'ocorrencia_botao_cancelar':                    'Cancelar',
                    'ocorrencia_botao_salvar':                      'Salvar',
                    'ocorrencia_botao_armar_painel':                'Armar',
                    'ocorrencia_botao_desarmar_painel':             'Desarmar',
                    'ocorrencia_botao_armar_painel_stay':           'Armar Stay',
                    'ocorrencia_botao_iniciar_contato':             'Iniciar Contato',
                    'ocorrencia_text_area_mensagem_padrao':         'Digite @ para utilizar mensagens pré definidas',
                    'ocorrencia_text_area_nao_ha_mensagem_padrao':  'Não há mensagens pré definidas',
                    'ocorrencia_text_area_mensagem_contato':        'Complemento',
                    'ocorrencia_toast_title_atualizacao':           'Atualização',
                    'ocorrencia_toast_title_prioridade_alta':       'Evento com Prioridade alta',
                    'ocorrencia_toast_title_prioridade_media':      'Evento com Prioridade média',
                    'ocorrencia_toast_title_prioridade_baixa':      'Evento com Prioridade baixa',
                    'ocorrencia_toast_atendimento_outro_usuario':   'Ocorrência sendo atendida por outro usuário!',
                    'ocorrencia_toast_finalizado_outro_usuario':    'Ocorrência foi finalizada por outro usuário!',
                    'ocorrencia_toast_finalizado_pelo_ronda':       'Ocorrência foi finalizada no patrulhamento!',
                    'ocorrencia_toast_finalizado_pelo_sistema':     'Ocorrência finalizada pelo sistema',
                    'ocorrencia_toast_novo_evento_recebido':        'Novo evento recebido!',
                    'ocorrencia_toast_em_processo':                 'Ocorrência colocada em Processo por outro usuário!',
                    'ocorrencia_toast_colocada_em_observacao':      'Ocorrência colocada em Observação  por outro usuário!',
                    'ocorrencia_toast_troca_atendimento':           'Outro operador assumiu o atendimento da ocorrência',
                    'ocorrencia_toast_aguardando_ronda':            'Patrulhamento solicitado para esta ocorrência',
                    'ocorrencia_toast_ronda_a_caminho':             'Patrulha a caminho do local',
                    'ocorrencia_toast_ronda_no_local':              'Patrulha no local',
                    'ocorrencia_toast_ronda_finalizada':            'Patrulha finalizada',
                    'ocorrencia_toast_sucesso_comando':             'Comando enviado con éxito',
                    'ocorrencia_toast_sucesso_solicitacao_os':      'Solicitação enviada com sucesso',
                    'ocorrencia_toast_horario_postergado_sucesso':  'Horário postergado com sucesso',
                    'ocorrencia_toast_horario_postergar_excedido':  'Horário para postergar excedido. Finalize a ocorrência.',
                    'ocorrencia_toast_horario_postergar_excluido':  'O registro foi exlcuído na tabela de horário. Finalize a ocorrência.',
                    'ocorrencia_toast_horario_postergar_menor':     'Insira um horário maior que o atual',
                    'ocorrencia_toast_configuracao_sucesso':        'Configuração alterada com sucesso.',
                    'ocorrencia_toast_permissao_microfone':         'Verifique as configurações do navegador e do computador',
                    'ocorrencia_toast_permissao_postergar_negada':  'Você não pode finalizar essa ocorrência, pois não tem permissão para postergar',
                    'ocorrencia_toast_tempo_observacao_invalido':   'Insira um tempo válido',
                    'ocorrencia_toast_info_sistema_alterado':       'Informações alteradas com sucesso',
                    'ocorrencia_toast_info_maunutencao_iniciada':   'Manutenção iniciada com sucesso',
                    'ocorrencia_toast_info_maunutencao_revogada':   'Manutenção revogada com sucesso',
                    'ocorrencia_toast_info_maunutencao_prorrogada': 'Manutenção prorrogada com sucesso',
                    'ocorrencia_setor_nao_possui_cameras':          'Setor não possui câmeras',
                    'ocorrencias_modal_log_title':                  'Logs da Ocorrência ',
                    'ocorrencias_modal_log_subtitle':               'Log inserido na ocorrência ',
                    'ocorrencias_modal_providencias_subtitle':      'Para eventos do tipo',
                    'ocorrencias_modal_anotacoes_subtitle':         'Anotação temporária expira em ',
                    'ocorrencias_modal_troca_usuario_title':        'Dados do Usuário ',
                    'ocorrencias_modal_aguardando_interacao':       'Ocorrências aguardando interação',
                    'ocorrencias_tooltip_aviso_finalizar':          'Insira um comentário ou entre em contato com o cliente para finalizar',
                    'ocorrencia_tooltip_aviso_observacao':          'Já se encontra em Observação',
                    'ocorrencia_tooltip_aviso_atendimento':         'Já se encontra em Atendimento',
                    'ocorrencia_tooltip_aviso_processo':            'Já se encontra em Processo',
                    'ocorrencia_tooltip_acao_usuario':              'Gerado pelo úsuario',
                    'ocorrencia_tooltip_evento_gerado':             'Evento Gerado',
                    'ocorrencia_tooltip_imagem_disparo':            'Imagem do local do Disparo',
                    'ocorrencia_tooltip_status':                    'Status da Ocorrência',
                    'ocorrencia_tooltip_video_pre_alarme':          'Pré Alarme',
                    'ocorrencia_tooltip_mqtt_desconectado':         'Desconectado',
                    'ocorrencia_tooltip_ativar':                     'Ativar',
                    'ocorrencia_tooltip_ligar':                     'Ligar',
                    'ocorrencia_tooltip_desligar':                  'Desligar',
                    'ocorrencia_tooltip_anterior':                  'Anterior',
                    'ocorrencia_tooltip_proximo':                   'Próximo',
                    'ocorrencia_tooltip_deve_estar_em_atendimento': 'Ocorrência deve estar em atendimento',
                    'localizacao_em':                               'Localização do veiculo em ',
                    'ultima_posicao':                               'Última Posição',
                    'ultima_1_hora':                                '1 Hora',
                    'ultimas_2_horas':                              '2 Horas',
                    'ultimas_3_horas':                              '3 Horas',
                    'status_veiculo_por_cor_red':                   'Desligado',
                    'status_veiculo_por_cor_blue':                  'Ligado em movimento',
                    'status_veiculo_por_cor_green':                 'Ligado parado',
                    'status_veiculo_por_status_desligado':          'Desligado',
                    'status_veiculo_por_status_em_movimento':       'Ligado em movimento',
                    'status_veiculo_por_status_parado':             'Ligado parado',
                    'ocorrencia_search_nenhum_resultado_encontrado':'Nenhum resultado',
                    'ocorrencia_search_buscar_sistema':             'Buscar por Sistema',
                    'ocorrencia_search_buscar_contato':             'pesquisar contato',
                    'ocorrencia_search_sair_da_busca':              'Pressione ESC para fechar',
                    'ocorrencia_search_buscar_buscando':            'Buscando',
                    'ocorrencia_search_selecionar_particao':        'Escolha a partição para gerar o evento manual',
                    'ocorrencia_search_nao_ha_particao':            'Não há partição para geração de evento manual',
                    'ocorrencia_informacao_existe_chamada_em_andamento':'Existe uma chamada em andamento',
                    'api_sistema_monitoramento_argumento_sistema':  'Sistema',
                    'ocorrencia_botao_mostrar_log_cliente':         'Enviar para Cliente',
                    'ocorrencia_botao_push_log_cliente':            'Enviar via Push para Cliente',

                    /* Setores */
                    'ocorrencia_setores_legenda':                   'Legenda',
                    'ocorrencia_setores_outros':                    'Outro Sensor',
                    'ocorrencia_setores_ivp':                       'Sensor Infravermelho',
                    'ocorrencia_setores_magnetico':                 'Sensor Magnético',
                    'ocorrencia_setores_optico':                    'Sensor Óptico',
                    'ocorrencia_setores_sinal':                     'Nível de Sinal',
                    'ocorrencia_setores_disparado':                 'Disparado',
                    'ocorrencia_setores_memoria':                   'Memória',
                    'ocorrencia_setores_inibido':                   'Inibido',
                    'ocorrencia_setores_bateria_fraca':             'Bateria Fraca',
                    'ocorrencia_setores_bateria_carregada':         'Bateria',
                    'ocorrencia_setores_temperatura':               'Temperatura',
                    'ocorrencia_setores_setor_24':                  'Setor 24hs',
                    'ocorrencia_setores_silencioso':                'Silencioso',
                    'ocorrencia_setores_interno':                   'Interno',
                    'ocorrencia_setores_aberto':                    'Aberto',
                    'ocorrencia_setores_tamper':                    'Tamper',
                    'ocorrencia_setores_falha_supervisao':          'Falha de Supervisão',
                    'ocorrencia_setor_fechado':                     'Fechado',
                    'ocorrencia_setor_aberto':                      'Aberto',
                    'ocorrencia_setores_perimetro':                 'Perímetro',
                    'ocorrencia_setores_curto':                     'Em curto',
                    'ocorrencia_chat_audio_enviado':                'Novo áudio recebido',
                    'ocorrencia_painel_legenda_sensor_camera': 'Sensor câmera',
                    'ocorrencia_painel_legenda_sensor_com_fio': 'Sensor com fio',
                    'ocorrencia_painel_legenda_sensor_sem_fio': 'Sensor sem fio',
                    'ocorrencia_painel_legenda_sensor_camera_analitico_on': 'Analítico Ligado',
                    'ocorrencia_painel_legenda_sensor_camera_analitico_off': 'Analítico Desligado',
                    /** Setores **/

                    /** comandos **/

                    "falha_comando_painel_desconectado":               "Não foi possível executar o comando, o painel está desconectado.",
                    "falha_timeout_comando":                           "Não foi possível verificar se o comando foi recebido com êxito. Tente reenviar o comando.",
                    "falha_erro_gerenerico":                           "Não foi possível efetuar o comando",
                    "falha_arme_stay_recusado_zonas_externas_abertas": "Arme Stay recusado todos setores externos estão inibidos.",
                    "falha_inibir_zona_nao_inibido":                   "Setor não pode ser inibido.",
                    "falha_de_arme_todas_as_zonas_inibidas":           "Não é possível armar com todos os setores do painel inibidos.",
                    "falha_inibir_zona_particao_armada":               "Não foi possível inibir. Existe partição armada.",
                    "falha_senha_incorreta":                           "Senha incorreta ou não cadastrada na central de alarme.",
                    "falha_comando_invalido":                          "A central de alarme considerou o comando inválido.",
                    "falha_central_nao_particionada":                  "A central não está particionada.",
                    "falha_zonas_nao_cadastradas_abertas":             "A central está com um ou mais setores abertos não cadastrados. Contate o suporte técnico.",
                    "falha_comando_descontinuado":                     "Este comando não é mais suportado pela versão atual da central.",
                    "falha_desinibir_zona_nao_desinibido":             "Não foi possível restaurar o setor.",
                    "falha_arme_tempo_saida":                          "Falha de arme com o tempo de saida.",
                    "falha_portao_ja_aberto":                          "Portão já se encontra aberto",
                    "falha_portao_ja_fechado":                         "Portão já se encontra fechado",
                    "falha_spirit_nao_responde":                       "Falha de comunicação: Spirit não responde.",
                    "falha_spirit_sensor_nao_encontrada":              "Falha de comunicação: Sensor não encontrado.",
                    "falha_spirit_sensor_nao_responde":                "Falha de comunicação: Sensor não responde.",
                    "falha_spirit_nao_monitorada":                     "Falha de comunicação: Spirit não é monitorada.",
                    "falha_spirit_nao_existe":                         "Falha de comunicação: Spirit não existe.",
                    "falha_pgm_desabilitada":                          "PGM desabilitada.",
                    "falha_falha_arme_tamper":                         "Falha ao armar, sensor em tamper.",
                    "falha_arme_inibindo_tamper":                      "Falha ao armar inibindo setores, setor em tamper.",
                    "falha_arme_stay_tamper":                          "Falha ao armar stay, setor em tamper.",
                    "falha_arme_stay_inibindo_tamper":                 "Falha ao armar stay inibindo setores, setor em tamper.",
                    "falha_sensor_offline":                            "Falha ao armar, sensor offline.",
                    "falha_inibindo_setores_setor_offline":            "Falha ao armar inibindo setores, sensor offline.",
                    "falha_stay_sensor_offline":                       "Falha ao armar stay, sensor offline.",
                    "falha_arme_stay_inibindo_offline":                "Falha ao armar stay inibindo setores, sensor offline.",
                    "falha_de_arme_zonas_desabilitada":                "O seguinte setor está desativado.",
                    "falha_de_arme_zonas_nao_inibivel":                "Não foi possível executar o comando. Existe setor que não pode ser inibido.",
                    "falha_de_desarme_particao_ja_desarmada":          "Painel já se encontra desarmado",
                    "falha_de_arme_particao_ja_armado":                "Painel já se encontra armado.",
                    "falha_de_arme_particao_ja_armado_stay":           "Painel já se encontra armado stay.",
                    "falha_arme_setor_aberto_nao_listado":             "Falha ao armar, existem setores abertos. \nTentar armar novamente?",
                    "setores_externo_abertos":                         "Setores externos abertos",
                    "setores_abertos":                                 "Setores abertos",
                    "comando_enviado_com_sucesso":                     "Comando enviado com sucesso",
                    "comando_nao_foi_enviado":                         "O comando não foi enviado, tente novamente.",
                    "executando":                                      "Executando...",
                    "inibicao_nao_permitida_pois_central_esta_armada": "Usuário não tem permissão para armar inibindo setores pois a central já está armada",
                    "usuario_sem_permissao_desarme":                   "Usuário não tem permissão para desarmar",
                    "usuario_sem_permissao_inibir":                    "Usuário não tem permissão para armar inibindo setores",
                    "powermanage_painel_desconectado":                 "O painel não pode receber o comando, tente novamente mais tarde.",
                    "falha_pgm_ja_acionada":                           "O dispositivo já está ativado.",
                    "falha_pgm_ja_desligada":                          "O dispositivo já está desativado.",
                    "usuario_sem_permissao_comando":                   "Você não tem permissão para enviar comando ao dispositivo",
                    /** comandos **/
                    'modulo_painel_setor_camera_inativo': 'Setor inativo. A câmera vinculada está com a função analítico desativada.',
                    'modulo_painel_modal_legenda_fechar': 'Fechar',

                    /** Ocorrência aba informações do Local */
                    'ocorrencia_informacoes_local_aba_titulo':      'Informações do Local',
                    'ocorrencia_informacoes_local_titulo_endereco': 'Endereço',
                    'ocorrencia_informacoes_local_observacao':      'Observação',
                    'ocorrencia_informacoes_local_complemento':     'Complemento',
                    'ocorrencia_informacoes_local_salvar':          'Salvar',
                    'ocorrencia_informacoes_local_cancelar':        'Cancelar',
                    /** Ocorrência aba informações do Local */

                    /**Fullcond */
                    'ocorrencia_fullcond_titulo_interfone': 'Interfones',
                    'ocorrencia_fullcond_nao_ha_interfones_cadastrados': 'Não há interfones cadastrados',
                    'ocorrencia_fullcond_titulo_usuarios': 'Unidades',
                    'ocorrencia_fullcond_nao_ha_usuarios_cadastrados': 'Não há unidades cadastradas',
                    'ocorrencia_fullcond_buscar_usuarios': 'Buscar unidade'
                    /**Fullcond */

            },
            'es': {
                    /* Genéricas */
                    'nenhum_registro_encontrado':'No se encontraron registros',
                    'relatorios': 'Informes',
                    /* Genéricas */

                    'ocorrencia_acao_atender':                      'Atender',
                    'ocorrencia_acao_observar':                     'Observación',
                    'ocorrencia_acao_observar_sem_retorno':         'Observar sin tiempo de retorno',
                    'ocorrencia_acao_finalizar':                    'Final',
                    'ocorrencia_acao_visualizar':                   'Visualizar',
                    'ocorrencia_acao_processo':                     'Proceso',
                    'ocorrencia_label_inicio':                      'Início',
                    'ocorrencia_label_tolerancia':                  'Tolerancia',
                    'ocorrencia_label_horario_arme':                'Horario de arme',
                    'ocorrencia_label_horario_desarme':             'Horario de desarme',
                    'ocorrencia_label_trocar_usuario':              'Cambiar usuario',
                    'ocorrencia_label_mostrar_localizacao':         'Mostrar ubicación',
                    'ocorrencia_label_localizacao':                 'Ubicación',
                    'ocorrencia_label_enviar':                      'Enviar',
                    'ocorrencia_label_aguardar':                    'Espere',
                    'ocorrencia_label_confirmar':                   'Confirmar',
                    'ocorrencia_label_problema':                    'Problema',
                    'ocorrencia_label_colocada_em_processo':        'Puesta en proceso por ',
                    'ocorrencia_label_cliente':                     'Cliente',
                    'ocorrencia_label_iniciado_em':                 'Atendimiento Iniciado en:',
                    'ocorrencia_label_tempo_atendimento':           'Tiempo de Atendimiento:',
                    'ocorrencia_label_contatos':                    'Contactos',
                    'ocorrencia_label_setores':                     'Sectores',
                    'ocorrencia_label_inibir_setor':                'Inhibir',
                    'ocorrencia_label_inibir_os_setores':           'Inhibir setores',
                    'ocorrencia_label_cameras':                     'Cámaras',
                    'ocorrencia_label_painel' :                     'Panel',
                    'ocorrencia_label_codigo':                      'Código',
                    'ocorrencia_label_setor':                       'Sector/Usuario',
                    'ocorrencia_label_data_hora':                   'Fecha/Hora',
                    'ocorrencia_label_descricao':                   'Descripción',
                    'ocorrencia_label_numero':                      'Numero',
                    'ocorrencia_label_anotacao':                    'Anotacion',
                    'ocorrencia_label_anotacao_providencia':        'Providencia',
                    'ocorrencia_label_modelo':                      'Modelo',
                    'ocorrencia_label_fabricante':                  'Fabricante',
                    'ocorrencia_label_novo':                        'Nuevo',
                    'ocorrencia_label_novas':                       'En Espera',
                    'ocorrencia_label_anotacao_observacao':         'Observación',
                    'ocorrencia_label_data_hora_disparo':           'Ocurrido en',
                    'ocorrencia_label_tipo':                        'Especie',
                    'ocorrencia_label_tipo_evento':                 'Tipo de Evento',
                    'ocorrencia_label_anual':                       'Anual',
                    'ocorrencia_label_dias':                        'Días',
                    'ocorrencia_label_horas':                       'Horas',
                    'ocorrencia_label_minutos':                     'Minuto',
                    'ocorrencia_label_segundos':                    'Segundos',
                    'ocorrencia_label_operador':                    'Operador',
                    'ocorrencia_label_sistema':                     'Sistema',
                    'ocorrencia_label_imagem_local_disparo':        'Imagen generada en el lugar del disparo',
                    'ocorrencia_label_video_pre_alarme':            'Vídeo capturado en Pre alarma',
                    'ocorrencia_label_veiculos':                    'Vehículos',
                    'ocorrencia_label_veiculo':                     'Vehículo',
                    'ocorrencia_label_anotacoes':                   'Anotaciones temporales',
                    'ocorrencia_label_placa_veiculo':               'Placa',
                    'ocorrencia_label_data':                        'Fecha',
                    'ocorrencia_label_latitude':                    'Latitud',
                    'ocorrencia_label_longitude':                   'Longitud',
                    'ocorrencia_label_velocidade':                  'Velocidad',
                    'ocorrencia_label_status':                      'Status',
                    'ocorrencia_label_nome_motorista':              'Conductor',
                    'ocorrencia_label_contato_motorista':           'Contato',
                    'ocorrencia_label_sair':                        'Salir',
                    'ocorrencia_label_logs_ocorrencia':             'Registro da ocurrencia',
                    'ocorrencia_label_prioridade_alta':             'Prioridad - Alto',
                    'ocorrencia_label_prioridade_baixa':            'Prioridad - Bajo',
                    'ocorrencia_label_prioridade_media':            'Prioridad - Medio',
                    'ocorrencia_label_em_atendimento_por':          'Ocurrencia en Atendimiento por: ',
                    'ocorrencia_label_observacao':                  'Ocurrencia en observación',
                    'ocorrencia_label_informe_um_motivo':           'Introduzca una razón para terminar',
                    'ocorrencia_label_historico_de_eventos':        'Historia de eventos',
                    'ocorrencia_label_historico':                   'Historia',
                    'ocorrencia_label_providencias':                'Providencias',
                    'ocorrencia_label_providencia_como_agir':       'Cómo actuar',
                    'ocorrencia_label_mensagem_padrao':             'Mensajes predeterminados',
                    'ocorrencia_label_ordem_servico':               'Orden de servicio',
                    'ocorrencia_label_senha':                       'Contraseña',
                    'ocorrencia_label_senha_resposta':              'Contraseña respuesta',
                    'ocorrencia_label_senha_coacao':                'Contraseña coacción',
                    'ocorrencia_label_sucesso':                     'Éxito',
                    'ocorrencia_label_sem_resposta':                'Sin respuesta',
                    'ocorrencia_label_ocupado':                     'Ocupado',
                    'ocorrencia_label_caixa_postal':                'Buzón de mensajes',
                    'ocorrencia_label_numero_nao_existe':           'Número no existe',
                    'ocorrencia_label_iniciar_contato_whatsapp':    'Iniciar contacto por whatsapp',
                    'ocorrencia_label_prioridade':                  'Prioridad',
                    'ocorrencia_label_dados':                       'Datos',
                    'ocorrencia_label_comentario_log':              'COMENTARIO SOBRE LA OCURRENCIA',
                    'ocorrencia_label_abrir_nova_aba':              'Abrir en nueva pestaña',
                    'ocorrencia_label_prioridade_contato':          'Prioridad',
                    'ocorrencia_label_nivel_risco':                 'Nivel de riesgo',
                    'ocorrencia_label_funcao_contato':              'Relación',
                    'ocorrencia_label_pergunta_finalizar':          '¿Desea finalizar la ocurrencia?',
                    'ocorrencia_label_info_motivo_disparo':         'Introduzca el motivo del disparo',
                    'ocorrencia_label_telefone':                    'Teléfono',
                    'ocorrencia_label_mensagem_chamada_aberta':     'Hay intento de contacto abierto',
                    'ocorrencia_label_ultimo_keep_alive':           'Último mantenimiento',
                    'ocorrencia_label_veiculos_proximos':           'Vehículos próximos',
                    'ocorrencia_label_endereco':                    'Dirección',
                    'ocorrencia_label_data_localizacao':            'Fecha de la ubicación',
                    'ocorrencia_label_data_comunicacao':            'Fecha de la comunicación',
                    'ocorrencia_label_ver_endereco':                'Ver la dirección',
                    'ocorrencia_label_local_nao_encontrado':        'Ubicación no encontrada',
                    'ocorrencia_label_assumir':                     'Asumir atendimiento',
                    'ocorrencia_label_assumir_observacao':          'Asumir observación',
                    'ocorrencia_label_nao_contem_anotacao':         'No contiene anotación temporal',
                    'ocorrencia_label_todos_rastreados':            'Última posición de todos los rastreados',
                    'ocorrencia_label_postergar':                   'Posponer',
                    'ocorrencia_label_postergar_para':              'Posponer a',
                    'ocorrencia_label_postergar_inicio_para':       'Posponer la hora de inicio a',
                    'ocorrencia_label_postergar_fim_para':          'Posponer la hora de finalización a',
                    'ocorrencia_label_postergar_finalizar':         'Posponer y Finalizar',
                    'ocorrencia_label_postergar_arme':              'Posponer arme del panel',
                    'ocorrencia_label_postergar_desarme':           'Posponer desarme del panel',
                    'ocorrencia_label_comentario':                  'Comentario',
                    'ocorrencia_label_contato_nao_cadastrado':      'No hay contacto registrado',
                    'ocorrencia_label_video_nao_cadastrado':        'No hay cámara registrada',
                    'ocorrencia_label_painel_nao_cadastrado':       'No hay panel registrado',
                    'ocorrencia_label_rastreado_nao_cadastrado':    'No hay rastreado registrado',
                    'ocorrencia_label_veiculo_nao_cadastrado':      'No hay vehículo registrado',
                    'ocorrencia_label_providencia_nao_cadastrado':  'No hay providencia registrada',
                    'ocorrencia_label_cadastrar_contato':           'Registrar un contacto',
                    'ocorrencia_label_cadastrar_video':             'Registro de Cámara',
                    'ocorrencia_label_cadastrar_rastreado':         'Registro de Rastreo',
                    'ocorrencia_label_cadastrar_providencia':       'Registrar Providencia',
                    'ocorrencia_label_cadastrar_painel':            'Registro Panel',
                    'ocorrencia_label_configuracao_sucesso':        'Configuración guardada con éxito!',
                    'ocorrencia_label_configuracao_erro':           'Error al enviar los datos.',
                    'ocorrencia_label_ler_mais':                    'leer más',
                    'ocorrencia_label_motivo_disparo':              'Motivo del Disparo',
                    'ocorrencia_label_nao_existe_veiculo_proximo':  'No hay vehículo dentro de límite establecido.',
                    'ocorrencia_label_nao_existe_viatura_vinculada':'No se encontraron registros.',
                    'ocorrencia_label_usuario':                     'Usuario',
                    'ocorrencia_label_rastreados':                  'Rastreado',
                    'ocorrencia_label_teclas_atalho':               'Teclas de acceso directo',
                    'ocorrencia_label_botoes_atendimento':          'Botones de servicio',
                    'ocorrencia_label_ocorrencia_anteior':          'Selecciona la ocurrencia anterior',
                    'ocorrencia_label_proxima_ocorrencia':          'Selecciona la siguiente ocurrencia',
                    'ocorrencia_label_aba_esquerda':                'Selecciona pestañas a la izquierda',
                    'ocorrencia_label_aba_direita':                 'Selecciona pestañas a la derecha',
                    'ocorrencia_label_ir_para_comentario':          'Ir al campo de comentarios',
                    'ocorrencia_label_enter_comentario':            'Enter después de comentario escrito',
                    'ocorrencia_label_insere_comentario':           'Inserta el comentario y abre la pantalla para finalizar',
                    'ocorrencia_label_enter_tela_finalizacao':      'Entrar en la pantalla de finalización',
                    'ocorrencia_label_finaliza_ou_cancela':         'Finaliza la ocurrencia o cancela acción',
                    'ocorrencia_label_left_rigth_finalizacao':      'Left y Rigth en la pantalla de Finalización',
                    'ocorrencia_label_botoes_cancelar_finalizar':   'Selecciona los botones Cancelar y Finalizar respectivamente',
                    'ocorrencia_label_outros_atalhos':              'Otros accesos directos',
                    'ocorrencia_label_deseja_finalizar':            'Desea Finalizar la ocurrencia',
                    'ocorrencia_label_carregamento_ocorrencia':     'Carga automática de ocurrencia',
                    'ocorrencia_label_carregamento_finalizar':      'Opción de finalización al insertar comentario',
                    'ocorrencia_label_habilitado':                  'Habilitado',
                    'ocorrencia_label_desabilitado':                'Deshabilitado',
                    'ocorrencia_label_configuracao':                'Configuración',
                    'ocorrencia_label_menu_usuario':                'Menú de Usuário',
                    'ocorrencia_label_automacao':                   'Automatización',
                    'ocorrencia_label_portao':                      'Puerta',
                    'ocorrencia_label_ligada':                      'Encendida',
                    'ocorrencia_label_desligada':                   'Apagada',
                    'ocorrencia_label_abrir':                       'Abre',
                    'ocorrencia_label_fechar':                      'Cierra',
                    'ocorrencia_label_operadora':                   'Operador',
                    'ocorrencia_label_pre_visualizar':              'Vista previa',
                    'ocorrencia_label_adicionar_legenda':           'Agregar un subtítulo',
                    'ocorrencia_label_comandos':                    'Comandos',
                    'ocorrencia_label_acionamento_sirene':          'Activación sirena',
                    'ocorrencia_label_tempo_acionamento':           'Tiempo de activación en segundos',
                    'ocorrencia_label_tempo_acionamento_validacao': 'Ingrese un tiempo de activación mayor que cero.',
                    'ocorrencia_label_nao_possui_comando':          'Este modelo no tiene este tipo de comando.',
                    'ocorrencia_label_desconectado_validacao':      'El panel está desconectado',
                    'ocorrencia_label_permissao_comando_validacao': 'No tienes permiso para enviar comandos.',
                    'ocorrencia_label_sirene':                      'Sirena',
                    'ocorrencia_label_proximo':                     'Siguiente',
                    'ocorrencia_label_anterior':                    'Anterior',
                    'ocorrencia_label_imagens':                     'Imágenes',
                    'ocorrencia_label_grupo_atendimento':           'Grupo de atendimiento',
                    'ocorrencia_label_nome':                        'Nombre',
                    'ocorrencia_label_fpatrol':                     'Fpatrol',
                    'ocorrencia_label_solicitar_patrulha':          'Solicitar patrulla',
                    'ocorrencia_label_operador_solicitado':         'Solicitud pendiente',
                    'ocorrencia_label_operador_disponivel':         'Disponible',
                    'ocorrencia_label_operador_ocupado':            'Ocupado',
                    'ocorrencia_label_cancelar_patrulha':           'Cancelar solicitud',
                    'ocorrencia_label_cadastro_alterado':           'Registro cambiado',
                    'ocorrencia_label_idioma_portugues':            'Português do Brasil',
                    'ocorrencia_label_idioma_espanhol':             'Español',
                    'ocorrencia_label_idioma_ingles':               'English',
                    'ocorrencia_label_idioma':                      'Español',
                    'ocorrencia_label_por':                         'por',
                    'ocorrencia_label_expandir':                    'Expandir',
                    'ocorrencia_label_encolher':                    'Contraer',
                    'ocorrencia_label_tempo_observacao':            'Pasar a la observación',
                    'ocorrencia_label_aguardar_observcao':          'Espere observación por',
                    'ocorrencias_label_tipo_alarme_arme':           'Arme',
                    'ocorrencias_label_tipo_alarme_desarme':        'Desarme',
                    'ocorrencias_label_tipo_alarme_alarme':         'Alarma',
                    'ocorrencias_label_tipo_alarme_panico':         'Pánico / Emergencia',
                    'ocorrencias_label_tipo_alarme_problemas':      'Problemas y fallos',
                    'ocorrencias_label_tipo_alarme_abertura':       'Apertura/Cierre Puerta',
                    'ocorrencias_label_tipo_alarme_outros':         'Otro',
                    'ocorrencias_label_tipo_alarme_ronda':          'Ronda',
                    'ocorrencias_label_msg_desconhecida':           'Tipo desconocido',
                    'ocorrencias_label_ampliar':                    'Agrandar',
                    'ocorrencias_label_empresa':                    'Empresa',
                    'ocorrencias_label_cor_mensagem':               'Color del mensaje',
                    'ocorrencias_label_cor_fundo_mensagem':         'Color del fondo del mensaje',
                    'ocorrencias_label_cor_fundo_chat':             'Color de fondo del cha',
                    'ocorrencias_label_font_size':                  'Tamaño de la fuente',
                    'ocorrencias_label_configuracao_chat':          'Configuración del Chat',
                    'ocorrencias_label_informacoes_ocorrencia':     'INFORMACIÓN DE LA OCURRENCIA',
                    'ocorrencias_label_ver_no_mapa':                'Ver en el mapa',
                    'ocorrencias_label_ver_na_lista':               'Ver en la Lista',
                    'ocorrencias_label_identificador':              'Identificador',
                    'ocorrencias_label_voltar':                     'Volver',
                    'ocorrencias_label_chat_desabilitado':          'Chat deshabilitado para este cliente',
                    'ocorrencias_label_tipo_destinatario_fpatrol':  'Operador externo',
                    'ocorrencias_label_tipo_destinatario_cliente':  'Cliente',
                    'ocorrencias_label_sistema_manutencao':         'Sistema en mantenimiento, tiempo restante',
                    'ocorrencia_label_atendimento_por':             'En atendimiento por',
                    'ocorrencia_label_observacao_por':              'En observación por',
                    'ocorrencia_label_evento_manual':               'Evento Manual',
                    'ocorrencia_label_log_enviado_cliente':         'Enviado al cliente',
                    'ocorrencia_informacoes_local_aba_titulo':            'Información sobre la ubicación',
                    'ocorrencia_label_editar_sistema':              'Editar Sistema',
                    'ocorrencia_label_manutencao':                  'Manutención',
                    'ocorrencia_label_manutencao_title':            'Seleccione la cantidad de horas de manutención',
                    'ocorrencia_label_iniciar_manutencao':          'Inicio de manutención',
                    'ocorrencia_label_revogar_manutencao':          'Revocar',
                    'ocorrencia_label_prorrogar_manutencao':        'Prorrogar el tiempo',
                    'ocorrencia_label_tempo_restante':              'Tiempo restante',
                    'ocorrencia_label_tempo_invalido':              'El tiempo mínimo permitido es 01:00',
                    'ocorrencia_label_habilitar_manutencao':        'Habilitar la manutención',
                    'ocorrencia_label_confirma_revogacao':          '¿Desea revocar el manutención del sistema a continuación?',
                    'ocorrencia_label_revogar_prorrogar':           'Revocar/Prorrogar',
                    'ocorrencia_label_sim':                         'Sí',
                    'ocorrencia_label_nao':                         'No',
                    'ocorrencia_label_exemplo_manutencao':          'Ejemplo. Si el manutención tarda tres horas el valor será 03:00',

                    'ocorrencia_label_error_401':                   'No autorizado. Compruebe su nombre de usuario y contraseña',
                    'ocorrencia_label_error_400':                   'No se pudo realizar la solicitud',
                    'ocorrencia_label_error_500':                   'Error interno. No se pudo realizar la solicitud',
                    'ocorrencia_label_error_0':                     'Usted está fuera de línea',
                    'ocorrencia_label_hoje':                        'Hoy',
                    'ocorrencia_label_processando':                 'Processando...',
                    'localizacao_em':                               'Ubicación del vehiculo en ',
                    'ocorrencia_status_novos':                      'Aguardando atendimento',
                    'ocorrencia_status_em_atendimento':             'En atendimiento',
                    'ocorrencia_status_em_observacao':              'En Observación',
                    'ocorrencia_status_finalizado':                 'Terminado',
                    'ocorrencia_status_em_processo':                'En proceso',
                    'ocorrencia_status_aguardando_ronda':           'Esperando patrulla',
                    'ocorrencia_status_roda_a_caminho':             'Patrulla a camino',
                    'ocorrencia_status_ronda_no_local':             'Patrulla en el local',
                    'ocorrencia_status_ronda_finalizada':           'Patrulla finalizada',
                    'ocorrencia_tab_geral_atendimento':             'En Atendimiento',
                    'ocorrencia_tab_geral_observacao':              'En Observación',
                    'ocorrencia_tab_geral_processo':                'En Proceso',
                    'ocorrencia_status_alterado_para':              'Estado cambiado para',
                    'ocorrencia_informacao_particao_armada':        'Armada',
                    'ocorrencia_informacao_particao_armada_stay':   'Armada Stay',
                    'ocorrencia_informacao_particao_desarmada':     'Desarmada',
                    'ocorrencia_informacao_painel_conectado':       'Conectado',
                    'ocorrencia_informacao_painel_desconectado':    'Desconectado',
                    'ocorrencia_informacao_status_desconhecido':    'Estado desconocido',
                    'ocorrencia_informacao_label_feriado':          'Feriado',
                    'ocorrencia_informacao_label_de':               'de',
                    'ocorrencia_informacao_feriado_municipal':      'Municipal',
                    'ocorrencia_informacao_feriado_estadual':       'State',
                    'ocorrencia_informacao_feriado_internacional':  'International',
                    'ocorrencia_informacao_feriado_nacional':       'National',
                    'ocorrencia_informacao_feriado':                'Hoy es feriado para el cliente',
                    'ocorrencia_informacao_chave_no_local':         'Tiene llaves en el lugar',
                    'ocorrencia_informacao_feriado_anual':          'se celebra anualmente',
                    'ocorrencia_informacao_feriado_nao_anual':      'sólo sucede este año',
                    'ocorrencias_informacao_modal_advertencias_log':'Escriba un comentario válido',
                    'ocorrencia_informacao_colocar_atendimento':    'Coloque la instancia en atendimiento antes de finalizar',
                    'ocorrencia_informacao_nivel_risco_baixo':      'Cliente con nivel de riesgo Bajo',
                    'ocorrencia_informacao_nivel_risco_medio':      'Cliente com nível de risco medio',
                    'ocorrencia_informacao_nivel_risco_alto':       'Cliente con alto nivel de riesgo',
                    'ocorrencia_title_modal_status_painel':         'Estatus del Panel',
                    'ocorrencia_title_modal_status_particao':       'Estatus del Particíon',
                    'ocorrencias_title_modal_advertencias':         'Atención',
                    'ocorrencias_titulo_modal_chaves':              'Tiene llaves en el lugar',
                    'ocorrencias_modal_numero_chaveiro':            'Número de Llavero',
                    'ocorrencia_informacao_painel':                 'Panel Armado',
                    'ocorrencia_botao_mostrar_mais':                'Mostrar más',
                    'ocorrencia_botao_mostrar_menos':               'Mostrar menos',
                    'ocorrencia_botao_gerar_log':                   'Generar Comentario',
                    'ocorrencia_botao_gerar_os':                    'Solicitar OS',
                    'ocorrencia_botao_finalizar':                   'Finalizar',
                    'ocorrencia_botao_cancelar':                    'Cancelar',
                    'ocorrencia_botao_salvar':                      'Guardar',
                    'ocorrencia_botao_armar_painel':                'Armar',
                    'ocorrencia_botao_desarmar_painel':             'Desarmar',
                    'ocorrencia_botao_armar_painel_stay':           'Armar Stay',
                    'ocorrencia_botao_iniciar_contato':             'Inicio Contacto',
                    'ocorrencia_text_area_mensagem_padrao':         'Escriba @ para utilizar mensajes predefinidos',
                    'ocorrencia_text_area_nao_ha_mensagem_padrao':  'No hay mensajes predefinidos',
                    'ocorrencia_text_area_mensagem_contato':        'Complemento',
                    'ocorrencia_toast_title_atualizacao':           'Actualización',
                    'ocorrencia_toast_title_prioridade_alta':       'Evento con prioridad alta',
                    'ocorrencia_toast_title_prioridade_media':      'Evento con prioridad media',
                    'ocorrencia_toast_title_prioridade_baixa':      'Evento con prioridad baja',
                    'ocorrencia_toast_atendimento_outro_usuario':   'Ocurrencia siendo atendida por otro usuario!',
                    'ocorrencia_toast_finalizado_outro_usuario':    'La ocurrencia fue finalizada por otro usuario!',
                    'ocorrencia_toast_finalizado_pelo_ronda':       'La ocurrencia fue finalizada en patrulla!',
                    'ocorrencia_toast_finalizado_pelo_sistema':     'Ocurrencia finalizada por el sistema',
                    'ocorrencia_toast_novo_evento_recebido':        'Nuevo evento recibido!',
                    'ocorrencia_toast_em_processo':                 'Ocurrencia modificada para En Proceso por otro usuario!',
                    'ocorrencia_toast_colocada_em_observacao':      'Ocurrencia modificada para En Observacion  por otro usuario!',
                    'ocorrencia_toast_troca_atendimento':           'Otro operador asumió el atendimiento de la ocurrencia',
                    'ocorrencia_toast_aguardando_ronda':            'Patrulla solicitado para esta ocurrencia',
                    'ocorrencia_toast_ronda_a_caminho':             'Patrulla en ruta al local',
                    'ocorrencia_toast_ronda_no_local':              'Patrulla en el local',
                    'ocorrencia_toast_ronda_finalizada':            'Patrulla terminada',
                    'ocorrencia_toast_sucesso_comando':             'Comando enviado com sucesso',
                    'ocorrencia_toast_sucesso_solicitacao_os':      'Solicitud enviada con éxito',
                    'ocorrencia_toast_horario_postergado_sucesso':  'Horario postergado con éxito',
                    'ocorrencia_toast_horario_postergar_excedido':  'Horario para postergar excedido. Finalizar la ocurrencia.',
                    'ocorrencia_toast_horario_postergar_excluido':  'El registro se eliminó en la tabla horaria. Finalizar la ocurrencia.',
                    'ocorrencia_toast_horario_postergar_menor':     'Ingrese una hora mayor que la hora actual',
                    'ocorrencia_toast_configuracao_sucesso':        'Configuración modificada con éxito.',
                    'ocorrencia_toast_permissao_microfone':         'Verifique la configuración del navegador y la computadora',
                    'ocorrencia_toast_permissao_postergar_negada':  'No puede finalizar esta ocurrencia porque no tiene permitido postergar',
                    'ocorrencia_toast_tempo_observacao_invalido':   'Introduzca una hora válida',
                    'ocorrencia_toast_info_sistema_alterado':       'La información cambió con éxito',
                    'ocorrencia_toast_info_maunutencao_iniciada':   'La manutención se inició con éxito',
                    'ocorrencia_toast_info_maunutencao_revogada':   'Manutención revocada con éxito',
                    'ocorrencia_toast_info_maunutencao_prorrogada': 'La Manutención se há extendida con éxito',
                    'ocorrencia_setor_nao_possui_cameras':          'El sector no tiene cámaras',
                    'ocorrencias_modal_log_title':                  'Logs del Ocurrencia ',
                    'ocorrencias_modal_log_subtitle':               'Registro insertado en la instancia ',
                    'ocorrencias_modal_providencias_subtitle':      'Para los eventos del tipo ',
                    'ocorrencias_modal_anotacoes_subtitle':         'La anotación temporal expira en ',
                    'ocorrencias_modal_troca_usuario_title':        'Datos del usuario ',
                    'ocorrencias_modal_aguardando_interacao':       'Ocurrencias que aguardan la interacción',
                    'ocorrencias_tooltip_aviso_finalizar':          'Introduzca un comentario o póngase en contacto con el cliente para finalizar',
                    'ocorrencia_tooltip_aviso_observacao':          'A se encuentra en Observación',
                    'ocorrencia_tooltip_aviso_atendimento':         'A se encuentra en Atendimiento',
                    'ocorrencia_tooltip_aviso_processo':            'A se encuentra en Proceso',
                    'ocorrencia_tooltip_acao_usuario':              'Generado por el úsario',
                    'ocorrencia_tooltip_evento_gerado':             'Evento generado',
                    'ocorrencia_tooltip_imagem_disparo':            'Imagen del sitio del Disparo',
                    'ocorrencia_tooltip_status':                    'Estado de la Ocurrencia',
                    'ocorrencia_tooltip_video_pre_alarme':          'Prealarma',
                    'ocorrencia_tooltip_mqtt_desconectado':         'Inactivo',
                    'ocorrencia_tooltip_ativar':                     'Activar',
                    'ocorrencia_tooltip_ligar':                     'Enciende',
                    'ocorrencia_tooltip_desligar':                  'Apaga',
                    'ocorrencia_tooltip_anterior':                  'Anterior',
                    'ocorrencia_tooltip_proximo':                   'Siguiente',
                    'ocorrencia_tooltip_deve_estar_em_atendimento': 'La ocurrencia debe estar en atendimiento',
                    'ultima_posicao':                               'Ultima Posição',
                    'ultima_1_hora':                                '1 Hora',
                    'ultimas_2_horas':                              '2 Horas',
                    'ultimas_3_horas':                              '3 Horas',
                    'status_veiculo_por_cor_red':                   'Desligado',
                    'status_veiculo_por_cor_blue':                  'Ligado em movimento',
                    'status_veiculo_por_cor_green':                 'Ligado parado',
                    'status_veiculo_por_status_desligado':          'Desligado',
                    'status_veiculo_por_status_em_movimento':       'Ligado em movimento',
                    'status_veiculo_por_status_parado':             'Ligado parado',
                    'ocorrencia_search_nenhum_resultado_encontrado':'No hay resultados',
                    'ocorrencia_search_buscar_sistema':             'Buscar por Sistema',
                    'ocorrencia_search_buscar_contato':             'buscar en contactos',
                    'ocorrencia_search_sair_da_busca':              'Presione ESC para cerrar',
                    'ocorrencia_search_buscar_buscando':            'búsqueda',
                    'ocorrencia_search_selecionar_particao':        'Elija la partición para generar el evento manual',
                    'ocorrencia_search_nao_ha_particao':            'No hay partición para generación de evento manual',
                    'ocorrencia_informacao_existe_chamada_em_andamento':'Hay una llamada en curso',
                    'api_sistema_monitoramento_argumento_sistema':  'Sistema',
                    'ocorrencia_botao_mostrar_log_cliente':         'Enviar al cliente',
                    'ocorrencia_botao_push_log_cliente':            'Enviar vía Push al cliente',

                    /* Setores */
                    'ocorrencia_setores_legenda':                   'Leyenda',
                    'ocorrencia_setores_outros':                    'Otro Sensor',
                    'ocorrencia_setores_ivp':                       'Sensor infrarrojo',
                    'ocorrencia_setores_magnetico':                 'Sensor magnético',
                    'ocorrencia_setores_optico':                    'Sensor Óptico',
                    'ocorrencia_setores_sinal':                     'Nivel de señal',
                    'ocorrencia_setores_disparado':                 'Disparada',
                    'ocorrencia_setores_memoria':                   'Memoria',
                    'ocorrencia_setores_inibido':                   'Inhibido',
                    'ocorrencia_setores_bateria_fraca':             'Batería baja',
                    'ocorrencia_setores_bateria_carregada':         'Batería',
                    'ocorrencia_setores_temperatura':               'Temperatura',
                    'ocorrencia_setores_setor_24':                  'Sector 24hs',
                    'ocorrencia_setores_silencioso':                'Silencioso',
                    'ocorrencia_setores_interno':                   'Interna',
                    'ocorrencia_setores_aberto':                    'Abierto',
                    'ocorrencia_setores_tamper':                    'Tamper',
                    'ocorrencia_setores_falha_supervisao':          'Falla de Supervisión',
                    'ocorrencia_setor_fechado':                     'Cerrado',
                    'ocorrencia_setor_aberto':                      'Abierto',
                    'ocorrencia_setores_perimetro':                 'Perímetro',
                    'ocorrencia_setores_curto':                     'En cortocircuito',
                    'ocorrencia_chat_audio_enviado':                'Nuevo audio recibido',
                    'ocorrencia_painel_legenda_sensor_camera': 'Sensor cámara',
                    'ocorrencia_painel_legenda_sensor_com_fio': 'Sensor con cable',
                    'ocorrencia_painel_legenda_sensor_sem_fio': 'Sensor inalámbrico',
                    'ocorrencia_painel_legenda_sensor_camera_analitico_on': 'Analítica Ligado',
                    'ocorrencia_painel_legenda_sensor_camera_analitico_off': 'Analítica Desligado',
                    /* Setores */

                    /** comandos **/

                    "falha_comando_painel_desconectado":               "No fue posible ejecutar el comando, el panel está desconectado.",
                    "falha_timeout_comando":                           "No fue posible verificar que el comando se recibió correctamente. Intente volver a enviar el comando.",
                    "falha_erro_gerenerico":                           "No se pudo ejecutar el comando",
                    "falha_arme_stay_recusado_zonas_externas_abertas": "Armado en casa rechazado, todos los sectores externos están inhibidos",
                    "falha_inibir_zona_nao_inibido":                   "El sector no se puede inhibir.",
                    "falha_de_arme_todas_as_zonas_inibidas":           "No es posible armar con todos los sectores del panel inhibidos.",
                    "falha_inibir_zona_particao_armada":               "No fue posible inhibir. Hay una partición armada.",
                    "falha_senha_incorreta":                           "Contraseña incorrecta o no registrada en el panel de control.",
                    "falha_comando_invalido":                          "El panel de control consideró que el comando no era válido.",
                    "falha_central_nao_particionada":                  "La planta no está dividida.",
                    "falha_zonas_nao_cadastradas_abertas":             "La planta tiene uno o más sectores abiertos no registrados. Comuníquese con el soporte técnico.",
                    "falha_comando_descontinuado":                     "Este comando ya no es compatible con la versión actual del panel.",
                    "falha_desinibir_zona_nao_desinibido":             "El sector no se pudo restaurar.",
                    "falha_arme_tempo_saida":                          "Fallo de armado con tiempo de salida.",
                    "falha_portao_ja_aberto":                          "La puerta ya está abierta",
                    "falha_portao_ja_fechado":                         "La puerta ya está cerrada",
                    "falha_spirit_nao_responde":                       "Fallo de comunicación: Spirit no responde.",
                    "falha_spirit_sensor_nao_encontrada":              "Fallo de comunicación: Sensor no encontrado.",
                    "falha_spirit_sensor_nao_responde":                "Fallo de comunicación: Sensor no responde.",
                    "falha_spirit_nao_monitorada":                     "Fallo de comunicación: Spirit no é monitorada.",
                    "falha_spirit_nao_existe":                         "Fallo de comunicación: Spirit no existe.",
                    "falha_pgm_desabilitada":                          "PGM deshabilitado.",
                    "falha_falha_arme_tamper":                         "Fallo de armado, sensor en tamper.",
                    "falha_arme_inibindo_tamper":                      "Fallo de armado inibindo setores, setor en tamper.",
                    "falha_arme_stay_tamper":                          "Fallo de armado stay, setor en tamper.",
                    "falha_arme_stay_inibindo_tamper":                 "Fallo de armado stay inhibiendo sectores, setor en tamper.",
                    "falha_sensor_offline":                            "Fallo de armado, sensor offline.",
                    "falha_inibindo_setores_setor_offline":            "Fallo de armado inhibiendo sectores, sensor offline.",
                    "falha_stay_sensor_offline":                       "Fallo de armado stay, sensor offline.",
                    "falha_arme_stay_inibindo_offline":                "Fallo de armado stay inhibiendo sectores, sensor offline.",
                    "falha_de_arme_zonas_desabilitada":                "El siguiente sector está deshabilitado.",
                    "falha_de_arme_zonas_nao_inibivel":                "No se pudo ejecutar el comando. Hay un sector que no se puede inhibir.",
                    "falha_de_desarme_particao_ja_desarmada":          "El panel ya está desarmado",
                    "falha_de_arme_particao_ja_armado":                "El panel ya está armado.",
                    "falha_de_arme_particao_ja_armado_stay":           "El panel ya está armado stay",
                    "falha_arme_setor_aberto_nao_listado":             "No se pudo armar, hay sectores abiertos. ¿Intentar armar de nuevo?",
                    "setores_externo_abertos":                         "Sectores externos abiertos",
                    "setores_abertos":                                 "Sectores abiertos",
                    "comando_enviado_com_sucesso":                     "Comando enviado exitosamente",
                    "comando_nao_foi_enviado":                         "El comando no se envió, inténtelo de nuevo.",
                    "executando":                                      "Corriendo...",
                    "inibicao_nao_permitida_pois_central_esta_armada": "El usuario no puede armar sectores inhibidores porque el panel de control ya está armado",
                    "usuario_sem_permissao_desarme":                   "El usuario no puede desarmar",
                    "usuario_sem_permissao_inibir":                    "El usuario no puede armar inhibiendo sectores",
                    "powermanage_painel_desconectado":                 "El panel no puede recibir el comando, inténtelo de nuevo más tarde.",
                    "falha_pgm_ja_acionada":                           "El dispositivo ya está activado.",
                    "falha_pgm_ja_desligada":                          "El dispositivo ya está desactivado.",
                    "usuario_sem_permissao_comando":                   "No tienes permiso para enviar comandos al dispositivo",
                    /** comandos **/
                    'modulo_painel_setor_camera_inativo': 'Sector inactivo. La cámara vinculada tiene la función de análisis deshabilitada.',
                    'modulo_painel_modal_legenda_fechar': 'Cerrar',

                     /** Ocorrência aba informações do Local */
                     'ocorrencia_informacoes_local_aba_titulo':      'Información sobre la ubicación',
                     'ocorrencia_informacoes_local_titulo_endereco': 'Dirección',
                     'ocorrencia_informacoes_local_observacao':      'Observación',
                     'ocorrencia_informacoes_local_complemento':     'Complemento',
                     'ocorrencia_informacoes_local_salvar':          'Guardar',
                     'ocorrencia_informacoes_local_cancelar':        'Cancelar',
                     /** Ocorrência aba informações do Local */

                      /**Fullcond */
                    'ocorrencia_fullcond_titulo_interfone': 'Interfonos',
                    'ocorrencia_fullcond_nao_ha_interfones_cadastrados': 'No hay interfonos registrados',
                    'ocorrencia_fullcond_titulo_usuarios': 'Usuarios',
                    'ocorrencia_fullcond_nao_ha_usuarios_cadastrados': 'No hay usuarios registrados',
                    'ocorrencia_fullcond_buscar_usuarios': 'Buscar usuarios'
                    /**Fullcond */

	        },
            'en': {
                    /* Genéricas */
                    'nenhum_registro_encontrado':'No records found',
                    'relatorios': 'Reports',
                    /* Genéricas */

                    'ocorrencia_acao_atender':                      'Answer',
                    'ocorrencia_acao_observar':                     'Observe',
                    'ocorrencia_acao_observar_sem_retorno':         'Observe without return time',
                    'ocorrencia_acao_finalizar':                    'Finalize',
                    'ocorrencia_acao_visualizar':                   'View',
                    'ocorrencia_acao_processo':                     'Process',
                    'ocorrencia_label_inicio':                      'Start',
                    'ocorrencia_label_tolerancia':                  'Tolerance',
                    'ocorrencia_label_horario_arme':                'Arming time',
                    'ocorrencia_label_horario_desarme':             'Time to disarm',
                    'ocorrencia_label_trocar_usuario':              'Change user',
                    'ocorrencia_label_mostrar_localizacao':         'Show Location',
                    'ocorrencia_label_localizacao':                 'Location',
                    'ocorrencia_label_enviar':                      'Submit',
                    'ocorrencia_label_aguardar':                    'Wait',
                    'ocorrencia_label_confirmar':                   'Confirm',
                    'ocorrencia_label_problema':                    'Problem',
                    'ocorrencia_label_colocada_em_processo':        'Put in the process of',
                    'ocorrencia_label_cliente':                     'Customer',
                    'ocorrencia_label_status':                      'Status',
                    'ocorrencia_label_iniciado_em':                 'Attendance Started on:',
                    'ocorrencia_label_tempo_atendimento':           'Time of attendance:',
                    'ocorrencia_label_contatos':                    'Contacts',
                    'ocorrencia_label_setores':                     'Sectors',
                    'ocorrencia_label_inibir_setor':                'Inhibit',
                    'ocorrencia_label_inibir_os_setores':           'Inhibit sectors',
                    'ocorrencia_label_cameras':                     'Cameras',
                    'ocorrencia_label_painel' :                     'Panel',
                    'ocorrencia_label_codigo':                      'Code',
                    'ocorrencia_label_setor':                       'Sector/User',
                    'ocorrencia_label_data_hora':                   'Date/Hour',
                    'ocorrencia_label_descricao':                   'Description',
                    'ocorrencia_label_numero':                      'Number',
                    'ocorrencia_label_anotacao':                    'Annotation',
                    'ocorrencia_label_anotacao_providencia':        'Measure',
                    'ocorrencia_label_modelo':                      'Model',
                    'ocorrencia_label_fabricante':                  'Manufacturer',
                    'ocorrencia_label_novo':                        'New',
                    'ocorrencia_label_novas':                       'On Hold',
                    'ocorrencia_label_data_hora_disparo':           'Occurred in:',
                    'ocorrencia_label_tipo':                        'Type',
                    'ocorrencia_label_tipo_evento':                 'Event Type',
                    'ocorrencia_label_anual':                       'Yearly',
                    'ocorrencia_label_dias':                        'Days',
                    'ocorrencia_label_horas':                       'Hours',
                    'ocorrencia_label_minutos':                     'Minutes',
                    'ocorrencia_label_segundos':                    'Seconds',
                    'ocorrencia_label_operador':                    'Operator',
                    'ocorrencia_label_sistema':                     'System',
                    'ocorrencia_label_imagem_local_disparo':        'Image generated at the trigger location',
                    'ocorrencia_label_video_pre_alarme':            'Video captured on Pre Alarm',
                    'ocorrencia_label_veiculos':                    'Vehicles',
                    'ocorrencia_label_veiculo':                     'Vehicle',
                    'ocorrencia_label_anotacoes':                   'Temporary annotations',
                    'ocorrencia_label_placa_veiculo':               'Car plate',
                    'ocorrencia_label_data':                        'Fecha',
                    'ocorrencia_label_latitude':                    'Latitud',
                    'ocorrencia_label_longitude':                   'Longitud',
                    'ocorrencia_label_velocidade':                  'Velocidad',
                    'ocorrencia_label_nome_motorista':              'Driver',
                    'ocorrencia_label_contato_motorista':           'Contact',
                    'ocorrencia_label_sair':                        'Exit',
                    'ocorrencia_label_logs_ocorrencia':             'Occurrence Logs',
                    'ocorrencia_label_prioridade_alta':             'Priority - High',
                    'ocorrencia_label_prioridade_baixa':            'Priority - Low',
                    'ocorrencia_label_prioridade_media':            'Priority - Average',
                    'ocorrencia_label_em_atendimento_por':          'Occurrence in attendance by: ',
                    'ocorrencia_label_observacao':                  'Occurrence in observation',
                    'ocorrencia_label_informe_um_motivo':           'Please provide a reason to finalize',
                    'ocorrencia_label_historico_de_eventos':        'Event history',
                    'ocorrencia_label_historico':                   'History',
                    'ocorrencia_label_providencias':                'Arrangements',
                    'ocorrencia_label_providencia_como_agir':       'How to act',
                    'ocorrencia_label_anotacao_observacao':         'Observation',
                    'ocorrencia_label_mensagem_padrao':             'Default Messages',
                    'ocorrencia_label_ordem_servico':               'Service order',
                    'ocorrencia_label_senha':                       'Password',
                    'ocorrencia_label_senha_resposta':              'Countersign',
                    'ocorrencia_label_senha_coacao':                'Duress Password',
                    'ocorrencia_label_sucesso':                     'Success',
                    'ocorrencia_label_sem_resposta':                'No answer',
                    'ocorrencia_label_ocupado':                     'Occupied',
                    'ocorrencia_label_caixa_postal':                'Mailbox',
                    'ocorrencia_label_numero_nao_existe':           'Number does not exist',
                    'ocorrencia_label_iniciar_contato_whatsapp':    'Start contacting via whatsapp',
                    'ocorrencia_label_prioridade':                  'Priority',
                    'ocorrencia_label_dados':                       'Data',
                    'ocorrencia_label_comentario_log':              'COMMENT ABOUT THE OCCURRENCE',
                    'ocorrencia_label_abrir_nova_aba':              'Open in new tab',
                    'ocorrencia_label_prioridade_contato':          'Priority',
                    'ocorrencia_label_nivel_risco':                 'Risk level',
                    'ocorrencia_label_funcao_contato':              'Relation',
                    'ocorrencia_label_pergunta_finalizar':          'Do you want to end the occurrence?',
                    'ocorrencia_label_info_motivo_disparo':         'Inform the reason for the trigger',
                    'ocorrencia_label_telefone':                    'Telephones',
                    'ocorrencia_label_mensagem_chamada_aberta':     'Contact attempt is open',
                    'ocorrencia_label_ultimo_keep_alive':           'Last keepalive',
                    'ocorrencia_label_veiculos_proximos':           'Upcoming Vehicles',
                    'ocorrencia_label_endereco':                    'Address',
                    'ocorrencia_label_data_localizacao':            'Location date',
                    'ocorrencia_label_data_comunicacao':            'Date of communication',
                    'ocorrencia_label_ver_endereco':                'View address',
                    'ocorrencia_label_local_nao_encontrado':        'Location not found',
                    'ocorrencia_label_assumir':                     'Assume service',
                    'ocorrencia_label_assumir_observacao':          'Assume observation',
                    'ocorrencia_label_nao_contem_anotacao':         'No temporary annotation',
                    'ocorrencia_label_todos_rastreados':            'Last position of all traced',
                    'ocorrencia_label_postergar':                   'Postpone',
                    'ocorrencia_label_postergar_para':              'Postpone to',
                    'ocorrencia_label_postergar_inicio_para':       'Postpone start time to',
                    'ocorrencia_label_postergar_fim_para':          'Postpone end time to',
                    'ocorrencia_label_postergar_finalizar':         'Postpone and end',
                    'ocorrencia_label_postergar_arme':              'Postpone panel arming',
                    'ocorrencia_label_postergar_desarme':           'Postpone panel disarming',
                    'ocorrencia_label_comentario':                  'Comment',
                    'ocorrencia_label_contato_nao_cadastrado':      'No contacts registered',
                    'ocorrencia_label_video_nao_cadastrado':        'No camera registered',
                    'ocorrencia_label_painel_nao_cadastrado':       'No panel registered',
                    'ocorrencia_label_rastreado_nao_cadastrado':    'There is no tracked registered',
                    'ocorrencia_label_veiculo_nao_cadastrado':      'No registered vehicle',
                    'ocorrencia_label_providencia_nao_cadastrado':  'There is no recorded order',
                    'ocorrencia_label_cadastrar_contato':           'Register Contact',
                    'ocorrencia_label_cadastrar_video':             'Register Camera',
                    'ocorrencia_label_cadastrar_rastreado':         'Register a tracker',
                    'ocorrencia_label_cadastrar_providencia':       'Register Providence',
                    'ocorrencia_label_cadastrar_painel':            'Register Panel',
                    'ocorrencia_label_configuracao_sucesso':        'Configuration saved successfully!',
                    'ocorrencia_label_configuracao_erro':           'Error sending data.',
                    'ocorrencia_label_ler_mais':                    'read more',
                    'ocorrencia_label_motivo_disparo':              'Alarm Reason',
                    'ocorrencia_label_nao_existe_veiculo_proximo':  'There is no vehicle within Limit configured.',
                    'ocorrencia_label_nao_existe_viatura_vinculada':'No records found.',
                    'ocorrencia_label_usuario':                     'User',
                    'ocorrencia_label_rastreados':                  'Tracked',
                    'ocorrencia_label_teclas_atalho':               'Hotkeys',
                    'ocorrencia_label_botoes_atendimento':          'Call buttons',
                    'ocorrencia_label_ocorrencia_anteior':          'Select the previous occurrence',
                    'ocorrencia_label_proxima_ocorrencia':          'Select the next occurrence',
                    'ocorrencia_label_aba_esquerda':                'Select left-hand tab',
                    'ocorrencia_label_aba_direita':                 'Select right tab',
                    'ocorrencia_label_ir_para_comentario':          'Go to comment field',
                    'ocorrencia_label_enter_comentario':            'Enter after typed comment',
                    'ocorrencia_label_insere_comentario':           'Enter comment and open screen to finish',
                    'ocorrencia_label_enter_tela_finalizacao':      'Enter in the finish screen',
                    'ocorrencia_label_finaliza_ou_cancela':         'Ends occurrence or cancels action',
                    'ocorrencia_label_left_rigth_finalizacao':      'Left and Rigth on the Finishing screen',
                    'ocorrencia_label_botoes_cancelar_finalizar':   'Select the Cancel and Finish buttons respectively',
                    'ocorrencia_label_outros_atalhos':              'Other Shortcuts',
                    'ocorrencia_label_deseja_finalizar':            'Do you want to end the event',
                    'ocorrencia_label_carregamento_ocorrencia':     'Autoload of occurrence',
                    'ocorrencia_label_carregamento_finalizar':      'End option after logging',
                    'ocorrencia_label_habilitado':                  'Enabled',
                    'ocorrencia_label_desabilitado':                'Disabled',
                    'ocorrencia_label_configuracao':                'Configuration',
                    'ocorrencia_label_menu_usuario':                'User Menu',
                    'ocorrencia_label_automacao':                   'Automation',
                    'ocorrencia_label_portao':                      'Gate',
                    'ocorrencia_label_ligada':                      'On',
                    'ocorrencia_label_desligada':                   'Off',
                    'ocorrencia_label_abrir':                       'Open',
                    'ocorrencia_label_fechar':                      'Close',
                    'ocorrencia_label_operadora':                   'Operator',
                    'ocorrencia_label_pre_visualizar':              'Preview',
                    'ocorrencia_label_adicionar_legenda':           'Add a subtitle',
                    'ocorrencia_label_comandos':                    'Commands',
                    'ocorrencia_label_acionamento_sirene':          'Siren Triggering',
                    'ocorrencia_label_tempo_acionamento':           'Trigger time in seconds',
                    'ocorrencia_label_tempo_acionamento_validacao': 'Enter a trigger time greater than zero.',
                    'ocorrencia_label_nao_possui_comando':          'This model does not have this type of command.',
                    'ocorrencia_label_desconectado_validacao':      'The panel is unplugged.',
                    'ocorrencia_label_permissao_comando_validacao': 'You do not have permission to send commands.',
                    'ocorrencia_label_sirene':                      'Siren',
                    'ocorrencia_label_proximo':                     'Next',
                    'ocorrencia_label_anterior':                    'Previous',
                    'ocorrencia_label_imagens':                     'Images',
                    'ocorrencia_label_grupo_atendimento':           'Service group',
                    'ocorrencia_label_nome':                        'Name',
                    'ocorrencia_label_fpatrol':                     'Fpatrol',
                    'ocorrencia_label_solicitar_patrulha':          'Request Patrol',
                    'ocorrencia_label_operador_solicitado':         'Pending request',
                    'ocorrencia_label_operador_disponivel':         'Available',
                    'ocorrencia_label_operador_ocupado':            'Busy',
                    'ocorrencia_label_cancelar_patrulha':           'Cancel request',
                    'ocorrencia_label_cadastro_alterado':           'Registration changed',
                    'ocorrencia_label_idioma_portugues':            'Português do Brasil',
                    'ocorrencia_label_idioma_espanhol':             'Español',
                    'ocorrencia_label_idioma_ingles':               'English',
                    'ocorrencia_label_idioma':                      'English',
                    'ocorrencia_label_por':                         'by',
                    'ocorrencia_label_expandir':                    'Expand',
                    'ocorrencia_label_encolher':                    'Shrink',
                    'ocorrencia_label_tempo_observacao':            'Move to observation',
                    'ocorrencia_label_aguardar_observcao':          'Wait for observation by',
                    'ocorrencias_label_tipo_alarme_arme':           'Arm',
                    'ocorrencias_label_tipo_alarme_desarme':        'Disarm',
                    'ocorrencias_label_tipo_alarme_alarme':         'Alarm',
                    'ocorrencias_label_tipo_alarme_panico':         'Panic/Emergency',
                    'ocorrencias_label_tipo_alarme_problemas':      'Problems and failures',
                    'ocorrencias_label_tipo_alarme_abertura':       'Opening/Closing Gate',
                    'ocorrencias_label_tipo_alarme_outros':         'Others',
                    'ocorrencias_label_tipo_alarme_ronda':          'Patrol',
                    'ocorrencias_label_msg_desconhecida':           'Unknown type',
                    'ocorrencias_label_ampliar':                    'Enlarge',
                    'ocorrencias_label_empresa':                    'Company',
                    'ocorrencias_label_cor_mensagem':               'Message color',
                    'ocorrencias_label_cor_fundo_mensagem':         'Message Background Color',
                    'ocorrencias_label_cor_fundo_chat':             'Chat background color',
                    'ocorrencias_label_font_size':                  'Font size',
                    'ocorrencias_label_configuracao_chat':          'Chat Settings',
                    'ocorrencias_label_informacoes_ocorrencia':     'INFORMATION OF THE OCCURRENCE',
                    'ocorrencias_label_ver_no_mapa':                'See on the map',
                    'ocorrencias_label_ver_na_lista':               'View in list',
                    'ocorrencias_label_identificador':              'Identifier',
                    'ocorrencias_label_voltar':                     'Return',
                    'ocorrencias_label_chat_desabilitado':          'Chat disabled for this client',
                    'ocorrencias_label_tipo_destinatario_fpatrol':  'External operator',
                    'ocorrencias_label_tipo_destinatario_cliente':  'Client',
                    'ocorrencias_label_sistema_manutencao':         'System in maintenance, time left',
                    'ocorrencia_label_atendimento_por':             'In attendance by',
                    'ocorrencia_label_observacao_por':              'In Observation by',
                    'ocorrencia_label_evento_manual':               'Evento Manual',
                    'ocorrencia_label_log_enviado_cliente':         'Sent to client',
                    'ocorrencia_informacoes_local_aba_titulo':            'Location Information',
                    'ocorrencia_label_editar_sistema':              'Edit System',
                    'ocorrencia_label_manutencao':                  'Maintenance',
                    'ocorrencia_label_manutencao_title':            'Select the number of hours of maintenance',
                    'ocorrencia_label_iniciar_manutencao':          'Start maintenance',
                    'ocorrencia_label_revogar_manutencao':          'Revoke',
                    'ocorrencia_label_prorrogar_manutencao':        'Extend',
                    'ocorrencia_label_tempo_restante':              'Time left',
                    'ocorrencia_label_tempo_invalido':              'The minimum time allowed is 01:00',
                    'ocorrencia_label_habilitar_manutencao':        'Enable maintenance',
                    'ocorrencia_label_confirma_revogacao':          'Do you want to revoke the system maintenance below?',
                    'ocorrencia_label_revogar_prorrogar':           'Revoke/Extend',
                    'ocorrencia_label_sim':                         'Yes',
                    'ocorrencia_label_nao':                         'Not',
                    'ocorrencia_label_exemplo_manutencao':          'Example. If the maintenance take three hours the value will be 03:00',

                    'ocorrencia_label_error_401':                   'Not authorized. Check your login and password',
                    'ocorrencia_label_error_400':                   'Could not complete request',
                    'ocorrencia_label_error_500':                   'Internal error. Could not complete request',
                    'ocorrencia_label_error_0':                     'You are offline',
                    'ocorrencia_label_hoje':                        'Today',
                    'ocorrencia_label_processando':                 'Processing...',
                    'ocorrencia_status_novos':                      'Waiting for attendance',
                    'ocorrencia_status_em_atendimento':             'In Attendance',
                    'ocorrencia_status_em_observacao':              'In Observation',
                    'ocorrencia_status_finalizado':                 'Finished',
                    'ocorrencia_status_em_processo':                'In Process',
                    'ocorrencia_status_aguardando_ronda':           'Waiting patrol',
                    'ocorrencia_status_roda_a_caminho':             'Patrol on the road',
                    'ocorrencia_status_ronda_no_local':             'Patrol in place',
                    'ocorrencia_status_ronda_finalizada':           'Patrol finished',
                    'ocorrencia_tab_geral_atendimento':             'In Attendance',
                    'ocorrencia_tab_geral_observacao':              'In Observation',
                    'ocorrencia_tab_geral_processo':                'In Process',
                    'ocorrencia_status_alterado_para':              'Status chenged to',
                    'ocorrencia_informacao_particao_armada':        'Armed',
                    'ocorrencia_informacao_particao_armada_stay':   'Stay Armed',
                    'ocorrencia_informacao_particao_desarmada':     'Disarmed',
                    'ocorrencia_informacao_painel_conectado':       'Connected',
                    'ocorrencia_informacao_painel_desconectado':    'Disconnected',
                    'ocorrencia_informacao_status_desconhecido':    'Unknown status',
                    'ocorrencia_informacao_label_feriado':          'Holiday',
                    'ocorrencia_informacao_label_de':               'of',
                    'ocorrencia_informacao_feriado_municipal':      'Municipal',
                    'ocorrencia_informacao_feriado_estadual':       'Estadual',
                    'ocorrencia_informacao_feriado_internacional':  'Internacional',
                    'ocorrencia_informacao_feriado_nacional':       'Nacional',
                    'ocorrencia_informacao_feriado':                'Today is a holiday for the client',
                    'ocorrencia_informacao_feriado_anual':          'happens yearly',
                    'ocorrencia_informacao_feriado_nao_anual':      'happens only this year',
                    'ocorrencia_informacao_chave_no_local':         'Has keys on the spot',
                    'ocorrencias_informacao_modal_advertencias_log':'Insert a valid comment',
                    'ocorrencia_informacao_colocar_atendimento':    'Put the occurrence in attendance before finalizing',
                    'ocorrencia_informacao_nivel_risco_baixo':      'Client with Low risk level',
                    'ocorrencia_informacao_nivel_risco_medio':      'Client with Average risk level',
                    'ocorrencia_informacao_nivel_risco_alto':       'Client with High risk level',
                    'ocorrencia_title_modal_status_painel':         'Panel Status',
                    'ocorrencia_title_modal_status_particao':       'Partition Status',
                    'ocorrencias_title_modal_advertencias':         'Attention',
                    'ocorrencias_titulo_modal_chaves':              'Has keys on the spot',
                    'ocorrencias_modal_numero_chaveiro':            'Keychain Number',
                    'ocorrencia_botao_mostrar_mais':                'Show more',
                    'ocorrencia_botao_mostrar_menos':               'Show less',
                    'ocorrencia_botao_gerar_log':                   'Generate Comment',
                    'ocorrencia_botao_gerar_os':                    'Request OS',
                    'ocorrencia_botao_finalizar':                   'Finish',
                    'ocorrencia_botao_cancelar':                    'Cancel',
                    'ocorrencia_botao_salvar':                      'Save',
                    'ocorrencia_botao_armar_painel':                'Arm',
                    'ocorrencia_botao_desarmar_painel':             'Disarm',
                    'ocorrencia_botao_armar_painel_stay':           'Arm Stay',
                    'ocorrencia_botao_iniciar_contato':             'Start Contact',
                    'ocorrencia_text_area_mensagem_padrao':         'Type @ to use pre-set messages',
                    'ocorrencia_text_area_nao_ha_mensagem_padrao':  'No pre-set messages',
                    'ocorrencia_text_area_mensagem_contato':        'Complement',
                    'ocorrencia_toast_title_atualizacao':           'Update',
                    'ocorrencia_toast_title_prioridade_alta':       'Event with high priority',
                    'ocorrencia_toast_title_prioridade_media':      'Event with average priority',
                    'ocorrencia_toast_title_prioridade_baixa':      'Event with low priority',
                    'ocorrencia_toast_atendimento_outro_usuario':   'Occurrence being answered by another user!',
                    'ocorrencia_toast_finalizado_outro_usuario':    'Occurrence was finished by another user!',
                    'ocorrencia_toast_finalizado_pelo_ronda':       'Occurrence ended on patrol!',
                    'ocorrencia_toast_finalizado_pelo_sistema':     'Occurrence was finished by the system',
                    'ocorrencia_toast_novo_evento_recebido':        'New event received!',
                    'ocorrencia_toast_em_processo':                 'Occurrence put in Process by another user!',
                    'ocorrencia_toast_colocada_em_observacao':      'Occurrence put in Observation by another user!',
                    'ocorrencia_toast_troca_atendimento':           'Another operator assumed the attendance of the occurrence',
                    'ocorrencia_toast_aguardando_ronda':            'Patrol requested for this occurrence',
                    'ocorrencia_toast_ronda_a_caminho':             'Patrol on the way to the place',
                    'ocorrencia_toast_ronda_no_local':              'Patrolling is in the place',
                    'ocorrencia_toast_ronda_finalizada':            'Patrol finished',
                    'ocorrencia_toast_sucesso_comando':             'Command sent successfully',
                    'ocorrencia_toast_sucesso_solicitacao_os':      'Solicitud enviada con éxito',
                    'ocorrencia_toast_horario_postergado_sucesso':  'Time delayed successfully',
                    'ocorrencia_toast_horario_postergar_excedido':  'Time to postpone exceeded. Finish the occurrence.',
                    'ocorrencia_toast_horario_postergar_excluido':  'The record was deleted in the schedule Time. Finish the occurrence.',
                    'ocorrencia_toast_horario_postergar_menor':     'Enter a time greater than the current time',
                    'ocorrencia_toast_configuracao_sucesso':        'Configuration successfully changed.',
                    'ocorrencia_toast_permissao_microfone':         'Check browser and computer settings',
                    'ocorrencia_toast_permissao_postergar_negada':  'You cannot end this occurrence because you are not allowed to postpone',
                    'ocorrencia_toast_tempo_observacao_invalido':   'Please enter a valid time',
                    'ocorrencia_toast_info_sistema_alterado':       'Information changed successfully',
                    'ocorrencia_toast_info_maunutencao_iniciada':   'Maintenance started successfully',
                    'ocorrencia_toast_info_maunutencao_revogada':   'Maintenance successfully revoked',
                    'ocorrencia_toast_info_maunutencao_prorrogada': 'Maintenance has been extended successfully',
                    'ocorrencia_setor_nao_possui_cameras':          'Sector does not have cameras',
                    'ocorrencias_modal_log_title':                  'Occurrence Logs',
                    'ocorrencias_modal_log_subtitle':               'Log inserted in the occurrence ',
                    'ocorrencias_modal_providencias_subtitle':      'For events of the type',
                    'ocorrencias_modal_anotacoes_subtitle':         'Temporary annotation expires in ',
                    'ocorrencias_modal_troca_usuario_title':        'User Data',
                    'ocorrencias_modal_aguardando_interacao':       'Events waiting for interaction',
                    'ocorrencias_tooltip_aviso_finalizar':          'Insert a comment or contact the client to finalize',
                    'ocorrencia_tooltip_aviso_observacao':          'Already in Observation',
                    'ocorrencia_tooltip_aviso_atendimento':         'Already in Attendance',
                    'ocorrencia_tooltip_aviso_processo':            'Already in Process',
                    'ocorrencia_tooltip_acao_usuario':              'Generated by the user',
                    'ocorrencia_tooltip_evento_gerado':             'Generated Event',
                    'ocorrencia_tooltip_imagem_disparo':            'Trigger location image',
                    'ocorrencia_tooltip_status':                    'Occurrence Status',
                    'ocorrencia_tooltip_video_pre_alarme':          'Pre Alarm',
                    'ocorrencia_tooltip_mqtt_desconectado':         'Disconnected',
                    'ocorrencia_tooltip_ativar':                     'Activate',
                    'ocorrencia_tooltip_ligar':                     'Turn on',
                    'ocorrencia_tooltip_desligar':                  'Turn off',
                    'ocorrencia_tooltip_anterior':                  'Previous',
                    'ocorrencia_tooltip_proximo':                   'Next',
                    'ocorrencia_tooltip_deve_estar_em_atendimento': 'Occurrence must be in attendance',
                    'localizacao_em':                               'Location of the vehicle in ',
                    'ultima_posicao':                               'Latest Position',
                    'ultima_1_hora':                                '1 Hour',
                    'ultimas_2_horas':                              '2 Hours',
                    'ultimas_3_horas':                              '3 Hours',
                    'status_veiculo_por_cor_red':                   'Off',
                    'status_veiculo_por_cor_blue':                  'Turned on in motion',
                    'status_veiculo_por_cor_green':                 'Turned on stationary',
                    'status_veiculo_por_status_desligado':          'Off',
                    'status_veiculo_por_status_em_movimento':       'Turned on in motion',
                    'status_veiculo_por_status_parado':             'Turned on stationary',
                    'ocorrencia_search_nenhum_resultado_encontrado':'No result',
                    'ocorrencia_search_buscar_sistema':             'Search for System',
                    'ocorrencia_search_buscar_contato':             'search contact',
                    'ocorrencia_search_sair_da_busca':              'Press ESC to close',
                    'ocorrencia_search_buscar_buscando':            'Searching',
                    'ocorrencia_search_selecionar_particao':        'Choose the partition to generate the manual event',
                    'ocorrencia_search_nao_ha_particao':            'There is no partition for manual event generation',
                    'ocorrencia_informacao_existe_chamada_em_andamento':'There is a call in progress',
                    'api_sistema_monitoramento_argumento_sistema':  'System',
                    'ocorrencia_botao_mostrar_log_cliente':         'Send to Client',
                    'ocorrencia_botao_push_log_cliente':            'Send via Push to Client',

                    /* Setores */
                    'ocorrencia_setores_legenda':                   'Legend',
                    'ocorrencia_setores_outros':                    'Other Sensor',
                    'ocorrencia_setores_ivp':                       'Infrared Sensor',
                    'ocorrencia_setores_magnetico':                 'Magnetic Sensor',
                    'ocorrencia_setores_optico':                    'Optical Sensor',
                    'ocorrencia_setores_sinal':                     'Signal Level',
                    'ocorrencia_setores_disparado':                 'Triggered',
                    'ocorrencia_setores_memoria':                   'Memory',
                    'ocorrencia_setores_inibido':                   'Inhibited',
                    'ocorrencia_setores_bateria_fraca':             'Low Battery',
                    'ocorrencia_setores_bateria_carregada':         'Battery',
                    'ocorrencia_setores_temperatura':               'Temperature',
                    'ocorrencia_setores_setor_24':                  'Sector 24hs',
                    'ocorrencia_setores_silencioso':                'Silent',
                    'ocorrencia_setores_interno':                   'Internal',
                    'ocorrencia_setores_aberto':                    'Open',
                    'ocorrencia_setores_tamper':                    'Tamper',
                    'ocorrencia_setores_falha_supervisao':          'Supervision failure',
                    'ocorrencia_setor_fechado':                     'Closed',
                    'ocorrencia_setor_aberto':                      'Open',
                    'ocorrencia_setores_perimetro':                 'Perimeter',
                    'ocorrencia_setores_curto':                     'In short',
                    'ocorrencia_chat_audio_enviado':                'New audio received',
                    'ocorrencia_painel_legenda_sensor_camera': 'Camera sensor',
                    'ocorrencia_painel_legenda_sensor_com_fio': 'Wired sensor',
                    'ocorrencia_painel_legenda_sensor_sem_fio': 'Wireless sensor',
                    'ocorrencia_painel_legenda_sensor_camera_analitico_on': 'Analytical On',
                    'ocorrencia_painel_legenda_sensor_camera_analitico_off': 'Analytical Off',
                    /* Setores */


                    /** comandos **/

                    "falha_comando_painel_desconectado":               "It was not possible to execute the command, the panel is disconnected.",
                    "falha_timeout_comando":                           "It was not possible to verify that the command was received successfully. Try to resend the command.",
                    "falha_erro_gerenerico":                           "Could not perform command",
                    "falha_arme_stay_recusado_zonas_externas_abertas": "Stay arm refused all external sectors are inhibited.",
                    "falha_inibir_zona_nao_inibido":                   "Sector cannot be inhibited.",
                    "falha_de_arme_todas_as_zonas_inibidas":           "It is not possible to arm with all sectors of the panel inhibited.",
                    "falha_inibir_zona_particao_armada":               "It was not possible to inhibit. There is an armed partition.",
                    "falha_senha_incorreta":                           "Incorrect or not registered password in the control panel.",
                    "falha_comando_invalido":                          "The control panel considered the command to be invalid.",
                    "falha_central_nao_particionada":                  "The plant is not partitioned.",
                    "falha_zonas_nao_cadastradas_abertas":             "The plant has one or more open sectors not registered. Contact technical support.",
                    "falha_comando_descontinuado":                     "This command is no longer supported by the current version of the panel.",
                    "falha_desinibir_zona_nao_desinibido":             "The sector could not be restored.",
                    "falha_arme_tempo_saida":                          "Arming failure with exit time.",
                    "falha_portao_ja_aberto":                          "Gate is already open",
                    "falha_portao_ja_fechado":                         "Gate is already closed",
                    "falha_spirit_nao_responde":                       "Communication failure: Spirit does not respond.",
                    "falha_spirit_sensor_nao_encontrada":              "Communication failure: Sensor not found.",
                    "falha_spirit_sensor_nao_responde":                "Communication failure: Sensor does not respond.",
                    "falha_spirit_nao_monitorada":                     "Communication failure: Spirit is not monitored.",
                    "falha_spirit_nao_existe":                         "Communication failure: Spirit does not exist.",
                    "falha_pgm_desabilitada":                          "PGM disabled.",
                    "falha_falha_arme_tamper":                         "Arming failure, tamper sensor.",
                    "falha_arme_inibindo_tamper":                      "Failure to arm inhibiting sectors, sector in tamper.",
                    "falha_arme_stay_tamper":                          "Failed to arm stay, sector in tamper.",
                    "falha_arme_stay_inibindo_tamper":                 "Failed to arm stay by inhibiting sectors, sector in tamper.",
                    "falha_sensor_offline":                            "Arming failure, sensor offline.",
                    "falha_inibindo_setores_setor_offline":            "Failure to arm inhibiting sectors, sensor offline.",
                    "falha_stay_sensor_offline":                       "Failed to arm stay, sensor offline.",
                    "falha_arme_stay_inibindo_offline":                "Failure to arm stay inhibiting sectors, sensor offline.",
                    "falha_de_arme_zonas_desabilitada":                "The following sector is disabled.",
                    "falha_de_arme_zonas_nao_inibivel":                "The command could not be executed. There is a sector that cannot be inhibited.",
                    "falha_de_desarme_particao_ja_desarmada":          "Panel is already disarmed",
                    "falha_de_arme_particao_ja_armado":                "Panel is already armed.",
                    "falha_de_arme_particao_ja_armado_stay":           "Panel is already armed stay.",
                    "falha_arme_setor_aberto_nao_listado":             "Failed to arm, there are open sectors. Try to arm again?",
                    "setores_externo_abertos":                         "Open external sectors",
                    "setores_abertos":                                 "Open sectors",
                    "comando_enviado_com_sucesso":                     "Command sent successfully",
                    "comando_nao_foi_enviado":                         "The command was not sent, please try again.",
                    "executando":                                      "Executing...",
                    "inibicao_nao_permitida_pois_central_esta_armada": "User is not allowed to arm inhibiting sectors because the control panel is already armed",
                    "usuario_sem_permissao_desarme":                   "User is not allowed to disarm",
                    "usuario_sem_permissao_inibir":                    "User is not allowed to arm by inhibiting sectors",
                    "powermanage_painel_desconectado":                 "The panel cannot receive the command, try again later.",
                    "falha_pgm_ja_acionada":                           "The device is already activated.",
                    "falha_pgm_ja_desligada":                          "The device is already disabled.",
                    "usuario_sem_permissao_comando":                   "You do not have permission to send command to device",

                    /** comandos **/
                    'modulo_painel_setor_camera_inativo': 'Inactive sector. The linked camera has the analytics function disabled',
                    'modulo_painel_modal_legenda_fechar': 'Close',

                     /** Ocorrência aba informações do Local */
                    'ocorrencia_informacoes_local_aba_titulo':      'Location Information',
                    'ocorrencia_informacoes_local_titulo_endereco': 'Address',
                    'ocorrencia_informacoes_local_observacao':      'Observation',
                    'ocorrencia_informacoes_local_complemento':     'Complement',
                    'ocorrencia_informacoes_local_salvar':          'Save',
                    'ocorrencia_informacoes_local_cancelar':        'Cancel',
                    /** Ocorrência aba informações do Local */

                     /**Fullcond */
                     'ocorrencia_fullcond_titulo_interfone': 'Intercoms',
                     'ocorrencia_fullcond_nao_ha_interfones_cadastrados': 'There are no intercoms registered',
                     'ocorrencia_fullcond_titulo_usuarios': 'Users',
                     'ocorrencia_fullcond_nao_ha_usuarios_cadastrados': 'There are no users registered',
                     'ocorrencia_fullcond_buscar_usuarios': 'Search Users'
                     /**Fullcond */
                    
            },
    });

var FullcenterEntrypointController = function(Auth, $state){
    if(Auth.isAuth()){
        $state.go("ocorrencias");
    } else{
        $state.go("login")
    }
}
FullcenterEntrypointController.$inject = ['Auth', '$state'];

var FullcenterEntrypointControllerConfig = function($stateProvider){
    $stateProvider.state('entrypoint', {
        url: '/entrypoint',
        controller:'FullcenterEntrypointController',
        allowAnonymous:true
    });
};
FullcenterEntrypointControllerConfig.$inject = ['$stateProvider'];

angular.module('Fullarm')
.controller('FullcenterEntrypointController', FullcenterEntrypointController)
.config(FullcenterEntrypointControllerConfig);
angular.module('Fullarm').controller('ChatController', function ($scope, $uibModal, ChatService, PopupWindowService, MqttService, OcorrenciaAtualService, MonitoramentoService) {

    $scope.srcPremImg = "";
    $scope.id_usuario_ftalk = MonitoramentoService.getIdUsuarioFtalk();
    $scope.fileObj = [];
    $scope.textoImagem = "";

    $scope.abreImagemChat = function(base64) {
        $("#taImagemChat").focus();
        $scope.srcPremImg = 'data:image/png;base64,'+base64;
        ChatService.setMostrarCorpoMensagem(false);
        ChatService.setMostrarPreImagem(true);
    };

    $scope.fecharPreImagem = function(){
        $scope.srcPremImg = "";
        ChatService.setMostrarCorpoMensagem(true);
        ChatService.setMostrarPreImagem(false);
        ChatService.rolarParaBaixo();
    };

    $scope.enviarMensagemTexto = function(){
        enviarMensagem();
    };

    $scope.enviarImagemMensagem = function(){
        $scope.fecharPreImagem();
        ChatService.setMessageType(1);
        enviarMensagem();
    };

    $scope.minimizarChat = function(){
        ChatService.fechaConversaChat();
        ChatService.setMostrarPreImagem(false);
    };

    $(document).on('keypress', '.text-box', function (e) {
        if(e.keyCode === 13)            {
            event.preventDefault();
            if(ChatService.getMostrarPreImagem()){
                ChatService.setMessageType(1);
                $scope.fecharPreImagem();
            }
            enviarMensagem();
        }
    });

    $scope.onLoad = function (e, reader, file, fileList, fileOjects, fileObj) {
        $scope.abreImagemChat(fileObj.base64);
        $scope.fileObj = fileObj;
        $("#file").val("");
    };

    $(document).on('click', '.imgChat', function (e) {
        var options = {
            height: window.outerHeight * 80 / 100,
            width: window.outerWidth * 80 / 100,
            left: window.outerWidth * 10 / 100,
            top: window.outerHeight * 10 / 100,
            url:this.src
        };
        PopupWindowService.openPopupWindow(options);
    });

    function enviarMensagem() {
        var userInput = "";
        var nome_arquivo = "";
        var file = "";
        var newMessage = "";

        if (!angular.isUndefined($scope.fileObj.base64) && $scope.fileObj.base64 != "" && ChatService.getMessageType() === 1) {
            newMessage = $scope.textoImagem;
            $scope.textoImagem = "";
        } else {
            userInput = $('#txb_' + OcorrenciaAtualService.getIdOcorrenciaAtual());
            newMessage = userInput.html().replace(/&nbsp;/gi,'').replace(/\<div\>|\<br.*?\>/ig, '\n').replace(/\<\/div\>/g, '').trim().replace(/\n/g, '<br>');
            userInput.html('');
            userInput.focus();
        }

        nome_arquivo = moment().format("YYYY-MM-DD_HH:mm:s");

        ChatService.adicionarParticipanteNaConversa(OcorrenciaAtualService.getIdOcorrenciaAtual()).then(function () {
            if(ChatService.getMessageType() != 3){
                ChatService.enviarArquivoChat($scope.fileObj, nome_arquivo).then(function () {
                    MqttService.publicarMensagemMqtt(newMessage, file, nome_arquivo);
                    ChatService.enviarMensagemPush(newMessage);
                    setTimeout(function(){
                        ChatService.setMessageType(3);
                    },500);
                });
                file = $scope.fileObj;
                $scope.fileObj = [];
            }else{
                if(newMessage){
                    MqttService.publicarMensagemMqtt(newMessage, file, nome_arquivo);
                    ChatService.enviarMensagemPush(newMessage);
                }
            }
        });
    }

    $scope.openModalConfigChat = function () {
        $scope.modalConfigChat = $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/modals/chatConfigModal.html',
            size: 'sm',
            controller:'ChatConfigController',
            scope:$scope
        });
    };

}).config(function (recorderServiceProvider) {
    recorderServiceProvider.forceSwf(false).withMp3Conversion(true);
});
angular.module('Fullarm').controller('ChatConfigController', function ($scope, $rootScope, $uibModal, ChatService) {

    $scope.setInitConfig = function(){
        $scope.tamanhoFonte = userOption.font_size_chat;
        $scope.corMsg = userOption.cor_mensagem_chat;
        $scope.corMsgFundo = userOption.cor_fundo_mensagem_chat ===  'rgba(25, 147, 147, 0.2)' ? '#199393' : userOption.cor_fundo_mensagem_chat;
        $scope.corFundoChat = userOption.cor_fundo_chat === '-webkit-linear-gradient(-45deg,#c8d3dc 0,#bad0e0 25%,#bbc9dc 50%,#4f535d 75%,#1e1f22 100%)' ? '#4f535d' : userOption.cor_fundo_chat;
    };

    $scope.alteraFonte = function(){
        ChatService.removeClassFontSize();
        ChatService.addClassFontSize($scope.tamanhoFonte);
    };

    $scope.alteraCorMensagem = function(){
        $('.textoChat').css('color', $scope.corMsg);
        $('.dataMensagemChat a').css('color', $scope.corMsg);
    };

    $scope.alteraCorFundoMsg = function(){
        $('.floating-chat .chat .messages li').css('background-color', $scope.corMsgFundo);
        $('.dataMensagemChat p').css('background-color', $scope.corMsgFundo);

        if(tinycolor($scope.corMsgFundo).isLight()){
            $('.descricao_login').css('color', '#000000');
            $('.horaChat').css('color', '#000000');
        }else{
            $('.descricao_login').css('color', '#ffffff');
            $('.horaChat').css('color', '#ffffff');
        }
    };

    $scope.alteraCorFundoChat = function(){
        $('.floating-chat').css('background', $scope.corFundoChat);
        $('.floating-chat').css('background-repeat', 'no-repeat');
        $('.floating-chat').css('background-attachment', 'fixed');
        $rootScope.fundoIsLight = tinycolor($scope.corFundoChat).isLight();
        if(tinycolor($scope.corFundoChat).isLight()){
            $('#iConfig').css('color', '#000000');
            $('#iClose').css('color', '#000000');
            $('.floating-chat .chat .header .title').css('color', '#000000');
        }else{
            $('#iConfig').css('color', '#ffffff');
            $('#iClose').css('color', '#ffffff');
            $('.floating-chat .chat .header .title').css('color', '#ffffff');
        }
    };

    $scope.salvarConfiguracao = function(){
        var data = {
            cor_mensagem_chat:       $scope.corMsg,
            cor_fundo_chat:          $scope.corFundoChat,
            cor_fundo_mensagem_chat: $scope.corMsgFundo,
            font_size_chat:          $scope.tamanhoFonte,
            id:                      parseInt(userOption.id)
        };
        ChatService.updateConfigChat(data);
    };

    $scope.cancelarConfiguracao = function(){
        ChatService.cancelarConfiguracao();
        ChatService.removeClassFontSize();
        $scope.setInitConfig();
    };

    $scope.setInitConfig();
});
/**
 * @author Fullarm
 * created on 27.08.2018
 */
(function () {

    'use strict';
    angular.module('Fullarm').controller('InformacoesOcorrenciaController', function ($scope,
                                                                                      PainelService,
                                                                                      VeiculosProximosService,
                                                                                      RastreadosService,
                                                                                      OcorrenciaAtualService,
                                                                                      InformacoesOcorrenciaService,
                                                                                      FullcondService,
                                                                                      VideosService, debounce) {

        $scope.screenLoadedId = 'tab';   
        
        function selecionarAba(tab, key){
            var tab = $scope.tab;
            var key = $scope.key;
            
            InformacoesOcorrenciaService.setCurrentIndex(key);
            PainelService.setAbaPainelSelecionada(false);
            switch (tab){
                case "rastreados":
                    $scope.buscaRastreados();
                break;
                case "veiculos_proximos":
                    $scope.buscaEndereco();
                break;
                case "painel":
                    PainelService.setAbaPainelSelecionada(true);
                break;
                case 'videos':
                    VideosService.buscarCamerasOcorrencia($scope.ocorrenciaAtual.id_sistema, $scope.ocorrenciaAtual.sistema.tipo_video)
                break;
                case "informacoes_local":
                    $scope.createLog = true;
                    $scope.$broadcast('informacoesDoLocal.tab.loadData',$scope.ocorrenciaAtual.id_sistema);
                break;
                case "modulo_fullcond":
                    FullcondService.loadContacts($scope.ocorrenciaAtual.id_sistema);
                break;
            }

        }
        $scope.acaoTabSelecionada = function (tab, key) {
            $scope.tab = tab;
            $scope.key = key;
            debounce(selecionarAba, 300);
        };

        $scope.buscaEndereco  = function () {
            VeiculosProximosService.buscarEnderecoPorLatLong();
        };

        $scope.buscaRastreados = function () {
            setTimeout(function () {
                RastreadosService.buscarUltimaPosicaoDeVeiculos(OcorrenciaAtualService.getSistema());
            },1000);
        };

    });
})();


var LoginController = function($scope, Auth, $state, LoginRequest, loginErrorCodes, customData){
    
    function goToInitialPage(){
        $state.go("ocorrencias");
    }

    if(Auth.isAuth()){
        goToInitialPage();
    } 

    $scope.customData = customData;
    $scope.warningMessages = {};
    $scope.showPassword = false;
    
    $scope.login = function(user,password){
        $scope.warningMessages = {};
        LoginRequest.login(user,password)
        .then(function(){
            goToInitialPage();
        })
        .catch(function(e){
            if(e.code == loginErrorCodes.UNKNOWN){

            }

            if(e.code == loginErrorCodes.INVALID_DATA){
                var errors = e.data;
                Object.keys(errors).forEach(function(key){
                    var error = errors[key];
                    $scope.warningMessages[key] = error;
                });
            }
        })
    }

    $scope.showHidePassword = function(){
        $scope.showPassword = !$scope.showPassword;
    }
}

LoginController.$inject = ['$scope','Auth','$state','LoginRequest','loginErrorCodes','customData'];

var LoginControllerConfig = function($stateProvider, $translateProvider, loginTranslateMessages){
    $translateProvider.translations('pt-BR', loginTranslateMessages.pt);
    $translateProvider.translations('es', loginTranslateMessages.es);
    $translateProvider.translations('en', loginTranslateMessages.en);

    $stateProvider.state('login', {
        url: '/login',
        templateUrl:'app/modules/login/login.html',
        controller:'LoginController',
        allowAnonymous:true,
        resolve: {
            'customData': ['LoginRequest','$location',function(LoginRequest,$location){      
                return LoginRequest.loadLoginCustom($location.host())
                .then(function(customData){
                    return customData;
                })
                .catch(function(customDataFallbakc){
                    return customDataFallbakc;
                });
            }]
        }
    });
}

LoginControllerConfig.$inject = ['$stateProvider','$translateProvider','loginTranslateMessages'];

angular.module('Fullarm')
.controller('LoginController', LoginController)
.config(LoginControllerConfig);
angular.module('Fullarm')
.constant('loginErrorCodes',{
    'OFFLINE':1,
    'UNKNOWN':2,
    'INVALID_DATA':3,
    'UNAUTHORIZED':4
});

var LoginRequest = function($q, $http,$httpParamSerializer, constant, loginErrorCodes){

    return {
        login:function(user,password) {
            
            var deferred = $q.defer();
        
                $http({
                    url : constant.BASE_URL + '/api/v1/login/check',
                    method : "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    data:$httpParamSerializer({
                        'username': user,
                        'password': password
                    })
                })
                .then(function(resp){
                    if(resp.status == 204){
                        deferred.resolve({code: 0,data:'OK'});
                    }
                    var error = {code: loginErrorCodes.UNAUTHORIZED, data: 'login_fullcenter_error_msg_unauthorized'}
                    deferred.reject(error);
                })
                .catch(function(e){
                    var  error = '';
                    switch (e.status){
                        case 0 /* offline */:
                            error = {code: loginErrorCodes.OFFLINE, data: 'login_fullcenter_error_msg_offline'}
                        break;
                        case 400 /* Bad Request */:
                            error = {code: loginErrorCodes.INVALID_DATA, data: e.data.erros}
                        break;
                        case 401 /* Unauthorized */:
                            error = {code: loginErrorCodes.UNAUTHORIZED, data: 'login_fullcenter_error_msg_unauthorized'}
                        break;
                        case 500 /* error */:
                        default:
                            var genericErroMessage = 'login_fullcenter_error_msg_unknown';
                            var errorData = e.data
                            var errorMessage = errorData ? (errorData.erro || genericErroMessage) : genericErroMessage; 
                            error = {code: loginErrorCodes.UNKNOWN, data: errorMessage}
                        break;
                    }

                    deferred.reject(error);
                });

            return deferred.promise;
        },
        loadLoginCustom:function(host) {
    
            var deferred = $q.defer();
        
            $http({
                url : constant.BASE_URL + '/api/v1/fullcenter/login-custom',
                method : "GET",
                data: {
                    'host':host
                }
            }).then(function(resp){
                var customData = resp.data;
                deferred.resolve(customData)
            })
            .catch(function(e){
                customData = {
                    "appname": "FullCenter"
                }
                deferred.reject(customData);
            });
    
            return deferred.promise;
        }
    }
};

LoginRequest.$inject = ['$q','$http','$httpParamSerializer','constant','loginErrorCodes'];

angular.module('Fullarm')
.factory('LoginRequest', LoginRequest)
angular.module('Fullarm')
.constant('loginTranslateMessages',{
        'pt':{
            'login_fullcenter_user': 'Usuário',
            'login_fullcenter_email': 'Email',
            'login_fullcenter_password': 'Senha',
            'login_fullcenter_login': 'Entrar'
        },
        'en':{
            'login_fullcenter_user': 'User',
            'login_fullcenter_email': 'Email',
            'login_fullcenter_password': 'Password',
            'login_fullcenter_login': 'Enter'
        },
        'es':{
            'login_fullcenter_user': 'Usuario',
            'login_fullcenter_email': 'Mail',
            'login_fullcenter_password': 'Contraseña',
            'login_fullcenter_login': 'Entrar'
        }
});


/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
          $scope.$watch('values', function (value) {
              $timeout(function () {
                  $element.data("ionRangeSlider").update({values: value});
              });
          });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('Fullarm.theme')
        .directive('imageOnload', imageOnload);

    /** @ngInject */
    function imageOnload() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.bind('load', function() {
                    scope.$apply(attrs.imageOnload);
                });
            }
        };
    }

})();
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          //elem.addClass('animated zoomIn');
          elem.addClass('');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('Fullarm.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
angular.module('Fullarm').service('AcaoUsuarioService', function (AcaoUsuarioFactory, ToastMessageService, $q) {
    var deferred = $q.defer();
    return{
        inserirTentativaContato: function(params) {
            AcaoUsuarioFactory.inserirLogTentativaContato(params, function (result) {
                deferred.resolve(result);
            },
            function (error) {
                ToastMessageService.showErrorMenssage(error);
            });
            return deferred.promise;
        },

        finalizarContato: function(params) {
            AcaoUsuarioFactory.inserirLogFinalizarContato(params, function (result) {
                deferred.resolve(result);
            },
            function (error) {
                ToastMessageService.showErrorMenssage(error);
            });
            return deferred.promise;
        },

        inserirLogAcaoUsuario: function(params){
            AcaoUsuarioFactory.inserirLogAcaoUsuario(params, function (result) {
                deferred.resolve(result);
            }, function (error) {
                ToastMessageService.showErrorMenssage(error);
            });
            return deferred.promise;
        },

        inserirLogSolicitacaoOrdemServico:function (params) {
            AcaoUsuarioFactory.inserirLogOrdemServico(params, function (result) {
                deferred.resolve(result);
            }, function (error) {
                ToastMessageService.showErrorMenssage(error);
            });
            return deferred.promise;
        },

        inserirLogHorarioPotergado:function (params) {
            AcaoUsuarioFactory.inserirLogHorarioPotergado(params, function (result) {
                deferred.resolve(result);
            }, function (error) {
                ToastMessageService.showErrorMenssage(error);
            });
            return deferred.promise;
        },

        inserirLogAutomacaoAcionada: function(params){
            AcaoUsuarioFactory.inserirLogAutomacaoAcionada(params, function (result) {
                return result;
            }, function (error) {
                ToastMessageService.showErrorMenssage(error);
            });
        },
    }

});
angular.module('Fullarm').service('AnotacoesTemporariasService', function () {

    var _scope = {};
    var $this;
    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.anotacoesTemporarias = [];
            _scope.exibeAnotacoes = false;
        },

        setAnotacoesTemporarias: function (objAnotacoesTemporarias) {
            _scope.anotacoesTemporarias = objAnotacoesTemporarias;
            _scope.exibeAnotacoes = objAnotacoesTemporarias.length > 0;
            $this.setOpenCloseTab(_scope.exibeAnotacoes);
        },

        setOpenCloseTab:function (openClose) {
            _scope.status_8.open = openClose;
        }

    }

});
angular.module('Fullarm').service('AutomacaoService', function (AutomacaoFactory, ToastMessageService, AcaoUsuarioService, PainelService, painelConstants) {
    var _scope = {};
    var $this;
    return {
        setScope: function (scope) {
            _scope = scope;
            $this = this;
            _scope.dispositivos = [];
            _scope.mostraPortao = false;
            _scope.mostraPgm = false;
            _scope.comandosDispositivosEnviados = [];
            _scope.comandosDispositivosRecebidos = [];
        },

        conectaTopicoAutomacao:function(id_sistema){
            _scope.client.subscribe("sistema/"+id_sistema+"/dispositivo/#", {qos: 2});
            _scope.client.subscribe("sistema/"+id_sistema+"/sonoff/#", {qos: 2});
            _scope.client.subscribe("sistema/"+id_sistema+"/pgm/#", {qos: 2});
            _scope.client.subscribe("sistema/"+id_sistema+"/rele/#", {qos: 2});
            _scope.client.subscribe("sistema/"+id_sistema+"/portao/#", {qos: 2});
        },

        atualizaInformacoesAutomacaoSononff: function(destinationName, msg){
            const regex = new RegExp('^sistema\\/(?<idSistema>\\d{1,})\\/sonoff\\/(?<id>\\d{1,})\\/(?<propriedade>.*)','gm');
            var atributos = regex.exec(destinationName);

            if(atributos != null && !angular.isUndefined(_scope.dispositivos[atributos.groups.id])){
                _scope.dispositivos[atributos.groups.id][atributos.groups.propriedade] = msg.payloadString == "true" ? true : false;
                $("#sonoff_"+atributos.groups.id).hide("");
                $(".icon_sonoff_"+atributos.groups.id).show("");
            }
            _scope.$apply();
        },

        atualizaInformacoesAutomacaoEwelink: function(destinationName, msg){
            const regex = new RegExp('^sistema\\/(?<idSistema>\\d{1,})\\/dispositivo\\/(?<id>\\d{1,})\\/(?<propriedade>.*)','gm');
            var atributos = regex.exec(destinationName);

            if(atributos != null && _scope.dispositivos[atributos.groups.id] != undefined){
                _scope.dispositivos[atributos.groups.id][atributos.groups.propriedade] = msg.payloadString == "true" ? true : false;
                $("#dispositivo_"+atributos.groups.id).hide("");
                $(".icon_dispositivo_"+atributos.groups.id).show("");
            }
            _scope.$apply();
        },

        atualizaInformacoesAutomacaoPgm: function(destinationName, msg){
            const regex = new RegExp('^sistema\\/(?<idSistema>\\d{1,})\\/pgm\\/(?<id>\\d{1,})','gm');
            var atributos = regex.exec(destinationName);
            if(atributos != null && !angular.isUndefined(_scope.dispositivos[atributos.groups.id])){
                _scope.dispositivos[atributos.groups.id]["ligada"] = msg.payloadString == "true" ? true : false;
                $("#pgm_"+atributos.groups.id).hide("");
                $(".icon_pgm_"+atributos.groups.id).show("");
            }
            _scope.$apply();
        },

        atualizaInformacoesAutomacaoRele: function(destinationName, msg){
            const regex = new RegExp('^sistema\\/(?<idSistema>\\d{1,})\\/rele\\/(?<id>\\d{1,})','gm');
            var atributos = regex.exec(destinationName);
            if(atributos != null && !angular.isUndefined(_scope.dispositivos[atributos.groups.id])){
                _scope.dispositivos[atributos.groups.id]["ligado"] = msg.payloadString == "true" ? true : false;
                $("#rele_"+atributos.groups.id).hide("");
                $(".icon_rele_"+atributos.groups.id).show("");
            }
            _scope.$apply();
        },

        atualizaInformacaoPortao: function(destinationName, msg){
            if(!angular.isUndefined(_scope.dispositivos[msg.id_sensor])){
                _scope.dispositivos[msg.id_sensor]['aberto'] = msg.aberto;
                _scope.$apply();
            }
        },

        setDispositivos:function (dispositivos) {
            var arrDispositivos = {};
            if(dispositivos.length > 0){
                angular.forEach(dispositivos, function (dispositivo) {
                    arrDispositivos[dispositivo.id] = dispositivo;
                });
                _scope.dispositivos = arrDispositivos;
            }
            $this.verificaDispositivos(dispositivos);
        },

        verificaDispositivos:function(dispositivos){
            var pgm = null;
            var portao = null;
            pgm = dispositivos.find(function (item) {
                return item.dispositivo == 'pgm' || item.dispositivo == 'Rele' || item.dispositivo == 'sonoff' || item.dispositivo == 'dispositivo';
            });
            portao = dispositivos.find(function (item) {
                return item.dispositivo == 'portao';
            });
            _scope.mostraPortao = !angular.isUndefined(portao) && portao.dispositivo == 'portao' && _scope.ocorrenciaAtual.existe_permissao_visualizar.existe_visualizar_portao;
            _scope.mostraPgm = !angular.isUndefined(pgm) && (pgm.dispositivo == 'pgm' || pgm.dispositivo == 'Rele' || pgm.dispositivo == 'sonoff' || pgm.dispositivo == 'dispositivo') && _scope.ocorrenciaAtual.existe_permissao_visualizar.existe_visualizar_dispositivos;
        },

        esvaziaAutomacao:function(){
            _scope.dispositivos = [];
        },

        enviaComandoDispositivo:function (comando, item) {
            var id = item.id;
            $(".icon_"+item.dispositivo+"_"+id).hide("");
            $("#"+item.dispositivo+"_"+id).show("");

            AutomacaoFactory.enviarComandoDispositivo($this.getParam(parseInt(comando), item), function (success) {
                ToastMessageService.showSuccessMenssage(success.data.msg, "");
                _scope.comandosDispositivosEnviados.push(success.data.status);
                $this.verificaResultadoComandoDispositivo(success.data.status.id);
                AcaoUsuarioService.inserirLogAcaoUsuario($this.preparaObjetoLogAutomacao(item.dispositivo, id, comando));
            }, function(error){
                ToastMessageService.showErrorMenssage(error);
            });
        },

        preparaObjetoLogAutomacao: function(dispositivo, id, comando){
            return {
                acao_usuario: 'AUTOMACAO_ACIONADA',
                ocorrencia: _scope.ocorrenciaAtual.id_ocorrencia,
                comando: (comando == painelConstants.Comandos.ACIONAR_PGM || comando == painelConstants.Comandos.ACIONAR_SONOFF
                    || comando == painelConstants.Comandos.ABRIR_PORTAO || comando == painelConstants.Comandos.LIGAR_TOMADA) ? 'aciona' : 'desaciona',
                descricao:  _scope.dispositivos[id].descricao,
                id_dispositivo: id,
                dispositivo: dispositivo == "sonoff" ? "pgm" : dispositivo
            };
        },

        verificaResultadoComandoDispositivo: function (id) {
            if(_scope.comandosDispositivosRecebidos.length > 0){
                angular.forEach(_scope.comandosDispositivosRecebidos, function (comando) {
                    if(comando.id == id){
                        $this.executaResultadoComandoDispositivo(comando);
                    }
                });
            }
        },

        recebeResultadoComandoDispositivo: function (destinationName, resultado) {
            const regex = new RegExp('^sistema\\/(?<idSistema>\\d{1,})\\/(?<dispositivo>.*)\\/(?<idDispositivo>\\d{1,})\\/comando\\/(?<idComando>\\d{1,})','gm');
            var atributos = regex.exec(destinationName);
            if(atributos != null && !angular.isUndefined(atributos)){
                resultado.id = atributos.groups.idComando;
                resultado.id_dispositivo = atributos.groups.idDispositivo;
                resultado.tipo_dispositivo = atributos.groups.dispositivo;
                _scope.comandosDispositivosRecebidos.push(resultado);
                if(_scope.comandosDispositivosEnviados.length > 0){
                    angular.forEach(_scope.comandosDispositivosEnviados, function(comando){
                        if(comando.id == atributos.groups.idComando){
                            $this.executaResultadoComandoDispositivo(resultado);
                        }
                    });
                }
            }
        },

        executaResultadoComandoDispositivo:function (resultado) {
            if(!angular.isUndefined(resultado)){
                switch(resultado.status){
                    case 0:
                    case 1:
                    case 2:
                        $("#"+resultado.tipo_dispositivo+"_"+resultado.id_dispositivo).show("");
                        $(".icon_"+resultado.tipo_dispositivo+"_"+resultado.id_dispositivo).hide("");
                        return;
                    case 3:
                        $("#"+resultado.tipo_dispositivo+"_"+resultado.id_dispositivo).hide("");
                        $(".icon_"+resultado.tipo_dispositivo+"_"+resultado.id_dispositivo).show("");
                        ToastMessageService.showSuccessMenssage(painelConstants.StatusComando[resultado.status], "");
                        return;
                }

                if(!angular.isUndefined(painelConstants.StatusComando[resultado.status])){
                    $("#"+resultado.tipo_dispositivo+"_"+resultado.id_dispositivo).hide("");
                    $(".icon_"+resultado.tipo_dispositivo+"_"+resultado.id_dispositivo).show("");
                    ToastMessageService.showErrorMenssageWeb(painelConstants.StatusComando[resultado.status]);
                }
            }
        },

        getParam:function(comando, item){
            var param = {"comando": comando};
            switch(comando){
                case painelConstants.Comandos.ACIONAR_PGM:
                case painelConstants.Comandos.DESACIONAR_PGM:
                    if(item.dispositivo == "Rele"){
                        param.idRele = parseInt(item.id);
                    }else{
                        param.idPgm = parseInt(item.id);
                    }
                break;
                case painelConstants.Comandos.DESLIGAR_TOMADA:
                case painelConstants.Comandos.LIGAR_TOMADA:
                     param.idDispositivo = parseInt(item.id);
                     param.tipo_periferico = 7;
                     param.comando = comando === painelConstants.Comandos.DESLIGAR_TOMADA ? painelConstants.Comandos.DESACIONAR_SONOFF : painelConstants.Comandos.ACIONAR_SONOFF;
                break;
                case painelConstants.Comandos.ACIONAR_SONOFF:
                case painelConstants.Comandos.DESACIONAR_SONOFF:
                     param.idDispositivo = parseInt(item.id);
                break;
                case painelConstants.Comandos.ABRIR_PORTAO:
                case painelConstants.Comandos.FECHAR_PORTAO:
                    param.idSistemaPortao = parseInt(item.id);
                break;
            }
            return param;
        },

        criarModalPostergacao: function () {
            $(function(){
                $("#modal-comando-portao").iziModal({
                    padding: 30,
                    width: '20%',
                    transitionIn: 'fadeInUp',
                    transitionOut: 'fadeOutDown'
                })
            });
        }
    }
});
angular.module('Fullarm').service('CarregamentoOcorrenciaService', function ($rootScope, $timeout, ChatService, PainelService, OcorrenciasService, OcorrenciaAtualService,
                                                                             MonitoramentoService, LogService, VideoFrameService, VideosService, InformacoesOcorrenciaService,
                                                                             VeiculosProximosService, AutomacaoService, LoginService, ViaturasService, ManutencaoSistemaService,
                                                                             MapaService, StatusService, constant, ConfigService) {

    var _scope = {};
    var $this;
    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            $rootScope.$dadosFinishedLoading = true;
            _scope.index = 0;
            _scope.idsLogins = [];
        },

        carregaOcorrencia:function(idOcorrencia, botoes){
            $rootScope.$dadosFinishedLoading = false;
            if(idOcorrencia !== ""){
                OcorrenciasService.listaOcorrenciaPorId(idOcorrencia).then(function(result){
                    OcorrenciaAtualService.setOcorrenciaAtual(result).then(function () {
                        if (!$rootScope.$dadosFinishedLoading) {
                            $rootScope.$dadosFinishedLoading = true;
                        }
                    }, function(){
                        $rootScope.$dadosFinishedLoading = true;
                    });

                    $rootScope.tab_informacoes_ocorrencia = 0;
                    MonitoramentoService.habiltaBotaoFinalizar(result.pode_finalizar);
                    MonitoramentoService.setBotoes(botoes);
                    LogService.listarLogsOcorrencia(result.id_ocorrencia).then(function () {}, function () {});
                    $this.carregarRotasFpatrol(result.id_sistema);
                    MapaService.setObjSistema(result.sistema);

                    if(result.conversas != null && result.conversas.length > 0){
                        ChatService.getConversasPorIds(result.conversas);
                    }

                    if(MonitoramentoService.getPermissaoFullarmFulltrack()){
                        VeiculosProximosService.setSistema(result.sistema);
                        VeiculosProximosService.setEnderecoSistema(result.sistema.endereco);
                        if(!angular.isUndefined(result.sistema.endereco.latitude) && result.sistema.endereco.latitude != 0){
                            VeiculosProximosService.buscarVeiculosProximos(result.sistema.endereco);
                        }
                    }

                    _scope.ocorrenciaTabs.length = 0;
                    InformacoesOcorrenciaService.organizaAbasOcorrencia(result);
                    PainelService.conectaTopicoPainel(result.sistema.painel_virtual, result.id_sistema);
                    ChatService.conectaTopicoChat(result.conversas, result.id_monitoramento);
                    AutomacaoService.conectaTopicoAutomacao(result.id_sistema);
                    ManutencaoSistemaService.conectaTopicoManutencao(result.id_sistema);
                }, function () {
                    $rootScope.$dadosFinishedLoading = true;
                });
            }
        },

        carregarRotasFpatrol:function(id_sistema){
            if(permissoes.fpatrol && permissoes.rota && permissoes.viatura){
                LoginService.getLoginsPorRotasDoSistema(id_sistema).then(function(logins){
                    if(logins.data.length){
                        angular.forEach(logins.data, function(login){
                            _scope.idsLogins.push(login.id);
                        });
                        ViaturasService.buscarViaturasPorLoginsDaRota(_scope.idsLogins, true);
                        ViaturasService.conectaTopicoRotas(id_sistema);
                        ViaturasService.conectaTopicoViaturas(_scope.idsLogins);
                    }
                    _scope.idsLogins = [];
                });
            }
        },

        selecionaOcorrencia: function(upDown){
            if(_scope.abaPainelSelecionada){
                return;
            }
            event.preventDefault();
            var proximoId = "";
            $(".div_ocorrencia").each(function() {
                  if($("#"+$(this).attr('id')).hasClass('item-selecionado')){
                      proximoId = upDown === 'down' ? $("#"+$(this).attr('id')).next().attr('id') : $("#"+$(this).attr('id')).prev().attr('id');
                  }
            });
            if(!angular.isUndefined(proximoId) && proximoId !== ""){
                $("#"+$(this).attr('id')).removeClass('item-selecionado');
                OcorrenciasService.buscarOcorrenciaIndice(proximoId).then(function(indice){
                    var prioridadeText = OcorrenciasService.buscaOcorrenciaPorPrioridade(indice.prioridade);
                    var statusText =  OcorrenciasService.buscaOcorrenciaPorStatus(indice.status);
                    var botoes = $this.getBotoesOcorrenciaPorId(statusText, prioridadeText, proximoId);
                    OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                    $this.carregaOcorrencia(proximoId, botoes);
                });
            }else if(angular.isUndefined(OcorrenciaAtualService.getIdOcorrenciaAtual())){
                $this.verificaPrimeiraOcorrenciaPorStatus(_scope.statusSelecionado);
            }
        },

        getBotoesOcorrenciaPorId:function(statusText, prioridadeText, id){
            var arrOcorrencia = [];
            arrOcorrencia = _scope.ocorrencias[statusText][prioridadeText].find(function (ocorrencia) {
                return ocorrencia.id_ocorrencia === id;
            });
            return arrOcorrencia.botoes;
        },

        carregaOcorrenciaComBotoesValidados:function(idOcorrencia){
            OcorrenciasService.buscarOcorrenciaIndice(idOcorrencia).then(function(indice){
                var prioridadeText = OcorrenciasService.buscaOcorrenciaPorPrioridade(indice.prioridade);
                var statusText =  OcorrenciasService.buscaOcorrenciaPorStatus(indice.status);
                var botoes = $this.getBotoesOcorrenciaPorId(statusText, prioridadeText, idOcorrencia);
                OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                $this.carregaOcorrencia(idOcorrencia, botoes);
            });
        },

        verificaOcorrenciasComPrioridadeAltaEmEspera:function(){
            var idOcorrencia = "";
            var botoes = [];
            if(!angular.isUndefined(_scope.ocorrencias.em_espera)){
                if(_scope.ocorrencias.em_espera.quantidade > 0 && !angular.isUndefined(_scope.ocorrencias.em_espera.alta) && _scope.ocorrencias.em_espera.alta.length > 0){
                    idOcorrencia = _scope.ocorrencias.em_espera.alta[0].id_ocorrencia;
                    botoes = _scope.ocorrencias.em_espera.alta[0].botoes;
                }else if(_scope.ocorrencias.em_espera.quantidade > 0 && !angular.isUndefined(_scope.ocorrencias.em_espera.media) && _scope.ocorrencias.em_espera.media.length > 0){
                    idOcorrencia = _scope.ocorrencias.em_espera.media[0].id_ocorrencia;
                    botoes       = _scope.ocorrencias.em_espera.media[0].botoes;
                }else if(_scope.ocorrencias.em_espera.quantidade > 0 && !angular.isUndefined(_scope.ocorrencias.em_espera.baixa) && _scope.ocorrencias.em_espera.baixa.length > 0){
                    idOcorrencia = _scope.ocorrencias.em_espera.baixa[0].id_ocorrencia;
                    botoes       = _scope.ocorrencias.em_espera.baixa[0].botoes;
                }

                if(idOcorrencia !== ""){
                    $this.carregaOcorrencia(idOcorrencia, botoes);
                }
            }
        },

        verificaPrimeiraOcorrenciaPorStatus:function(statusInt){
            var idOcorrencia = "";
            var botoes = [];
            status = OcorrenciasService.buscaOcorrenciaPorStatus(statusInt);

            if(!angular.isUndefined(_scope.ocorrencias[status])){

                if(_scope.ocorrencias[status].quantidade > 0 && !angular.isUndefined(_scope.ocorrencias[status].alta) && _scope.ocorrencias[status].alta.length > 0){
                    idOcorrencia = _scope.ocorrencias[status].alta[0].id_ocorrencia;
                    botoes = _scope.ocorrencias[status].alta[0].botoes;
                }else if(_scope.ocorrencias[status].quantidade > 0 && !angular.isUndefined(_scope.ocorrencias[status].media) && _scope.ocorrencias[status].media.length > 0){
                    idOcorrencia = _scope.ocorrencias[status].media[0].id_ocorrencia;
                    botoes       = _scope.ocorrencias[status].media[0].botoes;
                }else if(_scope.ocorrencias[status].quantidade > 0 && !angular.isUndefined(_scope.ocorrencias[status].baixa) && _scope.ocorrencias[status].baixa.length > 0){
                    idOcorrencia = _scope.ocorrencias[status].baixa[0].id_ocorrencia;
                    botoes       = _scope.ocorrencias[status].baixa[0].botoes;
                }

                if(idOcorrencia !== ""){
                    $this.carregaOcorrencia(idOcorrencia, botoes);
                }
            }
        },

        setStatusSelecionado:function(status){
            _scope.statusSelecionado = status;
        },

        finalizaOcorrencia: function () {
            var id = _scope.ocorrenciaAtual.id_ocorrencia;
            var statusFinalizadoParams = {
                ocorrencia: id,
                status: constant.STATUS.FINALIZADO
            };

            if(_scope.mensagemMotivoAlarme !== ""){
                statusFinalizadoParams.motivo = _scope.mensagemMotivoAlarme;
            }
            StatusService.alterarStatus(statusFinalizadoParams).then(function (result) {
                statusFinalizadoParams = [];
                _scope.mensagemMotivoAlarme = "";
                $this.resultadoOcorrenciaFinalizada(id);
            });
        },

        resultadoOcorrenciaFinalizada: function(id){
            OcorrenciasService.contaQuantidadeEventosOcorrenciaAnterior(id).then(function(statusAnterior) {
                OcorrenciasService.verificaQuantidadeEventosPorStatusOcorrencia(statusAnterior)
            });
            OcorrenciasService.finalizarOcorrenciaMqtt(id);
            setTimeout(function(){
                OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                if(ConfigService.getAutoCarregamentoOcorrencia()){
                    setTimeout(function() {
                        $this.verificaOcorrenciasComPrioridadeAltaEmEspera();
                        OcorrenciasService.setTabStatusSuperior(0);
                    }, 100);
                }
            },200);

            OcorrenciasService.notificarTrocaDeStatus(constant.STATUS.FINALIZADO, id, false, false, null);
        },

    }

});

angular.module('Fullarm').service('ChatService', function (ChatFactory, $rootScope, MonitoramentoService, orderByFilter, SomService, $q, $filter, ToastMessageService) {
    var _scope = {};
    var $this;
    var html ="";
    var url = "";
    var classe = "";
    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.conversas = [];
            _scope.mensagens = [];
            _scope.idsConversas = [];
            _scope.exibeIconeChat = false;
            _scope.imagemHeader = "";
            _scope.loginConversaAtual = "";
            _scope.audio = "";
            _scope.tipoMensagem = 3;
            _scope.mostraCorpoMensagem = false;
            _scope.mensagemCarregada = true;
            _scope.existeNaOcorrenciaClicada = false;
            _scope.usuarioParticipaConversa = false;
            _scope.mostrarPreImagem = false;
        },

        conectaTopicoChat: function(idsConversas, monitoramento){
            if(_scope.clientFtalk.isConnected()) {
                angular.forEach(idsConversas, function (id) {
                    _scope.clientFtalk.subscribe("/conversas/ftalk/fullarm/" + monitoramento + "/" + id, {qos: 2});
                });
            }
        },

        enviarArquivoChat: function (file, nome_arquivo) {
            var deferred = $q.defer();
            _scope.mensagemCarregada = false;
            var sistema = _scope.ocorrenciaAtual.id_sistema;
            var data = $this.parserArquivo(file, nome_arquivo);
            ChatFactory.salvarArquivoConversa(data, sistema, function (sucess) {
                deferred.resolve(sucess);
                _scope.mensagemCarregada = true;
                $this.setAudioFile("");
            }, function (error) {
                _scope.mensagemCarregada = true;
            });
            return deferred.promise;
        },

        enviarMensagemPush: function(msg){
            var data = {
                texto: msg,
                tipo_mensagem: _scope.tipoMensagem,
                id_conversa: _scope.idConversaClicada,
                sistema: _scope.ocorrenciaAtual.id_sistema
            };
            angular.forEach(_scope.conversas, function (conversa) {
                if(conversa.id_conversa == _scope.idConversaClicada){
                    var conversaFpatrol = conversa.tipo_login_origem == 1 && (_scope.ocorrenciaAtual.status_ocorrencia != 7 && _scope.ocorrenciaAtual.status_ocorrencia != 8);
                    if(!conversaFpatrol){
                        ChatFactory.enviarMenssagemPush(data, function (sucess) {}, function (error) {});
                    }
                }
            });
        },

        getConversaPorId: function (id, imagem, login, sistema) {
            $this.setMostrarCorpoMensagem(false);
            imagem = (imagem === null || angular.isUndefined(imagem)) ? 'assets/img/no_image.png' : imagem;
            _scope.mensagemCarregada = false;
            _scope.audio = "";
            $("#not_"+id).removeClass('notificacao_chat');
            ChatFactory.bucaConversaPorId(id, sistema,  function (mensagens) {
                _scope.mensagens = mensagens.data;

                if(_scope.mensagens != null && _scope.mensagens.length > 0 ){
                    _scope.usuarioParticipaConversa = _scope.mensagens[0].participa;
                }

                $this.adicionaConversaChat(mensagens.data, imagem, id);
                _scope.imagemHeader = imagem;
                _scope.loginConversaAtual = login;
                $this.rolarParaBaixo();
                _scope.mensagemCarregada = true;
                $this.setMostrarCorpoMensagem(true);
            }, function (error) { });
        },

        getConversasPorIds: function (ids) {
            ChatFactory.bucaConversaPorIds(ids, _scope.ocorrenciaAtual.id_sistema, function (conversas) {
                _scope.conversas = conversas.data.conversas;
                angular.forEach(_scope.conversas, function(conversa){
                    if(!(_scope.idsConversas.indexOf(conversa.id_conversa) > -1)){
                        _scope.idsConversas.push(conversa.id_conversa);
                    }
                });
                _scope.exibeIconeChat = (!angular.isUndefined(_scope.conversas) && _scope.conversas.length > 0) && userOption.login_ftalk > 0 && _scope.ocorrenciaAtual.atendendo;
                $this.addClassChat();
            }, function (error) { });
        },

        getImagemConversa:function(id){
            angular.forEach(_scope.conversas, function(conversa){
                if(conversa.id_conversa == id){
                    return conversa.foto;
                }
            });
        },

        getConversasPorOcorrencia:function(id){
            ChatFactory.bucaConversasPorOcorrencia(id, function(conversas){
                if(conversas.data != null && conversas.data.length > 0){
                    $this.getConversasPorIds(conversas.data);
                }
            }, function(){

            });
        },

        updateConfigChat:function(data){
            ChatFactory.updateConfigChat(data, function (result) {
                $this.setChatConfigPosUpdate(result.data.loginMonitoramento.config);
                ToastMessageService.showInfoMenssageWeb('ocorrencia_label_configuracao_sucesso');
            }, function () {
                ToastMessageService.showInfoMenssageWeb('ocorrencia_label_configuracao_erro');
            });
            $('#modal-config').iziModal('close');
        },

        setChatConfigPosUpdate:function(config){
            userOption.cor_mensagem_chat = config.cor_mensagem_chat;
            userOption.cor_fundo_mensagem_chat = config.cor_fundo_mensagem_chat;
            userOption.cor_fundo_chat = config.cor_fundo_chat;
            userOption.font_size_chat = config.font_size_chat;
            userOption.cor_fundo_mensagem_chat_to_component = config.cor_fundo_mensagem_chat;
            userOption.cor_fundo_chat_to_component = config.cor_fundo_chat;
            $rootScope.fundoIsLight = tinycolor(config.cor_fundo_chat).isLight();
        },

        rolarParaBaixo:function(){
            setTimeout(function () {
                var area = document.getElementById('conteudo');
                area.scrollTop = area.scrollHeight;
            },500);
        },

        recebeMensagemChatMqtt:function(msgJson, classe, sistema){

            html = "";
            url = "";
            var elementoChat = $('#conteudo');
            var ultima_mensagem = [];

            if(_scope.mensagens != null && _scope.mensagens.length > 0){
                ultima_mensagem = _scope.mensagens[_scope.mensagens.length-1];
            }
            msgJson.hora_formatada = moment.unix(msgJson.timestamp_gerado).format("HH:mm:ss");

            if(userOption.login_ftalk != msgJson.id_origem){
                SomService.executarSom("https://s3.amazonaws.com/fullarm-static/sons/nova_notificacao.mp3");
            }

            if(_scope.idConversaClicada.trim() == ""){
                openElement();
                var imgHeader = $this.getImagemConversa(msgJson.id_conversa);
                $this.getConversaPorId(msgJson.id_conversa, imgHeader, msgJson.descricao_origem, sistema);
                $this.setIdConversaClicada(msgJson.id_conversa);

            }else if(msgJson.id_conversa == _scope.idConversaClicada){
                if(ultima_mensagem.length > 0){
                    $this.setDiaMensagemMqtt(ultima_mensagem, msgJson);
                }
                switch(msgJson.tipo_mensagem){
                    case 1:
                        $this.setMensagemImagem(msgJson, classe, msgJson.id_conversa);
                    break;
                    case 3:
                        $this.setMensagemTexto(msgJson, classe);
                    break;
                    case 8:
                        $this.setMensagemAudio(msgJson, classe, msgJson.id_conversa);
                    break;
                    case 9:
                        $this.setMensagemVideo(msgJson, classe);
                    break;
                }
                $this.setEnvolvidosConversa(msgJson, _scope.imagemHeader);
                $this.rolarParaBaixo();
            }else if(msgJson.id_conversa != _scope.idConversaClicada){
                $("#not_"+msgJson.id_conversa).addClass('notificacao_chat');
            }
            elementoChat.append(html);
            $this.addClassConversas();
        },

        adicionaConversaChat:function(mensagens, imagem, id){
            var elementoChat = $('#conteudo');
            elementoChat.empty();
            classe = "";
            url = "";
            html = "";
            angular.forEach(mensagens , function(mensagem, key){
                mensagem.hora_formatada = moment.unix(mensagem.timestamp_gerado).format("HH:mm:ss");
                mensagem.descricao_origem = mensagem.descricao_origem.nome;
                classe = mensagem.id_origem == userOption.login_ftalk ? 'other' : 'self';
                $this.setDiaMensagens(mensagens, mensagem, key);
                switch(mensagem.tipo){
                    case 1:
                        $this.setMensagemImagem(mensagem, classe, id);
                    break;
                    case 3:
                        $this.setMensagemTexto(mensagem, classe);
                    break;
                    case 8:
                        $this.setMensagemAudio(mensagem, classe, id);
                    break;
                    case 9:
                        $this.setMensagemVideo(mensagem, classe);
                    break;
                }
                $this.setEnvolvidosConversa(mensagem, imagem);
            });
            elementoChat.append(html);
            $this.addClassConversas();
        },

        setMensagemTexto:function(mensagem, classe){
            html += "<li class='"+classe+"'><p class='descricao_login'>"+mensagem.descricao_origem+"</p><p class='textoChat'>"+mensagem.texto+"</p><p class='horaChat'>" + mensagem.hora_formatada + "</p></li>";
        },

        setMensagemImagem:function(mensagem, classe, id){
            if(mensagem.dado_extra != null){
                url =  $this.getFileS3(mensagem.dado_extra.local + '/'+ id + '/' + mensagem.dado_extra.nome_arquivo);
                if(mensagem.texto != "" && mensagem.texto != null){
                    html += "<li class='"+classe+"'><p class='descricao_login'>"+mensagem.descricao_origem+"</p><img class='imgChat' src='"+url+"' onError='this.onerror=null; this.src='assets/img/no_image.png';'/><p class='textoChat'>"+mensagem.texto+"</p><p class='horaChat'>"+mensagem.hora_formatada+"</p></li>";
                }else {
                    html += "<li class='"+classe+"'><p class='descricao_login'>"+mensagem.descricao_origem+"</p><img class='imgChat' src='"+url+"' onError='this.onerror=null; this.src='assets/img/no_image.png';'/><p style='text-align: right; font-size: 8px !important; float:none !important;' class='horaChat'>"+mensagem.hora_formatada+"</p></li>";
                }
            }
        },

        setMensagemAudio:function(mensagem, classe, id){
            if(mensagem.dado_extra != null) {
                url = $this.getFileS3(mensagem.dado_extra.local + '/' + id + '/' + mensagem.dado_extra.nome_arquivo);
                html += "<li class='"+classe+"'><p class='descricao_login'>"+mensagem.descricao_origem+"</p><audio class='audio_chat' controls controlsList='nodownload' preload='auto' autobuffer><source src='"+url+"' type='audio/wav'></audio><p class='horaChat'>"+mensagem.hora_formatada+"</p></li>";
            }
        },

        setMensagemVideo:function(mensagem, classe){
            if(mensagem.dado_extra != null) {
                html += "<li class='"+classe+"'><p class='descricao_login'>"+mensagem.descricao_origem+"</p><video class='videoChat' controls width='200' height='200'><source src='"+url+"' type='audio/mp4' onError='this.onerror=null; this.src='assets/img/no_image.png';'></video><p class='horaChat'>" + mensagem.hora_formatada + "</p></li>";
            }
        },

        setDiaMensagens:function(mensagens, mensagem, key){
            if(key > 0){
                if(moment.unix(mensagens[key].timestamp_gerado).format("DD/MM/YYYY") != moment.unix(mensagens[key-1].timestamp_gerado).format("DD/MM/YYYY")){
                    if(moment.unix(mensagens[key].timestamp_gerado).format("DD/MM/YYYY") == moment().format("DD/MM/YYYY")){
                        html += "<div class='dataMensagemHoje'><a><p>"+$filter('translate')('ocorrencia_label_hoje')+"</p></a></div>";
                    }else{
                        html += "<div class='dataMensagemChat'><a><p>"+moment.unix(mensagem.timestamp_gerado).format("LL")+"</p></a></div>";
                    }
                }
            }else if(key === 0){
                if(moment.unix(mensagens[key].timestamp_gerado).format("DD/MM/YYYY") == moment().format("DD/MM/YYYY")){
                    html += "<div class='dataMensagemHoje'><a><p>"+$filter('translate')('ocorrencia_label_hoje')+"</p></a></div>";
                }else{
                    html += "<div class='dataMensagemChat'><a><p>"+moment.unix(mensagem.timestamp_gerado).format("LL")+"</p></a></div>";
                }
            }
        },

        setDiaMensagemMqtt:function(ultimaMensagem, mensagem){
            if(moment.unix(ultimaMensagem.timestamp_gerado).format("DD/MM/YYYY") != moment.unix(mensagem.timestamp_gerado).format("DD/MM/YYYY")){
                html += "<div class='dataMensagemHoje'><a><p>"+$filter('translate')('ocorrencia_label_hoje')+"</p></a></div>";
            }
        },

        setEnvolvidosConversa:function(mensagem, imagem){
            if(mensagem.id_origem === MonitoramentoService.getIdUsuarioFtalk()){
                document.styleSheets[0].addRule('li.other:before','background-image : url('+userOption.imagem_login+')');
            }else{
                document.styleSheets[0].addRule('li.self:before','background-image : url('+imagem+')');
            }
        },

        parserMensagem:function(msg, fileObj, nome_arquivo){

            var mensagem = {
                "id_origem": userOption.login_ftalk,
                "descricao_origem": userOption.descricao_login_ftalk,
                "id_conversa": _scope.idConversaClicada,
                "texto": msg,
                "dado_extra":null,
                "indice":  _scope.ocorrenciaAtual.id_monitoramento,
                "plataforma": "fullarm",
                "data_hora_formatada": moment().tz(_scope.ocorrenciaAtual.time_zone).format("DD/MM/YYYY HH:mm:s"),
                "hora_formatada": moment().tz(_scope.ocorrenciaAtual.time_zone).format("HH:mm"),
                "tipo_mensagem": _scope.tipoMensagem,
                "timestamp_gerado": moment().tz(_scope.ocorrenciaAtual.time_zone).unix()
            };
            switch(_scope.tipoMensagem){
                case 1:
                    mensagem.dado_extra = {
                        base64: null,
                        nome_arquivo: nome_arquivo,
                        mime_arquivo: _scope.tipoMensagem === 1 ? fileObj.filetype : _scope.tipoMensagem === 8 ? 'audio/mp3' : '',
                        local: 'shared'
                    };
                    break;
                case 3:
                    return mensagem;
                case 8:
                    mensagem.dado_extra = {
                        base64: null,
                        nome_arquivo: nome_arquivo,
                        mime_arquivo: 'audio/mp3',
                        local: 'shared-audio'
                    };
                break;
            }
            return mensagem;
        },

        parserArquivo:function(fileObj, nome_arquivo){
            var data = [];
            switch(_scope.tipoMensagem){
                case 1:
                    data = {
                        id_conversa: _scope.idConversaClicada,
                        id_origem: userOption.login_ftalk,
                        descricao_origem: userOption.descricao_login_ftalk,
                        dado_extra: {
                            base64: "data:image/*;charset=utf-8;base64," + fileObj.base64,
                            nome_arquivo: nome_arquivo,
                            mime_arquivo: _scope.tipoMensagem === 1 ? fileObj.filetype : _scope.tipoMensagem === 8 ? 'audio/mp3' : '',
                            local: 'shared'
                        }
                    };
                break;
                case 8:
                    data = {
                        id_conversa: _scope.idConversaClicada,
                        id_origem: userOption.login_ftalk,
                        descricao_origem: userOption.descricao_login_ftalk,
                        dado_extra: {
                            base64: _scope.audio,
                            nome_arquivo: nome_arquivo,
                            mime_arquivo: 'audio/mp3',
                            local: 'shared-audio'
                        }
                    };
                break;
            }
            return data;
        },

        getFileS3: function (chave) {
            AWS.config.update({ accessKeyId: configAwsSdk.access_key, secretAccessKey: configAwsSdk.secret_access_key, "region": "sa-east-1" });
            var s3 = new AWS.S3;
            var params = { Bucket: 'ftalk', Key: chave };
            return s3.getSignedUrl('getObject', params);
        },

        adicionarParticipanteNaConversa:function (id) {
            var deferred = $q.defer();
            if(!_scope.usuarioParticipaConversa){
                ChatFactory.adicionaParticipanteConversa(id, function (sucess) {
                    deferred.resolve(sucess);
                    _scope.usuarioParticipaConversa = true;
                }, function (error) {
                    deferred.reject(error);
                    _scope.usuarioParticipaConversa = false;
                });
            }else{
                deferred.resolve();
            }
            return deferred.promise;
        },

        setMostrarCorpoMensagem:function(mostrar){
            _scope.mostraCorpoMensagem = mostrar;
        },

        setMostrarPreImagem: function(mostrar){
            _scope.mostrarPreImagem = mostrar;
        },

        getMostrarPreImagem: function(){
            return _scope.mostrarPreImagem;
        },

        esvaziaChat: function () {
            _scope.exibeIconeChat = false;
            _scope.mensagens = [];
            _scope.conversas = [];
            _scope.idConversaClicada = "";
            $this.setMostrarCorpoMensagem(false);
            $this.setMostrarPreImagem(false);
            closeElement();
        },

        fechaConversaChat: function () {
            _scope.mensagens = [];
            _scope.loginConversaAtual = "";
            $this.setIdConversaClicada("");
            $this.setMostrarCorpoMensagem(false);
            closeElement();
        },

        setIdConversaClicada:function(id){
            _scope.idConversaClicada = id;
            setTimeout(function () {
                _scope.$apply();
            },100);

        },

        cancelarConfiguracao:function(){
            $this.addClassConversas();
            $this.addClassChat();
            $('#modal-config').iziModal('close');
        },

        addClassConversas:function(){
            $('.textoChat').css('color', userOption.cor_mensagem_chat);
            $('.floating-chat .chat .messages li').css('background-color', userOption.cor_fundo_mensagem_chat);
            $('.dataMensagemChat p').css('background-color', userOption.cor_fundo_mensagem_chat);
            $('.dataMensagemChat a').css('color', userOption.cor_mensagem_chat);

            if(tinycolor(userOption.cor_fundo_mensagem_chat).isLight()){
                $('.descricao_login').css('color', '#000000');
                $('.horaChat').css('color', '#000000');
            }else{
                $('.descricao_login').css('color', '#ffffff');
                $('.horaChat').css('color', '#ffffff');
            }
            $this.addClassFontSize(userOption.font_size_chat);
        },

        addClassChat : function(){
            $('.floating-chat').css('background', userOption.cor_fundo_chat);
            $('.floating-chat').css('background-repeat', 'no-repeat');
            $('.floating-chat').css('background-attachment', 'fixed');
            $rootScope.fundoIsLight = tinycolor(userOption.cor_fundo_chat).isLight();

            if(tinycolor(userOption.cor_fundo_chat).isLight()){
                $('#iConfig').css('color', '#000000');
                $('#iClose').css('color', '#000000');
                $('.floating-chat .chat .header .title').css('color', '#000000');
            }else{
                $('#iConfig').css('color', '#ffffff');
                $('#iClose').css('color', '#ffffff');
                $('.floating-chat .chat .header .title').css('color', '#ffffff');
            }
        },

        removeClassFontSize: function(){
            $('.textoChat').removeClass('textoChat12');
            $('.textoChat').removeClass('textoChat16');
            $('.textoChat').removeClass('textoChat24');
            $('.horaChat').removeClass('horaChat10');
            $('.horaChat').removeClass('horaChat14');
            $('.descricao_login').removeClass('descricao_login12');
            $('.descricao_login').removeClass('descricao_login14');
        },

        addClassFontSize: function(font_size){
            $('.descricao_login').addClass('descricao_login'+font_size);
            $('.horaChat').addClass('horaChat'+font_size);
            $('.textoChat').addClass('textoChat'+font_size);
        },

        setAudioFile: function(audio){
            _scope.audio = audio;
        },

        setMessageType:function(tipo){
            _scope.tipoMensagem = tipo;
        },

        getMessageType:function(){
            return _scope.tipoMensagem;
        }
    }
});


angular.module('Fullarm').service('ComentarioOcorrenciaService', function ($filter, constant, ComentarioOcorrenciaFactory,
                                                                           LogService, ToastMessageService, OcorrenciasService,
                                                                           MotivosAlarmeService, ConfigService, MonitoramentoService) {

    var _scope = {};
    var $this;

    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.mensagensPadrao = [];
            _scope.exibeComentarioOcorrencia = false;
            _scope.existeContatoEmAndamento = false;
            _scope.mensagemPadraoSelecionada = "";
            _scope.exibeBotoesLogCliente = false;
        },

        setMensagensPadrao: function (objMensagensPadrao) {
            _scope.mensagensPadrao = objMensagensPadrao;
        },

        exibeComentarioOcorrencia: function (objOcorrencia) {
            if(objOcorrencia){
                var observacaoPeloSistema = objOcorrencia.status_ocorrencia == constant.STATUS.EM_OBSERVACAO && objOcorrencia.id_operador_atendendo <= 0;
                _scope.exibeComentarioOcorrencia = observacaoPeloSistema || (objOcorrencia.atendendo || objOcorrencia.status_ocorrencia === constant.STATUS.EM_ESPERA);
            }else{
                _scope.exibeComentarioOcorrencia = false;
            }
        },

        exibeMensagemContatoAndamento: function (_existeContatoEmAndamento) {
            _scope.existeContatoEmAndamento = _existeContatoEmAndamento;
        },

        exibeBotoesLogCliente: function (exibirBotoesLogCliente) {
            _scope.exibeBotoesLogCliente = exibirBotoesLogCliente;
        },

        uncheckLogCLiente:function () {
            $("#mostrar_log_cliente").prop("checked", false);
            $("#push_log_cliente").prop("checked", false);
        },

        preencheTextAreaComentario: function (mensagem) {
            _scope.$apply(function () {
                $("#text_log").val($("#text_log").val()+mensagem);
            });
        },

        listarMensagensPadrao: function() {
            ComentarioOcorrenciaFactory.listarMensagemPadrao(function (mensagens) {
                if(mensagens.data.length > 0){
                    $this.setMensagensPadrao(mensagens.data);
                }else{
                    $("#text_log").attr("placeholder", $filter('translate')('ocorrencia_text_area_nao_ha_mensagem_padrao')).blur();
                }
                setTimeout(function () {
                    $this.criarIzimodal();
                },0);
            },
            function (error) { });
        },

        verificaComentarioOcorrencia: function () {
            if($("#text_log").val() != ""){
                $this.inserirComentarioOcorrencia();
            }else{
                ToastMessageService.showErrorMenssageWeb('ocorrencias_informacao_modal_advertencias_log');
            }
        },

        inserirComentarioOcorrencia: function () {
            var dados = this.extrairDadosComentario();
            $("#btnInserirComentario").button("loading");
            LogService.inserirLog(dados).then(() => {
                $this.resetComentario();
                let podeFinalizar = $this.verificaExibicaoFinalizar(_scope.ocorrenciaAtual);

                if(_scope.ocorrenciaAtual.status_ocorrencia === constant.STATUS.EM_ESPERA){
                    OcorrenciasService.resultadoAlteracaoStatus(podeFinalizar);
                    LogService.notificar(dados, 'log');
                }else{
                    $this.resultadoInsercaoLog(dados, podeFinalizar);
                }
            });
        },

        resultadoInsercaoLog: function(dados, podeFinalizar){
            OcorrenciasService.zeraQuantidadeEventos(_scope.ocorrenciaAtual.id_ocorrencia).then(function() {
                OcorrenciasService.verificaQuantidadeEventosPorStatus(_scope.ocorrenciaAtual)
            }, function(){});
            LogService.listaLogNovoEvento(_scope.ocorrenciaAtual.id_ocorrencia).then(function(){}, function(){});
            if(_scope.ocorrenciaAtual.status_ocorrencia !== constant.STATUS.EM_ESPERA){
                LogService.notificar(dados, 'log');
            }

            if(ConfigService.getAutoCarregamentoBotaoFinalizar() && podeFinalizar){
                LogService.exibeLog(false);
                MotivosAlarmeService.exibirMotivosAlarme(true);
            }
        },

        verificaExibicaoFinalizar: function(ocorrencia){
            let isNotRonda = (_scope.ocorrenciaAtual.status_ocorrencia !== constant.STATUS.AGUARDANDO_RONDA &&
                _scope.ocorrenciaAtual.status_ocorrencia !== constant.STATUS.RONDA_A_CAMINHO &&
                _scope.ocorrenciaAtual.status_ocorrencia !== constant.STATUS.RONDA_NO_LOCAL);
            let statusAceito = ocorrencia.status_ocorrencia === constant.STATUS.RONDA_FINALIZADA || isNotRonda;
            let podeFinalizar = !ocorrencia.existe_contato_em_andamento && statusAceito;
            MonitoramentoService.habiltaBotaoFinalizar(podeFinalizar);
            return podeFinalizar;
        },

        extrairDadosComentario: function(){
            var comentario = $("#text_log").val();
            var mostrarLogCliente = $("#push_log_cliente").is(':checked') ? 1 : $("#mostrar_log_cliente").is(':checked') ? 1 : 0;
            var pushLogCliente =  $("#push_log_cliente").is(':checked') ? 1 : 0;
            return {
                mensagem: comentario,
                mostrarLogCliente: mostrarLogCliente,
                pushLogCliente: pushLogCliente,
                ocorrencia: _scope.ocorrenciaAtual.id_ocorrencia
            };
        },

        resetComentario: function(){
            $("#text_log").val("");
            $("#btnInserirComentario").button("reset");
            $("#mostrar_log_cliente").prop('disabled', false);

            if ($("#mostrar_log_cliente").is(":checked") === true){
                $("#mostrar_log_cliente").prop("checked", false);
            }
            if ($("#push_log_cliente").is(":checked") === true){
                $("#push_log_cliente").prop("checked", false);
            }
        },

        criarIzimodal: function () {
            $(function(){
                var modal = $("#modalMensagensPadrao");
                modal.on('change', '#select_msg_padrao',function (e) {
                    $this.preencheTextAreaComentario($(this).find(':selected').text());
                    modal.iziModal('close');
                });
                modal.iziModal({
                    padding: 30,
                });
            });
        },



    }

})
angular.module("Fullarm").factory("ConfigFactory", function(RequestFactory){

    return{
        alteraConfiguracao:function (data, s, e) {
            var URL  = '/api/v1/login-monitoramento-config/'+data.login;
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e);
        }
    };
});
angular.module('Fullarm').service('ConfigService', function (ConfigFactory, ToastMessageService) {

    var _scope = {};
    var $this;
    return {
        setScope: function (scope) {
            _scope = scope;
            $this = this;
            $this.teclas_atalho_ativo = userOption.teclas_atalho_ativo;
            $this.auto_carregamento_ocorrencia = userOption.auto_carregamento_ocorrencia;
            $this.auto_carregamento_botao_finalizar = userOption.auto_carregamento_botao_finalizar;
        },

        alteraConfiguracao:function(config, habilitar, login){
            var dados = {};
            dados[config] = habilitar;
            dados['login'] = login;
            $this.setaConfiguracoesAtivas(config, habilitar);
            ConfigFactory.alteraConfiguracao(dados, function(){ToastMessageService.showSuccessMenssage('ocorrencia_toast_configuracao_sucesso', "")}, function(){return false});
        },

        setaConfiguracoesAtivas: function(config, ativo){
            switch(config){
                case 'teclas_atalho_ativo':
                    $this.teclas_atalho_ativo = ativo;
                    break;
                case 'auto_carregamento_ocorrencia':
                    $this.auto_carregamento_ocorrencia = ativo;
                    break;
                case 'auto_carregamento_botao_finalizar':
                    $this.auto_carregamento_botao_finalizar = ativo;
                    break;
            }
        },

        selecionaConfiguracaoTeclaAtalho : function(){
            if($this.getTeclasAtalhoAtivo()){
                $('#rbTeclaAtalhoAtivo').bootstrapToggle('on');
            }
            if($this.getAutoCarregamentoOcorrencia()){
                $('#rbCarregamentoOcorrencia').bootstrapToggle('on');
            }
            if($this.getAutoCarregamentoBotaoFinalizar()){
                $('#rbBotaoFinalizarAtivo').bootstrapToggle('on');
            }
        },

        getTeclasAtalhoAtivo : function() {
            return $this.teclas_atalho_ativo;
        },

        getAutoCarregamentoOcorrencia : function() {
            return $this.auto_carregamento_ocorrencia;
        },

        getAutoCarregamentoBotaoFinalizar : function() {
            return $this.auto_carregamento_botao_finalizar;
        },

    }

});
angular.module('Fullarm').service('ContatosService', function (AcaoUsuarioService, MergeObjetosService) {

    var _scope = {};

    return {
        setScope: function (scope) {
            _scope = scope;
            _scope.contatos = [];
            _scope.nomeContatoBusca = "";
            _scope.exibeContatos = false;
        },

        setContatos: function (objContato){
            if(objContato.length > 0){
                MergeObjetosService.merge(_scope.contatos, objContato);
                _scope.exibeContatos = true;
            }
        },

        esvaziaContatos: function () {
            _scope.exibeContatos = false;
            _scope.contatos = [];
        },

        inserirTentativaContato: function (idOcorrencia, idTelefone, callback) {
            var tentativaContatoParams = {
                ocorrencia: idOcorrencia,
                telefone: idTelefone
            };
            AcaoUsuarioService.inserirTentativaContato(tentativaContatoParams).then(function (result) {
                tentativaContatoParams = [];
                if(callback){
                    callback();
                }
            });
        },

        inserirResultadoContato: function (objContato, callback) {
            var telefone = null;

            if(objContato.telefones){
                telefone = objContato.telefones.find(function (telefone) {
                    return telefone.chamada_aberta == 1;
                });
            }

            if(telefone == null){
                return;
            }

            var resultadoContatoParams = {
                ocorrencia: objContato.id_ocorrencia,
                mensagem: objContato.mensagem,
                contato: objContato.id,
                telefone:telefone.id,
                tentativa_contato: telefone.id_chamada
            };

            if(objContato.complemento != ""){
                resultadoContatoParams.complemento = objContato.complemento;
            }

            AcaoUsuarioService.finalizarContato(resultadoContatoParams).then(function (result) {
                resultadoContatoParams = [];
                if(callback){
                    callback(result)
                }
            });
        },
    }

});
angular.module('Fullarm').service('EdicaoSistemaService', function (EdicaoSistemaFactory, AcaoUsuarioService, ToastMessageService, $q) {

    var _scope = {};
    var $this;
    return {
        setScope: function (scope) {
            _scope = scope;
            $this = this;
        },

        buscarSistemaParaEdicao: function (idSistema, s , e) {
            EdicaoSistemaFactory.getSistemaEdicao(idSistema, s, e);
        },

        editarInformacoesLocalSistema: function (dados) {
            var deferred = $q.defer();
            EdicaoSistemaFactory.editarSistema(dados, function (result) {
                ToastMessageService.showSuccessMenssage('ocorrencia_toast_info_sistema_alterado', '');
                if(_scope.ocorrenciaAtual.id_sistema > 0){
                    _scope.ocorrenciaAtual.sistema.endereco = result.data;
                }
                deferred.resolve(result.data);
            }, function (error) {
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_label_error_500');
                deferred.reject();
            });
            return deferred.promise;
        },

        insereLogPosAlteracaoSistema: function () {
            var params = {
                acao_usuario: 'SISTEMA_EDITADO',
                ocorrencia: _scope.ocorrenciaAtual.id_ocorrencia,
            };
            AcaoUsuarioService.inserirLogAcaoUsuario(params).then(function () {}, function () {});
        },

        iniciaManutencaoSistema: function (dados, sistema) {
            $('#btn-iniciar-manutencao').button('loading');
            EdicaoSistemaFactory.iniciarManutencao(dados, sistema, function () {
                $('#btn-iniciar-manutencao').button('reset');
                _scope.modalEdicao.close();
                ToastMessageService.showSuccessMenssage('ocorrencia_toast_info_maunutencao_iniciada', '');
            }, function () {
                $('#btn-iniciar-manutencao').button('reset');
                _scope.modalEdicao.close();
            });
        },

        prorrogarManutencaoSistema: function (dados, sistema) {
            $('#btn-prorrogar-manutencao').button('loading');
            EdicaoSistemaFactory.prorrogarManutencao(dados, sistema, function () {
                $('#btn-prorrogar-manutencao').button('reset');
                _scope.modalEdicao.close();
                ToastMessageService.showSuccessMenssage('ocorrencia_toast_info_maunutencao_prorrogada', '');
            }, function () {
                $('#btn-prorrogar-manutencao').button('reset');
                _scope.modalEdicao.close();
            });
        },

        revogarManutencaoSistema: function (dados, sistema) {
            var deferred = $q.defer();
            EdicaoSistemaFactory.revogarManutencao(sistema, dados, function (data) {
                deferred.resolve(data);
                ToastMessageService.showSuccessMenssage('ocorrencia_toast_info_maunutencao_revogada', '');
            }, function (error) {
                ToastMessageService.showErrorMenssage(error);
                deferred.reject();
            });
            return deferred.promise;
        },
    }

});
angular.module('Fullarm').service('EventoManualService', function () {

    var _scope = {};
    return {
        setScope: function (scope) {
            _scope = scope;
        },

    }
});

angular.module('Fullarm').service('GrupoAtendimentoService', function (GrupoAtendimentoFactory, $q) {

    var _scope = {};
    var $this;
    return{
        setScope: function (scope) {
            $this = this;
            _scope = scope;
        },

        listaGruposAtendimento: function (loginUsuario) {
            var deferred = $q.defer();
            GrupoAtendimentoFactory.listarGrupoAtendimento(loginUsuario, function (grupos) {
                deferred.resolve(grupos.data);
            }, function (err) {
                deferred.reject();
            });
            return deferred.promise;
        },

        listaLoginsPorGruposAtendimento:function (grupos) {
            var deferred = $q.defer();
            GrupoAtendimentoFactory.listarLoginsPorGruposAtendimento(grupos, function (logins) {
                deferred.resolve(logins.data);
            }, function (err) {
                deferred.reject();
            });
            return deferred.promise;
        }

    }

});
angular.module('Fullarm').service('HistoricoEventosService', function (HistoricoEventosFactory, ToastMessageService, $q) {

    var _scope = {};
    var $this;
    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.historicoEventos = [];
            _scope.exibeHistorico = false;
            _scope.totalDeEventosCarregado = 0;
            _scope.totalEventosExistentes = 0;
            _scope.exibeBotaoMostrarMenos = false;
            _scope.exibeBotaoMostrarMais  = false;
            _scope.idSistema = 0;
            _scope.existeEventosRastreados = false;
            _scope.exibeHistoricoRastreados = false;
            _scope.totalEventosPainel = 0;
        },

        listarHistoricoEventos: function (idSistema, _limite, rastreados) {
            var deferred = $q.defer();
            var limite = _limite > 0 ? _scope.totalDeEventosCarregado+10 : 10;
            _scope.exibeHistoricoRastreados = rastreados;
            $this.setIdSistema(idSistema);

            if(_scope.totalDeEventosCarregado <= _scope.totalEventosExistentes){
                HistoricoEventosFactory.listarHistorico(idSistema, limite, rastreados,  function (historicoEventos) {
                    $this.setHistoricoEventos(historicoEventos.data.eventos);
                    $this.setQuantidadesPaginacao(historicoEventos.data);
                    deferred.resolve(historicoEventos.data.eventos);
                }, function (error) {
                    deferred.reject(error);
                });
            }else {
                _scope.totalDeEventosCarregado = 0;
            }
            return deferred.promise;
        },

        setaTamanhoHistorico:function () {
            setTimeout(function () {
                var tamanhoDiv = $(".viewportHistorico").height();
                $("#tableHistoricoResponsive").css("max-height", tamanhoDiv-120);
            }, 1000);
        },

        esvaziaHistoricoEventos: function () {
            $this.setHistoricoEventos([]);
            _scope.exibeHistorico = false;
            $this.setExibeBotaoMostrarMenos(false);
            $this.setExibeBotaoMostrarMais(false);
            $("#tableHistoricoResponsive").css("max-height", "");
        },

        setQuantidadesPaginacao: function (historicoEventos) {
            _scope.totalEventosExistentes = historicoEventos.total;
            _scope.totalDeEventosCarregado = _scope.historicoEventos.length;
            $this.setExibeBotaoMostrarMenos(_scope.totalDeEventosCarregado > 20);
            $this.setExibeBotaoMostrarMais(_scope.totalDeEventosCarregado < _scope.totalEventosExistentes);
        },

        setIdSistema: function (_idSistema) {
            _scope.idSistema = _idSistema;
        },

        setExibeBotaoMostrarMenos: function (exibir) {
            _scope.exibeBotaoMostrarMenos = exibir;
        },

        setExibeBotaoMostrarMais: function (exibir) {
            _scope.exibeBotaoMostrarMais = exibir;
        },

        setHistoricoEventos: function (objHistorico) {
            _scope.historicoEventos = objHistorico;
        },

        setExisteEventosRastreados(total){
            _scope.existeEventosRastreados = total > 0;
        },

        setTotalEventosPainel(total){
            _scope.totalEventosPainel = total;
        }
    }
});

angular.module('Fullarm').service('InformacoesOcorrenciaService', function ($filter, TelaConfigService, RastreadosService, VideosService) {

    var _scope = {};
    var $this;
    var tabAtiva = "";
    return{
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.id_sistema = 0;
            _scope.ocorrenciaTabs = new Array();
            _scope.lengthVideo = 0;
            _scope.lengthFrame = 0;
            _scope.lengthVp = false;
            _scope.tabActive = 0;
            _scope.indexCurrent = 1;
            _scope.indexAbaSelecionada = 0;
        },

        setSistema:function (idSistema) {
            _scope.id_sistema = idSistema;
        },

        setLengthVideoTab:function (length) {
            _scope.lengthVideo = length;
        },

        setLengthFrameTab:function (length) {
            _scope.lengthFrame = length;
        },

        setExibeVeicuProx:function (latitide) {
            _scope.lengthVp = latitide != 0;
        },

        setCurrentIndex:function(index){
            _scope.indexCurrent = index;
        },

        rightTab:function(){
            if(_scope.indexCurrent < _scope.ocorrenciaTabs.length){
                $("ul.nav.nav-tabs li").each(function() {
                    if($(this).hasClass('infos')){
                        if(!angular.isUndefined($( this ).attr('id'))){
                            if($(this).hasClass('active')){
                                tabAtiva = $( this ).attr('id');
                                $("#"+$( this ).attr('id')).removeClass("active");
                                $("#corpo_"+$( this ).attr('id')).removeClass("tab-pane fade in active");
                                $("#corpo_"+$( this ).attr('id')).addClass("tab-pane fade");
                            }
                        }
                    }
                });
                $("#"+tabAtiva).next().addClass('active');
                $("#corpo_"+tabAtiva).next().addClass("tab-pane fade in active");
                _scope.indexCurrent +=1;
                return $("#"+tabAtiva).next().attr('id');
            }
            _scope.$apply();
        },

        leftTab:function(){
            if(_scope.indexCurrent > 1){
                $("ul.nav.nav-tabs li").each(function() {
                    if($(this).hasClass('infos')){
                        if(!angular.isUndefined($( this ).attr('id'))){
                            if($(this).hasClass('active')){
                                _scope.indexCurrent = $( this ).index();
                                tabAtiva = $( this ).attr('id');
                                $("#"+$( this ).attr('id')).removeClass("active");
                                $("#corpo_"+$( this ).attr('id')).removeClass("tab-pane fade in active");
                                $("#corpo_"+$( this ).attr('id')).addClass("tab-pane fade");
                            }
                        }
                    }
                });
                $("#"+tabAtiva).prev().addClass('active');
                $("#corpo_"+tabAtiva).prev().addClass("tab-pane fade in active");
                return $("#"+tabAtiva).prev().attr('id');
            }
            _scope.$apply();
        },

        atualizaAbasPorOpcaoMostrarCameras: function(mostrarCameras){
            _scope.ocorrenciaTabs = new Array();
            _scope.ocorrenciaAtual.mostrar_cameras = mostrarCameras || mostrarCameras == "true" ? true : false;
            $this.organizaAbasOcorrencia(_scope.ocorrenciaAtual);
        },

        organizaAbasOcorrencia:function (ocorrencia) {
           
            var contatoActive      = ocorrencia.sistema.contato.length > 0;
            var painelActive       = !contatoActive && Object.keys(ocorrencia.sistema.painel_virtual).length > 0;
            var videoActive        = !painelActive && !contatoActive && ocorrencia.video_ativo && ocorrencia.mostrar_cameras;
            var automacaoActive    = !videoActive && !contatoActive && !painelActive && (!angular.isUndefined(ocorrencia.sistema.dispositivos) && ocorrencia.sistema.dispositivos.length > 0);
            var rastreadosActive   = !videoActive && !contatoActive && !painelActive && !automacaoActive && ocorrencia.sistema.rastreados_ativo && (!angular.isUndefined(ocorrencia.sistema.veiculos) && ocorrencia.sistema.veiculos.length > 0);
            var veicProxActive     = !videoActive && !contatoActive && !painelActive && !automacaoActive && !rastreadosActive;
            var fpatrolActive      = !videoActive && !contatoActive && !painelActive && !automacaoActive && !rastreadosActive && ocorrencia.ronda_ativo;
            var providenciasActive = !videoActive && !contatoActive && !painelActive && !automacaoActive && !rastreadosActive && !veicProxActive && _scope.exibeProvidencias;
            var sistemaActive      = !videoActive && !contatoActive && !painelActive && !automacaoActive && !rastreadosActive && !veicProxActive && !providenciasActive;
            var fullcondActive     = !videoActive && !contatoActive && !painelActive && !automacaoActive && !rastreadosActive && !veicProxActive && !providenciasActive && !sistemaActive && ocorrencia.sistema.fullcond_ativo;
            var historicoActive    = !videoActive && !contatoActive && !painelActive && !automacaoActive && !rastreadosActive && !veicProxActive && !providenciasActive && !sistemaActive && !fullcondActive;


            _scope.abaPainelSelecionada = painelActive;

            if(rastreadosActive){
                setTimeout(function(){
                    RastreadosService.buscarUltimaPosicaoDeVeiculos(ocorrencia.id_sistema);
                },1000);
            }

            if(videoActive){
                setTimeout(function() {
                    VideosService.buscarCamerasOcorrencia(ocorrencia.id_sistema, ocorrencia.sistema.tipo_video);
                }, 1000);
            }

            if(!angular.isUndefined(ocorrencia.sistema.contato) && ocorrencia.sistema.contato.length > 0){
                _scope.contatosExiste = true;
                var ocorrenciaContato = {
                    "exibir":true,
                    "caminho":"app/pages/InformacoesOcorrencia/Contatos/contatos.html",
                    "titulo": $filter('translate')('ocorrencia_label_contatos'),
                    "controller":"ContatosController",
                    "id":"contatos",
                    "classe": contatoActive ? 'active' : '',
                    "classe_corpo": contatoActive ? 'tab-pane fade in active' : 'tab-pane fade'
                };
                _scope.ocorrenciaTabs.push(ocorrenciaContato);
            }else{
                _scope.contatosExiste = false;
            }

            if(Object.keys(ocorrencia.sistema.painel_virtual).length > 0){
                _scope.painelExiste = true;
                var ocorrenciaPainel = {
                    "exibir":true,
                    "caminho":"app/pages/InformacoesOcorrencia/Painel/painel.html",
                    "titulo": $filter('translate')('ocorrencia_label_painel'),
                    "controller":"PainelController",
                    "id":"painel",
                    "classe": painelActive ? 'active' : '',
                    "classe_corpo": painelActive ? 'tab-pane fade in active' : 'tab-pane fade'
                };
                _scope.ocorrenciaTabs.push(ocorrenciaPainel);
            }else{
                _scope.painelExiste = false;
            }

            if(ocorrencia.video_ativo && ocorrencia.mostrar_cameras) {
                _scope.videoExiste = true;
                var ocorrenciaVideo = {
                    "exibir": true,
                    "caminho": "app/pages/InformacoesOcorrencia/VideosGeneric/VideosGeneric.html",
                    "titulo": $filter('translate')('Vídeos'),
                    "controller": "VideosGenericController",
                    "id":"videos",
                    "classe": videoActive ? 'active' : '',
                    "classe_corpo": videoActive ? 'tab-pane fade in active' : 'tab-pane fade'
                };
                _scope.ocorrenciaTabs.push(ocorrenciaVideo);
            }else{
                _scope.videoExiste = false;
            }

            var existePermissaoVisualizar = ocorrencia.existe_permissao_visualizar.existe_visualizar_dispositivos || ocorrencia.existe_permissao_visualizar.existe_visualizar_portao;
            if(!angular.isUndefined(ocorrencia.sistema.dispositivos) && ocorrencia.sistema.dispositivos.length > 0 && (permissoes.enviar_comando_portao || permissoes.enviar_comando_dispositivo) && existePermissaoVisualizar){
                _scope.automacaoExiste = true;
                var ocorrenciaAutomacao = {
                    "exibir":true,
                    "caminho":"app/pages/InformacoesOcorrencia/Automacao/automacao.html",
                    "titulo": $filter('translate')('ocorrencia_label_automacao'),
                    "controller":"AutomacaoController",
                    "id":"automacao",
                    "classe": automacaoActive ? 'active' : '',
                    "classe_corpo": automacaoActive ? 'tab-pane fade in active' : 'tab-pane fade'
                };
                _scope.ocorrenciaTabs.push(ocorrenciaAutomacao);
            }else{
                _scope.automacaoExiste = false;
            }

            if(ocorrencia.sistema.rastreados_ativo && !angular.isUndefined(ocorrencia.sistema.veiculos) && ocorrencia.sistema.veiculos.length > 0){
                _scope.rastreadosExiste = true;
                var ocorrenciaVeiculos = {
                    "exibir":true,
                    "caminho":"app/pages/InformacoesOcorrencia/Rastreados/rastreados.html",
                    "titulo": $filter('translate')('ocorrencia_label_rastreados'),
                    "controller":"RastreadosController",
                    "id":"rastreados",
                    "classe": rastreadosActive ? 'active' : '',
                    "classe_corpo": rastreadosActive ? 'tab-pane fade in active' : 'tab-pane fade'
                };
                _scope.ocorrenciaTabs.push(ocorrenciaVeiculos);
            }else{
                _scope.rastreadosExiste = false;
            }

            if(monitoramento_config.fulltrack_ativo || monitoramento_config.fulltrack_ativo == 1){
                var ocorrenciaVeiculosProximos = {
                    "exibir":true,
                    "caminho":"app/pages/InformacoesOcorrencia/VeiculosProximos/veiculosProximos.html",
                    "titulo": $(window).width() > 1300 ? $filter('translate')('ocorrencia_label_veiculos_proximos') : $filter('translate')('ocorrencia_label_veiculos'),
                    "controller":"VeiculosProximosController",
                    "id":"veiculos_proximos",
                    "classe": veicProxActive ? 'active' : '',
                    "classe_corpo": veicProxActive ? 'tab-pane fade in active' : 'tab-pane fade'
                };
                _scope.ocorrenciaTabs.push(ocorrenciaVeiculosProximos);
            }

            if(ocorrencia.sistema.ronda_ativo && permissoes.fpatrol && permissoes.rota && permissoes.viatura){
                var ocorrenciaViaturas = {
                    "exibir":true,
                    "caminho":"app/pages/InformacoesOcorrencia/Fpatrol/fpatrol.html",
                    "titulo": is_condhouse ? 'Check Patrol' : $filter('translate')('ocorrencia_label_fpatrol'),
                    "controller":"FpatrolController",
                    "id":"fpatrol",
                    "classe": fpatrolActive ? 'active' : '',
                    "classe_corpo": fpatrolActive ? 'tab-pane fade in active' : 'tab-pane fade'
                };
                _scope.ocorrenciaTabs.push(ocorrenciaViaturas);
            }

            

            if(_scope.exibeProvidencias > 0){
                _scope.providenciasExiste = true;
                var ocorrenciaProvidencias = {
                    "exibir":true,
                    "caminho":"app/pages/InformacoesOcorrencia/Providencias/providencias.html",
                    "titulo": $filter('translate')('ocorrencia_label_providencias'),
                    "controller":"ProvidenciasController",
                    "id":"providencias",
                    "classe": providenciasActive ? 'active' : '',
                    "classe_corpo": providenciasActive ? 'tab-pane fade in active' : 'tab-pane fade'
                };
                _scope.ocorrenciaTabs.push(ocorrenciaProvidencias);
            }else{
                _scope.providenciasExiste = false;
            }

            if( ocorrencia.sistema.fullcond_ativo ){
                var moduloFullcond = {
                    "exibir": true,
                    "caminho": "app/pages/InformacoesOcorrencia/Fullcond/fullcond.html",
                    "titulo": is_condhouse ? 'Condhouse' : 'Fullcond',
                    "controller": "ModuloFullcondController",
                    "id": "modulo_fullcond",
                    "classe": fullcondActive ? 'active' : '',
                    "classe_corpo": fullcondActive ? 'tab-pane fade in active' : 'tab-pane fade'
                };
                _scope.ocorrenciaTabs.push(moduloFullcond);
            }

            
            var sistemaManutencao = {
                "exibir": true,
                "caminho": "app/pages/InformacoesOcorrencia/InformacoesDoLocal/tab.html",
                "titulo": $filter('translate')('ocorrencia_informacoes_local_aba_titulo'),
                "controller": "InformacoesDoLocalController",
                "id": "informacoes_local",
                "classe": sistemaActive ? 'active' : '',
                "classe_corpo": sistemaActive ? 'tab-pane fade in active' : 'tab-pane fade'
            };
            _scope.ocorrenciaTabs.push(sistemaManutencao);
        

            var historico = {
                "exibir":true,
                "caminho":"app/pages/HistoricoEventos/historicoEventos.html",
                "titulo": $(window).width() > 1400 ? $filter('translate')('ocorrencia_label_historico_de_eventos') : $filter('translate')('ocorrencia_label_historico'),
                "controller":"VeiculosProximosController",
                "id":"historico",
                "classe": historicoActive ? 'active' : '',
                "classe_corpo": historicoActive ? 'tab-pane fade in active' : 'tab-pane fade'
            };
            _scope.ocorrenciaTabs.push(historico);

            setTimeout(function () {
                _scope.$apply();
            }, 0);
    },





    }

});
angular.module('Fullarm').service('LembreteService', function ($rootScope, $timeout, LembreteFactory, $q,
                                                                $filter, SomService) {

    var _scope = {};
    var $this;

    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            $rootScope.ocorrenciaEmEspera = [];
        },

        buscaOCorrenciasEmEspera : function (idLogin, link) {
            LembreteFactory.buscaOcorrenciasEmEspera(idLogin, function (result) {
                if(result.data.length > 0){
                    $this.setHtmlModalLembrete(result.data, link);
                }else{
                    $('#modal-lembrete').iziModal('close');
                }
            }, function (error) {

            });
        },

        criaModalLembrete : function(){
            var html = "<div id='modalLembreteBody'><span class='pulse'></span><span>"+$filter('translate')('ocorrencias_modal_aguardando_interacao')+"</span></div>";
            $('#modal-lembrete').iziModal({
                overlayClose: false,
                overlayColor: 'rgba(0, 0, 0, 0.6)',
                timeout: false,
                closeOnEscape: false,
                timeout: 0,
                title: html,
                zIndex:1000,
                onClosed:$this.onCloseLembreteModal
            });

        },

        onCloseLembreteModal: function(){
            SomService.stopSom();
        },

        setHtmlModalLembrete:function(ocorrencias, link){
            SomService.executaSomLembrete(link);
            $("#lembrete").html("");
            var html = "";
            html+= "<ul id='tableLembrete'>";
            angular.forEach(ocorrencias, function(ocorrencia){
                if(monitoramento_config.ocorrencias_fullcenter){
                    html+= "<li id='"+ocorrencia.id_ocorrencia+"'><i class='fa fa-home'></i>     "+ocorrencia.sistema_descricao+"</li><hr>";
                }else{
                    html+= "<li id='"+ocorrencia.id_ocorrencia+"'><i class='fa fa-home'></i>     "+ocorrencia.sistema_descricao+" - "+ocorrencia.descricao_evento+"</li><hr>";
                }
            });
            html+= "</ul>";
            $("#lembrete").append(html);
            if(!$('#modal-lembrete').is(':visible')){
                setTimeout(function () {
                    $this.criaModalLembrete();
                    $('#modal-lembrete').iziModal('open');
                },1000);
            }
        },
    }
});
angular.module('Fullarm').service('LocalizacaoService', function (LocalizacaoFactory, MonitoramentoService) {

    var _scope = {};
    var $this;

    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
        },

        getLocalizacao: function (objEvento) {
            var options = {
                width : window.outerWidth * 80 / 100,
                height : window.outerHeight * 80 / 100,
                left : window.outerWidth * 10 / 100,
                top : window.outerHeight * 10 / 100,
                url : MonitoramentoService.getUrl()
            };

            LocalizacaoFactory.getLocalizacao(objEvento, options);
        },
    }
});
angular.module('Fullarm').service('LogDeErroService', function (LogDeErroFactory) {
    return{
        enviaLogDeErro:function (error, dados, msgMqtt) {
            var params = {
                "descricao_problema" : error,
                "dados":dados,
                "mensagem_mqtt" : msgMqtt
            };
            LogDeErroFactory.inserirLogDeErro(params, function (sucess) { }, function (error) { });
        },
    }

});
angular.module('Fullarm').service('LogService', function ($anchorScroll, $rootScope, $location, LogFactory, ToastMessageService, $q) {
    var _scope = {};
    var offset = 0;
    var $this;
    return{

        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.logsOcorrencia = [];
            _scope.exibeLogsOcorrencia = false;
            _scope.totalLogs = 0;
        },

        rolarParaCima: function(){
            var area = document.getElementById('scroll_log');
            area.scrollTop = 0;
            area.offsetHeight = 0;
        },

        setLogsOcorrencia: function(objLogsOcorrencia) {
            offset = 0;
            _scope.logsOcorrencia = objLogsOcorrencia;
        },

        exibeLog:function (exibir) {
            _scope.exibeLogsOcorrencia = exibir;
        },

        inserirLog: function(params) {

            var deferred = $q.defer();

            LogFactory.inserirMensagemLog(params, function (result) {
                deferred.resolve(result);
            },
            function (error) {
                ToastMessageService.showErrorMenssage(error);
            });
            return deferred.promise;
        },

        notificar: function(params, tipo){
            switch (tipo) {
                case 'log':
                    LogFactory.enviarNotificacoesLog(params, function (success) {}, function (error) {});
                break;
                case 'status':
                    LogFactory.enviarNotificacoesStatus(params, function (success) {}, function (error) {});
                break;
            }

        },

        listaLogNovoEvento : function (idOcorrencia) {
            var deferred = $q.defer();
            LogFactory.listarLogsPorOcorrencia(idOcorrencia, _scope.totalLogs, 0, function (result) {
                offset += result.data.logs.length;
                _scope.totalLogs = result.data.total;
                deferred.resolve(result.data.logs);
                angular.forEach(result.data.logs, function (data) {
                    _scope.logsOcorrencia.unshift(data);
                });
            }, function (error) {
                deferred.reject(error);
            });

            return deferred.promise;
        },

        listarLogsOcorrencia: function (idOcorrencia) {

            var deferred = $q.defer();

            if(_scope.totalLogs > _scope.logsOcorrencia.length || offset === 0 && (!angular.isUndefined(idOcorrencia))){
                LogFactory.listarLogsPorOcorrencia(idOcorrencia, offset, 15, function (result) {

                    offset += result.data.logs.length;
                    _scope.totalLogs = result.data.total;
                    deferred.resolve(result.data.logs);
                    angular.forEach(result.data.logs, function (data) {
                        _scope.logsOcorrencia.push(data);
                    });
                }, function (error) {
                    deferred.reject(error);
                });

                setTimeout(function () {
                    _scope.$apply();
                }, 0);
            }

            return deferred.promise;
        },
    }

});
angular.module('Fullarm').service('LoginService', function (LoginFactory, $q, ToastMessageService) {
    var _scope = {};
    var $this;
    ToastMessageService.init();
    return{

        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.loginsRonda = [];
        },

        trocaUsuario:function(data){
            LoginFactory.trocaUsuario(data, function (success) {
                if(success.status == 204){
                    window.location.reload();
                }
            }, function (error) {
                $this.getErrorloginLogout(error.status);
            });
        },

        deslogar:function (data) {
            LoginFactory.checaLoginUsuario(data,
                function (data) {
                    if(data.status === 204){
                        if(is_condhouse){
                            window.location.href = "/monitoramento/logout/condhouse";
                        }else{
                            window.location.href = "/monitoramento/logout";
                        }

                    }
                }, function (error) {
                    $this.getErrorloginLogout(error.status);
                });
        },

        getErrorloginLogout:function (status) {
            switch (status){
                case 0 /* offline */:
                    ToastMessageService.showErrorMenssageWeb("ocorrencia_label_error_0");
                    break;
                case 400 /* Bad Request */:
                    ToastMessageService.showErrorMenssageWeb("ocorrencia_label_error_400");
                    break;
                case 401 /* Unauthorized */:
                    ToastMessageService.showErrorMenssageWeb("ocorrencia_label_error_401");
                    break;
                case 500 /* error */:
                    ToastMessageService.showErrorMenssageWeb("ocorrencia_label_error_500");
                    break;
                default:
                break;
            }
        },

        buscarLoginsRota: function(id_sistema){
            $this.getLoginsPorRotasDoSistema(id_sistema).then(function(logins){
                _scope.loginsRonda = logins.data;
            });
        },

        getLoginsPorRotasDoSistema:function (id_sistema) {
            var deferred = $q.defer();
            LoginFactory.buscarLoginsPorRotasDoSistema(id_sistema,
            function(logins){
                deferred.resolve(logins);
            },
            function(error){
                deferred.reject();
            });
            return deferred.promise;
        }
    }

});
angular.module('Fullarm').service('ManutencaoSistemaService', function () {
    var _scope = {};
    var $this;
    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.fim_manutencao = "";
        },

        conectaTopicoManutencao: function (idSistema) {
            if(_scope.client.isConnected()) {
                _scope.client.subscribe("sistema/"+idSistema+"/manutencao", {qos: 2});
            }
        },

        countdownManutencao: function(data){
            var date = new Date(data);
            var hora_atual = new Date();
            if(date > hora_atual){
                $("#div-countdown").show();
                $("#countdown").countdown(date, function (event) {
                    $(this).text(event.strftime('%H:%M:%S'));
                }).on('finish.countdown', function() {
                    $("#div-countdown").hide();
                });
            }
        },

        countdownEdicao: function(data){
            var date = new Date(data);
            var hora_atual = new Date();
            if(date > hora_atual){
                $("#countdownEdicao").countdown(date, function (event) {
                    $(this).text(event.strftime('%H:%M:%S'));
                }).on('finish.countdown', function() {
                    setTimeout(function () {
                        _scope.$apply();
                    },0);
                });
            }
        },

        removeInformacaoManutencao:function(){
            $("#div-countdown").hide();
            setTimeout(function () {
                _scope.$apply();
            },0);
        },

        countdownManutencaoRemove: function(){
            $('#countdown').countdown('remove');
            $this.removeInformacaoManutencao();
        }
    };
});
angular.module('Fullarm').service('MergeObjetosService', function () {

    _merge = function(target, source) {

        angular.forEach(Object.keys(source), function (key) {
            if (source[key] instanceof Object && key in target){
                Object.assign(source[key], _merge(target[key], source[key]))
            }
        });

        Object.assign( target || {}, source);
        return target
    };

    return{
        merge:_merge
    }
});


angular.module('Fullarm').service('MotivosAlarmeService', function (MotivosAlarmeFactory, constant, ToastMessageService,
                                                                    PostergarHorarioService, StatusService, LogService) {

    var $this;
    var _scope = {};

    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.motivosAlarme = [];
            _scope.exibeMotivosAlarme = false;
            _scope.tipoEventoDisparo = false;
            _scope.mensagemMotivoAlarme = "";
        },

        exibirMotivosAlarme: function (exibe) {
            _scope.exibeMotivosAlarme = exibe;
            if(exibe){
                $this.setaFocoBotaoFinalizar();
            }
            setTimeout(function(){
                _scope.$apply();
            },0);
        },

        setaFocoBotaoFinalizar: function(){
            setTimeout(function(){
                $("#btnFinalizarMotivoAlarme").attr("tabindex",-1).focus();
            },500);
        },

        listarMotivosAlarme: function () {
            MotivosAlarmeFactory.listarMotivosAlarme(function (motivos){
                $this.setMotivosAlarme(motivos.data);
            });
        },

        setMotivosAlarme: function (objMotivosAlarme) {
            _scope.motivosAlarme = objMotivosAlarme;
        },

        tipoDeEventoDisparo: function (tipo) {
            _scope.tipoEventoDisparo = tipo === 3;
        },

        setMensagemMotivo: function (mensagem) {
            _scope.mensagemMotivoAlarme = mensagem;
        },

        verificaExibicaoMotivoAlarme: function () {
            if(!_scope.existeEventoTabelaHorario){
                $this.exibirMotivosAlarme(true);
                LogService.exibeLog(false);
                return;
            }

            $this.validaHorarios();
        },

        validaHorarios: function(){
            let horarioValido = PostergarHorarioService.verificaTabelaHorario();

            if(horarioValido === constant.ESTADO_TABELA_HORARIO.HORARIO_VALIDO){
                PostergarHorarioService.abreModalPostergar();
            }

            if(horarioValido === constant.ESTADO_TABELA_HORARIO.HORARIO_EXCEDIDO){
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_toast_horario_postergar_excedido');
                LogService.exibeLog(false);
                $this.exibirMotivosAlarme(true);
                PostergarHorarioService.setEventoTabelaHorario(false);
                return;
            }

            if(horarioValido === constant.ESTADO_TABELA_HORARIO.PERMISSAO_NEGADA){
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_toast_permissao_postergar_negada');
                return;
            }
        },
    }

});
angular.module('Fullarm').service('OcorrenciaAtualService', function (constant, $q, $filter, ContatosService,
                                                                      AnotacoesTemporariasService, VideosService,
                                                                      PainelService, RastreadosService,
                                                                      ProvidenciasService, MotivosAlarmeService,
                                                                      ComentarioOcorrenciaService, LogService,
                                                                      HistoricoEventosService,TelaConfigService,
                                                                      PageTopService, OrdemServicoService, VideoFrameService,
                                                                      MonitoramentoService, LocalizacaoService,
                                                                      VeiculosProximosService, PostergarHorarioService,
                                                                      InformacoesOcorrenciaService, ChatService,
                                                                      AutomacaoService, ViaturasService, ManutencaoSistemaService,
                                                                      OcorrenciasService) {


    var _scope = {};
    var $this;

    return{
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.ocorrenciaAtual = [];
            _scope.tipoVideo = 0;
            _scope.exibirInformacoesOcorrencia = false;
            _scope.btnAssumirAtendimento = false;
        },

        setOcorrenciaAtual: function (ocorrenciaAtual) {

            var deferred = $q.defer();
            _scope.ocorrenciaAtual = ocorrenciaAtual;
            _scope.tipoVideo = ocorrenciaAtual.sistema.tipo_video;
            _scope.btnAssumirAtendimento = (!ocorrenciaAtual.atendendo && ocorrenciaAtual.status_ocorrencia !== constant.STATUS.EM_ESPERA && ocorrenciaAtual.status_ocorrencia !== constant.STATUS.EM_OBSERVACAO);
            OcorrenciasService.atualizaHabilitarBotaoObservacao(_scope.ocorrenciaAtual);
            $this.setButtonAtendimento(_scope.btnAssumirAtendimento);
            ContatosService.setContatos(ocorrenciaAtual.sistema.contato);
            InformacoesOcorrenciaService.setSistema(ocorrenciaAtual.id_sistema);

            VideosService.setIdOcorrenciaAtual(ocorrenciaAtual.id_ocorrencia);
            VideosService.setCamerasEmEstacao(MonitoramentoService.getIdUsuarioLogado(), ocorrenciaAtual.id_sistema, ocorrenciaAtual.id_ocorrencia);
            PostergarHorarioService.setEventoTabelaHorario(ocorrenciaAtual.evento_tabela_horario);
            PainelService.setPaineisVirtuaisDoSistema(ocorrenciaAtual.sistema.painel_virtual);
            PainelService.setPainelVirtualQueGerouOcorrencia(ocorrenciaAtual.primeiro_evento.id_painel_virtual);
            RastreadosService.setRastreados(ocorrenciaAtual.sistema.veiculos, ocorrenciaAtual.primeiro_evento.id_veiculo);
            ProvidenciasService.setProvidencias(ocorrenciaAtual.sistema.providencias);
            MotivosAlarmeService.tipoDeEventoDisparo(ocorrenciaAtual.primeiro_evento.tipo);
            ComentarioOcorrenciaService.exibeComentarioOcorrencia(ocorrenciaAtual);
            ComentarioOcorrenciaService.exibeMensagemContatoAndamento(ocorrenciaAtual.existe_contato_em_andamento);
            ComentarioOcorrenciaService.exibeBotoesLogCliente(ocorrenciaAtual.sistema.log_mobile);
            AnotacoesTemporariasService.setAnotacoesTemporarias(ocorrenciaAtual.sistema.anotacoes_temporarias);
            AutomacaoService.setDispositivos(ocorrenciaAtual.sistema.dispositivos);
            HistoricoEventosService.setExisteEventosRastreados(ocorrenciaAtual.total_eventos_rastreados);
            HistoricoEventosService.listarHistoricoEventos(ocorrenciaAtual.id_sistema, 0, false).then(function (eventos) {
                if(eventos.length <= 0 && ocorrenciaAtual.total_eventos_rastreados > 0){
                    HistoricoEventosService.listarHistoricoEventos(ocorrenciaAtual.id_sistema, 0, true).then(null, null);
                }else {
                    HistoricoEventosService.setTotalEventosPainel(eventos.length);
                }
            }, function (error) {});
            if(ocorrenciaAtual.sistema.em_manutencao){
                ManutencaoSistemaService.countdownManutencao(ocorrenciaAtual.sistema.fim_manutencao);
            }

            HistoricoEventosService.setaTamanhoHistorico();
            PageTopService.exibeIconesNoTopo(ocorrenciaAtual);
            OrdemServicoService.listaProblemas(ocorrenciaAtual.atendendo);
            MonitoramentoService.habiltaBotaoFinalizar(ocorrenciaAtual.pode_finalizar);
            LogService.exibeLog(true);
            $this.exibeInformacoesOcorrencia(true);
            deferred.resolve();
            return deferred.promise;
        },

        esvaziaOcorrenciaAtual: function () {
            $this.exibeInformacoesOcorrencia(false);
            _scope.ocorrenciaAtual = [];
            _scope.tipoVideo = null;
            PostergarHorarioService.esvaziaEventoTabelaHorario();
            LogService.setLogsOcorrencia([]);
            ContatosService.esvaziaContatos([]);
            VideosService.setVideosHls([]);
            VideosService.cleanPlayer();
            VideosService.esvaziaVideoAtual();
            VideoFrameService.esvaziaVideoAtual();
            PainelService.esvaziaPainelVirtual();
            RastreadosService.setRastreados([]);
            RastreadosService.removeMapa();
            MotivosAlarmeService.exibirMotivosAlarme(false);
            LogService.exibeLog(false);
            ProvidenciasService.limpaProvidencias();
            ComentarioOcorrenciaService.exibeComentarioOcorrencia(false);
            ComentarioOcorrenciaService.exibeBotoesLogCliente(false);
            ComentarioOcorrenciaService.uncheckLogCLiente();
            AnotacoesTemporariasService.setAnotacoesTemporarias([]);
            HistoricoEventosService.esvaziaHistoricoEventos();
            PageTopService.escondeIconesNoTopo();
            VeiculosProximosService.esvaziaVeiculos();
            MonitoramentoService.habiltaBotaoFinalizar(false);
            InformacoesOcorrenciaService.setSistema(0);
            ChatService.esvaziaChat();
            AutomacaoService.esvaziaAutomacao();
            ManutencaoSistemaService.removeInformacaoManutencao();
            ViaturasService.esvazia();
        },

        getSistema: function () {
            return _scope.ocorrenciaAtual.id_sistema;
        },

        getMonitoramento: function () {
            return _scope.ocorrenciaAtual.id_monitoramento;
        },

        getTipoPrimeiroEvento: function () {
            return _scope.ocorrenciaAtual.primeiro_evento.tipo;
        },

        getIdOcorrenciaAtual: function () {
            return _scope.ocorrenciaAtual.id_ocorrencia ;
        },

        getOperadorAtendendo: function () {
            return _scope.ocorrenciaAtual.atendendo;
        },

        exibeInformacoesOcorrencia:function (exibir) {
            _scope.exibirInformacoesOcorrencia = exibir;
        },

        getOcorrenciaAtual:function () {
          return _scope.ocorrenciaAtual;
        },

        getPainelVirtual: function () {
            if(_scope.ocorrenciaAtual.length > 0){
                return _scope.ocorrenciaAtual.painel_virtual.id;
            }else{
                return null;
            }
        },

        getTimeZoneSistema:function () {
            return _scope.ocorrenciaAtual.time_zone;
        },

        setButtonAtendimento:function (btnAssumirAtendimento) {
            if(btnAssumirAtendimento)
                $("#btnAtenderOcorrencia").text($filter('translate')('ocorrencia_label_assumir'));
            else
                $("#btnAtenderOcorrencia").text($filter('translate')('ocorrencia_acao_atender'));
        }
    }

});
angular.module('Fullarm').service('OcorrenciasService', function ($q, $filter, constant, OcorrenciasFactory, StatusService,
                                                                  StatusFactory, $rootScope, MonitoramentoService,
                                                                  ToastMessageService, LembreteService, ChatService, LogService,
                                                                  ConfigService, MotivosAlarmeService, ViaturasService, ManutencaoSistemaService) {

    var _scope = {};
    var $this;
    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.msgMqttOcorrencia = "";
            _scope.ocorrencias = [];
            _scope.tab_status_superior = 0;
            _scope.cor_status_atendimento = '';
            _scope.cor_status_observacao = '';
            _scope.cor_status_processo = '';
            _scope.cor_status_espera = '';
            _scope.cor_status_aguardando_ronda = '';
            _scope.cor_status_ronda_a_caminho = '';
            _scope.cor_status_ronda_no_local = '';
            _scope.cor_status_ronda_finalizada = '';
            _scope.exibeBtnAguardarEmObservacao = false;
        },

        setMsgMqtt:function(msg){
            _scope.msgMqttOcorrencia = msg;
        },

        setOcorrencias: function (ocorrencias) {
            _scope.ocorrencias = ocorrencias;
        },

        getOcorrencias: function () {
            return _scope.ocorrencias;
        },

        recebeNovaOcorrencia: function (ocorrencia) {
            var deferred = $q.defer();
            OcorrenciasFactory.listarNovaOcorrenciaPorId(ocorrencia.id_ocorrencia, function (result) {
                deferred.resolve(result.data);
                $this.verificaPosicaoNovaOcorrenciaPorStatusPrioridade(result.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        },

        recebeNovoEvento: function (objOcorrencia) {
            $this.verificaPosicaoOcorrenciaPorPrioridade(objOcorrencia);
        },

        atualizaDadosComNovoEventoRecebido:function(objetoOcorrenciaIndex){
            OcorrenciasFactory.listarNovaOcorrenciaPorId(objetoOcorrenciaIndex.id_ocorrencia, function (result){
                var ocorrencia = result.data;
                if(!angular.isUndefined(ocorrencia) && !angular.isUndefined(objetoOcorrenciaIndex['evento_maior_prioridade'])){
                    objetoOcorrenciaIndex['evento_maior_prioridade'] = ocorrencia.evento_maior_prioridade;
                    objetoOcorrenciaIndex['tipo_descricao'] = ocorrencia.tipo_descricao;
                }
            }, function (error) {

            });
        },

        atualizaDadosDasOcorrencias: function(ocorrencia){
            OcorrenciasFactory.listarNovaOcorrenciaPorId(ocorrencia.id_ocorrencia, function(result) {
                $this.contaQuantidadeEventosOcorrenciaAnterior(ocorrencia.id_ocorrencia).then(function(statusAnterior) {
                    $this.atualizaInformacoesDaOcorrencia(result.data).then(function(){
                        $this.verificaQuantidadeEventosPorStatus(result.data);
                        $this.verificaQuantidadeEventosPorStatusOcorrencia(statusAnterior);
                    });
                });
            }, function(error){
                if(error.status == 404){
                    ToastMessageService.getMensagemAtualizacaoPorStatus(4);
                }else{
                    ToastMessageService.showErrorMenssage(error);
                }
            });
        },

        atualizaInformacoesDaOcorrencia:function (objOcorrencia) {
            var deferred = $q.defer();
            $this.buscarOcorrenciaIndice(objOcorrencia.id_ocorrencia).then(function (ocorrenciaIndice) {
                try{
                    if(!angular.isUndefined(ocorrenciaIndice)) {
                        var status = $this.buscaOcorrenciaPorStatus(ocorrenciaIndice.status);
                        var prioridade = $this.buscaOcorrenciaPorPrioridade(ocorrenciaIndice.prioridade);
                        var indexOcorrencia = $this.getIndexOcorrencia(ocorrenciaIndice.id_ocorrencia, status, prioridade);
                        if(!angular.isUndefined(indexOcorrencia) && indexOcorrencia != null) {
                            var novoStatusIndex = $this.buscaOcorrenciaPorStatus(objOcorrencia.status_ocorrencia);
                            $this.removeOcorrenciaPrioridadeIndexStatus(indexOcorrencia, status, prioridade).then(function (result) {
                                $this.adicionaOcorrenciaPrioridadeIndexStatus(objOcorrencia, novoStatusIndex, prioridade);
                                $this.atualizarIndiceDeOcorrencia(objOcorrencia);
                            });
                            MonitoramentoService.setBotoes(objOcorrencia.botoes);
                            deferred.resolve(novoStatusIndex);
                        }
                    }
                }catch(err){

                }
            });
            return deferred.promise;
        },

        verificaPosicaoNovaOcorrenciaPorStatusPrioridade: function (objOcorrencia) {
            try{
                if(!angular.isUndefined(objOcorrencia)){
                    var status = $this.buscaOcorrenciaPorStatus(objOcorrencia.status_ocorrencia);
                    var prioridade = $this.buscaOcorrenciaPorPrioridade(objOcorrencia.prioridade);
                    $this.selecionaTabStatus(objOcorrencia.status_ocorrencia);
                    $this.adicionaOcorrenciaPrioridadeIndexStatus(objOcorrencia, status, prioridade);
                    $this.atualizarIndiceDeOcorrencia(objOcorrencia);
                }
            }catch(err){

            }
        },

        verificaPosicaoOcorrenciaPorPrioridade: function (objOcorrencia) {
            try{
                $this.buscarOcorrenciaIndice(objOcorrencia.id_ocorrencia).then(function (ocorrenciaIndice) {
                    if(!angular.isUndefined(ocorrenciaIndice)){
                        var status = $this.buscaOcorrenciaPorStatus(ocorrenciaIndice.status);
                        var prioridade = $this.buscaOcorrenciaPorPrioridade(ocorrenciaIndice.prioridade);
                        var indexOcorrencia = $this.getIndexOcorrencia(ocorrenciaIndice.id_ocorrencia, status, prioridade);
                        if(!angular.isUndefined(indexOcorrencia) && indexOcorrencia != null){
                            $this.atualizaQuantidadeEventos(status, prioridade, indexOcorrencia);
                            $this.selecionaTabStatus(ocorrenciaIndice.status);
                            var novaPrioridadeIndex = $this.buscaOcorrenciaPorPrioridade(objOcorrencia.prioridade);
                            var ocorrencia = _scope.ocorrencias[status][prioridade][indexOcorrencia];
                            if($this.deveTrocarPrioridade(ocorrenciaIndice.prioridade, objOcorrencia.prioridade)){
                                $this.removeOcorrenciaPrioridadeIndexStatus(indexOcorrencia, status, prioridade).then(function (result) {
                                    ocorrencia.prioridade = objOcorrencia.prioridade;
                                    $this.adicionaOcorrenciaPrioridadeIndexStatus(ocorrencia, status, novaPrioridadeIndex);
                                    $this.atualizarIndiceDeOcorrencia(ocorrencia);
                                });
                                $this.atualizaDadosComNovoEventoRecebido(ocorrencia);
                            }
                        }
                    }
                });
            }catch(err){

            }
        },

        retornaDescricaoSistemaPorIdOcorrencia:function(objOcorrencia){
            var deferred = $q.defer();
            $this.buscarOcorrenciaIndice(objOcorrencia.id_ocorrencia).then(function (ocorrenciaIndice) {
                if(!angular.isUndefined(ocorrenciaIndice)){
                    var status = $this.buscaOcorrenciaPorStatus(ocorrenciaIndice.status);
                    var prioridade = $this.buscaOcorrenciaPorPrioridade(ocorrenciaIndice.prioridade);
                    var indexOcorrencia = $this.getIndexOcorrencia(ocorrenciaIndice.id_ocorrencia, status, prioridade);
                    var ocorrencia = _scope.ocorrencias[status][prioridade][indexOcorrencia];
                    if(!angular.isUndefined(ocorrencia) && ocorrencia != null){
                        deferred.resolve(ocorrencia.descricao_sistema);
                    }else{
                        deferred.resolve("");
                    }
                }
            });
            return deferred.promise;
        },

        selecionaTabStatus: function (status) {
            switch (status){
                case constant.STATUS.EM_ATENDIMENTO:
                    _scope.cor_status_atendimento = 'rgb(222, 83, 65)';
                break;
                case constant.STATUS.EM_OBSERVACAO:
                    _scope.cor_status_observacao = 'rgb(222, 83, 65)';
                break;
                case constant.STATUS.AGUARDANDO_RONDA:
                    _scope.cor_status_aguardando_ronda = 'rgb(222, 83, 65)';
                break;
                case constant.STATUS.RONDA_A_CAMINHO:
                    _scope.cor_status_ronda_a_caminho = 'rgb(222, 83, 65)';
                break;
                case constant.STATUS.RONDA_NO_LOCAL:
                    _scope.cor_status_ronda_no_local = 'rgb(222, 83, 65)';
                break;
                case constant.STATUS.RONDA_FINALIZADA:
                    _scope.cor_status_ronda_finalizada = 'rgb(222, 83, 65)';
                break;
            }
        },

        apagaTabStatus: function (status) {
            switch (status){
                case constant.STATUS.EM_ATENDIMENTO:
                    _scope.cor_status_atendimento = '';
                break;
                case constant.STATUS.EM_OBSERVACAO:
                    _scope.cor_status_observacao = '';
                break;
                case constant.STATUS.AGUARDANDO_RONDA:
                    _scope.cor_status_aguardando_ronda = '';
                break;
                case constant.STATUS.RONDA_A_CAMINHO:
                    _scope.cor_status_ronda_a_caminho = '';
                break;
                case constant.STATUS.RONDA_NO_LOCAL:
                    _scope.cor_status_ronda_no_local = '';
                break;
                case constant.STATUS.RONDA_FINALIZADA:
                    _scope.cor_status_ronda_finalizada = '';
                break;
            }
        },

        atualizaQuantidadeEventos:function (status, prioridade, indexOcorrencia) {
            try{
                _scope.ocorrencias[status][prioridade][indexOcorrencia].quantidade_eventos++;
                setTimeout(function () {
                    _scope.$apply();
                },0);
            }catch (err){

            }
        },

        zeraQuantidadeEventos: function (idOcorrencia) {
            var deferred = $q.defer();

            $this.buscarOcorrenciaIndice(idOcorrencia).then(function (ocorrenciaIndice) {
                if(!angular.isUndefined(ocorrenciaIndice)){
                    var status = $this.buscaOcorrenciaPorStatus(ocorrenciaIndice.status);
                    var prioridade = $this.buscaOcorrenciaPorPrioridade(ocorrenciaIndice.prioridade);
                    var indexOcorrencia = $this.getIndexOcorrencia(ocorrenciaIndice.id_ocorrencia, status, prioridade);
                    if(!angular.isUndefined(indexOcorrencia) && indexOcorrencia != null){
                        _scope.ocorrencias[status][prioridade][indexOcorrencia].quantidade_eventos = 0;
                    }
                    deferred.resolve();
                }
            });
            return deferred.promise;
        },

        contaQuantidadeEventosOcorrenciaAnterior: function (idOcorrencia) {
            var deferred = $q.defer();
            $this.buscarOcorrenciaIndice(idOcorrencia).then(function (ocorrenciaIndice) {
                if(!angular.isUndefined(ocorrenciaIndice)) {
                    deferred.resolve(ocorrenciaIndice.status);
                }
            });
            return deferred.promise;
        },

        verificaQuantidadeEventosPorStatus:function (ocorrencia) {
            var statusDescricao = $this.buscaOcorrenciaPorStatus(ocorrencia.status_ocorrencia)
            var ocorrenciaStatus = _scope.ocorrencias[statusDescricao];
            $this.contaEventosPorStatus(ocorrenciaStatus, ocorrencia.status_ocorrencia);
        },

        verificaQuantidadeEventosPorStatusOcorrencia:function (status) {
            var statusDescricao = $this.buscaOcorrenciaPorStatus(status);
            $this.contaEventosPorStatus(_scope.ocorrencias[statusDescricao], status);
        },

        contaEventosPorStatus:function (ocorrenciaStatus, statusCodigo) {

            var qtdEventosAlta = 0;
            var qtdEventosMedia = 0;
            var qtdEventosBaixa = 0;
            var total = 0;

            angular.forEach(ocorrenciaStatus.alta, function (ocorrenciaAlta) {
                qtdEventosAlta += ocorrenciaAlta.quantidade_eventos;
            });
            angular.forEach(ocorrenciaStatus.media, function (ocorrenciaMedia) {
                qtdEventosMedia += ocorrenciaMedia.quantidade_eventos;
            });

            angular.forEach(ocorrenciaStatus.baixa, function (ocorrenciaBaixa) {
                qtdEventosBaixa +=  ocorrenciaBaixa.quantidade_eventos;
            });

            total = qtdEventosAlta+qtdEventosMedia+qtdEventosBaixa;

            if(total <= 0){
                $this.apagaTabStatus(statusCodigo);
            }else{
                $this.selecionaTabStatus(statusCodigo);
            }

            setTimeout(function () {
                _scope.$apply();
            },0);
        },

        verificaQuantidadeEventosPorStatusInicio:function (ocorrencias) {
            if(ocorrencias.em_espera.quantidade > 0){
                $this.contaEventosPorStatus(ocorrencias.em_espera, constant.STATUS.EM_ESPERA);
            }

            if(ocorrencias.em_atendimento.quantidade > 0){
                $this.contaEventosPorStatus(ocorrencias.em_atendimento, constant.STATUS.EM_ATENDIMENTO);
            }

            if(ocorrencias.em_observacao.quantidade > 0){
                $this.contaEventosPorStatus(ocorrencias.em_observacao, constant.STATUS.EM_OBSERVACAO);
            }

            if(ocorrencias.aguardando_ronda.quantidade > 0){
                $this.contaEventosPorStatus(ocorrencias.aguardando_ronda, constant.STATUS.AGUARDANDO_RONDA);
            }

            if(ocorrencias.ronda_a_caminho.quantidade > 0){
                $this.contaEventosPorStatus(ocorrencias.ronda_a_caminho, constant.STATUS.RONDA_A_CAMINHO);
            }

            if(ocorrencias.ronda_no_local.quantidade > 0){
                $this.contaEventosPorStatus(ocorrencias.ronda_no_local, constant.STATUS.RONDA_NO_LOCAL);
            }

            if(ocorrencias.ronda_finalizada.quantidade > 0){
                $this.contaEventosPorStatus(ocorrencias.ronda_finalizada, constant.STATUS.RONDA_FINALIZADA);
            }
        },


        atualizarIndiceDeOcorrencia:function (objOcorrencia) {
            try{
                var indice = null;
                var indiceOcorrencia = {
                    id_ocorrencia : objOcorrencia.id_ocorrencia,
                    prioridade : objOcorrencia.prioridade,
                    status : objOcorrencia.status_ocorrencia
                };
                angular.forEach(_scope.ocorrencias.indice, function (ocorrencia, key) {
                    if(ocorrencia.id_ocorrencia == objOcorrencia.id_ocorrencia){
                        indice = key;
                    }
                });

                if(indice == null){
                    _scope.ocorrencias.indice.push(indiceOcorrencia);
                }else{
                    _scope.ocorrencias.indice[indice] = indiceOcorrencia;
                }
            }catch(err){

            }
        },

        removeIndiceDeOcorrencia:function (idOcorrencia) {
            try{
                var indice = null;
                angular.forEach(_scope.ocorrencias.indice, function (ocorrencia, key) {
                    if(ocorrencia.id_ocorrencia == idOcorrencia){
                        indice = key;
                    }
                });

                if(indice != null){
                    _scope.ocorrencias.indice.splice(indice, 1);
                }
                setTimeout(function () {
                    _scope.$apply();
                },0);
            }catch(err){

            }
        },

        deveTrocarPrioridade: function (prioridadeOcorrenciaAtual, prioridadeOcorrenciaNova) {
            return prioridadeOcorrenciaNova < prioridadeOcorrenciaAtual;
        },

        finalizarOcorrenciaMqtt: function (idOcorrencia) {
            try{
                $this.buscarOcorrenciaIndice(idOcorrencia).then(function (ocorrenciaIndice) {
                    if(!angular.isUndefined(ocorrenciaIndice)) {
                        var status = $this.buscaOcorrenciaPorStatus(ocorrenciaIndice.status);
                        var prioridade = $this.buscaOcorrenciaPorPrioridade(ocorrenciaIndice.prioridade);
                        var indexOcorrencia = $this.getIndexOcorrencia(ocorrenciaIndice.id_ocorrencia, status, prioridade);
                        if(!angular.isUndefined(indexOcorrencia) && indexOcorrencia != null){
                            $this.removeOcorrenciaPrioridadeIndexStatus(indexOcorrencia, status, prioridade);
                            $this.removeIndiceDeOcorrencia(idOcorrencia);
                            setTimeout(function () {
                                _scope.$apply();
                            }, 0);
                        }
                    }
                });
            }catch(err){

            }
        },

        removeOcorrenciaPrioridadeIndexStatus: function (index, statusKey, prioridadeKey) {
            try{
                var deferred = $q.defer();
                _scope.ocorrencias[statusKey][prioridadeKey].splice(index, 1);
                _scope.ocorrencias[statusKey].quantidade--;
                setTimeout(function () {
                    _scope.$apply();
                },0);
                deferred.resolve();
                return deferred.promise;
            }catch (err){

            }
        },

        adicionaOcorrenciaPrioridadeIndexStatus: function (ocorrencia, statusKey, prioridadeKey) {
           try{
               if(!angular.isUndefined(_scope.ocorrencias[statusKey])){
                   _scope.ocorrencias[statusKey].quantidade++;
                   _scope.ocorrencias[statusKey][prioridadeKey].push(ocorrencia);
                   setTimeout(function () {
                       _scope.$apply();
                   },0);
               }
           } catch (err){

           }
        },

        buscarOcorrenciaIndice : function (idOcorrencia) {
            var deferred = $q.defer();
            try{
                var indice = null;
                indice = _scope.ocorrencias.indice.find(function (ocorrencia) {
                    return ocorrencia.id_ocorrencia == idOcorrencia;
                });

                if(indice === null){
                    deferred.reject(indice);
                }else{
                    deferred.resolve(indice);
                }
                return deferred.promise;
            }catch(err){
            }
        },

        getIndexOcorrencia: function (idOcorrencia, status, prioridade) {
            try{
                var index = 0;
                angular.forEach(_scope.ocorrencias[status][prioridade], function(ocorrencia, key){
                    if(ocorrencia.id_ocorrencia == idOcorrencia){
                        index = key;
                    }
                });
                return index;
            }catch (err){

            }
        },

        buscaOcorrenciaPorStatus: function (status) {
            switch (status) {
                case constant.STATUS.EM_ESPERA:
                    return "em_espera";
                case constant.STATUS.EM_ATENDIMENTO:
                    return "em_atendimento";
                case constant.STATUS.EM_OBSERVACAO:
                    return "em_observacao";
                case constant.STATUS.AGUARDANDO_RONDA:
                    return "aguardando_ronda";
                case constant.STATUS.RONDA_A_CAMINHO:
                    return "ronda_a_caminho";
                case constant.STATUS.RONDA_NO_LOCAL:
                    return "ronda_no_local";
                case constant.STATUS.RONDA_FINALIZADA:
                    return "ronda_finalizada";
            }
        },

        buscaOcorrenciaPorPrioridade: function (prioridade) {
            switch (prioridade) {
                case constant.PRIORIDADE.ALTA:
                    return "alta";
                case constant.PRIORIDADE.MEDIA:
                    return "media";
                case constant.PRIORIDADE.BAIXA:
                    return "baixa";
            }
        },

        listaOcorrencias: function () {
            OcorrenciasFactory.listarOcorrencias(MonitoramentoService.getIdUsuarioLogado(), function (ocorrencias) {
                $this.setOcorrencias(ocorrencias.data);
                $this.verificaQuantidadeEventosPorStatusInicio(ocorrencias.data);
            }, function (error) {});
        },

        listaOcorrenciaPorId: function (idOcorrencia) {
            var deferred = $q.defer();
            OcorrenciasFactory.listarOcorrenciaPorId(idOcorrencia, function (ocorrencia) {
                deferred.resolve(ocorrencia.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        },

        alteraStatusOcorrencia: function (status, tempo) {
            let id = _scope.ocorrenciaAtual.id_ocorrencia;
            let statusParams = {
                ocorrencia: id,
                status: status,
                tempo_observacao:tempo
            };
            StatusService.alterarStatus(statusParams).then(function () {
                $this.verificarBotaoMapaFpatrol();
                statusParams = [];
                $this.resultadoAlteracaoStatus(false);
            });
        },

        alteraStatusObservacao: function(tempo){
            let statusParams = {
                ocorrencia: _scope.ocorrenciaAtual.id_ocorrencia,
                status: constant.STATUS.EM_OBSERVACAO,
                tempo_observacao:tempo
            };
            StatusService.alterarStatus(statusParams).then(function () {
                if(tempo != null){
                    _scope.modalObservacao.close();
                }
                $this.verificarBotaoMapaFpatrol();
                statusParams = [];
                $this.resultadoAlteracaoStatus(false);
            });
        },

        buttonDisable:function(status){
            switch (status) {
                case constant.STATUS.EM_ATENDIMENTO:
                    _scope.botao_atender = false;
                    $("#btnAtenderOcorrencia").button('loading');
                break;
                case constant.STATUS.EM_OBSERVACAO:
                    _scope.botao_observar = false;
                    $("#btnObservarOcorrencia").button('loading');
                break;
            }
        },

        buttonReset:function(status){
            switch (status) {
                case constant.STATUS.EM_ATENDIMENTO:
                        $("#btnAtenderOcorrencia").text($filter('translate')('ocorrencia_acao_atender'));
                break;
                case constant.STATUS.EM_OBSERVACAO:
                    $("#btnObservarOcorrencia").text($filter('translate')('ocorrencia_acao_observar'));
                break;
            }
        },

        verificarBotaoMapaFpatrol: function(){
            if(_scope.buttonMapFpatrolExists){
                $('.btn-solicitar-map').show();
            }
        },

        postergarObservacao: function(tempo, idSalaEspera){
            var params = {
                tempo_observacao:tempo,
                id:idSalaEspera,
                id_ocorrencia:_scope.ocorrenciaAtual.id_ocorrencia
            };
            StatusFactory.postergarObservacao(params, function (success) {
            }, function (error) {
            });
        },

        solicitarRonda: function (idOcorrencia, login) {
            var deferred = $q.defer();
            var statusParams = {
                ocorrencia: idOcorrencia,
                status: constant.STATUS.AGUARDANDO_RONDA,
                login_operador_externo: login
            };
            StatusService.alterarStatus(statusParams).then(function (result) {
                $this.resultadoAlteracaoStatus(false);
                deferred.resolve(result);
                statusParams = [];
            }, function (erro) {
                statusParams = [];
                deferred.reject(erro);
                ToastMessageService.showErrorMenssage(erro);
            });
            return deferred.promise;
        },

        retirarSolicitacaoRonda: function (idOcorrencia, login) {
            var deferred = $q.defer();
            var params = {
                id_ocorrencia: idOcorrencia,
                login_operador_externo: login
            };
            OcorrenciasFactory.cancelarSolicitacaoRonda(params, function (result) {
                $this.resultadoCancelarRonda(login);
                deferred.resolve(result);
                params = [];
            }, function (erro) {
                deferred.reject(erro);
                params = [];
                ToastMessageService.showErrorMenssage(erro);
            });
            return deferred.promise;
        },

        setTabStatusSuperior: function (index) {
            $rootScope.esvaziaTela = false;
            $rootScope.tab_status_superior = index;
            setTimeout(function(){
                $rootScope.$apply();
            },100);

        },

        resultadoAlteracaoStatus: function(alteradoPeloLog){
            $this.listaOcorrenciaPorId(_scope.ocorrenciaAtual.id_ocorrencia).then(function(ocorrencia) {
                switch (ocorrencia.status_ocorrencia) {
                    case constant.STATUS.EM_ATENDIMENTO:
                        let isTrocaAtendimento = _scope.ocorrenciaAtual.status_ocorrencia === constant.STATUS.EM_ATENDIMENTO && _scope.ocorrenciaAtual.id_operador_atendendo !== userOption.id;
                        $this.resultadoAlteracaoAtendimento(ocorrencia, isTrocaAtendimento, alteradoPeloLog);
                        break;
                    case constant.STATUS.EM_OBSERVACAO:
                        $this.resultadoAlteracaoObservacao(ocorrencia);
                        break;
                    case constant.STATUS.AGUARDANDO_RONDA:
                        $this.resultadoAguardandoRonda(ocorrencia);
                    break;
                }
            }, function(){});
        },

        atualizaHabilitarBotaoObservacao: function(ocorrencia){
            _scope.exibeBtnAguardarEmObservacao = permissoes.aguardar_observacao
                && (ocorrencia.status_ocorrencia === constant.STATUS.EM_ESPERA || ocorrencia.status_ocorrencia === constant.STATUS.EM_ATENDIMENTO);
        },

        resultadoAlteracaoAtendimento: function(ocorrencia, isTrocaAtendimento, alteradoPeloLog){
            if($('#modal-lembrete').is(':visible')){
                LembreteService.buscaOCorrenciasEmEspera(userOption.id);
            }
            Pace.restart();
            $this.setTabStatusSuperior(1);
            ChatService.getConversasPorOcorrencia(ocorrencia.id_ocorrencia);
            $this.atualizaOcorrencia(ocorrencia);
            $this.atualizaHabilitarBotaoObservacao(ocorrencia);
            if(ConfigService.getAutoCarregamentoBotaoFinalizar() && alteradoPeloLog){
                LogService.exibeLog(false);
                MotivosAlarmeService.exibirMotivosAlarme(true);
            }
            if(isTrocaAtendimento){
                _scope.exibeComentarioOcorrencia = true;
            }
            $this.notificarTrocaDeStatus(constant.STATUS.EM_ATENDIMENTO, ocorrencia.id_ocorrencia, isTrocaAtendimento, false);
        },

        resultadoAlteracaoObservacao: function(ocorrencia){
            _scope.exibirInformacoesOcorrencia = false;
            _scope.ocorrenciaAtual = [];
            $this.atualizaDadosDasOcorrencias(ocorrencia);
            $this.notificarTrocaDeStatus(constant.STATUS.EM_OBSERVACAO, ocorrencia.id_ocorrencia, false, false, null);
            ManutencaoSistemaService.removeInformacaoManutencao();
        },

        resultadoAguardandoRonda: function(ocorrencia){
            ViaturasService.atualizaStatusLoginsRonda(ocorrencia.login_operador_externo_atual, constant.STATUS_OPERADOR_RONDA.PENDENTE);
            $this.atualizaOcorrencia(ocorrencia);
            $this.setTabStatusSuperior(3);
            $this.notificarTrocaDeStatus(constant.STATUS.AGUARDANDO_RONDA, ocorrencia.id_ocorrencia, false, false, null);
        },

        resultadoCancelarRonda: function(loginOperadorExternoAtual){
            $this.setTabStatusSuperior(1);
            ChatService.getConversasPorOcorrencia(_scope.ocorrenciaAtual.id_ocorrencia);
            $this.notificarTrocaDeStatus(constant.STATUS.RONDA_CANCELADA, _scope.ocorrenciaAtual.id_ocorrencia, false, false, loginOperadorExternoAtual);

            $this.listaOcorrenciaPorId(_scope.ocorrenciaAtual.id_ocorrencia).then(function(ocorrencia) {
                ViaturasService.atualizaStatusLoginsRonda(loginOperadorExternoAtual, ocorrencia.status_operador_externo_atual);
                $this.atualizaOcorrencia(ocorrencia);
            }, function(){})
        },

        atualizaOcorrencia: function(ocorrencia){
            _scope.ocorrenciaAtual = ocorrencia;
            LogService.listaLogNovoEvento(ocorrencia.id_ocorrencia).then(function(){return true}, function(){return false});
            $this.atualizaDadosDasOcorrencias(ocorrencia);
        },

        notificarTrocaDeStatus: function (status, idOcorrencia, isTrocaAtendimento, foiAlteradoPeloLog, loginOperadorExternoAtual) {
            let params = {
                "status_ocorrencia": status,
                "id_ocorrencia": idOcorrencia,
                "id_login": userOption.id
            };
            switch (status) {
                case constant.STATUS.EM_ATENDIMENTO:
                    params.alterado_pelo_log = foiAlteradoPeloLog ? 1 : 0;
                    params.troca_atendimento = isTrocaAtendimento ? 1 : 0;
                break;
                case constant.STATUS.RONDA_CANCELADA:
                    params.login_operador_externo_atual = loginOperadorExternoAtual;
                break;
            }

            OcorrenciasFactory.notificarTrocaDeStatus(params, function (){}, function () {});
        }
    }

});
angular.module('Fullarm').service('OrdemServicoService', function (OrdemServicoFactory, ToastMessageService, $q, $uibModal) {
    var _scope = {};
    var $this;
    return{

        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.problemas = [];
        },

        listaProblemas:function (atendendo) {
            OrdemServicoFactory.listarProblemasOrdemServico(function (problemas) {
                _scope.problemas = problemas.data;
                if(_scope.problemas != null){
                    if(_scope.problemas.length > 0 && atendendo){
                        setTimeout(function () {
                            $("#btnOs").show();
                        },0);
                    }else{
                        $("#btnOs").hide();
                    }
                }
            }, function (error) {
            });
        },

        abreModalOrdemDeServico: function(){
            setTimeout(function () {
                $("#selectProblemas").val("");
                $("#descricaoServico").val("");
                _scope.problemas_fullcontrol = _scope.problemas;
                _scope.modalOs = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/pages/modals/osModal.html',
                    windowClass: 'zindex',
                    size:'lg',
                    backdrop  : 'static',
                    keyboard  : false,
                    scope:_scope
                });
            }, 100);
        },

        fecharModalOrdemDeServico:function(){
            _scope.modalOs.close();
        },

        gerarSolicitacao: function (idSistema) {
            var deferred = $q.defer();
            var problemaId = $("#selectProblemas").val();
            var problemaDescricao = $("#selectProblemas").find(':selected').text();
            var osDescricao = $("#descricaoServico").val();

            var objOrdemServico = {descricao:osDescricao, descricao_problema:problemaDescricao, problema:problemaId};

            OrdemServicoFactory.cadastrarSolicitacaoOrdemDeServico(objOrdemServico, idSistema, function (sucess) {
                ToastMessageService.showSuccessMenssage("ocorrencia_toast_sucesso_solicitacao_os", "ocorrencia_label_ordem_servico");
                $this.fecharModalOrdemDeServico();
                deferred.resolve(sucess);
            }, function (error) {
                ToastMessageService.showErrorMenssage(error);
                deferred.reject(error);
                $this.fecharModalOrdemDeServico();
            });
            return deferred.promise;
        }
    }

});
angular.module('Fullarm').service('PageTopService', function ($filter, RequestFactory) {
    var _scope = {};
    var $this;

    return{
        setScope: function (scope) {
            $this  = this;
            _scope = scope;
            _scope.exibirOrdemServico = false;
        },

        exibeIconesNoTopo: function (objeOcorrencia) {

            if(objeOcorrencia.sistema.possui_chaves && objeOcorrencia.sistema.chave_ativo){
                var html = "";
                angular.forEach(objeOcorrencia.sistema.chaves, function (chave) {
                    html += "<tr><td>"+chave.numero_chaveiro+"</td><td>"+chave.observacao+"</td></tr>";
                });
                $("#listChaves").html(html);
                $("#li_chaves").show();
            }else{
                $("#li_chaves").hide();
            }
            if(objeOcorrencia.feriado_hoje){
                var tipoDescricao = $this.getDescricaoTipoFeriado(objeOcorrencia.sistema.feriado.tipo);
                var anual = objeOcorrencia.sistema.feriado.anual == 1 ? 'ocorrencia_informacao_feriado_anual' : 'ocorrencia_informacao_feriado_nao_anual';
                $("#li_feriado").show();

                if(userOption.idioma == 'en'){
                    $("#descricao_feriado").html( $filter('translate')(tipoDescricao) +' '+ $filter('translate')('ocorrencia_informacao_label_feriado') +' '+  $filter('translate')('ocorrencia_informacao_label_de') +' '+ objeOcorrencia.sistema.feriado.descricao+', '+$filter('translate')(anual));
                }else{
                    $("#descricao_feriado").html( $filter('translate')('ocorrencia_informacao_label_feriado') +' '+ $filter('translate')(tipoDescricao) +' '+ $filter('translate')('ocorrencia_informacao_label_de') +' '+ objeOcorrencia.sistema.feriado.descricao+', '+$filter('translate')(anual));
                }

            }else{
                $("#li_feriado").hide();
            }

            if(!angular.isUndefined(objeOcorrencia.sistema.cliente.nivel_risco) && objeOcorrencia.sistema.cliente.nivel_risco > 0) {
                if (objeOcorrencia.sistema.cliente.nivel_risco === "1") {
                    $("#nivel_risco_alto").show();
                    $("#nivel_risco_baixo").hide();
                    $("#nivel_risco_medio").hide();
                } else if (objeOcorrencia.sistema.cliente.nivel_risco == "2") {
                    $("#nivel_risco_medio").show();
                    $("#nivel_risco_alto").hide();
                    $("#nivel_risco_baixo").hide();
                } else {
                    $("#nivel_risco_baixo").show();
                    $("#nivel_risco_medio").hide();
                    $("#nivel_risco_alto").hide();
                }
            }
        },

        getDescricaoTipoFeriado:function(tipo){
            switch (tipo) {
                case 'Municipal':
                    return 'ocorrencia_informacao_feriado_municipal';
                case 'Estadual':
                    return 'ocorrencia_informacao_feriado_estadual';
                case 'Nacional':
                    return 'ocorrencia_informacao_feriado_nacional';
                case 'Internacional':
                    return 'ocorrencia_informacao_feriado_internacional';
            }
            return '';
        },

        escondeIconesNoTopo:function () {
            $("#nivel_risco_alto").hide();
            $("#nivel_risco_baixo").hide();
            $("#nivel_risco_medio").hide();
            $("#li_chaves").hide();
            $("#li_feriado").hide();
            $("#btnOs").hide();
        },
        
        deslogar:function () {
            var URL  = '/monitoramento/logout';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, function (result) {}, function (error) {});
        },
    }
});
angular.module('Fullarm').service('PainelService', function ($filter, $uibModal, PostergarHorarioService, PainelFactory, AcaoUsuarioService, ToastMessageService, painelConstants) {

    var _scope = {};
    var $this;
    return{
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.painel = [];
            _scope.painelVirtual = [];
            _scope.setores = [];
            _scope.painelVirtualId = 0;
            _scope.painelVirtualModelo = 0;
            _scope.statusPainel = "false";
            _scope.sireneAcionada = false;
            _scope.paineisVirtuais = [];
            _scope.painelAtual = 0;
            _scope.abaPainelSelecionada = false;
            _scope.statusParticaoGerouOcorrencia = false;
            _scope.painelVirtualLength = 0;
            _scope.comandosEnviados = [];
            _scope.comandosRecebidos = [];
            _scope.executando = false;
            _scope.setoresAbertos = [];
        },
        filterPaneis: function(paineisVirtuais){
            if( angular.isArray(paineisVirtuais) ){
                return paineisVirtuais.filter(function(painelVirtual){
                    return painelVirtual.painel.ativo;
                })
            }

            return paineisVirtuais;
        },
        conectaTopicoPainel: function (paineisVirtuais, idSistema) {

            var paineisVirtuais = $this.filterPaneis(paineisVirtuais);

            if(_scope.client.isConnected()) {
                if(paineisVirtuais.length > 0){
                    angular.forEach(paineisVirtuais, function (painel) {
                        _scope.client.subscribe("sistema/" + idSistema + "/painel/"+painel.id+"/comando/#", {qos: 2});
                        _scope.client.subscribe("sistema/" + idSistema + "/painel/"+painel.id+"/armado", {qos: 2});
                        _scope.client.subscribe("sistema/" + idSistema + "/painel/"+painel.id+"/conectado", {qos: 2});
                        _scope.client.subscribe("fullcenter/sistema/" + idSistema + "/painel/"+painel.id+"/setor/+", {qos: 2});
                        _scope.client.subscribe("sistema/" + idSistema + "/painel/"+painel.id+"/keep_alive", {qos: 2});
                        _scope.client.subscribe("sistema/" + idSistema + "/painel/"+painel.id+"/sirene/status", {qos: 2});
                        _scope.client.subscribe("fullcenter/sistema/" + idSistema + "/painel/"+painel.id+"/tipo_arme", {qos: 2});
                    });
                }
            }
        },

        setPainelVirtualQueGerouOcorrencia: function (idPainelVirtual) {
            if(idPainelVirtual > 0) {
                var objPainelVirtual = _scope.paineisVirtuais[idPainelVirtual];
                if (objPainelVirtual && objPainelVirtual.id > 0) {
                    _scope.painelVirtual = objPainelVirtual;
                    $this.setPainel(objPainelVirtual.painel);
                    $this.setPainelVirtualId(objPainelVirtual.id);
                    $this.setPainelVirtualModelo(objPainelVirtual.id_modelo);
                }
            }
        },

        setPaineisVirtuaisDoSistema: function(paineisVirtuais){

            var paineisVirtuais = $this.filterPaneis(paineisVirtuais)
            var setores = [];
            var arrPaineis = {};
            _scope.painelVirtualLength = Object.keys(paineisVirtuais).length;

            if(Object.keys(paineisVirtuais).length > 0){
                angular.forEach(paineisVirtuais, function (painel) {
                    if(_scope.ocorrenciaAtual.primeiro_evento.id_painel_virtual > 0 && (painel.id == _scope.ocorrenciaAtual.primeiro_evento.id_painel_virtual)){
                        PostergarHorarioService.setBotaoPostergar(painel.armado);
                        _scope.statusParticaoGerouOcorrencia = painel.armado;
                        $this.setPainelAtual(painel.id);
                    }else{
                        $this.setPainelAtual(paineisVirtuais[0].id);
                    }
                    arrPaineis[painel.id] = painel;
                    angular.forEach(painel.setores, function (setor) {
                        setores.push(setor);
                    });
                });
                _scope.paineisVirtuais = arrPaineis;
                $this.setSetores(setores);
            }
        },

        setPainelAtual : function(id){
            _scope.painelAtual = id;
        },

        setAbaPainelSelecionada:function(selecionada){
            _scope.abaPainelSelecionada = selecionada;
        },

        esvaziaPainelVirtual: function () {
            $this.setSetores([]);
            $this.setPainel([]);
            $this.setPainelVirtualId(0);
            $this.setPainelVirtualModelo(0);
            _scope.paineisVirtuais = [];
        },

        setPainel: function (objPainel) {
            _scope.painel = objPainel;
            _scope.exibePainel = objPainel.id > 0;
        },

        atualizaInformacoesHardware: function(destinationName, msg){

            const regex = new RegExp('^sistema\\/(?<idSistema>\\d{1,})\\/painel\\/(?<idPainel>\\d{1,})\\/setor\\/(?<idSetor>\\d{1,})\\/(?<atributo>.*)','gm');
            var atributos = regex.exec(destinationName);

            if(atributos !== null && !angular.isUndefined(_scope.setores[atributos.groups.idSetor])){
                if(atributos.groups.atributo !== 'temperatura' && atributos.groups.atributo !== 'nivel_sinal'){
                    _scope.setores[atributos.groups.idSetor][atributos.groups.atributo] = msg.payloadString == 'true' ? true : false;
                }else{
                    _scope.setores[atributos.groups.idSetor][atributos.groups.atributo] = msg.payloadString;
                }
                _scope.$apply();
            }
        },

        atualizaInformacoesHardwarePorJason: function(destinationName, msg){
            const regex = new RegExp('^fullcenter/sistema\\/(?<idSistema>\\d{1,})\\/painel\\/(?<idPainel>\\d{1,})\\/setor\\/(?<idSetor>\\d{1,})','gm');
            var atributos = regex.exec(destinationName);
            var dadosDaMensgaem = JSON.parse(msg.payloadString);

            if(atributos !== null && !angular.isUndefined(_scope.setores[atributos.groups.idSetor])) {
                angular.forEach(dadosDaMensgaem, function (valor, key) {
                    if(!angular.isUndefined(_scope.setores[atributos.groups.idSetor][key])){
                        _scope.setores[atributos.groups.idSetor][key] = valor;
                    }
                });
                _scope.$apply();
            }
        },

        atualizaKeepAlive: function(destinationName, msg){
            const regex = new RegExp('^sistema\\/(?<idSistema>\\d{1,})\\/painel\\/(?<idPainel>\\d{1,})\\/(?<atributo>.*)','gm');
            var atributos = regex.exec(destinationName);
            if((atributos != null && !angular.isUndefined(atributos)) && !angular.isUndefined(_scope.paineisVirtuais[atributos.groups.idPainel])){
                _scope.paineisVirtuais[atributos.groups.idPainel][atributos.groups.atributo] = $this.getKeepAlivePainel(msg.payloadString);
                _scope.$apply();
            }
        },

        atualizaInformacoesPainelVirtual: function(destinationName, msg){
            const regex = new RegExp('^sistema\\/(?<idSistema>\\d{1,})\\/painel\\/(?<idPainel>\\d{1,})\\/(?<atributo>.*)','gm');
            var atributos = regex.exec(destinationName);
            var status = msg.payloadString == "true";
            var tipo_atualizacao = atributos.groups.atributo;

            if((atributos != null && !angular.isUndefined(atributos)) && !angular.isUndefined(_scope.paineisVirtuais[atributos.groups.idPainel])){
                _scope.paineisVirtuais[atributos.groups.idPainel][tipo_atualizacao] = status;
                _scope.$apply();
            }
            if(tipo_atualizacao == 'armado'){
                if(atributos.groups.idPainel == _scope.ocorrenciaAtual.sistema.painel_virtual.id){
                    PostergarHorarioService.setBotaoPostergar(status);
                }
            }
        },

        atualizaInformacaoTipoArme: function(destinationName, msg){
            const regex = new RegExp('^fullcenter/sistema\\/(?<idSistema>\\d{1,})\\/painel\\/(?<idPainel>\\d{1,})\\/(?<atributo>.*)','gm');
            var atributos = regex.exec(destinationName);

            if((atributos != null && !angular.isUndefined(atributos)) && !angular.isUndefined(_scope.paineisVirtuais[atributos.groups.idPainel])){
                _scope.paineisVirtuais[atributos.groups.idPainel]['tipo_arme'] = msg.payloadString;
                _scope.$apply();
            }
        },

        atualizaStatusSirene:function(destinationName, msg){
            const regex = new RegExp('^sistema\\/(?<idSistema>\\d{1,})\\/painel\\/(?<idPainel>\\d{1,})\\/(?<atributo>.*)','gm');
            var atributos = regex.exec(destinationName);

            if((atributos != null && !angular.isUndefined(atributos)) && !angular.isUndefined(_scope.paineisVirtuais[atributos.groups.idPainel])){
                _scope.paineisVirtuais[atributos.groups.idPainel]['sirene_acionada'] = msg.acionada;

                if(msg.acionada && msg.tempoAcionamento > 0){
                    setTimeout(function(){
                        _scope.paineisVirtuais[atributos.groups.idPainel]['sirene_acionada'] = false;
                        _scope.$apply();
                    },msg.tempoAcionamento*1000);
                }
                _scope.$apply();
            }
        },

        getKeepAlivePainel:function (msg) {
            if($this.isDate(msg.substring(0,10)) && msg != ""){
                var date = new Date(msg).toLocaleDateString()+" "+new Date(msg).toLocaleTimeString();
                return date;
            }else{
                return "";
            }
        },

        isDate : function(value) {
            return toString.call(new Date(value)) === '[object Date]';
        },

        esvaziaSetoresAbertos: function(){
          _scope.setoresAbertos = [];
        },

        setSetores: function(objSetores){
            var arrSetores = {};
            if(objSetores.length > 0){
                angular.forEach(objSetores, function (setor) {
                    arrSetores[setor.id] = setor;
                });
                _scope.setores = arrSetores;
                _scope.exibeSetores = true;
            }
        },

        getPainelVirtualId: function () {
            return _scope.painelVirtualId;
        },

        getPainelVirtualModelo: function () {
            return _scope.painelVirtualModelo;
        },

        setPainelVirtualId: function (id) {
            _scope.painelVirtualId = id;
        },

        setPainelVirtualModelo: function (modelo) {
            _scope.painelVirtualModelo = modelo;
        },

        enviarComandosParaPainel:function (data) {
            if(!angular.isUndefined(data.idPainelVirtual) && data.idPainelVirtual > 0){
                PainelFactory.enviarComando(data, function (result) {
                    _scope.comandosEnviados.push(result.data.status);
                    $this.verificaResultadoComando(result.data.status.id);
                },function (error) {
                    ToastMessageService.showErrorMenssage(error);
                });
            }
        },

        enviarComandosParaSirene:function (data, s, e) {
            PainelFactory.enviarComando(data, function (sucess) {
                s(sucess);
            },function (error) {
                e(error)
            });
        },

        insereLogPosComandoSirene:function(comando){
            var data = {
                "acao_usuario": "ACIONAMENTO_SIRENE",
                "id_painel": comando.idPainel,
                "ocorrencia": _scope.ocorrenciaAtual.id_ocorrencia,
                "tempo_acionamento": comando.tempoAcionamento,
                "comando": comando.comando
            };
            AcaoUsuarioService.inserirLogAcaoUsuario(data);
        },

        recebeResultadoComando: function (destinationName, resultado) {
            const regex = new RegExp('^sistema\\/(?<idSistema>\\d{1,})\\/painel\\/(?<idPainel>\\d{1,})\\/comando\\/(?<idComando>\\d{1,})','gm');
            var atributos = regex.exec(destinationName);
            resultado.id = atributos.groups.idComando;
            _scope.comandosRecebidos.push(resultado);
            if(_scope.comandosEnviados.length > 0){
                angular.forEach(_scope.comandosEnviados, function(comando){
                    if(comando.id == atributos.groups.idComando){
                        $this.executaResultadoComando(resultado);
                    }
                });
            }
        },

        verificaResultadoComando: function (id) {
            if(_scope.comandosRecebidos.length > 0){
                angular.forEach(_scope.comandosRecebidos, function (comando) {
                    if(comando.id == id){
                        $this.executaResultadoComando(comando);
                    }
                });
            }
        },

        executaResultadoComando:function (resultado) {
            if(!angular.isUndefined(resultado)){
                switch(resultado.status){
                    case 0:
                    case 1:
                    case 2:
                        _scope.executando = true;
                        return;
                    case 3:
                        _scope.executando = false;
                        ToastMessageService.showSuccessMenssage(painelConstants.StatusComando[resultado.status], "");
                        return;
                    case 7:
                    case 12:
                        _scope.executando = false;
                        if(resultado.mensagem == ""){
                            ToastMessageService.showErrorMenssageWeb(painelConstants.StatusComando[resultado.status]);
                        }else{
                            $this.verificaSetoresAbertos(resultado.tipo);
                        }
                        return;
                }

                if(!angular.isUndefined(painelConstants.StatusComando[resultado.status])){
                    _scope.executando = false;
                    ToastMessageService.showErrorMenssageWeb(painelConstants.StatusComando[resultado.status]);
                }
            }
        },

        verificaSetoresAbertos: function(comando){
            angular.forEach(_scope.setores, function (setor) {
                if(setor.aberto){
                    _scope.setoresAbertos.push(setor);
                }
            });
            if(_scope.setoresAbertos.length > 0){
                $this.abrirModalSetores(comando);
            }
        },

        abrirModalSetores: function (comando) {
            _scope.comandoArmeStay = (comando == painelConstants.Comandos.ARMAR_STAY || comando == painelConstants.Comandos.ARMAR_STAY_INIBINDO_SETORES);
            _scope.modalSetoresAbertos = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/modals/setoresAbertosModal.html',
                size: 'gl',
                scope:_scope
            });
            _scope.modalSetoresAbertos.result.then(function(result){
                _scope.checagem = true;
                $this.esvaziaSetoresAbertos();
            }, function(result){
                _scope.checagem = true;
                $this.esvaziaSetoresAbertos();
            });

            setTimeout(function () {
                $('#rbInibirSetoresAbertos').bootstrapToggle();
                $(".toogleSetores .toggle-off").text("");
                $(".toogleSetores .toggle-on").text("");
            },100);

        },

        fecharModalSetoresAbertos:function(){
            _scope.modalSetoresAbertos.dismiss('cancel');
        },

    }
});
angular.module('Fullarm').service('MonitoramentoService', function (constant) {

    var _scope = {};
    return {
        setScope: function (scope) {
            _scope = scope;
            _scope.id_usuario_logado = userOption.id;
            _scope.is_usuario_ftalk = userOption.login_ftalk;
            _scope.user = userOption.descricao;
            _scope.userLogin = userOption.login;
            _scope.plataforma = plataform;
            _scope.url = constant.BASE_URL;
            _scope.permissao_evento_manual = permissoes.gerar_evento_manual;
            _scope.permissao_solicitar_os = permissoes.solicitar_os;
            _scope.assumir_atendimento = permissoes.assumir_atendimento;
            _scope.permissao_enviar_comandos = permissoes.enviar_comandos;
            _scope.permissao_fulltrack_fullarm = permissoes.fullarm_fulltrack;
            _scope.botao_atender = false;
            _scope.botao_observar = false;
            _scope.botao_processo = false;
            _scope.botao_assumir = false;
            _scope.botao_finalizar = false;
            _scope.botao_ronda = false;
            _scope.loginGruposAtendimento = [];

            _scope.status_1 = {
                isCustomHeaderOpen: false,
                isFirstOpen: true,
                isFirstDisabled: false,
                open: false
            };
            _scope.status_2 = {
                isCustomHeaderOpen: false,
                isFirstOpen: true,
                isFirstDisabled: false,
                open: false
            };
            _scope.status_3 = {
                isCustomHeaderOpen: false,
                isFirstOpen: true,
                isFirstDisabled: false,
                open: false
            };
            _scope.status_4 = {
                isCustomHeaderOpen: false,
                isFirstOpen: true,
                isFirstDisabled: false,
                open: false
            };
            _scope.status_5 = {
                isCustomHeaderOpen: false,
                isFirstOpen: true,
                isFirstDisabled: false,
                open: false
            };
            _scope.status_6 = {
                isCustomHeaderOpen: false,
                isFirstOpen: true,
                isFirstDisabled: false,
                open: false
            };
            _scope.status_7 = {
                isCustomHeaderOpen: false,
                isFirstOpen: true,
                isFirstDisabled: false,
                open: false
            };
            _scope.status_8 = {
                isCustomHeaderOpen: false,
                isFirstOpen: true,
                isFirstDisabled: false,
                open: false
            };
            _scope.status_9 = {
                isCustomHeaderOpen: false,
                isFirstOpen: true,
                isFirstDisabled: false,
                open: false
            };
            _scope.status_10 = {
                isCustomHeaderOpen: false,
                isFirstOpen: true,
                isFirstDisabled: false,
                open: false
            };
        },

        setBotoes:function (botoes) {
            _scope.botao_atender = botoes.atender;
            _scope.botao_observar = botoes.observar;
            _scope.botao_processo = botoes.processo;
            _scope.botao_ronda = botoes.ronda;
            _scope.botao_assumir = botoes.assumir;
            _scope.botao_solicitar_ronda = botoes.solicitar_ronda;
            //_scope.botao_finalizar = botoes.pode_fnalizar;
        },

        habiltaBotaoFinalizar: function (podeFinalizar) {
            _scope.botao_finalizar = podeFinalizar;
        },


        getIdUsuarioLogado: function () {
            return _scope.id_usuario_logado;
        },

        getNomeUsuarioLogado: function () {
            return _scope.user;
        },

        getLoginUsuarioLogado: function () {
            return _scope.userLogin;
        },

        getPlataformaDescricao: function () {
          return _scope.plataforma;
        },

        getUrl:function () {
            return _scope.url;
        },

        getPermissaoAssumirAtendimento: function () {
            return _scope.assumir_atendimento;
        },

        getPermissaoEventoManual: function () {
            return _scope.permissao_evento_manual;
        },

        getPermissaoSolicitarOs: function () {
            return _scope.permissao_solicitar_os;
        },

        getPermissaoFullarmFulltrack: function () {
            return _scope.permissao_fulltrack_fullarm;
        },

        getIdUsuarioFtalk: function(){
            return _scope.is_usuario_ftalk;
        },

        setLoginsRonda: function(objLogins){
            var arrLoginsRonda = {};
            if(objLogins.length > 0){
                angular.forEach(objLogins, function (login) {
                    arrLoginsRonda[login.id] = login;
                });
                _scope.loginGruposAtendimento = arrLoginsRonda;
            }
        },

        closeAllTabs:function () {
            _scope.status_1.open = false;
            _scope.status_2.open = false;
            _scope.status_3.open = false;
            _scope.status_4.open = false;
            _scope.status_5.open = false;
            _scope.status_6.open = false;
            _scope.status_7.open = false;
            _scope.status_8.open = false;
            _scope.status_9.open = false;
            _scope.status_10.open = false;
        },

        openTabContato:function () {
            _scope.status_3.open = true;
        }
    }

});
angular.module('Fullarm').service('PopupWindowService', function (constant, $filter) {

    var _scope = {};
    var $this;
    var w;
    return{
        setScope: function (scope) {
        $this = this;
        _scope = scope;
        },

        openPopupWindow: function (options) {
            var w = window.open(options.url,
                'popUpWindow',
                'height='+options.height+',' +
                'width='+options.width+',' +
                'left='+options.left+',' +
                'top='+options.top+',' +
                'resizable=yes,' +
                'scrollbars=yes,' +
                'toolbar=yes,' +
                'menubar=no,' +
                'location=no,' +
                'directories=no,' +
                'status=yes'
            );
        },

        openPopupWindowCarousel: function (options, dados) {
            var imagens     = !angular.isUndefined(dados.imagens) && dados.imagens != null ? dados.imagens : null;
            var videos      = !angular.isUndefined(dados.videos) && dados.videos != null ? dados.videos : null;

            if(w && !w.closed) {
                w.focus();
            }else{
                setTimeout(function () {
                    w = window.open('app/theme/components/slider/popupImagensDisparo.html',
                        'popUpWindow',
                        'height=' + options.height + ',' +
                        'width=' + options.width + ',' +
                        'left=' + options.left + ',' +
                        'top=' + options.top + ',' +
                        'resizable=yes,' +
                        'scrollbars=yes,' +
                        'toolbar=yes,' +
                        'menubar=no,' +
                        'location=no,' +
                        'directories=no,' +
                        'status=yes'
                    );

                    w.onload = function () {
                        var content = "";
                        var contentVideos = "";
                        var classe = "";
                        var indicators = '';
                        var indicatorsVideos = '';
                        var i = 0, j = 0;
                        var url = "";

                        w.document.getElementById('home-tab').style.display = 'none';
                        w.document.getElementById('profile-tab').style.display = 'none';
                        w.document.getElementById('home-tab').innerHTML = $filter('translate')('ocorrencia_label_imagens');
                        w.document.getElementById('profile-tab').innerHTML = $filter('translate')('ocorrencia_tooltip_video_pre_alarme');

                        if(imagens != null ) {
                            w.document.getElementById('home-tab').style.display = 'block';
                            if (imagens.length > 1) {
                                w.document.getElementById('sliderImagens').style.display = 'block';
                                for (i = 0; i < imagens.length; i++) {
                                    classe = i === 0 ? 'active' : 0;
                                    indicators += '<li data-target="#sliderImagens" data-slide-to="' + i + '" class="' + classe + '"></li>'
                                }
                                w.document.getElementById('indicators').innerHTML = indicators;
                                angular.forEach(imagens, function (imagem, index) {
                                    classe = index === 0 ? "item active" : "item";
                                    url = !angular.isUndefined(imagem.versao) && imagem.versao == "2" ? imagem.caminho_imagem : constant.IMAGE_URL + imagem.caminho_imagem;
                                    content += '<div class="' + classe + '">' +
                                        '<img src="' + url + '">' +
                                        '<div class="carousel-caption"></div>' +
                                        '</div>';
                                });
                                w.document.getElementById('slider').innerHTML = content;
                            } else {
                                w.document.getElementById('sliderImagens').style.display = 'none';
                                url = !angular.isUndefined(imagens[0].versao) && imagens[0].versao == "2" ? imagens[0].caminho_imagem : constant.IMAGE_URL + imagens[0].caminho_imagem;
                                content += '<img style="width: 100%" src="' + url + '">';
                                w.document.getElementById('uma-imagem').innerHTML = content;
                            }
                        }
                        if(videos != null){
                            w.document.getElementById('profile-tab').style.display = 'block';
                            if (videos.length > 1) {
                                w.document.getElementById('sliderVideos').style.display = 'block';
                                for (j = 0; j < videos.length; j++) {
                                    classe = j === 0 ? 'active' : 0;
                                    indicatorsVideos += '<li data-target="#sliderVideos" data-slide-to="' + j + '" class="' + classe + '"></li>'
                                }
                                w.document.getElementById('indicatorsVideos').innerHTML = indicatorsVideos;
                                angular.forEach(videos, function (video, index) {
                                    classe = index === 0 ? "item active" : "item";
                                    contentVideos += '<div class="' + classe + '">' +
                                        '<video style="width: 75%;" controls autoplay><source src="' + video.url_video + '" type="video/mp4"></video>' +
                                        '<div class="carousel-caption"></div>' +
                                        '</div>';
                                });
                                w.document.getElementById('vSlider').innerHTML = contentVideos;
                            } else {
                                w.document.getElementById('sliderVideos').style.display = 'none';
                                contentVideos += '<video style="width: 75%;" controls autoplay><source src="' + videos[0].url_video + '" type="video/mp4"></video>';
                                w.document.getElementById('um-video').innerHTML = contentVideos;
                            }
                        }
                        w.focus();
                    };
                },500);
            }
        }
    };
});
angular.module('Fullarm').service('PostergarHorarioService', function ($filter, constant, PostergarHorarioFactory, ToastMessageService, $q) {

    var _scope = {};
    var $this;
    return{
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.existeEventoTabelaHorario = false;
            _scope.eventoTabelaHorario = [];
            _scope.tituloModalPostergar = "";
            _scope.labelInicioFim = "";
            _scope.labelTolerancia = "";
            _scope.legendArmeDesarme = "";
            _scope.labelPostergarPara = "";
            _scope.horaInicio = "";
            _scope.tolerancia = "";
        },

        postergarHorario: function (params, idSistema) {
            var deferred = $q.defer();
            PostergarHorarioFactory.updateHorario(params, idSistema,
                function (result) {
                    ToastMessageService.showSuccessMenssage('ocorrencia_toast_horario_postergado_sucesso', '');
                    deferred.resolve(result);
                    $('#modal-postergar').iziModal('close');
                },
                function (error) {
                    deferred.reject(error);
                    $('#modal-postergar').iziModal('close');
                });
            return deferred.promise;
        },

        setEventoTabelaHorario:function (evento) {
            if(evento != false){
                _scope.eventoTabelaHorario = evento;
                $this.setTituloModalPostergar(_scope.eventoTabelaHorario);
            }else{
                _scope.existeEventoTabelaHorario = false;
                setTimeout(function () {
                    _scope.$apply();
                }, 0);
            }
        },

        esvaziaEventoTabelaHorario: function(){
            _scope.eventoTabelaHorario = [];
            _scope.existeEventoTabelaHorario = false;
        },

        setBotaoPostergar:function(statusParticao){
            _scope.existeEventoTabelaHorario = (_scope.eventoTabelaHorario.tipo_evento_tabela_horario == 1 && (statusParticao == 'false' || !statusParticao)) || (_scope.eventoTabelaHorario.tipo_evento_tabela_horario == 2 && (statusParticao == 'true' || statusParticao));
            setTimeout(function () {
               _scope.$apply();
            }, 0);
        },

        setTituloModalPostergar: function (evento) {
            _scope.tituloModalPostergar = evento.tipo_evento_tabela_horario == 1 ? $filter('translate')('ocorrencia_label_postergar_arme') : $filter('translate')('ocorrencia_label_postergar_desarme');
            _scope.legendArmeDesarme    = evento.tipo_evento_tabela_horario == 1 ? $filter('translate')('ocorrencia_label_horario_arme') : $filter('translate')('ocorrencia_label_horario_desarme');
            _scope.labelPostergarPara   = evento.tipo_evento_tabela_horario == 1 ? $filter('translate')('ocorrencia_label_postergar_inicio_para') : $filter('translate')('ocorrencia_label_postergar_fim_para');
            _scope.horario              = evento.inicio+' - '+evento.fim;
            _scope.tolerancia           = evento.tipo_evento_tabela_horario == 1 ? evento.tolerancia_inicio : evento.tolerancia_fim;
            _scope.labelInicioFim       = $filter('translate')('ocorrencia_label_inicio');
            _scope.labelTolerancia      = $filter('translate')('ocorrencia_label_tolerancia');
        },

        verificaTabelaHorario: function(){
            let horario_fim = _scope.ocorrenciaAtual.evento_tabela_horario.fim;
            let horario_existe = _scope.ocorrenciaAtual.evento_tabela_horario.horario_existe;
            let hora_atual = moment().format("HH:mm");
            let horaAtualMenorQueInicioDeArme = (_scope.ocorrenciaAtual.evento_tabela_horario.tipo_evento_tabela_horario == 1 && hora_atual < _scope.ocorrenciaAtual.evento_tabela_horario.inicio);
            let horaFimExcedida = hora_atual > horario_fim;

            if(horaFimExcedida || !horario_existe || horaAtualMenorQueInicioDeArme) {
                return constant.ESTADO_TABELA_HORARIO.HORARIO_EXCEDIDO;
            }else if(!permissoes.tabela_horario){
                return constant.ESTADO_TABELA_HORARIO.PERMISSAO_NEGADA;
            }
            return constant.ESTADO_TABELA_HORARIO.HORARIO_VALIDO;
        },

        getEventoTabelaHorario: function () {
            return _scope.eventoTabelaHorario;
        },

        abreModalPostergar: function(){
            setTimeout(function () {
                $("#hora_postergar").val("");
                $("#comentario_postergar").val("");
                $('#modal-postergar').iziModal('open');
                $("#modal-postergar").iziModal('setTitle', _scope.tituloModalPostergar);
                $("#span_horario").text(" "+_scope.horario);
                $("#span_tolerancia").text(" "+_scope.tolerancia);
                $("#legendTitle").text(_scope.legendArmeDesarme);
                $("#lblTolerancia").text(_scope.labelTolerancia+":");
                $("#lbl_postergar_para").text(_scope.labelPostergarPara+":");
            }, 100);
        }
    }
});
angular.module('Fullarm').service('MqttService', function ($timeout,
                                                           $filter,
                                                           constant,
                                                           $rootScope,
                                                           OcorrenciasService,
                                                           LogService,
                                                           TelaConfigService,
                                                           OcorrenciaAtualService,
                                                           MonitoramentoService,
                                                           ToastMessageService,
                                                           SomService,
                                                           HistoricoEventosService,
                                                           OcorrenciasFactory,
                                                           LogDeErroService,
                                                           PainelService,
                                                           VideosService,
                                                           ChatService,
                                                           LembreteService,
                                                           CarregamentoOcorrenciaService,
                                                           MotivosAlarmeService,
                                                           ConfigService,
                                                           AutomacaoService,
                                                           ViaturasService,
                                                           PostergarHorarioService,
                                                           ManutencaoSistemaService,
                                                           InformacoesOcorrenciaService) {


    var _scope = {};
    var $this;
    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.client = "";
            _scope.estadoMqtt = true;
            _scope.msgMqtt = [];
            _scope.painelArmado = false;
            ToastMessageService.init();
            _scope.client = new Paho.MQTT.Client(configMqtt.link, Number(configMqtt.porta), configMqtt.path, userOption.email+""+configMqtt.client_id);
            _scope.clientFtalk = new Paho.MQTT.Client(configMqttFtalk.link, Number(configMqttFtalk.porta), configMqttFtalk.path,  userOption.id+""+configMqttFtalk.client_id);
            _scope.myTimer = setInterval(function(){$this.recarregarATela();}, 900000);
            $rootScope.$logsFinishedLoading = true;
            _scope.msgs = "";
        },
        recarregarATela: function () {
            window.location.reload();
        },

        clearTimer:function () {
            clearInterval(_scope.myTimer);
            _scope.myTimer = setInterval(function() {
                $this.recarregarATela();
            }, 900000);
        },

        startMQtt: function (gruposAtendimento) {
            if(_scope.client.isConnected()){
                return;
            }
            _scope.client.connect({
                userName: configMqtt.user,
                password: configMqtt.password,
                useSSL: configMqtt.useSSL,
                onSuccess: function () {
                    _scope.estadoMqtt = true;
                    $this.conectaTopicoGrupoAtendimento(_scope.client, gruposAtendimento);
                    $('#div_login').css('background-color', 'green');
                    $('#div_login').attr('title', 'Conectado');
                },
                onFailure: function (msg) {
                    _scope.estadoMqtt = false;
                    $this.startMQtt();
                }
            });
            _scope.client.onMessageArrived = $this.receberMensagemMqtt;
            _scope.client.onConnectionLost = $this.onConnectionLost;
        },

        onConnectionLost: function (msg) {
            _scope.estadoMqtt = false;
            $('#div_login').css('background-color', 'red');
            $('#tt_desconectado').fadeIn(3000);
            ToastMessageService.mostraPushNavegador("Fullcenter Offline", null, function () {
                return false;
            });
            setTimeout(function () {
                $('#tt_desconectado').fadeOut(3000);
                $this.startMQtt();
            },10000);
        },

        startMQttFtalk: function () {
            if(_scope.clientFtalk.isConnected()){
                return;
            }
            _scope.clientFtalk.connect({
                userName: configMqttFtalk.user,
                password: configMqttFtalk.password,
                useSSL: configMqttFtalk.useSSL,
                onSuccess: function () {

                },
                onFailure: function (msg) {
                    $this.startMQttFtalk();
                }
            });
            _scope.clientFtalk.onMessageArrived = $this.receberMensagemFtalk;
            _scope.clientFtalk.onConnectionLost = $this.onConnectionFtalkLost;
        },

        onConnectionFtalkLost: function (msg) {
            setTimeout(function () {
                $this.startMQttFtalk();
            },10000);
        },

        conectaTopicoGrupoAtendimento: function (clienteMqtt, gruposAtendimento) {
            angular.forEach(gruposAtendimento, function (grupo, s, e) {
                clienteMqtt.subscribe("grupo_atendimento/"+grupo.id+"/ocorrencias/#", {qos: 2});
                clienteMqtt.subscribe("monitoramento/reload", {qos: 2});
            });
        },

        receberMensagemFtalk:function (msg) {
            var msgJson = $this.verificaJson(msg.payloadString);
            var classe = MonitoramentoService.getIdUsuarioFtalk() == msgJson.id_origem ? 'other' : 'self';
            var sistema = OcorrenciaAtualService.getSistema();
            ChatService.recebeMensagemChatMqtt(msgJson, classe, sistema);
        },

        publicarMensagemMqtt: function(msg, file, nome_arquivo){

            if (msg == "" && (!angular.isUndefined(file) || file == "")) return;

            var data = ChatService.parserMensagem(msg, file, nome_arquivo);
            var message = new Paho.MQTT.Message(JSON.stringify(data));
            message.destinationName = "/mensagens/ftalk";
            message.qos = 2;
            if(_scope.clientFtalk.isConnected()) {
                _scope.clientFtalk.send(message);
            }else{
                $this.startMQttFtalk();
            }
        },

        receberMensagemMqtt: function (msg){
            var destinationName = msg._getDestinationName();
            var atualizacao = destinationName.indexOf("atualizacao") > -1;
            var nova = destinationName.indexOf("nova") > -1;
            var reload = destinationName.indexOf("reload") > -1;
            var armado = destinationName.indexOf("armado") > -1;
            var conectado = destinationName.indexOf("conectado") > -1 && destinationName.indexOf("painel") > -1;
            var keep_alive = destinationName.indexOf("keep_alive") > -1;
            var setor = destinationName.indexOf("setor") > -1;
            var portao = destinationName.indexOf("portao") > -1;
            var pgm = destinationName.indexOf("pgm") > -1;
            var rele = destinationName.indexOf("rele") > -1;
            var sonoff = destinationName.indexOf("sonoff") > -1;
            var sirene = destinationName.indexOf("sirene") > -1;
            var tipo_arme = destinationName.indexOf("tipo_arme") > -1;
            var vinculoViaturaLoginAlteracao = destinationName.indexOf("vinculo_alteracao") > -1;
            var manutencao = destinationName.indexOf("manutencao") > -1;
            var comando = destinationName.indexOf("comando") > -1;
            var dispositivo = destinationName.indexOf("dispositivo") > -1;

            if(!reload){
                try{
                    var msgJson = "";
                    if(!keep_alive && !conectado && !armado){
                        msgJson = $this.verificaJson(msg.payloadString);
                    }else{
                        msgJson = msg.payloadString;
                    }
                    _scope.msgMqtt = msgJson;
                    OcorrenciasService.setMsgMqtt(msgJson);

                    if(nova) {
                        if ($('#modal-lembrete').is(':visible')) {
                            LembreteService.buscaOCorrenciasEmEspera(userOption.id);
                        }
                        OcorrenciasService.recebeNovaOcorrencia(msgJson).then(function () {
                            if (permissoes.cameras_desktop) {
                                VideosService.iniciaGravacaoNovaOcorrencia(msgJson.id_sistema, msgJson.id_ocorrencia);
                            }
                            ToastMessageService.mostraPushNavegador(msgJson.descricao_sistema, msgJson.id_ocorrencia, function () {
                                CarregamentoOcorrenciaService.carregaOcorrenciaComBotoesValidados(msgJson.id_ocorrencia);
                            });
                            ToastMessageService.getMensagemEventoPorPrioridade(msgJson.ultimo_evento.prioridade, msgJson.descricao_sistema, msgJson.id_ocorrencia);
                            if (msgJson.som_notificacao !== "" && !angular.isUndefined(msgJson.som_notificacao) && msgJson.som_notificacao !== null) {
                                SomService.executarSom(msgJson.som_notificacao);
                            }
                        }, function (error) {

                        });
                    }else if(manutencao){
                        var sistema = destinationName.split('/');
                        var em_manutencao = msgJson.em_manutencao || msgJson.em_manutencao == 'true';

                        if(_scope.idSistemaEdicao == parseInt(sistema[1])){
                            if(_scope.ocorrenciaAtual.sistema)
                                _scope.ocorrenciaAtual.sistema.em_manutencao = em_manutencao;

                            if (em_manutencao) {
                                ManutencaoSistemaService.countdownEdicao(msgJson.fim_manutencao);
                            }
                        }

                        if(sistema[1] == OcorrenciaAtualService.getSistema()) {
                            if (em_manutencao) {
                                ManutencaoSistemaService.countdownManutencao(msgJson.fim_manutencao);
                            } else {
                                ManutencaoSistemaService.countdownManutencaoRemove();
                            }
                        }
                    }else if(atualizacao){
                        $this.verificaTipoAtualizacao(msgJson);
                    }else if(vinculoViaturaLoginAlteracao){
                        var sistema = destinationName.split('/');
                        if(msgJson.tipo_atualizacao == "VINCULO_ROTA_ALTERADO" && sistema[2] == OcorrenciaAtualService.getSistema()){
                            CarregamentoOcorrenciaService.carregarRotasFpatrol(sistema[2]);
                        }else if(msgJson.tipo_atualizacao == "VINCULO_VIATURA_ALTERADO") {
                            ViaturasService.buscarViaturasPorLoginsDaRota(_scope.logins, false);
                        }
                    }else{
                        if(conectado || armado){
                            var partes = destinationName.split('/');
                            if(partes[1] == OcorrenciaAtualService.getSistema()){
                                PainelService.atualizaInformacoesPainelVirtual(destinationName, msg);
                            }
                        }else if(tipo_arme){
                            var partes = destinationName.split('/');
                            if(partes[2] == OcorrenciaAtualService.getSistema()){
                                PainelService.atualizaInformacaoTipoArme(destinationName, msg);
                            }
                        }else if(keep_alive){
                            var partes = destinationName.split('/');
                            if(partes[1] == OcorrenciaAtualService.getSistema()) {
                                PainelService.atualizaKeepAlive(destinationName, msg);
                            }
                        }else if(sirene){
                            var partes = destinationName.split('/');
                            if(partes[1] == OcorrenciaAtualService.getSistema()) {
                                PainelService.atualizaStatusSirene(destinationName, msgJson);
                            }
                        }
                        if(setor){
                            PainelService.atualizaInformacoesHardwarePorJason(destinationName, msg);
                        }
                        if(pgm){
                            if(destinationName.indexOf("comando") > -1){
                                AutomacaoService.recebeResultadoComandoDispositivo(destinationName, msgJson);
                            }else{
                                AutomacaoService.atualizaInformacoesAutomacaoPgm(destinationName, msg);
                            }
                        }
                        if(rele){
                            if(destinationName.indexOf("comando") > -1){
                                AutomacaoService.recebeResultadoComandoDispositivo(destinationName, msgJson);
                            }else{
                                AutomacaoService.atualizaInformacoesAutomacaoRele(destinationName, msg);
                            }
                        }
                        if(sonoff){
                            if(destinationName.indexOf("comando") > -1){
                                AutomacaoService.recebeResultadoComandoDispositivo(destinationName, msgJson);
                            }else{
                                AutomacaoService.atualizaInformacoesAutomacaoSononff(destinationName, msg);
                            }
                        }
                        if(portao){
                            if(destinationName.indexOf("comando") > -1){
                                AutomacaoService.recebeResultadoComandoDispositivo(destinationName, msgJson);
                            }else{
                                AutomacaoService.atualizaInformacaoPortao(destinationName, msgJson);
                            }
                        }
                        if(dispositivo){
                            if(destinationName.indexOf("comando") > -1){
                                AutomacaoService.recebeResultadoComandoDispositivo(destinationName, msgJson);
                            }else{
                                AutomacaoService.atualizaInformacoesAutomacaoEwelink(destinationName, msg);
                            }
                        }
                        if(comando){
                            PainelService.recebeResultadoComando(destinationName, msgJson);
                        }
                    }
                }catch (error){
                }
                return false;
            }else{
                location.reload();
            }
        },

        verificaJson: function (jsonString){
            try {
                var o = JSON.parse(jsonString);
                if (o && typeof o == "object" && o !== null){
                    return o;
                }
            }
            catch (error) {
                location.reload();
            }
            return false;
        },

        atualizaCabecalhoOcorrencia: function (evento) {
            var ocorrenciaAtual = OcorrenciaAtualService.getOcorrenciaAtual();
            if(!angular.isUndefined(evento) && !angular.isUndefined(ocorrenciaAtual)){
                if(evento.dados && !angular.isUndefined(ocorrenciaAtual.evento_maior_prioridade)){
                    if(evento.dados.prioridade <= ocorrenciaAtual.evento_maior_prioridade.dados.prioridade){
                        ocorrenciaAtual.evento_maior_prioridade = evento;
                    }
                }
            }
        },

        executaDebounce: (function(msgJson){
            'use strict';
            var timeWindow = 500;
            var timeout;
            var executaDebounce = function (msgJson) {
                $rootScope.$logsFinishedLoading = false;
                ChatService.getConversasPorOcorrencia(msgJson.id_ocorrencia);
                if(!angular.isUndefined(_scope.idsConversas) && _scope.idsConversas.length > 0){
                    ChatService.conectaTopicoChat(_scope.idsConversas, _scope.ocorrenciaAtual.id_monitoramento);
                }
                HistoricoEventosService.listarHistoricoEventos(OcorrenciaAtualService.getSistema(), 1, _scope.exibeHistoricoRastreados).then(function (result){}, function () {});
                LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function (data){
                    $rootScope.$logsFinishedLoading = true;
                    if(data) {
                        if (!angular.isUndefined(data[0].dados.id_sistema_horario_ativo) && data[0].dados.id_sistema_horario_ativo > 0) {
                            PostergarHorarioService.setEventoTabelaHorario(data[0].dados);
                            PostergarHorarioService.setBotaoPostergar(_scope.statusParticaoGerouOcorrencia);
                        }
                        $this.atualizaCabecalhoOcorrencia(data[0]);
                    }
                }, function () {
                    $rootScope.$logsFinishedLoading = true;
                });
            };
            return function (msgJson) {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    executaDebounce(msgJson);
                }, timeWindow);
            };
        }()),

        verificaAcoesPorStatus:function(telaCarregada, ocorrencia, msgJson){
            switch (ocorrencia.status_ocorrencia) {
                case constant.STATUS.EM_ESPERA:
                    if(telaCarregada){
                        OcorrenciaAtualService.setOcorrenciaAtual(ocorrencia);
                        LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function(){return true}, function(){return false});
                        OcorrenciasService.setTabStatusSuperior(0);
                    }
                break;
                case constant.STATUS.EM_ATENDIMENTO:
                    if($('#modal-lembrete').is(':visible')){
                        LembreteService.buscaOCorrenciasEmEspera(userOption.id);
                    }
                    if(telaCarregada){
                        OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                        ToastMessageService.getMensagemAtualizacaoPorStatus(ocorrencia.status_ocorrencia);
                    }
                break;
                case constant.STATUS.EM_OBSERVACAO:
                    if(telaCarregada){
                        ToastMessageService.getMensagemAtualizacaoPorStatus(ocorrencia.status_ocorrencia);
                        OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                    }
                break;
                case constant.STATUS.AGUARDANDO_RONDA:
                    if(telaCarregada){
                        OcorrenciaAtualService.setOcorrenciaAtual(ocorrencia);
                        LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function(){return true}, function(){return false});
                        OcorrenciasService.setTabStatusSuperior(3);
                    }
                break;
                case constant.STATUS.RONDA_A_CAMINHO:
                    ViaturasService.atualizaStatusLoginsRonda(msgJson.login, msgJson.status);
                    if(ocorrencia.atendendo){
                       if(telaCarregada){
                           ToastMessageService.getMensagemAtualizacaoPorStatus(ocorrencia.status_ocorrencia);
                           OcorrenciaAtualService.setOcorrenciaAtual(ocorrencia);
                           LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function(){return true}, function(){return false});
                           ChatService.getConversasPorOcorrencia(msgJson.id_ocorrencia);
                           OcorrenciasService.setTabStatusSuperior(4);
                       }
                    }else{
                        if(telaCarregada){
                            OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                            ToastMessageService.getMensagemAtualizacaoPorStatus(ocorrencia.status_ocorrencia);
                        }
                    }
                    break;
                case constant.STATUS.RONDA_NO_LOCAL:
                    if(ocorrencia.atendendo){
                        if(telaCarregada){
                            ToastMessageService.getMensagemAtualizacaoPorStatus(ocorrencia.status_ocorrencia);
                            OcorrenciaAtualService.setOcorrenciaAtual(ocorrencia);
                            LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function(){return true}, function(){return false});
                            OcorrenciasService.setTabStatusSuperior(5);
                        }
                    }else{
                        if(telaCarregada){
                            OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                            ToastMessageService.getMensagemAtualizacaoPorStatus(ocorrencia.status_ocorrencia);
                        }
                    }
                    break;
                case constant.STATUS.RONDA_FINALIZADA:
                    ViaturasService.atualizaStatusLoginsRonda(msgJson.login, msgJson.status);
                    if(ocorrencia.atendendo){
                        if(telaCarregada){
                            ToastMessageService.getMensagemAtualizacaoPorStatus(ocorrencia.status_ocorrencia);
                            OcorrenciaAtualService.setOcorrenciaAtual(ocorrencia);
                            setTimeout(function () {
                                LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function(){}, function(){return false});
                            },5000);
                            OcorrenciasService.setTabStatusSuperior(6);
                            if(_scope.buttonMapFpatrolExists){
                                $('.btn-solicitar-map').show();
                            }
                        }
                    }else{
                        if(telaCarregada){
                            OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                            ToastMessageService.getMensagemAtualizacaoPorStatus(ocorrencia.status_ocorrencia);
                        }
                    }
                    break;
            }
        },

        verificaAcoesAoTrocarAtendimento:function(telaCarregada, result, msgJson){
            var euAtendendo = MonitoramentoService.getIdUsuarioLogado() == result.data.id_operador_atendendo;
            if(telaCarregada){
                Pace.restart();
                OcorrenciasService.listaOcorrenciaPorId(msgJson.id_ocorrencia).then(function (ocorrencia) {
                    ChatService.getConversasPorOcorrencia(msgJson.id_ocorrencia);
                    OcorrenciaAtualService.setOcorrenciaAtual(ocorrencia);
                    LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function () {
                        return true
                    }, function () {
                        return false
                    });
                }, function (error) {
                    if (error.status == 404) {
                        ToastMessageService.getMensagemAtualizacaoPorStatus(4);
                    } else {
                        ToastMessageService.showErrorMenssage(error);
                    }
                });
                if(!euAtendendo) {
                    ToastMessageService.showDangerMenssageWeb($filter('translate')('ocorrencia_toast_troca_atendimento'), $filter('translate')('ocorrencia_toast_title_atualizacao'));
                }
            }
            OcorrenciasService.atualizaInformacoesDaOcorrencia(result.data).then(function(){return true}, function(){return false});
        },

        atualizaDadosDasOcorrencias: function(msgJson, ocorrencia){
            OcorrenciasFactory.listarNovaOcorrenciaPorId(msgJson.id_ocorrencia, function(result) {
                OcorrenciasService.contaQuantidadeEventosOcorrenciaAnterior(ocorrencia.id_ocorrencia).then(function(statusAnterior) {
                    OcorrenciasService.atualizaInformacoesDaOcorrencia(result.data).then(function(){
                        OcorrenciasService.verificaQuantidadeEventosPorStatus(result.data);
                        OcorrenciasService.verificaQuantidadeEventosPorStatusOcorrencia(statusAnterior);
                    });
                });
            }, function(error){
                if(error.status == 404){
                    ToastMessageService.getMensagemAtualizacaoPorStatus(4);
                }else{
                    ToastMessageService.showErrorMenssage(error);
                }
            });
        },

        verificaTipoAtualizacao: function(msgJson) {
            var telaCarregada = OcorrenciaAtualService.getIdOcorrenciaAtual() == msgJson.id_ocorrencia;
            switch (msgJson.tipo_atualizacao){
                case 'EVENTO':
                    if($('#modal-lembrete').is(':visible')){
                        LembreteService.buscaOCorrenciasEmEspera(userOption.id);
                    }
                    OcorrenciasService.recebeNovoEvento(msgJson);
                    OcorrenciasService.retornaDescricaoSistemaPorIdOcorrencia(msgJson).then(function(descricao){
                        ToastMessageService.mostraPushNavegador( descricao, msgJson.id_ocorrencia, function () {
                            CarregamentoOcorrenciaService.carregaOcorrenciaComBotoesValidados(msgJson.id_ocorrencia);
                        });
                        ToastMessageService.getMensagemEventoPorPrioridade(msgJson.prioridade, descricao, msgJson.id_ocorrencia);
                    });

                    if(msgJson.som_notificacao != "" && !angular.isUndefined(msgJson.som_notificacao) && msgJson.som_notificacao != null){
                        SomService.executarSom(msgJson.som_notificacao);
                    }
                    if(telaCarregada){
                        Pace.restart();
                        $this.executaDebounce(msgJson);
                        if(msgJson.mostrar_cameras && !_scope.ocorrenciaAtual.mostrar_cameras){
                            InformacoesOcorrenciaService.atualizaAbasPorOpcaoMostrarCameras(msgJson.mostrar_cameras);
                        }
                    }
                break;
                case 'MIDIA_VINCULADA':
                    if(telaCarregada) {
                        $rootScope.$logsFinishedLoading = false;
                        LogService.setLogsOcorrencia([]);
                        LogService.listarLogsOcorrencia(msgJson.id_ocorrencia).then(function (data) {
                            $rootScope.$logsFinishedLoading = true;
                        }, function (error) {

                        });
                    }
                break;
                case 'STATUS_ALTERADO':
                    if(msgJson.id_login != userOption.id){
                        OcorrenciasService.listaOcorrenciaPorId(msgJson.id_ocorrencia).then(function(ocorrencia) {
                            $this.verificaAcoesPorStatus(telaCarregada, ocorrencia, msgJson);
                            $this.atualizaDadosDasOcorrencias(msgJson, ocorrencia);
                        }, function(){});
                    }
                break;
                case 'RONDA_CANCELADA':
                case 'SOLICITACAO_RONDA_RECUSADA':
                    OcorrenciasService.listaOcorrenciaPorId(msgJson.id_ocorrencia).then(function (ocorrencia) {
                        if(telaCarregada) {
                            ViaturasService.atualizaStatusLoginsRonda(msgJson.login, msgJson.status);
                            $this.verificaAcoesPorStatus(telaCarregada, ocorrencia, msgJson);
                            if (_scope.buttonMapFpatrolExists) {
                                $('.btn-solicitar-map').show();
                            }
                        }
                        $this.atualizaDadosDasOcorrencias(msgJson, ocorrencia);
                    }, function () {});
                break;
                case 'RONDA_SOLICITADA':
                case 'SOLICITACAO_RONDA_CANCELADA':
                    if(msgJson.id_login != userOption.id){
                        if(telaCarregada) {
                            OcorrenciasService.listaOcorrenciaPorId(msgJson.id_ocorrencia).then(function (ocorrencia) {
                                ViaturasService.atualizaStatusLoginsRonda(msgJson.login, ocorrencia.status_operador_externo_atual);
                                $this.verificaAcoesPorStatus(telaCarregada, ocorrencia, msgJson);
                            }, function () {
                            });
                        }
                        $this.atualizaDadosDasOcorrencias(msgJson, ocorrencia);
                    }
                break;
                case 'MANUTENCAO_SISTEMA':
                    if(telaCarregada) {
                        Pace.restart();
                        LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function(){}, function(){});
                    }
                break;
                case 'LOG_INSERIDO':
                    if(msgJson.id_login != userOption.id){
                        OcorrenciasService.zeraQuantidadeEventos(msgJson.id_ocorrencia).then(function() {
                            OcorrenciasService.verificaQuantidadeEventosPorStatus(msgJson)
                        }, function(){});
                        if(telaCarregada) {
                            Pace.restart();
                            LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function(){}, function(){});
                        }
                    }
                break;
                case 'LOG_INSERIDO_RONDA':
                    OcorrenciasService.listaOcorrenciaPorId(msgJson.id_ocorrencia).then( function(ocorrencia) {
                        OcorrenciasService.zeraQuantidadeEventos(msgJson.id_ocorrencia).then(function() {
                            OcorrenciasService.verificaQuantidadeEventosPorStatus(ocorrencia)
                        }, function(){});

                        if(telaCarregada) {
                            Pace.restart();
                            LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function(){}, function(){});
                            if (ocorrencia.atendendo) {
                                OcorrenciaAtualService.setOcorrenciaAtual(ocorrencia);
                            }
                        }
                    }, function(){});
                    break;
                case 'FINALIZADO':
                    if(msgJson.id_login != userOption.id || msgJson.finalizado_pelo_ronda){
                        OcorrenciasService.contaQuantidadeEventosOcorrenciaAnterior(msgJson.id_ocorrencia).then(function(statusAnterior) {
                            OcorrenciasService.verificaQuantidadeEventosPorStatusOcorrencia(statusAnterior)
                        });
                        OcorrenciasService.finalizarOcorrenciaMqtt(msgJson.id_ocorrencia);
                        if(telaCarregada){
                            Pace.restart();

                            if(!OcorrenciaAtualService.getOperadorAtendendo()) {
                                ToastMessageService.getMensagemAtualizacaoPorStatus(4);
                            }else if(!angular.isUndefined(msgJson.finalizado_pelo_ronda) && msgJson.finalizado_pelo_ronda){
                                ToastMessageService.showInfoMenssageWeb($filter('translate')('ocorrencia_toast_finalizado_pelo_ronda'), $filter('translate')('ocorrencia_toast_title_atualizacao'));
                            }

                            setTimeout(function(){
                                OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                                if(ConfigService.getAutoCarregamentoOcorrencia()){
                                    setTimeout(function() {
                                        CarregamentoOcorrenciaService.verificaOcorrenciasComPrioridadeAltaEmEspera();
                                        OcorrenciasService.setTabStatusSuperior(0);
                                    }, 100);
                                }
                            },200);
                        }
                    }

                break;
                case 'FINALIZADO_SISTEMA':
                    OcorrenciasService.contaQuantidadeEventosOcorrenciaAnterior(msgJson.id_ocorrencia).then(function(statusAnterior) {
                        OcorrenciasService.verificaQuantidadeEventosPorStatusOcorrencia(statusAnterior)
                    });
                    OcorrenciasService.finalizarOcorrenciaMqtt(msgJson.id_ocorrencia);
                    if(telaCarregada){
                        Pace.restart();
                        setTimeout(function(){
                            OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                        },200);
                    }
                    break;
                case 'TROCA_ATENDIMENTO':
                    if(msgJson.id_login != userOption.id) {
                        OcorrenciasFactory.listarNovaOcorrenciaPorId(msgJson.id_ocorrencia, function (result) {
                            if (_scope.ocorrenciaAtual.status_ocorrencia == constant.STATUS.EM_OBSERVACAO) {
                                OcorrenciasService.setTabStatusSuperior(1);
                                OcorrenciasService.listaOcorrenciaPorId(msgJson.id_ocorrencia).then(function (ocorrencia) {
                                    if (telaCarregada) {
                                        Pace.restart();
                                        LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function () {
                                        }, function () {
                                        });
                                        OcorrenciaAtualService.setOcorrenciaAtual(ocorrencia);
                                    }
                                    $this.atualizaDadosDasOcorrencias(msgJson, ocorrencia);
                                }, function () {
                                });
                            } else {
                                $this.verificaAcoesAoTrocarAtendimento(telaCarregada, result, msgJson);
                            }

                        }, function (error) {
                            if (error.status == 404) {
                                ToastMessageService.getMensagemAtualizacaoPorStatus(4);
                            } else {
                                ToastMessageService.showErrorMenssage(error);
                            }
                        });
                    }
                break;
                case 'CONTATO':
                    if(telaCarregada) {
                        Pace.restart();
                        OcorrenciasService.listaOcorrenciaPorId(msgJson.id_ocorrencia).then(function(ocorrencia) {
                            OcorrenciaAtualService.setOcorrenciaAtual(ocorrencia);
                            OcorrenciasService.zeraQuantidadeEventos(ocorrencia);
                            LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function(){return true}, function(){return false});
                        }, function(error) {ToastMessageService.showErrorMenssage(error)});
                    }
                break;
                case 'AUTOMACAO_ACIONADA':
                case 'ORDEM_SERVICO':
                case 'VISUALIZACAO_VIDEO':
                case 'VISUALIZACAO_PRE_ALARME':
                case 'ACIONAMENTO_SIRENE':
                case 'SISTEMA_EDITADO':
                    Pace.restart();
                    if(telaCarregada){
                        Pace.restart();
                        LogService.listaLogNovoEvento(msgJson.id_ocorrencia).then(function(){return true}, function(){return false});
                    }
                break;
            }
        }
    }

});
angular.module('Fullarm').service('RastreadosService', function (RastreadosFactory, $filter, $timeout) {

    var _scope = {};
    var $this;
    var mapa;
    var markersGroup;
    var configRotas =
        {
            "delay": 800,
            "dashArray": [1, 87],
            "weight": 8,
            "color": "#0000FF",
            "pulseColor": "#FFFFFF",
            "paused": false,
            "reverse": false
        };

    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.rastreados = [];
            _scope.exibeRastreados = false;
            _scope.mapaRastreadosIsLoader = false;
        },

        setRastreados: function (rastreadosDaOcorrencia, idRastreadoDaOcorrencia) {

            var rastreados = [];
            if(angular.isObject(rastreadosDaOcorrencia)){
                rastreados = Object.values(rastreadosDaOcorrencia).map(function(r){
                    return Object.assign(r, {selecionado: r.id == idRastreadoDaOcorrencia})
                })
            }
            _scope.rastreados = rastreados;
            _scope.exibeRastreados = rastreados.length > 0;
        },

        setenderecoSistemaRatreadosRastreados: function (objenderecoSistemaRatreados) {
            _scope.enderecoSistemaRatreados = objenderecoSistemaRatreados;
        },

        buscarUltimaPosicaoDeVeiculos : function (idSistema) {
            $this.initMapa();

            RastreadosFactory.buscarPosicaoTodosVeiculosEPosicaoSistema(idSistema)
            .then(function(posicoes){
                
                $this.setMarkersRastreados(posicoes.veiculos);

                latLong = posicoes.veiculos.map(function(v){ return { latitude: v.latitude,longitude: v.longitude}});
                
                if(posicoes.sistema != null){
                    $this.setMarkerHouse(posicoes.sistema, false);

                    latLong.push({
                        latitude: posicoes.sistema.latitude,
                        longitude: posicoes.sistema.longitude
                    })
                }
                $this.fitBounds(latLong);
                $this.stopSpinMapa();

            })
            .catch(function(error){
                $this.stopSpinMapa();
            });
        },

        resizeMapa: function(){
            setTimeout(function() {
                mapa.invalidateSize();
            }, 10);
        },

        initMapa: function () {
            $this.startSpinMapa();
            $this.clearLears();
            if (mapa == null) {
                mapa = L.map(document.getElementById('leaflet-map'));
            }
            L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">Fulltrack Mapa</a>'
            }).addTo(mapa);

            markersGroup = L.layerGroup().addTo(mapa);

            mapa.setView([-22.215403, -49.654070], 12);
        },

        setMarkers: function (localizacoes, deveCriarRotas) {
            $this.clearLears();
            var rotas = [];

            angular.forEach(localizacoes, function (localizacao) {
                if (localizacao != null) {

                    var cor = $this.buscarCorPorEstadoDoVeiculo(localizacao);
                    var marker = $this.criarMaker(localizacao, cor);
                    $(marker._icon).append($this.createMarkerLabel(localizacao, cor, deveCriarRotas, localizacoes.length));

                    mapa.setView([localizacao.latitude, localizacao.longitude], 12);
                    rotas.push([Number(localizacao.latitude), Number(localizacao.longitude)]);
                }
            });

            if (deveCriarRotas) {
                $this.criarRotas(rotas);
            }
        },

        criarRotas:function(rotas){
            if(rotas.length > 0){
                var path = L.polyline.antPath(rotas,configRotas);
                markersGroup.addLayer(path);
                mapa.fitBounds(path.getBounds());
            }

        },

        setMarkersRastreados: function (localizacoes) {
            $this.clearLears();
            
            angular.forEach(localizacoes, function (localizacao) {
                if (localizacao != null) {
                    $this.criarMakerRastreado(localizacao);
                    mapa.setView([localizacao.latitude, localizacao.longitude], 12);
                }
            });

        },
        criarMakerRastreado: function(rastreado) {
            const colorClass = $this.getColorPorStatusRastreado(rastreado);
            const iconUrl   = $this.getIconePorTipoRastreado(rastreado.tipo_veiculo);
            
            return L.marker([rastreado.latitude, rastreado.longitude], {

                icon:L.divIcon({
                    iconSize: [40, 40],
                    className: 'rastreado-marker ' + colorClass,
                    html: '<img src=' + iconUrl + '></img><span class="rastreado-marker-label ' + colorClass + '"> ' + rastreado.descricao + '</span><span class="rastreado-marker-dot ' + colorClass + '"></span>'
                })
            })
            .addTo(markersGroup)
            .bindPopup($this.createPopupPorVeiculo(rastreado, 'cor'))
            .on('popupopen', function (popup) {
                $this.buscarEnderecoPorLatLong(popup.popup._latlng.lat, popup.popup._latlng.lng, popup.popup._container);
            });
        },
        getIconePorTipoRastreado:function(tipo){

            const tiposVeiculos = {
                "0":"rastreado-car-side.svg",//Nenhum selecionado ,
                "1":"rastreado-car-side.svg",//Carro,
                "2":"rastreado-motorcycle.svg",//Moto,
                "3":"rastreado-truck.svg",//Caminhão,
                "4":"rastreado-bus-alt.svg",//Ônibus,
                "5":"rastreado-tractor.svg",//Trator,
                "6":"rastreado-ship.svg",//Barco,
                "7":"rastreado-user.svg",//Usuario
                "8":"rastreado-truck-pickup.svg",//Caminhonete,
                "9":"rastreado-truck.svg",//Carreta,
                "10":"rastreado-bicycle.svg",//Bicicleta,
                "11":"rastreado-car-side.svg",//Outro
                "12":"rastreado-truck.svg",//Cavalo Mecânico,
                "13":"rastreado-plane.svg",//Avião,
                "14":"rastreado-paw.svg",//Rastro animal,
                "15":"rastreado-shoe-prints.svg",//Rastro humano,
                "16":"rastreado-box.svg",//Objeto,
                "17":"rastreado-crane.svg",//Guindaste,
                "18":"rastreado-shuttle-van.svg",//SUV,
                "19":"rastreado-shuttle-van.svg",//Van, 
                "20":"rastreado-truck-container.svg",//Furgão,
            }
            return '../assets/img/rastreados/' + (tiposVeiculos[tipo] || 'rastreado-car-side.svg');
        },
        getColorPorStatusRastreado:function(rastreado){

           const classes = {
                1:'rastreado-marker-color-desligado',
                2:'rastreado-marker-color-ligado-parado',
                3:'rastreado-marker-color-em-movimento',
                4:'rastreado-marker-color-bloqueado',
                5:'rastreado-marker-color-sem-sinal'
            };

            return classes[rastreado.estado_veiculo] || 'rastreado-marker-color-desconhecido';
        },
        setMarkersRotas: function (localizacoes) {
            $this.clearLears();
            var rotas = [], counter = 0;

            angular.forEach(localizacoes, function (localizacao) {
                if (localizacao != null) {
                    counter++;
                    var cor = $this.buscarCorPorEstadoDoVeiculo(localizacao);
                    $this.criarMakerRastreadoRota(localizacao, cor,counter);
                    
                    mapa.setView([localizacao.latitude, localizacao.longitude], 12);
                    rotas.push([Number(localizacao.latitude), Number(localizacao.longitude)]);
                }
            });

            $this.criarRotas(rotas);
        },
        criarMakerRastreadoRota: function(localizacao, cor, contador) {
            return L.marker([localizacao.latitude, localizacao.longitude], {
                icon: L.divIcon({
                    iconSize: [35, 45],
                    className: 'icon-counter-marker icon-counter-marker-' + cor , 
                    html:'<span class="number">' + contador + '</span>'
                })
            }).addTo(markersGroup).bindPopup($this.createPopupPorVeiculo(localizacao, cor)).on('popupopen', function (popup) {
                $this.buscarEnderecoPorLatLong(popup.popup._latlng.lat, popup.popup._latlng.lng, popup.popup._container);

            });
        },
        criarMaker: function (localizacao, cor) {
            return L.marker([localizacao.latitude, localizacao.longitude], {
                icon: L.AwesomeMarkers.icon({
                    icon: 'car marker-icon',
                    markerColor: cor,
                    prefix: 'fa'
                })
            }).addTo(markersGroup).bindPopup($this.createPopupPorVeiculo(localizacao, cor)).on('popupopen', function (popup) {
                $this.buscarEnderecoPorLatLong(popup.popup._latlng.lat, popup.popup._latlng.lng, popup.popup._container);

            });
        },

        clearLears: function () {
            if(markersGroup != null){
                markersGroup.clearLayers();
            }
        },

        buscarCorPorEstadoDoVeiculo: function (veiculo) {
            var cor = "";
            switch (veiculo.estado_veiculo) {
                case 1:
                    cor = "red";
                    break;
                case 2:
                    cor = "green";
                    break;
                case 3:
                    cor = "blue";
                    break;
            }
            return cor;
        },

        buscarDescricaoEstadoDoVeiculo: function (status) {

           var desc = "";
            switch (status) {
                case 1:
                    desc = $filter('translate')('status_veiculo_por_status_desligado');
                    break;
                case 2:
                    desc = $filter('translate')('status_veiculo_por_status_em_movimento');
                    break;
                case 3:
                    desc = $filter('translate')('status_veiculo_por_status_parado');
                    break;
            }
            return desc;
        },

        createMarkerLabel: function (veiculo, cor, deveCriarRotas, qtnPosicoes) {
            var label = "";

            if (qtnPosicoes == 1 || !deveCriarRotas) {
                label = '<span class="marker_div marker_div_' + cor + '"> ' + veiculo.descricao + '</span>';
            }
            return label;
        },
        
        setMarkerHouse: function (localizacaoCasa) {
            _scope.enderecoSistemaRatreados = localizacaoCasa;
            if(localizacaoCasa.length != []){
                L.marker([localizacaoCasa.latitude, localizacaoCasa.longitude], {
                    icon: L.AwesomeMarkers.icon({
                        icon: 'home',
                        markerColor: 'black',
                        prefix: 'fa'
                    })
                }).addTo(markersGroup).bindPopup($this.createPopupRastreadosPorSistema()).on('popupopen', function (popup) {

                });
            }
        },

        createPopupPorVeiculo: function (veiculo) {
            return '<div class="row pop-up-rastreados">\n' +
                '    <div class="col-md-10 col-sm-10 col-xs-10 descricao-rastreado">\n' +
                '        <span>' + veiculo.descricao + '</span>\n' +
                '    </div>\n' +
                '    <div class="col-md-12 col-sm-12 col-xs-12">\n' +
                '        <hr style="margin-top: 5px; margin-bottom: 5px;">\n' +
                '    </div>\n' +
                '    <div class="pop_up_rastreados_detalhes">\n' +
                '        <div class="info-marker"><span><i class="fa fa-calendar"></i>' + $filter("translate")("ocorrencia_label_data") + ': <strong>' + veiculo.data_comunicacao + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' + $filter("translate")("ocorrencia_label_latitude") + ': <strong>' + veiculo.latitude + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' +  $filter("translate")("ocorrencia_label_longitude") + ': <strong>' + veiculo.longitude + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-tachometer"></i>' +  $filter("translate")("ocorrencia_label_velocidade") + ': <strong>' + veiculo.velocidade + ' km/h</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-circle-o-notch"></i>' +  $filter("translate")("ocorrencia_label_status") + ': </span><strong>' + $this.buscarDescricaoEstadoDoVeiculo(veiculo.estado_veiculo)+ ' </strong></div>\n' +
                '    </div>\n' +
                '    <div class="info-tabs popup_div_botoes">\n' +
                '        <div class="tab-content">\n' +
                '            <div role="tabpanel" class="tab-pane active">\n' +
                '                <a class="btn btn-default" target="_blank"  href="https://www.google.com/maps/search/' + veiculo.latitude + ',' + veiculo.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no google maps"><i class="fa fa-google fa-2x"></i></a>\n' +
                '                <a class="btn btn-default" target="_blank" href="http://maps.google.com/maps?q=&layer=c&cbll=' + veiculo.latitude + ',' + veiculo.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no Google Street View"><i class="fa fa-street-view fa-2x"></i></a>\n' +
                '            </div>                        \n' +
                '        </div>\n' +
                '    </div>\n' +
                '</div>'
        },

        createPopupRastreadosPorSistema: function () {
            var endereco =  _scope.enderecoSistemaRatreados.logradouro +", "+ _scope.enderecoSistemaRatreados.numero +" - "+ _scope.enderecoSistemaRatreados.bairro +' '+ _scope.enderecoSistemaRatreados.cidade+' / '+ _scope.enderecoSistemaRatreados.estado;
            return '<div class="row pop-up-sistema">\n' +
                '    <div class="col-md-10 col-sm-10 col-xs-10 descricao-rastreado">\n' +
                '        <span>' + _scope.ocorrenciaAtual.sistema.descricao + '</span>\n' +
                '    </div>\n' +
                '    <div class="col-md-12 col-sm-12 col-xs-12">\n' +
                '        <hr style="margin-top: 5px; margin-bottom: 5px;">\n' +
                '    </div>\n' +
                '    <div class="pop_up_rastreados_detalhes">\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' + $filter("translate")("ocorrencia_label_latitude") + ': <strong>' + _scope.enderecoSistemaRatreados.latitude + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' + $filter("translate")("ocorrencia_label_longitude") + ': <strong>' + _scope.enderecoSistemaRatreados.longitude + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-map-marker"></i> '+ $filter('translate')('ocorrencia_label_endereco')+': </span><strong>'+endereco+'</strong></div>\n' +
                '    </div>\n' +
                '    <div class="info-tabs popup_div_botoes">\n' +
                '        <div class="tab-content">\n' +
                '            <div role="tabpanel" class="tab-pane active">\n' +
                '                <a class="btn btn-default" target="_blank"  href="https://www.google.com/maps/search/' + _scope.enderecoSistemaRatreados.latitude + ',' + _scope.enderecoSistemaRatreados.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no google maps"><i class="fa fa-google fa-2x"></i></a>\n' +
                '                <a class="btn btn-default" target="_blank" href="http://maps.google.com/maps?q=&layer=c&cbll=' + _scope.enderecoSistemaRatreados.latitude + ',' + _scope.enderecoSistemaRatreados.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no Google Street View"><i class="fa fa-street-view fa-2x"></i></a>\n' +
                '            </div>                        \n' +
                '        </div>\n' +
                '    </div>\n' +
                '</div>'
        },

        stopSpinMapa: function () {
            _scope.mapaRastreadosIsLoader = false;
        },

        startSpinMapa: function () {
            _scope.mapaRastreadosIsLoader = true;
        },

        removeMapa:function () {
            if(!angular.isUndefined(mapa) && mapa != null){
                mapa.remove();
                document.getElementById('leaflet-map').innerHTML = "";
                mapa = null;
            }
        },
        fitBounds: function(localizacoes){

            bounds = L.latLngBounds( localizacoes.map(function(l){
                return  L.latLng(l.latitude, l.longitude);
            }));

            mapa.fitBounds(bounds);

        },
        

        buscarEnderecoPorLatLong: function(lat,long, popup){
            RastreadosFactory.buscarEnderecoPorLatLong(lat, long, function (data) {
                var endereco = data.data;
                if(endereco != ""){
                    $(popup).find('.pop_up_rastreados_detalhes').append('<div class="info-marker"><span><i class="fa fa-map-marker"></i> '+$filter('translate')('ocorrencia_label_endereco')+': </span><strong>'+endereco+'</strong></div>');
                }
            },function (error) {
            });
        },
    }
});
angular.module('Fullarm').service('SistemaService', function () {
    var _scope = {};
    var $this;
    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
        },

    };
});
angular.module('Fullarm').service('StatusService', function (StatusFactory, ToastMessageService, $q) {
    return{
        alterarStatus: function (params) {

            var deferred = $q.defer();
            StatusFactory.alterarStatusOcorrencia(params, function (result) {
                    deferred.resolve(result);
                },
                function (error) {
                    ToastMessageService.showErrorMenssage(error);
                });
            return deferred.promise;
        },
    }
});
angular.module('Fullarm').service('TeclaAtalhoService', function (constant, MotivosAlarmeService, OcorrenciaAtualService, LogService, OcorrenciasService, InformacoesOcorrenciaService, VeiculosProximosService,
                                                                  RastreadosService, CarregamentoOcorrenciaService, ComentarioOcorrenciaService) {

    var _scope = {};
    var $this;

    return{
        setScope: function (scope) {
            $this = this;
            _scope = scope;
        },

        acoesTelaMotivosAlarme:function(){
            if(_scope.exibeMotivosAlarme) {
                event.preventDefault();
                if ($("#btnFinalizarMotivoAlarme").is(":focus")){
                    CarregamentoOcorrenciaService.finalizaOcorrencia();
                }else if ($("#btnCancelarMotivoAlarme").is(":focus")){
                    MotivosAlarmeService.exibirMotivosAlarme(false);
                    LogService.exibeLog(true);
                }
            }
        },

        acoesModalMensagemPadrao:function (e) {
            switch (e.keyCode){
                case 40:
                    event.preventDefault();
                    break;
                case 13:
                    event.preventDefault();
                    break;
            }
        },

        acoesBotoesDeAcao: function(e){
            if(!angular.isUndefined(OcorrenciaAtualService.getIdOcorrenciaAtual())){
                event.preventDefault();
                switch(e.keyCode){
                    case 65:
                        if(_scope.botao_atender)
                            _scope.preparaAlteracaoStatusParaAtendimento();
                        break;
                    case 79:
                        if(_scope.botao_observar)
                            _scope.preparaAlteracaoStatusParaObservacao();
                        break;
                    case 83:
                        if(_scope.botao_finalizar){
                            _scope.preparaFinalizacaoOcorrencia(_scope.existeEventoTabelaHorario);
                        }
                        break;
                }
                setTimeout(function(){
                    _scope.$apply();
                },100);
            }
        },

        acaoSelecionarBotaoCancelarFinalizacao:function(){
            $("#btnCancelarMotivoAlarme").attr("tabindex",-1).focus();
        },

        acaoSelecionarBotaoFinalizacao:function(){
            $("#btnFinalizarMotivoAlarme").attr("tabindex",-1).focus();
        },

        acaoVerificarRastreadosEveiculos:function(){
            switch(_scope.tabAtiva){
                case 'tab_veiculos_proximos':
                    VeiculosProximosService.buscarEnderecoPorLatLong();
                break;
                case 'tab_rastreados':
                    setTimeout(function () {
                        if(!angular.isUndefined(OcorrenciaAtualService.getSistema())){
                            RastreadosService.buscarUltimaPosicaoDeVeiculos(OcorrenciaAtualService.getSistema());
                        }
                    },1000);
                break;
            }
        },

        acaoVerificarRightLeft:function(leftOrRight){
            event.preventDefault();
            if(!angular.isUndefined(OcorrenciaAtualService.getIdOcorrenciaAtual()) && _scope.ocorrenciaTabs.length > 0){
                if(_scope.exibeMotivosAlarme) {
                    leftOrRight === 'left' ?  $this.acaoSelecionarBotaoFinalizacao() : $this.acaoSelecionarBotaoCancelarFinalizacao();
                }else{
                    _scope.tabAtiva = leftOrRight === 'left' ? InformacoesOcorrenciaService.leftTab() : InformacoesOcorrenciaService.rightTab();
                    $this.acaoVerificarRastreadosEveiculos();
                }
            }
        },

        acoesComentarioOcorrencia:function (e){
            switch (e.keyCode){
                case 9:
                    event.preventDefault();
                    if($('#mostrar_log_cliente').is(":focus")){
                        $('#push_log_cliente').focus();
                    }else if($('#push_log_cliente').is(":focus")){
                        $('#btnInserirComentario').focus();
                    }else{
                        $('#mostrar_log_cliente').focus();
                    }
                break;
                case 13:
                    event.preventDefault();
                    if($('#mostrar_log_cliente').is(":focus")){
                        if($("#mostrar_log_cliente").is(':checked')) {
                            $("#mostrar_log_cliente").prop('checked', false);
                        }else {
                            $("#mostrar_log_cliente").prop('checked', true);
                        }
                    }else if($('#push_log_cliente').is(":focus")){
                        if($("#push_log_cliente").is(':checked')) {
                            $("#push_log_cliente").prop('checked', false);
                            $("#mostrar_log_cliente").prop('checked', false);
                            $("#mostrar_log_cliente").prop('disabled', false);
                        }else {
                            $("#push_log_cliente").prop('checked', true);
                            $("#mostrar_log_cliente").prop('checked', true);
                            $("#mostrar_log_cliente").prop('disabled', true);
                        }
                    }else{
                        event.preventDefault();
                        MotivosAlarmeService.exibirMotivosAlarme(false);
                        $("#text_log").focus();
                        ComentarioOcorrenciaService.verificaComentarioOcorrencia();
                    }
                break;
            }
        },

        acoesDeSelecaoDeStatus:function(e){
            switch(e.keyCode){
                case 112:
                    event.preventDefault();
                    OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                    _scope.statusSelecionado = 1;
                    OcorrenciasService.setTabStatusSuperior(0);
                break;
                case 113:
                    event.preventDefault();
                    OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                    _scope.statusSelecionado = 2;
                    OcorrenciasService.setTabStatusSuperior(1);
                break;
                case 115:
                    event.preventDefault();
                    OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                    _scope.statusSelecionado = 6;
                    OcorrenciasService.setTabStatusSuperior(3);
                break;
                case 116:
                    event.preventDefault();
                    OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                    _scope.statusSelecionado = 7;
                    OcorrenciasService.setTabStatusSuperior(4);
                break;
                case 117:
                    event.preventDefault();
                    OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                    _scope.statusSelecionado = 8;
                    OcorrenciasService.setTabStatusSuperior(5);
                    break;
                case 118:
                    event.preventDefault();
                    OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                    _scope.statusSelecionado = 9;
                    OcorrenciasService.setTabStatusSuperior(6);
                    break;
                case 119:
                    event.preventDefault();
                    OcorrenciaAtualService.esvaziaOcorrenciaAtual();
                    _scope.statusSelecionado = 3;
                    OcorrenciasService.setTabStatusSuperior(2);
                    break;
                case 40:
                    CarregamentoOcorrenciaService.selecionaOcorrencia('down');
                break;
                case 38:
                    CarregamentoOcorrenciaService.selecionaOcorrencia('up');
                break;
            }
        }

    }

});
angular.module('Fullarm').service('TelaConfigService', function () {

    var _scope = {};
    var $this;

    return{
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.limit_desc_login = 0;
        },

        setLimiteCaracteresLogin: function () {
            _scope.limit_desc_login = $(window).width() <= 1500 ? 18 : 30;
        },

        atualizaTamanhoVideo:function(){
            setTimeout(function(){

            }, 100);
        },


        verificaTamanhoTela:function () {
            var tamanho = $(window).width();
            if(tamanho <= 1572){
                return "menor";
            }else if(tamanho >= 1623){
                return "maior";
            }
        },

        get_browser:function (){
            var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if(/trident/i.test(M[1])){
                tem=/\brv[ :]+(\d+)/g.exec(ua) || [];
                return {name:'IE',version:(tem[1]||'')};
            }
            if(M[1]==='Chrome'){
                tem=ua.match(/\bOPR\/(\d+)/)
                if(tem!=null)   {return {name:'Opera', version:tem[1]};}
            }
            M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
            if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
            return {
                name: M[0],
                version: M[1]
            };
        },
    }

});
angular.module('Fullarm').service('ToastMessageService', function ($filter) {

    var $this;
    return{
        init: function () {
            $this = this;
        },
        getErrorDescription: function (json) {
           
            var template = ' %value%. ';
            var erros = json.data.errors || json.data.erros || json.data.error || json.data.erro || json || [];

            erros = angular.isArray(erros) ? erros : ((angular.isString(erros)) ? [erros] : erros);
            var strErros = '';

            angular.forEach(erros, function (value, index) {

                if ((value || '').length > 0) {
                    var m = '';
                    m = template.replace('%value%', value);
                    m = m.replace('%index%', index);

                    strErros += m;
                }
            });
            return strErros;
        },

        showErrorMenssage: function (menssage) {
            menssage = this.getErrorDescription(menssage);
            iziToast.destroy();
            iziToast.error({
                title:$filter('translate')('Erro'),
                backgroundColor:'#d9534f',
                messageColor : 'rgba(0,0,0,.7)',
                messageSize : '16',
                message : $filter('translate')(menssage),
                position : "topRight",
                timeout : 3500,
            });
        },

        showErrorMenssageWeb: function (menssage) {
            iziToast.destroy();
            iziToast.error({
                title:$filter('translate')('ocorrencias_title_modal_advertencias'),
                backgroundColor:'#d9534f',
                messageColor : 'rgba(0,0,0,.7)',
                messageSize : '16',
                message : $filter('translate')(menssage),
                position : "topCenter",
                timeout : 3500,
            });
        },

        showWarningMenssageWebCenter: function (menssage) {
            iziToast.destroy();
            iziToast.warning({
                title:$filter('translate')('ocorrencias_title_modal_advertencias'),
                messageSize : '16',
                message : $filter('translate')(menssage),
                position : "topCenter",
                timeout : 3500,
            });
        },

        showWarningMenssageWeb: function (title, menssage, idOcorrencia)
        {
            if(angular.isUndefined(menssage)){
                menssage = "";
            }
            var html =  "<div class='divEvento'>" +
                            "<p class='tituloEvento'>"+$filter('translate')(title)+"</p>"+
                            "<p class='msgEvento'>"+$filter('translate')(menssage)+"</p>"+
                            "<input type='hidden' value='"+idOcorrencia+"'/>"+
                        "</div>";
            iziToast.destroy();
            iziToast.warning({
                title : html,
                position : "topRight",
                timeout : 3500,
                icon:'fas fa-bell'
            });
        },

        showDangerMenssageWeb: function (title, menssage, idOcorrencia)
        {
            if(angular.isUndefined(menssage)){
                menssage = "";
            }
            var html =  "<div class='divEvento'>" +
                            "<p class='tituloEvento'>"+$filter('translate')(title)+"</p>"+
                            "<p class='msgEvento'>"+$filter('translate')(menssage)+"</p>"+
                            "<input type='hidden' value='"+idOcorrencia+"'/>"+
                        "</div>";
            iziToast.destroy();
            iziToast.error({
                title : html,
                position : "topRight",
                timeout : 3500,
                icon:'fas fa-bell'
            });
        },

        showInfoMenssageWeb: function (title, menssage, idOcorrencia)
        {
            if(!angular.isUndefined(menssage)){
                menssage = "";
            }
            var html =  "<div class='divEvento'>" +
                            "<p class='tituloEvento'>"+$filter('translate')(title)+"</p>"+
                            "<p class='msgEvento'>"+$filter('translate')(menssage)+"</p>"+
                            "<input type='hidden' value='"+idOcorrencia+"'/>"+
                        "</div>";
            iziToast.destroy();
            iziToast.info({
                title : html,
                position : "topRight",
                timeout : 3500,
                icon:'fas fa-bell'
            });
        },

        showSuccessMenssage: function (menssage, title)
        {
            if(!angular.isUndefined(title)){
                title = "";
            }
            iziToast.destroy();
            iziToast.success({
                title : $filter('translate')(title),
                message : $filter('translate')(menssage),
                position : "topRight",
                timeout : 3500
            });

        },

        showConfirmMenssage: function (menssage, cb) {
            iziToast.destroy();
            iziToast.success({
                title : '',
                message :  $filter('translate')(menssage),
                timeout : 3500,
                position : 'topCenter',
                buttons : [
                    ['<button>OK</button>', function (instance, toast) {
                        instance.hide({
                            transitionOut : 'fadeOutUp',
                            onClose : function (instance, toast, closedBy) {
                                if (cb instanceof Function) {
                                    cb();
                                }
                            }
                        }, toast, 'close');
                    }]
                ],
                onclose : function () {
                    if (cb instanceof Function) {
                        cb();
                    }
                }
            });
            $(document).on('iziToast-close', function () {
                if (cb instanceof Function) {
                    cb();
                }
            });
        },

        showLembreteOperador: function (menssage) {
            iziToast.destroy();
            iziToast.info({
                title : '',
                message :  menssage,
                position : 'topCenter',
                close: false,
                closeOnEscape: false,
                closeOnClick: false,

            });
        },

        getTiuloPorPrioridade: function (prioridade) {
            switch (prioridade) {
                case 1:
                    return $filter('translate')('ocorrencia_toast_title_prioridade_alta');
                case 2:
                    return $filter('translate')('ocorrencia_toast_title_prioridade_media');
                case 3:
                    return $filter('translate')('ocorrencia_toast_title_prioridade_baixa');
            }
        },

        getMensagemEventoPorPrioridade: function (prioridade, msg, idOcorrencia) {
            try{
                switch (prioridade) {
                    case 1:
                        $this.showDangerMenssageWeb($filter('translate')('ocorrencia_toast_novo_evento_recebido'), msg, idOcorrencia);
                        break;
                    case 2:
                        $this.showWarningMenssageWeb($filter('translate')('ocorrencia_toast_novo_evento_recebido'), msg, idOcorrencia);
                        break;
                    case 3:
                        $this.showInfoMenssageWeb($filter('translate')('ocorrencia_toast_novo_evento_recebido'), msg, idOcorrencia);
                        break;
                }
            }catch(error){
            }
        },

        mostraPushNavegador: function(descricao, id, fn){
            try{
                Push.create(descricao, {
                    icon: "/assets/img/bell.png",
                    timeout: 5000,
                    onClick: fn
                });
            }catch(error){
            }
        },

        getMensagemAtualizacaoPorStatus: function (status) {
            switch (status) {
                case 2:
                    $this.showInfoMenssageWeb($filter('translate')('ocorrencia_toast_title_atualizacao'), $filter('translate')('ocorrencia_toast_atendimento_outro_usuario'));
                    break;
                case 3:
                    $this.showInfoMenssageWeb($filter('translate')('ocorrencia_toast_title_atualizacao'), $filter('translate')('ocorrencia_toast_colocada_em_observacao'));
                    break;
                case 4:
                    $this.showInfoMenssageWeb($filter('translate')('ocorrencia_toast_title_atualizacao'), $filter('translate')('ocorrencia_toast_finalizado_outro_usuario'));
                    break;
                case 5:
                    $this.showInfoMenssageWeb($filter('translate')('ocorrencia_toast_title_atualizacao'), $filter('translate')('ocorrencia_toast_em_processo'));
                    break;
                case 6:
                    $this.showInfoMenssageWeb($filter('translate')('ocorrencia_toast_title_atualizacao'), $filter('translate')('ocorrencia_toast_aguardando_ronda'));
                    break;
                case 7:
                    $this.showInfoMenssageWeb($filter('translate')('ocorrencia_toast_title_atualizacao'), $filter('translate')('ocorrencia_toast_ronda_a_caminho'));
                    break;
                case 8:
                    $this.showInfoMenssageWeb($filter('translate')('ocorrencia_toast_title_atualizacao'), $filter('translate')('ocorrencia_toast_ronda_no_local'));
                    break;
                case 9:
                    $this.showInfoMenssageWeb($filter('translate')('ocorrencia_toast_title_atualizacao'), $filter('translate')('ocorrencia_toast_ronda_finalizada'));
                    break;
            }
        },
    }

});
angular.module('Fullarm').service('ProvidenciasService', function (ProvidenciasFactory) {

    var _scope = {};
    var providenciasMonitoramento = [];
    var $this;
    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.providencias = [];
            _scope.exibeProvidencias = false;
        },

        setProvidencias: function (objProvidenciasSistema) {
            _scope.providencias = objProvidenciasSistema;
            _scope.exibeProvidencias = _scope.providencias.length > 0;
        },

        limpaProvidencias: function () {
            _scope.providencias = [];
        },

        setProvidenciasMonitoramento: function (objProvidenciasMonitoramento) {
            providenciasMonitoramento = objProvidenciasMonitoramento;
        },
    }
});


angular.module("Fullarm").service('SomService', function () {

    var audioLembrete = new Audio();
    return{

        executarSom : function (som) {
            var audio = new Audio(som);
            audio.play();
        },

        stopSom : function () {
            audioLembrete.pause();
        },

        executaSomLembrete : function(som){
            audioLembrete.src = som;
            if (audioLembrete.paused, audioLembrete.currentTime == 0, !audioLembrete.ended) {
                audioLembrete.play();
            }

            audioLembrete.addEventListener('ended', function(){
                audioLembrete.play();
            });
        }
    };
});
angular.module('Fullarm').service('VideoFrameService', function (CameraFactory, AcaoUsuarioService, $sce, playerService) {

    var _scope = {};
    var $this;

    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.cameras = [];
            _scope.cameraAtual = null;
            _scope.videoAtual = $sce.trustAsResourceUrl("");
            _scope.frameSet = true;
            _scope.showLoading = false;
            playerService.setNotificationSucesso($this.sucessoFrame);
            playerService.setNotificationFalha($this.falhaFrame);
        },

        setCameras: function (objCameras) {
            _scope.cameras = objCameras;
            setTimeout(function () {
                _scope.$apply();
            }, 0)
        },

        setCamAtual: function (camera) {
            _scope.cameraAtual = camera;
            playerService.stop();
            _scope.showLoading = true;
            _scope.imgLive = camera.thumb;
            playerService.setCamera(camera);
            playerService.play();
        },

        setFrameAovivo: function (aoVivoPorFrame) {
            _scope.frameSet = aoVivoPorFrame;
        },
        sucessoFrame: function (frame) {
            _scope.showLoading = false;
            _scope.imgLive = "data:image/JPEG;base64," + frame;
        },

        falhaFrame: function (falha) {
            _scope.showLoading = false;
            if (falha == "CAMERAINDISPONIVEL") {
                _scope.cameraAtual = {};
            }
            if (falha == "FRAMEVAZIO" || falha == "CAMERAINDISPONIVEL") {
                _scope.imgLive = 'assets/img/fullarm/canBroker_FullArm.png';
            }
        },

        esvaziaVideoAtual: function () {
            _scope.cameras = [];
            _scope.cameraAtual = null;
            _scope.videoAtual = $sce.trustAsResourceUrl("");
            playerService.stop();
        },

    }

});
angular.module('Fullarm')
.service('playerService', function ($http, $q, $timeout, encodeCamera) {

	var _camera    = null;
	var _intervalo = null;
	var _canceller = null;
	var _looper    = null;
	var _rodando   = false; 
	var _contRequest = 0;

	var _notificarSucesso = function(){};
	var _notificarFalha   = function(){};

    var INTERVALO_MAX  = 5000;
    var INTERVALO_MIN  = 100;
    var INTERVALO_DE_FALHA = 500;

    var FATOR_INCREMENTO_INTERVALO = +20;
    var FATOR_DECREMENTO_INTERVALO = -10;

    var ERRO_FRAME_VAZIO         = "FRAMEVAZIO";
    var ERRO_CAMERA_INDISPONIVEL = "CAMERAINDISPONIVEL";
    var ERRO_ACESSO_NEGADO       = "ACESSONEGADO";

	var _atualizarIntervalo = function (increment) {
		
		_intervalo += increment; 
		
		if(_intervalo < INTERVALO_MIN){
			_intervalo = INTERVALO_MIN;
		}

		if(_intervalo > INTERVALO_MAX){
			_intervalo = INTERVALO_MAX;
		}
	}

	var _sucessoRequestFrame = function(resp){

		var contentType = resp.headers('Content-type');
		var isImage     = contentType.indexOf("image/jpeg") > -1;
		var isText      = contentType.indexOf("text/plain") > -1;
		var errorText   = '';

		if (isImage) {			
			var bytes = resp.data;
			var imagem = encodeCamera.arrayBufferToBase64(bytes);	
			
			_atualizarIntervalo(FATOR_DECREMENTO_INTERVALO);
		    _notificarSucesso(imagem,_camera,(_contRequest == 0));
			_looper = $timeout(_requestFrame, _intervalo);
			_contRequest++;
		} 

		if (isText){
			errorText = encodeCamera.arrayBufferToString( resp.data );
			_atualizarIntervalo(FATOR_INCREMENTO_INTERVALO);
		}
	    if( isText && errorText == ERRO_FRAME_VAZIO && _intervalo >= INTERVALO_DE_FALHA){
    		_notificarFalha(ERRO_FRAME_VAZIO);
    		_looper = $timeout(_requestFrame, _intervalo);
    	} else if( isText && errorText == ERRO_FRAME_VAZIO){
    		_looper = $timeout(_requestFrame, _intervalo);
    	}else if(isText){
    		_notificarFalha(errorText);
    	}
		
	}

	var _falhaRequestFrame = function(error){
		var cancelPromise = error.config.timeout;
		if( cancelPromise.$$state.status == 0){
			_notificarFalha(ERRO_CAMERA_INDISPONIVEL)
		}
	}

	var _requestFrame = function(){
		if(_rodando){
			_canceller = $q.defer();
			var request = $http({
						method: 'GET',
						url: _camera.thumb,
						responseType:"arraybuffer",
						timeout:_canceller.promise,
                		withCredentials : false,
					});
			request.then(_sucessoRequestFrame,_falhaRequestFrame);
		}
	}

	var _setNotificarSucesso = function(notificarSucesso){
		_notificarSucesso = notificarSucesso;
	}

	var _setNotificarFalha   = function(notificarFalha){
		_notificarFalha   = notificarFalha;
	}
	
	var _setCamera = function ( camera ) {
		_camera = camera;
	};

	var _stop = function () {
		if(_rodando){
			_canceller.resolve('passei');
			$timeout.cancel(_looper);
		}
		
		_intervalo = INTERVALO_MIN;
		_contRequest = 0;
		_rodando = false;
	};

	var _play = function () {
		_intervalo = INTERVALO_MIN;
		_rodando   = true;
		_requestFrame();
	};

	return{
		setNotificationSucesso:_setNotificarSucesso,
		setNotificationFalha:_setNotificarFalha,
		setCamera: _setCamera,
		stop: _stop,
		play: _play
	};
});
angular.module('Fullarm').service('VeiculosProximosService', function (VeiculosProximosFactory, InformacoesOcorrenciaService, LoginService, $filter, $timeout, $q) {

    var _scope = {};
    var $this;
    var mapaVeiculosProximos;
    var markersGroupProximos;
    var configRotasProximos =
        {
            "delay": 800,
            "dashArray": [1, 87],
            "weight": 8,
            "color": "#0000FF",
            "pulseColor": "#FFFFFF",
            "paused": false,
            "reverse": false
        };

    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.sistema = [];
            _scope.enderecoSistema = [];
            _scope.exibeVeiculosProximos = false;
            _scope.veiculosProximos = [];
            _scope.enderecoVeiculo = "";
            _scope.enderecoCarregado = false;
            _scope.mapaVeiculosIsLoader = false;
        },

        setSistema:function (objSistema) {
            _scope.sistema = objSistema;
        },

        setEnderecoSistema: function (objEnderecoSistema) {
            _scope.enderecoSistema = objEnderecoSistema;
        },

        esvaziaVeiculos: function () {
            _scope.veiculosProximos = [];
            _scope.exibeVeiculosProximos =  false;
        },

        setVeiculosProximos:function (objVeiculosProximos) {
            _scope.veiculosProximos = objVeiculosProximos;
            _scope.exibeVeiculosProximos = objVeiculosProximos.length > 0;

            angular.forEach(_scope.veiculosProximos, function (veiculos, key) {
                var cor = $this.buscarCorPorEstadoDoVeiculo(veiculos);
                _scope.veiculosProximos[key].status = $filter('translate')('status_veiculo_por_cor_' + cor);
            });
            _scope.enderecoCarregado = false;
        },

        buscarVeiculosProximos: function () {
            InformacoesOcorrenciaService.setExibeVeicuProx(_scope.enderecoSistema.latitude);
            VeiculosProximosFactory.buscarPosicaoVeiculosProximosPorLatLong(_scope.enderecoSistema.latitude, _scope.enderecoSistema.longitude, function (result) {

                if(result.data != null){
                    $this.setVeiculosProximos(result.data);
                }
            }, function (error) {

            });
        },

        setaPosicoesMapa: function () {
            $this.initMapaVeiculosProximos();

            if(_scope.veiculosProximos.length > 0){
                $timeout(function () {
                    $this.setMarkersVeiculosProximos(_scope.veiculosProximos, false);
                    var marker = $this.criarMarkerSistema();
                    $(marker._icon).append($this.createMarkerLabelSistema(_scope.sistema));
                }, 100);
                $this.stopSpinMapaVeiculosProximos();
            }else{
                $this.stopSpinMapaVeiculosProximos();
            }
        },

        initMapaVeiculosProximos: function () {
            $this.clearLears();
            $this.startSpinMapaVeiculosProximos();
            if (mapaVeiculosProximos == null) {
                mapaVeiculosProximos = L.map(document.getElementById('leaflet-map-proximos'));
            }
            L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">Fulltrack Mapa</a>'
            }).addTo(mapaVeiculosProximos);

            markersGroupProximos = L.layerGroup().addTo(mapaVeiculosProximos);

            mapaVeiculosProximos.setView([-22.215403, -49.654070], 4);
        },

        setMarkersVeiculosProximos: function (localizacoes, deveCriarRotas) {

            $this.clearLears();
            var rotas = [];

            angular.forEach(localizacoes, function (localizacao) {
                if (localizacao != null) {
                    var cor = $this.buscarCorPorEstadoDoVeiculo(localizacao);
                    var marker = $this.criarMakerVeiculosProximos(localizacao, cor);
                    $(marker._icon).append($this.createMarkerLabelVeiculosProximos(localizacao, cor, deveCriarRotas, localizacoes.length));
                    mapaVeiculosProximos.setView([localizacao.latitude, localizacao.longitude], 12);
                    rotas.push([Number(localizacao.latitude), Number(localizacao.longitude)]);
                }
            });

            if (deveCriarRotas) {
                $this.criarRotas(rotas);
            }
        },

        criarRotas:function(rotas){
            if(rotas.length > 0){
                var path = L.polyline.antPath(rotas,configRotasProximos);
                markersGroupProximos.addLayer(path);
                mapaVeiculosProximos.fitBounds(path.getBounds());
            }

        },

        criarMakerVeiculosProximos: function (localizacao, cor) {
            return L.marker([localizacao.latitude, localizacao.longitude], {
                icon: L.AwesomeMarkers.icon({
                    icon: 'car',
                    markerColor: cor,
                    prefix: 'fa'
                })
            }).addTo(markersGroupProximos).bindPopup($this.createPopupPorVeiculo(localizacao, cor)).on('popupopen', function (popup) {
                $this.buscarEnderecoMapaPorLatLong(popup.popup._latlng.lat, popup.popup._latlng.lng, popup.popup._container);

            });
        },

        criarMarkerSistema: function () {
            if(_scope.enderecoSistema != []){
                return L.marker([_scope.enderecoSistema.latitude, _scope.enderecoSistema.longitude], {
                    icon: L.AwesomeMarkers.icon({
                        icon: 'home',
                        markerColor: 'black',
                        prefix: 'fa'
                    })
                }).addTo(markersGroupProximos).bindPopup($this.createPopupPorSistema()).on('popupopen', function (popup) {

                });
            }
        },

        clearLears: function () {
            if(markersGroupProximos != null){
                markersGroupProximos.clearLayers();
            }
        },

        buscarCorPorEstadoDoVeiculo: function (veiculo) {
            var cor = "";
            switch (veiculo.estado_veiculo) {
                case 1:
                    cor = "red";
                    break;
                case 2:
                    cor = "green";
                    break;
                case 3:
                    cor = "blue";
                    break;
            }
            return cor;
        },

        createMarkerLabelVeiculosProximos: function (veiculo, cor, deveCriarRotas, qtnPosicoes) {
            var label = "";

            if (qtnPosicoes == 1 || !deveCriarRotas) {
                label = '<div class="marker_div_proximos"><span class="marker_div_proximos_' + cor + '"> ' + veiculo.descricao + '</span></div>';
            }
            return label;
        },

        createMarkerLabelSistema: function (sistema) {
            var label = "";
            label = '<div class="marker_div_proximos"><span class="marker_div_proximos_black">' + sistema.descricao + '</span></div>';

            return label;
        },

        resizeMapa: function(){
            setTimeout(function() {
                mapaVeiculosProximos.invalidateSize();
            }, 10);
        },

        createPopupPorVeiculo: function (veiculo, cor) {
            veiculo.contato_motorista = veiculo.contato_motorista == 0 ? $filter("translate")("ocorrencia_label_contato_nao_cadastrado") : veiculo.contato_motorista;
            var mapaHtml = "";
            mapaHtml += '<div class="row">\n' +
                '    <div class="col-md-10 col-sm-10 col-xs-10 descricao-rastreado">\n' +
                '        <span>' + veiculo.descricao + '</span>\n' +
                '        <br>\n' +
                '        <span>' + $filter("translate")("ocorrencias_label_identificador")+ ': ' + veiculo.placa + '</span>\n' +
                '    </div>\n' +
                '    <div class="col-md-12 col-sm-12 col-xs-12">\n' +
                '        <hr style="margin-top: 5px; margin-bottom: 5px;">\n' +
                '    </div>\n' +
                '    <div class="pop_up_rastreados_detalhes">';
                if(veiculo.tipo_veiculo != 7){
                    mapaHtml +='<div class="info-marker"><span><i class="fa fa-user"></i>' + $filter("translate")("ocorrencia_label_nome_motorista") + ': <strong>' + veiculo.nome_motorista + '</strong></span></div>';
                }else{
                    mapaHtml +='<div class="info-marker"><span><i class="fa fa-user"></i>' + $filter("translate")("ocorrencia_label_usuario") + ': <strong>' + veiculo.nome_motorista + '</strong></span></div>';
                }
                mapaHtml +='<div class="info-marker"><span><i class="fa fa-phone"></i>' + $filter("translate")("ocorrencia_label_contato_motorista") + ': <strong>' + veiculo.contato_motorista + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-calendar"></i>' + $filter("translate")("ocorrencia_label_data_localizacao") + ': <strong>' + veiculo.data_gps + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-calendar"></i>' + $filter("translate")("ocorrencia_label_data_comunicacao") + ': <strong>' + veiculo.data_enviado + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' +  $filter("translate")("ocorrencia_label_latitude") + ': <strong>' + veiculo.latitude + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' +  $filter("translate")("ocorrencia_label_longitude") + ': <strong>' + veiculo.longitude + '</strong></span></div>\n';
                if(veiculo.tipo_veiculo != 7){
                    mapaHtml +=     '        <div class="info-marker"><span><i class="fa fa-tachometer"></i>' +  $filter("translate")("ocorrencia_label_velocidade") + ': <strong>' + veiculo.velocidade + ' km/h</strong></span></div>\n' +
                                    '        <div class="info-marker"><span><i class="fa fa-circle-o-notch"></i>' +  $filter("translate")("ocorrencia_label_status") + ': </span><strong>' + $filter('translate')('status_veiculo_por_cor_' + cor) + ' </strong></div>\n';
                }
                mapaHtml += '    </div>\n' +
                '    <div class="info-tabs popup_div_botoes">\n' +
                '        <div class="tab-content">\n' +
                '            <div role="tabpanel" class="tab-pane active">\n' +
                '                <a class="btn btn-default" target="_blank"  href="https://www.google.com/maps/search/' + veiculo.latitude + ',' + veiculo.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no google maps"><i class="fa fa-google fa-2x"></i></a>\n' +
                '                <a class="btn btn-default" target="_blank" href="http://maps.google.com/maps?q=&layer=c&cbll=' + veiculo.latitude + ',' + veiculo.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no Google Street View"><i class="fa fa-street-view fa-2x"></i></a>\n' +
                '            </div>                        \n' +
                '        </div>\n' +
                '    </div>\n' +
                '</div>';
                return mapaHtml;
        },

        createPopupPorSistema: function () {
            var endereco =  _scope.enderecoSistema.logradouro +", "+ _scope.enderecoSistema.numero +" - "+ _scope.enderecoSistema.bairro +' '+ _scope.enderecoSistema.cidade+' / '+ _scope.enderecoSistema.estado;
            return '<div class="row">\n' +
                '    <div class="col-md-10 col-sm-10 col-xs-10 descricao-rastreado">\n' +
                '        <span>' + _scope.sistema.descricao + '</span>\n' +
                '    </div>\n' +
                '    <div class="col-md-12 col-sm-12 col-xs-12">\n' +
                '        <hr style="margin-top: 5px; margin-bottom: 5px;">\n' +
                '    </div>\n' +
                '    <div class="pop_up_rastreados_detalhes">\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' + $filter("translate")("ocorrencia_label_latitude") + ': <strong>' + _scope.enderecoSistema.latitude + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-globe"></i>' + $filter("translate")("ocorrencia_label_longitude") + ': <strong>' + _scope.enderecoSistema.longitude + '</strong></span></div>\n' +
                '        <div class="info-marker"><span><i class="fa fa-map-marker"></i> '+ $filter('translate')('ocorrencia_label_endereco')+': </span><strong>'+endereco+'</strong></div>\n' +
                '    </div>\n' +
                '    <div class="info-tabs popup_div_botoes">\n' +
                '        <div class="tab-content">\n' +
                '            <div role="tabpanel" class="tab-pane active">\n' +
                '                <a class="btn btn-default" target="_blank"  href="https://www.google.com/maps/search/' + _scope.enderecoSistema.latitude + ',' + _scope.enderecoSistema.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no google maps"><i class="fa fa-google fa-2x"></i></a>\n' +
                '                <a class="btn btn-default" target="_blank" href="http://maps.google.com/maps?q=&layer=c&cbll=' + _scope.enderecoSistema.latitude + ',' + _scope.enderecoSistema.longitude + '" data-toggle="tooltip" data-placement="bottom" title="Mostrar no Google Street View"><i class="fa fa-street-view fa-2x"></i></a>\n' +
                '            </div>                        \n' +
                '        </div>\n' +
                '    </div>\n' +
                '</div>'
        },

        startSpinMapaVeiculosProximos: function(){
            _scope.mapaVeiculosIsLoader = true;
        },

        stopSpinMapaVeiculosProximos: function () {
            _scope.mapaVeiculosIsLoader = false;
        },

        removeMapaVeiculosProximos:function () {
            if(!angular.isUndefined(mapaVeiculosProximos) && mapaVeiculosProximos != null){
                mapaVeiculosProximos.remove();
                document.getElementById('leaflet-map-proximos').innerHTML = "";
                mapaVeiculosProximos = null;
            }
        },

        buscarEnderecoPorLatLong: function(){
            if(_scope.veiculosProximos.length > 0){
                if(!angular.isUndefined(_scope.veiculosProximos[0].endereco) || _scope.veiculosProximos[0].endereco == ""){
                    angular.forEach(_scope.veiculosProximos, function (veiculos, key) {
                        VeiculosProximosFactory.buscarEnderecoPorLatLong(veiculos.latitude, veiculos.longitude, function (data) {
                            var endereco = data.data;

                            if(endereco != ""){
                                _scope.enderecoCarregado = true;
                                _scope.veiculosProximos[key].endereco = endereco;
                            }

                        },function (error) {});
                    });
                }
            }else{

            }

        },

        buscarEnderecoMapaPorLatLong: function(lat,long, popup){
            VeiculosProximosFactory.buscarEnderecoPorLatLong(lat, long, function (data) {
                var endereco = data.data;
                if(endereco != ""){
                    $(popup).find('.pop_up_rastreados_detalhes').append('<div class="info-marker"><span><i class="fa fa-map-marker"></i> '+$filter('translate')('ocorrencia_label_endereco')+': </span><strong>'+endereco+'</strong></div>');
                }

            },function (error) {});
        },

     }
});
angular.module('Fullarm').service('VideosService', function ($rootScope, VideosHlsFactory, VideoFrameService, AcaoUsuarioService, $sce) {

    var _scope        = {};
    var $this;
    var horarios = [];

    return{
        setScope: function (scope) {
            $this = this;
            _scope = scope,
            _scope.videosHls = [];
            _scope.ocorrenciaAtualVideos = [];
            _scope.tipoReproducao = 1;
            _scope.values = [];
            _scope.videoGularApi = null;
            _scope.indexGravacao = 0;
            _scope.content = ["0"];
            _scope.idOcorrencia = 0;
            _scope.videoAtual = [];
            _scope.exibeCameras = false;
            $rootScope.videosFinishedLoading = false;
            _scope.config = {
                autoPlay: true,
                sources: [{src: $sce.trustAsResourceUrl(""), type: ""}],
                theme: "app/bower_components/videogular-themes-default/videogular.min.css"
            };
        },

        buscarCamerasOcorrencia: function(idSistema, tipoVideo){
            var videoJaCarregado = (_scope.cameras.length > 0 || _scope.videosHls.length > 0);
            if(!videoJaCarregado){
                $rootScope.videosFinishedLoading = true;
                _scope.exibeCameras = false;
                VideosHlsFactory.listarCamerasOocorrencia(idSistema, tipoVideo, function (result) {
                    _scope.exibeCameras = result.data.length > 0;
                    $rootScope.videosFinishedLoading = false;
                        if(_scope.ocorrenciaAtual && _scope.ocorrenciaAtual.video_ativo){
                            if(_scope.tipoVideo == 1){
                                VideoFrameService.setCameras(result.data);
                            }else{
                                $this.setVideosHls(result.data);
                            }
                        }
                }, function () {
                    $rootScope.videosFinishedLoading = false;
                })
            }
        },

        setVideosHls: function (objVideosHls) {
            _scope.videosHls = objVideosHls;
            setTimeout(function () {
                _scope.$apply();
            }, 0);
        },

        setIdOcorrenciaAtual: function (idOcorrencia) {
            _scope.idOcorrencia = idOcorrencia;
        },

        setVideoGular: function (videoGular) {
            _scope.videoGularApi = videoGular;
        },

        setVideoAovivo: function () {
            if(_scope.videoAtual != null){
                $this.setHlsCamInfo(_scope.videoAtual);
            }
            _scope.tipoReproducao = 1;
        },

        clearVideoGularApi:function () {
            _scope.videoGularApi.clearMedia();
        },

        setProximoVideo: function () {
            _scope.indexGravacao++;
            if (_scope.indexGravacao < horarios.length){
                $this.changeVideoGravacao(_scope.indexGravacao);
            }
        },

        esvaziaVideoAtual: function () {
            _scope.videoAtual = [];
        },

        setHlsCamInfo: function (hls) {
            if(hls != null){
                _scope.videoAtual = hls;
                _scope.tipoReproducao = 1;

                VideosHlsFactory.buscarHlsVideoPorId(hls, function (data) {
                    _scope.config.sources =[{
                        src: $sce.trustAsResourceUrl(data.data.hls), type: "application/x-mpegURL"
                    }];
                }, function (error) {

                });
            }
        },

        setCamerasEmEstacao:function (idLogin, idSistema, idOcorrencia) {
            VideosHlsFactory.setCamerasEmEstacao(idLogin, idSistema, idOcorrencia, function (sucesso) {}, function (erro) {});
        },

        iniciaGravacaoNovaOcorrencia:function(idSistema, idOcorrencia){
            VideosHlsFactory.iniciaGravacaoPorIdSistemaEporOcorrencia(idSistema, idOcorrencia, function (sucesso) {}, function (erro) {});
        },

        buscarUltimaHoraDeGravacao: function() {
            _scope.tipoReproducao = 2;
            $this.cleanPlayer();
            VideosHlsFactory.buscarUltimaHoraDeGravacao(_scope.videoAtual, function (data) {
                horarios = data.data;
                _scope.content = data.data.map(function (data) {
                    return data.minuto;
                });

                if(horarios.length > 0){
                    _scope.indexGravacao = 0;
                    $this.changeVideoGravacao(0);
                }

                setTimeout(function () {
                    _scope.$apply();
                }, 0);
            });
        },

        inserirLogVisualizacaoVideo: function (descCamera) {
            var videoParams = {acao_usuario: 'VISUALIZACAO_VIDEO', ocorrencia: _scope.idOcorrencia, camera: descCamera};
            AcaoUsuarioService.inserirLogAcaoUsuario(videoParams).then(function () {
                videoParams = [];
            });
        },

        changeVideoGravacao: function(indexVideo) {
            _scope.indexGravacao = indexVideo;
            _scope.config.sources =[{
                src: $sce.trustAsResourceUrl(horarios[indexVideo].filename), type: "video/mp4"
            }];
        },

        cleanPlayer: function () {
            _scope.config.sources =[{
                src: $sce.trustAsResourceUrl(""), type: ""
            }];

            if(_scope.videoGularApi != null){
                $this.clearVideoGularApi();
            }
            setTimeout(function () {
                _scope.$apply();
            }, 0);
        }
    }

});
angular.module('Fullarm').service('ViaturasService', function (ViaturasFactory, $filter, $timeout, $q, $rootScope, MapaService) {

    var _scope = {};
    var $this;

    return {
        setScope: function (scope) {
            $this = this;
            _scope = scope;
            _scope.viaturas = [];
            $rootScope.$viaturasFinishedLoading = false;
            _scope.fulltrack_ativo = permissoes.fulltrack_ativo;
            _scope.logins = [];
            _scope.mostrarMensagemLoading = false;
            $rootScope.exibeViaturas = false;
            _scope.exibeBotaoMapaFpatrol = false;
        },

        buscarViaturasPorLoginsDaRota: function (logins, mostrarLoad){
            _scope.logins = logins;
            $rootScope.$viaturasFinishedLoading = mostrarLoad;
            if(_scope.ocorrenciaAtual.sistema){
                ViaturasFactory.buscarViaturasPorLoginsDaRota(
                    logins,
                    _scope.ocorrenciaAtual.sistema.endereco.latitude,
                    _scope.ocorrenciaAtual.sistema.endereco.longitude,
                    function (viaturas) {
                        $this.setDataMapaFpatrol(viaturas.data);
                        $rootScope.$viaturasFinishedLoading = false;
                        $this.setViaturasRonda(viaturas.data);
                    }, function (error) {
                });
            }
        },

        setViaturasRonda: function(objViaturas){
            if(objViaturas.length > 0){
                $rootScope.exibeViaturas = true;
                _scope.viaturas = objViaturas;
            }
        },

        setDataMapaFpatrol: function(viaturas){
            var viaturasFulltrack = [];
            angular.forEach(viaturas, function(viatura){
                if(!angular.isUndefined(viatura.latitude)){
                    viatura.nome_motorista = viatura.login_descricao;
                    viaturasFulltrack.push(viatura);
                }
            });
            if(viaturasFulltrack.length > 0){
                _scope.exibeBotaoMapaFpatrol = true;
                MapaService.setData(viaturasFulltrack);
                MapaService.setMapId('leaflet-map-fpatrol');
            }
        },

        conectaTopicoViaturas:function(logins){
            if(_scope.client.isConnected()) {
                angular.forEach(logins, function (login) {
                    _scope.client.subscribe("fpatrol/login/" + login + "/vinculo_alteracao", {qos: 2});
                });
            }
        },

        conectaTopicoRotas:function(id_sistema){
            if(_scope.client.isConnected()) {
                _scope.client.subscribe("fpatrol/sistema/"+id_sistema+"/vinculo_alteracao", {qos: 2});
            }
        },

        esvazia:function(){
            _scope.viaturas = [];
            _scope.exibeBotaoMapaFpatrol = false;
        },

        atualizaStatusLoginsRonda: function(login, status){
            angular.forEach(_scope.viaturas, function (viatura, item) {
                if(viatura.login_id == login){
                    if(_scope.viaturas[item]){
                        _scope.viaturas[item].status_ronda = status;
                    }
                }
            });
        },
    }
});

/**
 * @author Fullarm
 * created on 20.03.2018
 */
(function () {
    'use strict';
    angular.module('Fullarm').controller('ComentarioOcorrenciaController', function ($scope,$filter, constant, ComentarioOcorrenciaService, OcorrenciaAtualService, MotivosAlarmeService,
                                                                                     PostergarHorarioService, AcaoUsuarioService, ToastMessageService, OcorrenciasService, CarregamentoOcorrenciaService) {

        $(document).on('change', '#push_log_cliente', function (e) {
            if ($("#push_log_cliente").is(':checked')){
                $("#mostrar_log_cliente").prop('checked', true);
                $("#mostrar_log_cliente").prop('disabled', true);
            }else{
                $("#mostrar_log_cliente").prop('checked', false);
                $("#mostrar_log_cliente").prop('disabled', false);
            }
        });

        var criarModalPostergacao = function () {
            $(function(){
                var modal = $("#modal-postergar");

                modal.iziModal({
                    padding: 30,
                    width: '50%'
                });

                modal.on('click', '#btnPostergarHorario',function (e) {
                    var objEventoTabelaHorario = PostergarHorarioService.getEventoTabelaHorario();
                    var comentario = $("#comentario_postergar").val();
                    var idSistema = OcorrenciaAtualService.getSistema();
                    var postergarPara = $("#hora_postergar").val();
                    var id = objEventoTabelaHorario.id_sistema_horario_ativo;
                    var tipo = objEventoTabelaHorario.tipo_evento_tabela_horario;
                    var hora_atual = moment().format("HH:mm");

                    if(postergarPara <= hora_atual ){
                        ToastMessageService.showWarningMenssageWebCenter('ocorrencia_toast_horario_postergar_menor');
                        return;
                    }

                    var paramsPostergar ={
                        postergar_para: postergarPara,
                        id: id,
                        tipo:tipo
                    };
                    PostergarHorarioService.postergarHorario(paramsPostergar, idSistema).then(function (sucess) {
                        var paramsLogPostergar = {
                            acao_usuario:'HORARIO_POSTERGADO',
                            ocorrencia:OcorrenciaAtualService.getIdOcorrenciaAtual(),
                            complemento:comentario,
                            postergar_para: postergarPara,
                            tipo:tipo
                        };
                        AcaoUsuarioService.inserirLogAcaoUsuario(paramsLogPostergar).then(function (sucess) {}, function (error) {});
                        CarregamentoOcorrenciaService.finalizaOcorrencia();
                    }, function (error) {
                        if(error.status == 404){
                            OcorrenciasService.alteraStatusOcorrencia(constant.STATUS.FINALIZADO, null);
                        }else{
                            ToastMessageService.showErrorMenssage(error);
                        }
                    });
                });
            });
        };

        $scope.abrirModalMensagensPadrao = function(event) {
            var selectElement = document.getElementById('select_msg_padrao');
            selectElement.selectedIndex = 0;
            var keyID = (event.charCode) ? event.charCode : ((event.which) ? event.which : event.keyCode);
            if (keyID == 64) {
                if($scope.mensagensPadrao.length > 0){
                    $("#modalMensagensPadrao").iziModal('open');
                }
            }
        };

        $scope.tratarInclusaoDoComentario = function () {
            MotivosAlarmeService.exibirMotivosAlarme(false);
            $("#text_log").focus();
            ComentarioOcorrenciaService.verificaComentarioOcorrencia();
        };

        criarModalPostergacao();
    });
})();



/**
 * @author Fullarm
 * created on 20.03.2018
 */
(function () {
    'use strict';
    angular.module('Fullarm').controller('HistoricoEventosController', function ($scope, HistoricoEventosService, MonitoramentoService, TelaConfigService) {
        var tamanho = "";
        var limite = 0;
        var descricaoHistorico = 0;

        $scope.verificaLimiteCaractere = function () {
            tamanho = TelaConfigService.verificaTamanhoTela();
            limite = 0;
            if(tamanho == "menor"){
                limite = 30;
                descricaoHistorico = "200px";
            }else if(tamanho == "maior"){
                limite = 80;
                descricaoHistorico = "400px";
            }
        };

        $scope.buscarHistoricoPaginado = function (idSistema, limite, rastreados) {
            MonitoramentoService.closeAllTabs();
            setTimeout(function () {
                $("#tableHistoricoResponsive").css("max-height",  $(".viewportHistorico").height()-120);
            },500);
            HistoricoEventosService.listarHistoricoEventos(idSistema, limite, rastreados);
        };

        $scope.buscarHistoricoRastreadosPaginado = function (idSistema, limite) {
            MonitoramentoService.closeAllTabs();
            setTimeout(function () {
                $("#tableHistoricoResponsive").css("max-height",  $(".viewportHistorico").height()-120);
            },500);
            HistoricoEventosService.listarHistoricoEventos(idSistema, limite, true);
        };

        $scope.verificaLimiteCaractere();
        $scope.descricaoHistorico = descricaoHistorico;
        $scope.limiteDescricaoHistorico = limite;
    });
})();


angular.module('Fullarm').controller('EventoManualController', function ($scope, EventoManualFactory, ToastMessageService) {

    $scope.sistema = "";
    $scope.pVirtual = "";

    $("#modal-descricao-evento").iziModal({
        padding: 30,
        width: '25%',
        transitionIn: 'fadeInUp',
        transitionOut: 'fadeOutDown'
    });

    $("#btnEnviarEventoManual").unbind().click(function (e) {
        var descricao = $("#descricao_evento").val();
        $scope.geraEventoManual(descricao);
        $("#modal-descricao-evento").iziModal('close');
        $("#descricao_evento").val("");
    });

    $("#btnCancelarEventoManual").unbind().click(function (e) {
        $("#descricao_evento").val("");
        $("#modal-descricao-evento").iziModal('close');
    });

    $scope.abrirModalDescricaoEvento = function(idSistema, idPainelVirtual){
        $scope.sistema = idSistema;
        $scope.pVirtual = idPainelVirtual;
        setTimeout(function () {
            $("#modal-descricao-evento").iziModal('open');
            $(".ng-spotlight").hide();
        },100);
    };

    $scope.geraEventoManual = function(descricao) {
        if($scope.sistema > 0){
            var dados = {
                "id_sistema":$scope.sistema,
                "evento":2,
                "id_painel_virtual":$scope.pVirtual,
                "desc_complemento":descricao
            };
            EventoManualFactory.gerarEventoManual(dados, function (retorno) {
                ToastMessageService.showSuccessMenssage(retorno.data.msg,"");
                $(".ng-spotlight").hide();
            },
            function (error) {
                $(".ng-spotlight").hide();
                ToastMessageService.showErrorMenssageWeb('falha_erro_gerenerico');
            });
        }
    };
});
angular.module('Fullarm').controller('LogsOcorrenciaController', function ($scope, $filter, constant, LogService, OcorrenciaAtualService, PopupWindowService, LocalizacaoService, AcaoUsuarioService) {

    $scope.carregarMais = function () {
       if(!angular.isUndefined(OcorrenciaAtualService.getIdOcorrenciaAtual())){
           LogService.listarLogsOcorrencia(OcorrenciaAtualService.getIdOcorrenciaAtual());
       }
    };

    $scope.ampliarTextoLog = function(text){
        var subtitle = $filter('translate')("ocorrencias_modal_log_subtitle");
        $("#corpo_modal_log").html((text));
        $("#subititle_modal_log").html(subtitle);
        setTimeout(function () {
            $('#modal-log').iziModal('open');
        }, 100);
        $("#modal-log").iziModal('setTitle',$filter('translate')('ocorrencias_modal_log_title'));
    };

    $('#modal-log').iziModal({
        headerColor: '#26A69A',
        width: '50%',
        overlayColor: 'rgba(0, 0, 0, 0.5)',
        fullscreen: true,
        transitionIn: 'fadeInUp',
        transitionOut: 'fadeOutDown'
    });

    $scope.abrirPopupWindowPreAlarme = function (dados) {
        var options = {
            height: window.outerHeight * 80 / 100,
            width: window.outerWidth * 80 / 100,
            left: window.outerWidth * 10 / 100,
            top: window.outerHeight * 10 / 100,
        };
        PopupWindowService.openPopupWindowCarousel(options, dados);
        $scope.enviaAcaoUsuarioPreAlarme();
    };

    $scope.abrirPopupWindow = function (dados) {
        var options = {
            height: window.outerHeight * 80 / 100,
            width: window.outerWidth * 80 / 100,
            left: window.outerWidth * 10 / 100,
            top: window.outerHeight * 10 / 100,
        };
        PopupWindowService.openPopupWindowCarousel(options, dados);
    };

    $scope.abrirModalLocalizacao = function (objEvento) {
        if(objEvento.latitude != null){
            LocalizacaoService.getLocalizacao(objEvento);
        }
    };

    $scope.abrirImagemDisparo = function (dadosImagem) {
        var options = {
            height: window.outerHeight * 80 / 100,
            width: window.outerWidth * 80 / 100,
            left: window.outerWidth * 10 / 100,
            top: window.outerHeight * 10 / 100,
            url: !angular.isUndefined(dadosImagem.versao) && dadosImagem.versao == "2" ? dadosImagem.caminho_imagem : constant.IMAGE_URL+dadosImagem.caminho_imagem
        };
        PopupWindowService.openPopupWindow(options);
    };

    $scope.abrirImagemRonda = function (caminhoImagem) {
        var options = {
            height: window.outerHeight * 80 / 100,
            width: window.outerWidth * 80 / 100,
            left: window.outerWidth * 10 / 100,
            top: window.outerHeight * 10 / 100,
            url: caminhoImagem
        };
        PopupWindowService.openPopupWindow(options);
    };

    $scope.abrirVideoPreAlarme = function (caminho) {
        var options = {
            height: window.outerHeight * 80 / 100,
            width: window.outerWidth * 80 / 100,
            left: window.outerWidth * 10 / 100,
            top: window.outerHeight * 10 / 100,
            url:caminho
        };
        PopupWindowService.openPopupWindow(options);
        $scope.enviaAcaoUsuarioPreAlarme();
    };

    $scope.enviaAcaoUsuarioPreAlarme = function () {
        var params = {
            acao_usuario: 'VISUALIZACAO_PRE_ALARME',
            ocorrencia: $scope.idOcorrencia
        };
        AcaoUsuarioService.inserirLogAcaoUsuario(params).then(function () {
            params = [];
        });
    };


}).directive('whenScrolledLog', function() {
    return function(scope, elm, attr) {
        var raw = elm[0];
        elm.bind('scroll', function() {
            if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                scope.$apply(attr.whenScrolledLog);
            }
        });
    };
});

/**
 * @author Fullarm
 * created on 27.08.2018
 */
(function () {

    'use strict';
    angular.module('Fullarm').controller('MonitoramentoController', function (constant, $http,  $scope, $uibModal, encodeCamera, $timeout, $rootScope, ContatosService, OcorrenciasService, MonitoramentoService, ProvidenciasService,
                                                                                                OcorrenciaAtualService, AnotacoesTemporariasService, VideosService, PainelService, RastreadosService,
                                                                                                MotivosAlarmeService, ComentarioOcorrenciaService, LogService, HistoricoEventosService, TelaConfigService,
                                                                                                GrupoAtendimentoService, MqttService, OrdemServicoService, PageTopService, AcaoUsuarioService, VideoFrameService,
                                                                                                LocalizacaoService, VeiculosProximosService, PostergarHorarioService, InformacoesOcorrenciaService, ChatService,
                                                                                                PopupWindowService, LoginService, ToastMessageService, LembreteService, $filter,
                                                                                                CarregamentoOcorrenciaService, ConfigService, TeclaAtalhoService, AutomacaoService,
                                                                                                ViaturasService, ManutencaoSistemaService, MapaService, EdicaoSistemaService,FullcondService, configs, $translate) {




        $translate.use(configs.userOption.idioma);

        if( configs.is_condhouse ){
            angular.element(document.body)
            .addClass('blur-theme fundo_ch')
        } 

        $rootScope.$pageFinishedLoading = true;

        
        $scope.novoHorario = "";
        $scope.statusSelecionado = 1;
        $scope.idConversaClicada = "";
        $scope.gruposAtendimento = [];
        $rootScope.fundoIsLight = tinycolor(userOption.cor_fundo_chat).isLight();
        $scope.permissoesMonitoramento = permissoes;
        $scope.permissao_fpatrol = permissoes.fpatrol;
        $scope.mostraChatDesabilitado = false;
        $rootScope.idiomaAtual = userOption.idioma;
        $scope.tempoEmObservacao = 0;
        $scope.existeTempoExecucao = false;
        $scope.permissao_aguardar_observacao = permissoes.aguardar_observacao;
        $rootScope.buttonClicked = null;
        $scope.permissao_editar_sistema = permissoes.editar_sistema_fullcenter;
        $scope.permissao_editar_sistema_sem_ocorrencia = permissoes.editar_sistema_fullcenter_sem_ocorrencia;
        $scope.sistemaEnderecoObservacao = "";
        $scope.sistemaEnderecoComplemento = "";
        $scope.habilitarProrrogar = false;
        $scope.permissao_colocar_sistema_em_manutencao_fullcenter = permissoes.colocar_sistema_em_manutencao_fullcenter;
        $scope.exibirEdicao = false;

        LogService.setScope($scope);
        PainelService.setScope($scope);
        VideosService.setScope($scope);
        ContatosService.setScope($scope);
        RastreadosService.setScope($scope);
        TelaConfigService.setScope($scope);
        OcorrenciasService.setScope($scope);
        ProvidenciasService.setScope($scope);
        MonitoramentoService.setScope($scope);
        MotivosAlarmeService.setScope($scope);
        OcorrenciaAtualService.setScope($scope);
        VeiculosProximosService.setScope($scope);
        HistoricoEventosService.setScope($scope);
        AnotacoesTemporariasService.setScope($scope);
        ComentarioOcorrenciaService.setScope($scope);
        VideoFrameService.setScope($scope);
        PageTopService.setScope($scope);
        OrdemServicoService.setScope($scope);
        LocalizacaoService.setScope($scope);
        LoginService.setScope($scope);
        MqttService.setScope($scope);
        PostergarHorarioService.setScope($scope);
        InformacoesOcorrenciaService.setScope($scope);
        ChatService.setScope($scope);
        LembreteService.setScope($scope);
        CarregamentoOcorrenciaService.setScope($scope);
        ConfigService.setScope($scope);
        TeclaAtalhoService.setScope($scope);
        AutomacaoService.setScope($scope);
        ViaturasService.setScope($scope);
        MapaService.setScope($scope);
        EdicaoSistemaService.setScope($scope);
        ManutencaoSistemaService.setScope($scope);
        FullcondService.setScope($scope);
        OcorrenciasService.listaOcorrencias();
        TelaConfigService.setLimiteCaracteresLogin();
        $scope.isProrrogacao = false;

        $rootScope.$on('loading:finish', function (){
            if($rootScope.buttonClicked){
                $rootScope.buttonClicked.button('reset');
            }
        });

        GrupoAtendimentoService.listaGruposAtendimento(MonitoramentoService.getIdUsuarioLogado()).then(function (grupos) {
            $scope.gruposAtendimento = grupos;
            MqttService.startMQtt(grupos);
        });

        MqttService.startMQttFtalk();
        MotivosAlarmeService.listarMotivosAlarme();
        ComentarioOcorrenciaService.listarMensagensPadrao();

        $scope.carregaConversaSelecionada = function(id, imagem, login, clienteComPermissao){
            $scope.idConversaClicada = id;
            if(clienteComPermissao){
                $scope.mostraChatDesabilitado = false;
                if(id != ""){
                    var sistema = OcorrenciaAtualService.getSistema();
                    ChatService.getConversaPorId(id, imagem, login, sistema);
                }
            }else{
                $scope.mostraChatDesabilitado = true;
                $scope.mostraCorpoMensagem = false;
                $scope.mensagens = [];
            }
        };

        setTimeout(function(){
            if(ConfigService.getAutoCarregamentoOcorrencia()){
                CarregamentoOcorrenciaService.verificaOcorrenciasComPrioridadeAltaEmEspera();
            }
        },3000);

        $(document).on('click', function (e) {
            e.stopPropagation();
            MqttService.clearTimer();
        });

        if(tempo_lembrete > 0){
            setInterval(function() {
                LembreteService.buscaOCorrenciasEmEspera(userOption.id, som_lembrete.link);
            }, tempo_lembrete);
        }

        $(document).on('click', '#tableLembrete li', function (event) {
            OcorrenciasService.setTabStatusSuperior(0);
            $('#modal-lembrete').iziModal('close');
            var botoes = {
                assumir: true,
                atender:true,
                observar:true,
                processo:false
            };
            OcorrenciaAtualService.esvaziaOcorrenciaAtual();
            CarregamentoOcorrenciaService.carregaOcorrencia(event.target.id, botoes);

        });

        $(document).keydown(function(e) {
            if(deveExecucutarTeclaAtalho()) {
                if ($('#modalMensagensPadrao').is(':visible')) {
                    TeclaAtalhoService.acoesModalMensagemPadrao(e);
                } else {
                    if (deveExecutarAcoesDoComentario()) {
                        TeclaAtalhoService.acoesComentarioOcorrencia(e);
                    } else {
                        verificaAcoesTeclaAtalho(e);
                    }
                }
            }
        });

        var deveExecucutarTeclaAtalho = function(){
            var deveExecutar = ConfigService.getTeclasAtalhoAtivo() && $rootScope.$dadosFinishedLoading && !$('#modal-postergar').is(':visible') && !$('#modal-observacao').is(':visible') && !$('#modal-troca-usuario').is(':visible') && !$("#modal-descricao-evento").is(':visible');
            return deveExecutar;
        };

        var deveExecutarAcoesDoComentario = function(){
            var deveExecutarComentario = $('#text_log').is(":focus") || $('#mostrar_log_cliente').is(":focus") || $('#push_log_cliente').is(":focus");
            return deveExecutarComentario;
        };

        var verificaAcoesTeclaAtalho = function(e){
            var atalhoBotoesDeAcao = e.ctrlKey;
            var atalhosBotoesMotivoAlarme = e.keyCode === 13;
            var atalhoColocarFocoNoComentario = e.keyCode === 9;
            var atalhoNavegarPelasAbas = e.keyCode === 39 || e.keyCode === 37;
            var direcao = e.keyCode === 39 ? 'right' : e.keyCode === 37 ? 'left' : '';

            if(atalhoBotoesDeAcao){
                TeclaAtalhoService.acoesBotoesDeAcao(e);
            }else{
                if(atalhosBotoesMotivoAlarme){
                    TeclaAtalhoService.acoesTelaMotivosAlarme();
                }else if(atalhoColocarFocoNoComentario){
                    event.preventDefault();
                    if(!angular.isUndefined(OcorrenciaAtualService.getIdOcorrenciaAtual())){
                        $("#text_log").focus();
                    }
                }else if(atalhoNavegarPelasAbas){
                    TeclaAtalhoService.acaoVerificarRightLeft(direcao);
                }else{
                    TeclaAtalhoService.acoesDeSelecaoDeStatus(e);
                }
            }
        };

        $(document).on('click', '#btnSolicitarOrdemServico', function (e) {
            $scope.geraSolicitacaoOrdemDeServico();
        });

        $(document).on('click', '#modal-os-close', function (e) {
            OrdemServicoService.fecharModalOrdemDeServico();
        });

        $scope.geraSolicitacaoOrdemDeServico = function () {
            OrdemServicoService.gerarSolicitacao(OcorrenciaAtualService.getSistema()).then(function (sucess) {
                var objOsCadastrada = sucess.data.Os;
                var osParams = {
                    acao_usuario:'ORDEM_SERVICO',
                    ocorrencia: OcorrenciaAtualService.getIdOcorrenciaAtual(),
                    complemento: $("#selectProblemas").find(':selected').text(),
                    os:objOsCadastrada
                };
                AcaoUsuarioService.inserirLogAcaoUsuario(osParams);
            }, function (error) {

            });
        };

        $scope.preparaAlteracaoStatusParaObservacao = function(){
            OcorrenciasService.alteraStatusObservacao(null);
        };

        $scope.preparaAlteracaoStatusParaAtendimento = function () {
            OcorrenciasService.alteraStatusOcorrencia(constant.STATUS.EM_ATENDIMENTO, null);
        };

        $scope.preparaFinalizacaoOcorrencia = function () {
            MotivosAlarmeService.verificaExibicaoMotivoAlarme();
        };

        $(document).on('change', '#rbTeclaAtalhoAtivo', function(e) {
            if($('#modal-legenda_tecla_atalho').is(':visible')){
                ConfigService.alteraConfiguracao('teclas_atalho_ativo', $(this).prop('checked'), MonitoramentoService.getIdUsuarioLogado());
                e.preventDefault()
            }
        });


        $scope.iniciarManutencao = function(){
            var tempo = $("#tempo_manutencao").val().split(':');
            var total = (parseInt(tempo[0]) * 60) + parseInt(tempo[1]);

            if(total <= 59){
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_label_tempo_invalido');
                return;
            }
            var manutencao = {
                hora: parseInt(tempo[0]),
                min: parseInt(tempo[1])
            };

            if(!angular.isUndefined($scope.ocorrenciaAtual.id_ocorrencia)){
                manutencao.ocorrencia = $scope.ocorrenciaAtual.id_ocorrencia;
            }
            EdicaoSistemaService.iniciaManutencaoSistema(manutencao, $scope.idSistemaEdicao);
        };

        $scope.prorrogarManutencao = function(){
            var tempo = $("#tempo_manutencao").val().split(':');
            var total = (parseInt(tempo[0]) * 60) + parseInt(tempo[1]);

            if(total <= 59){
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_label_tempo_invalido');
                return;
            }
            var manutencao = {
                hora: parseInt(tempo[0]),
                min: parseInt(tempo[1])
            };

            if(!angular.isUndefined($scope.ocorrenciaAtual.id_ocorrencia)){
                manutencao.ocorrencia = $scope.ocorrenciaAtual.id_ocorrencia;
            }
            EdicaoSistemaService.prorrogarManutencaoSistema(manutencao, $scope.idSistemaEdicao);
        };

        $scope.revogarManutencaoConfirm = function(){
            var manutencao = {};
            var existeOcorrencia = !angular.isUndefined($scope.ocorrenciaAtual.id_ocorrencia);
            var sistema = existeOcorrencia ? $scope.ocorrenciaAtual.id_sistema : $scope.idSistemaEdicao;

            if(!angular.isUndefined($scope.ocorrenciaAtual.id_ocorrencia)){
                manutencao.ocorrencia = $scope.ocorrenciaAtual.id_ocorrencia;
            }

            EdicaoSistemaService.revogarManutencaoSistema(manutencao, sistema).then(function () {
                $scope.modalConfirm.close();
                if(existeOcorrencia)
                    $scope.ocorrenciaAtual.sistema.em_manutencao = false;
            }, function () {
                $scope.modalConfirm.close();
            });
        };

        $scope.habilitarFormProrrogacao = function(){
            $scope.habilitarProrrogar = false;
        };

        $scope.habilitarFormProrrogacaoComOcorrencia = function(){
            $scope.habilitarProrrogar = false;
            $scope.abrirModalManutencaoSistema(true);
        };

        $scope.modalEdicaoClose = function(){
            $scope.modalEdicao.close('slow');
        };

        $scope.abrirModalEdicaoSistemaSemOcorrencia = function(idSistema){
            $(".ng-spotlight").hide();
            
            $scope.exibirEdicao = true;
            $scope.titleModal = '';
            
            //InformacoesDoLocalController callbacks e config
            $scope.screenLoadedId    = 'modal';
            $scope.formCloseCallback = $scope.modalEdicaoClose;
            $scope.postSaveCallback  = $scope.modalEdicaoClose;
            $scope.postLoadCallback  = function(sistema){ $scope.titleModal = sistema.descricao;}

            $scope.modalEdicaoOpen();
            
            setTimeout(function () {
                $scope.$broadcast('informacoesDoLocal.modal.loadData',idSistema);
            },100);
           
        };

        $scope.abrirModalMAnutencaoSemOcorrencia = function(idSistema){
            $(".ng-spotlight").hide();
            $scope.idSistemaEdicao = idSistema;
            $scope.exibirEdicao = false;
            EdicaoSistemaService.buscarSistemaParaEdicao(idSistema, function (result) {
                $scope.titleModal = result.data.descricao;
                $scope.habilitarProrrogar = result.data.em_manutencao;
                $scope.modalEdicaoOpen();
                ManutencaoSistemaService.conectaTopicoManutencao(idSistema);
                setTimeout(function () {
                    ManutencaoSistemaService.countdownEdicao(result.data.fim_manutencao);
                },100);
            }, function (error) {});
        };

        $scope.abrirModalManutencaoSistema = function(isProrrogacao){
            $scope.isProrrogacao = isProrrogacao;
            $scope.exibirEdicao = false;
            $scope.idSistemaEdicao = $scope.ocorrenciaAtual.id_sistema;
            $scope.titleModal = $scope.ocorrenciaAtual.sistema.descricao;
            $scope.modalEdicaoOpen();
            $scope.verificaManutencaoSistemaEdicao();
        };

        $scope.verificaManutencaoSistemaEdicao = function(){
            if($scope.ocorrenciaAtual.sistema.em_manutencao){
                setTimeout(function () {
                    ManutencaoSistemaService.countdownEdicao($scope.ocorrenciaAtual.sistema.fim_manutencao);
                },100);
            }
        };

        $scope.modalEdicaoOpen = function(){
            $scope.modalEdicao = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/modals/edicaoSistemaModal.html',
                size: 'sm',
                windowClass: 'zindex',
                backdrop  : 'static',
                scope:$scope
            });
        };

        $scope.modalConfirmOpen = function(){
            $scope.modalConfirm = $uibModal.open({
                size: 'md',
                templateUrl: 'app/pages/modals/confirmRevogacaoManutencaoModal.html',
                scope:$scope
            });
            $scope.modalEdicaoClose();
        };

        $scope.esvaziaModalEdicao = function(){
            $scope.modalEdicao.iziModal('close');
            $("#observacao_sistema").val("");
            $("#complemento_sistema").val("");
        };

        $scope.modalObservacaoOpen = function(){
            if($scope.permissao_aguardar_observacao) {
                $scope.modalObservacao = $uibModal.open({
                    size: 'md',
                    templateUrl: 'app/pages/modals/aguradarObservacaoModal.html',
                    scope: $scope
                });
            }
        };

        $scope.aguardarEmObservacao = function(){
            var tempo = $scope.calculaTempoObservacao();
            if(tempo <= 0){
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_toast_tempo_observacao_invalido');
                return;
            }
            OcorrenciasService.alteraStatusObservacao(tempo);
        };

        $scope.calculaTempoObservacao = function(){
            var tempo = $("#tempo_observcao").val();
            tempo = tempo.split(':');
            return (parseInt(tempo[0]) * 60) + parseInt(tempo[1]);
        };

        $scope.hablitaBotaoAguardarObservacao = function(){
            var value = $("#tempo_observcao").val().split(':');
            var total = (parseInt(value[0]) * 60) + parseInt(value[1]);
            if(total > 0){
                $('#btnEnviarTempoObs').attr('disabled', false);
            }else{
                $('#btnEnviarTempoObs').attr('disabled', true);
            }
        };

        $(document).on('change', '#rbCarregamentoOcorrencia', function(e) {
            if($('#modal-legenda_tecla_atalho').is(':visible')){
                ConfigService.alteraConfiguracao('auto_carregamento_ocorrencia', $(this).prop('checked'), MonitoramentoService.getIdUsuarioLogado());
                e.preventDefault()
            }
        });

        $(document).on('change', '#rbBotaoFinalizarAtivo', function(e) {
            if($('#modal-legenda_tecla_atalho').is(':visible')){
                ConfigService.alteraConfiguracao('auto_carregamento_botao_finalizar', $(this).prop('checked'), MonitoramentoService.getIdUsuarioLogado());
                e.preventDefault()
            }
        });

        setTimeout(function(){
            $scope.initToogle();
            ConfigService.selecionaConfiguracaoTeclaAtalho();
        },1000);

        $scope.initToogle = function(){
            $('#rbTeclaAtalhoAtivo').bootstrapToggle();
            $('#rbCarregamentoOcorrencia').bootstrapToggle();
            $('#rbBotaoFinalizarAtivo').bootstrapToggle();
        };

        $(document).on('click', '.divEvento', function (e) {
            var id_ocorrencia = $(".divEvento :input")[0].defaultValue;
            var ocorrencias = OcorrenciasService.getOcorrencias();
            var ocorrencia = ocorrencias.indice.find(function (ocorrencia) {
                return ocorrencia.id_ocorrencia == id_ocorrencia;
            });
            var tab = ocorrencia.status == 3 ? 2 : ocorrencia.status - 1;
            OcorrenciasService.setTabStatusSuperior(tab);
            CarregamentoOcorrenciaService.carregaOcorrenciaComBotoesValidados(id_ocorrencia);
        });


    }).config(function (recorderServiceProvider) {
        recorderServiceProvider.forceSwf(false).withMp3Conversion(true);
    })
})();
'use strict';

var createReadOnlyVersion = function (object) {
  var obj = {};
  for (var property in object) {
    if (object.hasOwnProperty(property)) {
      Object.defineProperty(obj, property, {
        get: (function (a) {
          var p = a;
          return function () {
            return object[p];
          }
        })(property),
        enumerable: true,
        configurable: true
      });
    }
  }
  return obj;
};


var blobToDataURL = function (blob, callback) {
  var a = new FileReader();
  a.onload = function (e) {
    callback(e.target.result);
  };
  a.readAsDataURL(blob);
};

var RecorderController = function (element, service, recorderUtils, $scope, $timeout, $interval, PLAYBACK, ChatService, MqttService, ToastMessageService, $filter) {
  var scopeApply = function (fn) {
    var phase = $scope.$root.$$phase;
    if (phase !== '$apply' && phase !== '$digest') {
      return $scope.$apply(fn);
    }
  };

  var control = this,
    cordovaMedia = {
      recorder: null,
      url: null,
      player: null
    }, timing = null,
    audioObjId = 'recorded-audio-' + control.id,
    status = {
      isRecording: false,
      playback: PLAYBACK.STOPPED,
      isDenied: null,
      isSwfLoaded: null,
      isConverting: false,
      get isPlaying() {
        return status.playback === PLAYBACK.PLAYING;
      },
      get isStopped() {
        return status.playback === PLAYBACK.STOPPED;
      },
      get isPaused() {
        return status.playback === PLAYBACK.PAUSED;
      }
    },
    shouldConvertToMp3 = angular.isDefined(control.convertMp3) ? !!control.convertMp3 : service.shouldConvertToMp3(),
    mp3Converter = shouldConvertToMp3 ? new MP3Converter(service.getMp3Config()) : null;
  ;


  control.timeLimit = control.timeLimit || 0;
  control.status = createReadOnlyVersion(status);
  control.isAvailable = service.isAvailable();
  control.elapsedTime = 0;

  if (!control.id) {
    control.id = recorderUtils.generateUuid();
    element.attr("id", control.id);
  }


  if (!service.isHtml5 && !service.isCordova) {
    status.isSwfLoaded = service.swfIsLoaded();
    $scope.$watch(function () {
      return service.swfIsLoaded();
    }, function (n) {
      status.isSwfLoaded = n;
    });
  }

  service.setController(control.id, this);

  var playbackOnEnded = function () {
    status.playback = PLAYBACK.STOPPED;
    control.onPlaybackComplete();
    scopeApply();
  };

  var playbackOnPause = function () {
    status.playback = PLAYBACK.PAUSED;
    control.onPlaybackPause();
  };

  var playbackOnStart = function () {
    status.playback = PLAYBACK.PLAYING;
    control.onPlaybackStart();
  };

  var playbackOnResume = function () {
    status.playback = PLAYBACK.PLAYING;
    control.onPlaybackResume();
  };

  var embedPlayer = function (blob) {
    if (document.getElementById(audioObjId) == null) {
      element.append('<audio class="baseAudio" type="audio/mp3" id="' + audioObjId + '"></audio>');

      var audioPlayer = document.getElementById(audioObjId);
      if (control.showPlayer) {
        audioPlayer.setAttribute('controls', '');
      }

      audioPlayer.addEventListener("ended", playbackOnEnded);
      audioPlayer.addEventListener("pause", function (e) {
        if (this.duration !== this.currentTime) {
          playbackOnPause();
          scopeApply();
        }
      });

      audioPlayer.addEventListener("playing", function (e) {
        if (status.isPaused) {
          playbackOnResume();
        } else {
          playbackOnStart();
        }
        scopeApply();
      });

    }

    if (blob) {
      blobToDataURL(blob, function (url) {
          var nome_arquivo = moment().format("YYYY-MM-DD_HH:mm:s");
          ChatService.setMessageType(8);
          ChatService.setAudioFile(url);
          ChatService.enviarArquivoChat(url, nome_arquivo).then(function(){
            ChatService.enviarMensagemPush($filter('translate')("ocorrencia_chat_audio_enviado"));
            MqttService.publicarMensagemMqtt("", url, nome_arquivo);
            setTimeout(function(){
              ChatService.setMessageType(3);
            },500);
          });
          document.getElementById(audioObjId).src = url;
      });
    } else {
        document.getElementById(audioObjId).removeAttribute('src');
    }
  };

  var doMp3Conversion = function (blobInput, successCallback) {
    if (mp3Converter) {
      status.isConverting = true;
      mp3Converter.convert(blobInput, function (mp3Blob) {
        status.isConverting = false;
        if (successCallback) {
          successCallback(mp3Blob);
        }
        scopeApply(control.onConversionComplete);
      }, function () {
        status.isConverting = false;
      });
      control.onConversionStart();
    }
  };

  control.getAudioPlayer = function () {
    return service.isCordova ? cordovaMedia.player : document.getElementById(audioObjId);
  };


  control.startRecord = function () {

    if (!service.isAvailable()) {
      return;
    }

    if (status.isPlaying) {
      control.playbackPause();
      status.playback = PLAYBACK.STOPPED;
    }
    control.audioModel = null;

    var id = control.id, recordHandler = service.getHandler();

    var start = function () {

      if (service.isCordova) {
        cordovaMedia.url = recorderUtils.cordovaAudioUrl(control.id);
        cordovaMedia.recorder = new Media(cordovaMedia.url, function () {
        }, function (err) {
        });
        cordovaMedia.recorder.startRecord();
      }
      else if (service.isHtml5) {
        if (!recordHandler) {
          return;
        }
        recordHandler.clear();
        recordHandler.record();
      }
      else {
        if (!service.isReady) {
          return;
        }
        recordHandler.record(id, 'audio.wav');
      }

      status.isRecording = true;
      control.onRecordStart();
      control.elapsedTime = 0;
      timing = $interval(function () {
        ++control.elapsedTime;
        if (control.timeLimit && control.timeLimit > 0 && control.elapsedTime >= control.timeLimit) {
          control.stopRecord();
        }
      }, 1000);
    };

    if (service.isCordova || recordHandler) {
      start();
    } else if (!status.isDenied) {
      service.showPermission({
        onDenied: function () {
          ToastMessageService.showErrorMenssageWeb('ocorrencia_toast_permissao_microfone');
          status.isDenied = true;
          $scope.$apply();
        },
        onAllowed: function () {
          status.isDenied = false;
          recordHandler = service.getHandler();
          start();
          scopeApply();
        }
      });
    }else{
      ToastMessageService.showErrorMenssageWeb('ocorrencia_toast_permissao_microfone');
    }
  };

  control.stopRecord = function () {
    var id = control.id;
    if (!service.isAvailable() || !status.isRecording) {
      return false;
    }

    var recordHandler = service.getHandler();
    var completed = function (blob) {
      $interval.cancel(timing);
      status.isRecording = false;
      var finalize = function (inputBlob) {
        control.audioModel = inputBlob;
        embedPlayer(inputBlob);
      };

      if (shouldConvertToMp3) {
        doMp3Conversion(blob, finalize);
      } else {
        finalize(blob)
      }

      embedPlayer(null);
      control.onRecordComplete();
    };

    if (service.isCordova) {
      cordovaMedia.recorder.stopRecord();
      window.resolveLocalFileSystemURL(cordovaMedia.url, function (entry) {
        entry.file(function (blob) {
          completed(blob);
        });
      }, function (err) {
      });
    } else if (service.isHtml5) {
      recordHandler.stop();
      recordHandler.getBuffer(function () {
        recordHandler.exportWAV(function (blob) {
          completed(blob);
          scopeApply();
        });
      });
    } else {
      recordHandler.stopRecording(id);
      completed(recordHandler.getBlob(id));
    }
  };

  control.playbackRecording = function () {
    if (status.isPlaying || !service.isAvailable() || status.isRecording || !control.audioModel) {
      return false;
    }

    if (service.isCordova) {
      cordovaMedia.player = new Media(cordovaMedia.url, playbackOnEnded, function () {
      });
      cordovaMedia.player.play();
      playbackOnStart();
    } else {
      control.getAudioPlayer().play();
    }

  };

  control.playbackPause = function () {
    if (!status.isPlaying || !service.isAvailable() || status.isRecording || !control.audioModel) {
      return false;
    }

    control.getAudioPlayer().pause();
    if (service.isCordova) {
      playbackOnPause();
    }
  };

  control.playbackResume = function () {
    if (status.isPlaying || !service.isAvailable() || status.isRecording || !control.audioModel) {
      return false;
    }

    if (status.isPaused) {
      control.getAudioPlayer().play();
      if (service.isCordova) {
        playbackOnResume();
      }
    } else {
      control.playbackRecording();
    }

  };


  control.save = function (fileName) {
    if (!service.isAvailable() || status.isRecording || !control.audioModel) {
      return false;
    }

    if (!fileName) {
      fileName = 'audio_recording_' + control.id + (control.audioModel.type.indexOf('mp3') > -1 ? 'mp3' : 'wav');
    }

    var blobUrl = window.URL.createObjectURL(control.audioModel);
    var a = document.createElement('a');
    a.href = blobUrl;
    a.target = '_blank';
    a.download = fileName;
    var click = document.createEvent("Event");
    click.initEvent("click", true, true);
    a.dispatchEvent(click);
  };

  control.isHtml5 = function () {
    return service.isHtml5;
  };

  if (control.autoStart) {
    $timeout(function () {
      control.startRecord();
    }, 1000);
  }

  element.on('$destroy', function () {
    $interval.cancel(timing);
  });

};

RecorderController.$inject = ['$element', 'recorderService', 'recorderUtils', '$scope', '$timeout', '$interval', 'recorderPlaybackStatus', 'ChatService', 'MqttService', 'ToastMessageService', '$filter'];

angular.module('Fullarm')
  .controller('recorderController', RecorderController)
;

/**
 * @author Fullarm
 * created on 27.08.2018
 */
(function () {

    'use strict';
    angular.module('Fullarm').controller('OcorrenciasController', function ($q, $scope, $timeout, $rootScope, CarregamentoOcorrenciaService, VideoFrameService, VideosService, InformacoesOcorrenciaService, OcorrenciasService, MonitoramentoService, OcorrenciaAtualService, LogService, MqttService) {
        $rootScope.esvaziaTela = true;
        $scope.permissao_fpatrol = permissoes.fpatrol;

        $scope.carregarInformacoesOcorrencia = function (idOcorrencia, botoes, index) {
            OcorrenciaAtualService.esvaziaOcorrenciaAtual();
            CarregamentoOcorrenciaService.carregaOcorrencia(idOcorrencia, botoes);
        };

        $scope.descarregaTela = function (status) {
            CarregamentoOcorrenciaService.setStatusSelecionado(status);
            if($rootScope.esvaziaTela){
                OcorrenciaAtualService.esvaziaOcorrenciaAtual();
            }else{
                $rootScope.esvaziaTela = true;
            }
        }
    });
})();

/**
 * @author Fullarm
 * created on 27.08.2018
 */
(function () {

    'use strict';
    angular.module('Fullarm').controller('ModalControler', function ($scope) {

    });
})();
/*!
 * Bootstrap v3.2.0 (http://getbootstrap.com)
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){return a(b.target).is(this)?b.handleObj.handler.apply(this,arguments):void 0}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.2.0",d.prototype.close=function(b){function c(){f.detach().trigger("closed.bs.alert").remove()}var d=a(this),e=d.attr("data-target");e||(e=d.attr("href"),e=e&&e.replace(/.*(?=#[^\s]*$)/,""));var f=a(e);b&&b.preventDefault(),f.length||(f=d.hasClass("alert")?d:d.parent()),f.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",c).emulateTransitionEnd(150):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.2.0",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),d[e](null==f[b]?this.options[b]:f[b]),setTimeout(a.proxy(function(){"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")&&(c.prop("checked")&&this.$element.hasClass("active")?a=!1:b.find(".active").removeClass("active")),a&&c.prop("checked",!this.$element.hasClass("active")).trigger("change")}a&&this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target);d.hasClass("btn")||(d=d.closest(".btn")),b.call(d,"toggle"),c.preventDefault()})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b).on("keydown.bs.carousel",a.proxy(this.keydown,this)),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=this.sliding=this.interval=this.$active=this.$items=null,"hover"==this.options.pause&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.2.0",c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0},c.prototype.keydown=function(a){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.to=function(b){var c=this,d=this.getItemIndex(this.$active=this.$element.find(".item.active"));return b>this.$items.length-1||0>b?void 0:this.sliding?this.$element.one("slid.bs.carousel",function(){c.to(b)}):d==b?this.pause().cycle():this.slide(b>d?"next":"prev",a(this.$items[b]))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){return this.sliding?void 0:this.slide("next")},c.prototype.prev=function(){return this.sliding?void 0:this.slide("prev")},c.prototype.slide=function(b,c){var d=this.$element.find(".item.active"),e=c||d[b](),f=this.interval,g="next"==b?"left":"right",h="next"==b?"first":"last",i=this;if(!e.length){if(!this.options.wrap)return;e=this.$element.find(".item")[h]()}if(e.hasClass("active"))return this.sliding=!1;var j=e[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:g});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,f&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(e)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:g});return a.support.transition&&this.$element.hasClass("slide")?(e.addClass(b),e[0].offsetWidth,d.addClass(g),e.addClass(g),d.one("bsTransitionEnd",function(){e.removeClass([b,g].join(" ")).addClass("active"),d.removeClass(["active",g].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(1e3*d.css("transition-duration").slice(0,-1))):(d.removeClass("active"),e.addClass("active"),this.sliding=!1,this.$element.trigger(m)),f&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this},a(document).on("click.bs.carousel.data-api","[data-slide], [data-slide-to]",function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}}),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.collapse"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b);!e&&f.toggle&&"show"==b&&(b=!b),e||d.data("bs.collapse",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.transitioning=null,this.options.parent&&(this.$parent=a(this.options.parent)),this.options.toggle&&this.toggle()};c.VERSION="3.2.0",c.DEFAULTS={toggle:!0},c.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},c.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var c=a.Event("show.bs.collapse");if(this.$element.trigger(c),!c.isDefaultPrevented()){var d=this.$parent&&this.$parent.find("> .panel > .in");if(d&&d.length){var e=d.data("bs.collapse");if(e&&e.transitioning)return;b.call(d,"hide"),e||d.data("bs.collapse",null)}var f=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[f](0),this.transitioning=1;var g=function(){this.$element.removeClass("collapsing").addClass("collapse in")[f](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return g.call(this);var h=a.camelCase(["scroll",f].join("-"));this.$element.one("bsTransitionEnd",a.proxy(g,this)).emulateTransitionEnd(350)[f](this.$element[0][h])}}},c.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse").removeClass("in"),this.transitioning=1;var d=function(){this.transitioning=0,this.$element.trigger("hidden.bs.collapse").removeClass("collapsing").addClass("collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(d,this)).emulateTransitionEnd(350):d.call(this)}}},c.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()};var d=a.fn.collapse;a.fn.collapse=b,a.fn.collapse.Constructor=c,a.fn.collapse.noConflict=function(){return a.fn.collapse=d,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(c){var d,e=a(this),f=e.attr("data-target")||c.preventDefault()||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""),g=a(f),h=g.data("bs.collapse"),i=h?"toggle":e.data(),j=e.attr("data-parent"),k=j&&a(j);h&&h.transitioning||(k&&k.find('[data-toggle="collapse"][data-parent="'+j+'"]').not(e).addClass("collapsed"),e[g.hasClass("in")?"addClass":"removeClass"]("collapsed")),b.call(g,i)})}(jQuery),+function(a){"use strict";function b(b){b&&3===b.which||(a(e).remove(),a(f).each(function(){var d=c(a(this)),e={relatedTarget:this};d.hasClass("open")&&(d.trigger(b=a.Event("hide.bs.dropdown",e)),b.isDefaultPrevented()||d.removeClass("open").trigger("hidden.bs.dropdown",e))}))}function c(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.2.0",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=c(e),g=f.hasClass("open");if(b(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a('<div class="dropdown-backdrop"/>').insertAfter(a(this)).on("click",b);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus"),f.toggleClass("open").trigger("shown.bs.dropdown",h)}return!1}},g.prototype.keydown=function(b){if(/(38|40|27)/.test(b.keyCode)){var d=a(this);if(b.preventDefault(),b.stopPropagation(),!d.is(".disabled, :disabled")){var e=c(d),g=e.hasClass("open");if(!g||g&&27==b.keyCode)return 27==b.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.divider):visible a",i=e.find('[role="menu"]'+h+', [role="listbox"]'+h);if(i.length){var j=i.index(i.filter(":focus"));38==b.keyCode&&j>0&&j--,40==b.keyCode&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",b).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f+', [role="menu"], [role="listbox"]',g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$backdrop=this.isShown=null,this.scrollbarWidth=0,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.2.0",c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var c=this,d=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(d),this.isShown||d.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.$body.addClass("modal-open"),this.setScrollbar(),this.escape(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.backdrop(function(){var d=a.support.transition&&c.$element.hasClass("fade");c.$element.parent().length||c.$element.appendTo(c.$body),c.$element.show().scrollTop(0),d&&c.$element[0].offsetWidth,c.$element.addClass("in").attr("aria-hidden",!1),c.enforceFocus();var e=a.Event("shown.bs.modal",{relatedTarget:b});d?c.$element.find(".modal-dialog").one("bsTransitionEnd",function(){c.$element.trigger("focus").trigger(e)}).emulateTransitionEnd(300):c.$element.trigger("focus").trigger(e)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.$body.removeClass("modal-open"),this.resetScrollbar(),this.escape(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").attr("aria-hidden",!0).off("click.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(300):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keyup.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keyup.dismiss.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var c=this,d=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var e=a.support.transition&&d;if(this.$backdrop=a('<div class="modal-backdrop '+d+'" />').appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus.call(this.$element[0]):this.hide.call(this))},this)),e&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;e?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(150):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var f=function(){c.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",f).emulateTransitionEnd(150):f()}else b&&b()},c.prototype.checkScrollbar=function(){document.body.clientWidth>=window.innerWidth||(this.scrollbarWidth=this.scrollbarWidth||this.measureScrollbar())},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.scrollbarWidth&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right","")},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;(e||"destroy"!=b)&&(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=this.options=this.enabled=this.timeout=this.hoverState=this.$element=null,this.init("tooltip",a,b)};c.VERSION="3.2.0",c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(this.options.viewport.selector||this.options.viewport);for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show()},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var c=a.contains(document.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!c)return;var d=this,e=this.tip(),f=this.getUID(this.type);this.setContent(),e.attr("id",f),this.$element.attr("aria-describedby",f),this.options.animation&&e.addClass("fade");var g="function"==typeof this.options.placement?this.options.placement.call(this,e[0],this.$element[0]):this.options.placement,h=/\s?auto?\s?/i,i=h.test(g);i&&(g=g.replace(h,"")||"top"),e.detach().css({top:0,left:0,display:"block"}).addClass(g).data("bs."+this.type,this),this.options.container?e.appendTo(this.options.container):e.insertAfter(this.$element);var j=this.getPosition(),k=e[0].offsetWidth,l=e[0].offsetHeight;if(i){var m=g,n=this.$element.parent(),o=this.getPosition(n);g="bottom"==g&&j.top+j.height+l-o.scroll>o.height?"top":"top"==g&&j.top-o.scroll-l<0?"bottom":"right"==g&&j.right+k>o.width?"left":"left"==g&&j.left-k<o.left?"right":g,e.removeClass(m).addClass(g)}var p=this.getCalculatedOffset(g,j,k,l);this.applyPlacement(p,g);var q=function(){d.$element.trigger("shown.bs."+d.type),d.hoverState=null};a.support.transition&&this.$tip.hasClass("fade")?e.one("bsTransitionEnd",q).emulateTransitionEnd(150):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top=b.top+g,b.left=b.left+h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=k.left?2*k.left-e+i:2*k.top-f+j,m=k.left?"left":"top",n=k.left?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(l,d[0][n],m)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c,a?50*(1-a/b)+"%":"")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(){function b(){"in"!=c.hoverState&&d.detach(),c.$element.trigger("hidden.bs."+c.type)}var c=this,d=this.tip(),e=a.Event("hide.bs."+this.type);return this.$element.removeAttr("aria-describedby"),this.$element.trigger(e),e.isDefaultPrevented()?void 0:(d.removeClass("in"),a.support.transition&&this.$tip.hasClass("fade")?d.one("bsTransitionEnd",b).emulateTransitionEnd(150):b(),this.hoverState=null,this)},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName;return a.extend({},"function"==typeof c.getBoundingClientRect?c.getBoundingClientRect():null,{scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop(),width:d?a(window).width():b.outerWidth(),height:d?a(window).height():b.outerHeight()},d?{top:0,left:0}:b.offset())},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.width&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){return this.$tip=this.$tip||a(this.options.template)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.validate=function(){this.$element[0].parentNode||(this.hide(),this.$element=null,this.options=null)},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){clearTimeout(this.timeout),this.hide().$element.off("."+this.type).removeData("bs."+this.type)};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;(e||"destroy"!=b)&&(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.2.0",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").empty()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")},c.prototype.tip=function(){return this.$tip||(this.$tip=a(this.options.template)),this.$tip};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){var e=a.proxy(this.process,this);this.$body=a("body"),this.$scrollElement=a(a(c).is("body")?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",e),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.2.0",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b="offset",c=0;a.isWindow(this.$scrollElement[0])||(b="position",c=this.$scrollElement.scrollTop()),this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight();var d=this;this.$body.find(this.selector).map(function(){var d=a(this),e=d.data("target")||d.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[b]().top+c,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){d.offsets.push(this[0]),d.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<=e[0])return g!=(a=f[0])&&this.activate(a);for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(!e[a+1]||b<=e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){this.activeTarget=b,a(this.selector).parentsUntil(this.options.target,".active").removeClass("active");var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.2.0",c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a")[0],f=a.Event("show.bs.tab",{relatedTarget:e});if(b.trigger(f),!f.isDefaultPrevented()){var g=a(d);this.activate(b.closest("li"),c),this.activate(g,g.parent(),function(){b.trigger({type:"shown.bs.tab",relatedTarget:e})})}}},c.prototype.activate=function(b,c,d){function e(){f.removeClass("active").find("> .dropdown-menu > .active").removeClass("active"),b.addClass("active"),g?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu")&&b.closest("li.dropdown").addClass("active"),d&&d()}var f=c.find("> .active"),g=d&&a.support.transition&&f.hasClass("fade");g?f.one("bsTransitionEnd",e).emulateTransitionEnd(150):e(),f.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this},a(document).on("click.bs.tab.data-api",'[data-toggle="tab"], [data-toggle="pill"]',function(c){c.preventDefault(),b.call(a(this),"show")})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=this.unpin=this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.2.0",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=a(document).height(),d=this.$target.scrollTop(),e=this.$element.offset(),f=this.options.offset,g=f.top,h=f.bottom;"object"!=typeof f&&(h=g=f),"function"==typeof g&&(g=f.top(this.$element)),"function"==typeof h&&(h=f.bottom(this.$element));var i=null!=this.unpin&&d+this.unpin<=e.top?!1:null!=h&&e.top+this.$element.height()>=b-h?"bottom":null!=g&&g>=d?"top":!1;if(this.affixed!==i){null!=this.unpin&&this.$element.css("top","");var j="affix"+(i?"-"+i:""),k=a.Event(j+".bs.affix");this.$element.trigger(k),k.isDefaultPrevented()||(this.affixed=i,this.unpin="bottom"==i?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(j).trigger(a.Event(j.replace("affix","affixed"))),"bottom"==i&&this.$element.offset({top:b-this.$element.height()-h}))}}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},d.offsetBottom&&(d.offset.bottom=d.offsetBottom),d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('Fullarm.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
         return true;
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
var element = $('.floating-chat');
var myStorage = localStorage;

if (!myStorage.getItem('chatID')) {
    myStorage.setItem('chatID', createUUID());
}

setTimeout(function() {
    element.addClass('enter');
}, 1000);

element.click(openElement);

function openElement() {
    element.find('>i').hide();
    element.addClass('expand');
    element.find('.chat').addClass('enter');
    setTimeout(function() {
        $('.divUsers').show();
    }, 500);
    element.off('click', openElement);
    element.find('#btnClose').click(closeElement);
}

function closeElement() {
    $('.divUsers').hide();
    element.find('.chat').removeClass('enter').hide();
    element.find('>i').show();
    element.removeClass('expand');
    element.find('#btnClose').off('click', closeElement);
    setTimeout(function() {
        element.find('.chat').removeClass('enter').show();
        element.click(openElement);
    }, 500);
}

function createUUID() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}
// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

    var trimLeft = /^\s+/,
        trimRight = /\s+$/,
        tinyCounter = 0,
        mathRound = Math.round,
        mathMin = Math.min,
        mathMax = Math.max,
        mathRandom = Math.random;

    function tinycolor (color, opts) {

        color = (color) ? color : '';
        opts = opts || { };

        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) {
            return color;
        }
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) {
            return new tinycolor(color, opts);
        }

        var rgb = inputToRGB(color);
        this._originalInput = color,
            this._r = rgb.r,
            this._g = rgb.g,
            this._b = rgb.b,
            this._a = rgb.a,
            this._roundA = mathRound(100*this._a) / 100,
            this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;

        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) { this._r = mathRound(this._r); }
        if (this._g < 1) { this._g = mathRound(this._g); }
        if (this._b < 1) { this._b = mathRound(this._b); }

        this._ok = rgb.ok;
        this._tc_id = tinyCounter++;
    }

    tinycolor.prototype = {
        isDark: function() {
            return this.getBrightness() < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        isValid: function() {
            return this._ok;
        },
        getOriginalInput: function() {
            return this._originalInput;
        },
        getFormat: function() {
            return this._format;
        },
        getAlpha: function() {
            return this._a;
        },
        getBrightness: function() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r/255;
            GsRGB = rgb.g/255;
            BsRGB = rgb.b/255;

            if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
            if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
            if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
            return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
        },
        setAlpha: function(value) {
            this._a = boundAlpha(value);
            this._roundA = mathRound(100*this._a) / 100;
            return this;
        },
        toHsv: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
        },
        toHsvString: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
            return (this._a == 1) ?
                "hsv("  + h + ", " + s + "%, " + v + "%)" :
                "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
        },
        toHsl: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
        },
        toHslString: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
            return (this._a == 1) ?
                "hsl("  + h + ", " + s + "%, " + l + "%)" :
                "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
        },
        toHex: function(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function(allow3Char) {
            return '#' + this.toHex(allow3Char);
        },
        toHex8: function(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function(allow4Char) {
            return '#' + this.toHex8(allow4Char);
        },
        toRgb: function() {
            return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
        },
        toRgbString: function() {
            return (this._a == 1) ?
                "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
                "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
            return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
        },
        toPercentageRgbString: function() {
            return (this._a == 1) ?
                "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
                "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
            if (this._a === 0) {
                return "transparent";
            }

            if (this._a < 1) {
                return false;
            }

            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function(secondColor) {
            var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";

            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }

            return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
        },
        toString: function(format) {
            var formatSet = !!format;
            format = format || this._format;

            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) {
                    return this.toName();
                }
                return this.toRgbString();
            }
            if (format === "rgb") {
                formattedString = this.toRgbString();
            }
            if (format === "prgb") {
                formattedString = this.toPercentageRgbString();
            }
            if (format === "hex" || format === "hex6") {
                formattedString = this.toHexString();
            }
            if (format === "hex3") {
                formattedString = this.toHexString(true);
            }
            if (format === "hex4") {
                formattedString = this.toHex8String(true);
            }
            if (format === "hex8") {
                formattedString = this.toHex8String();
            }
            if (format === "name") {
                formattedString = this.toName();
            }
            if (format === "hsl") {
                formattedString = this.toHslString();
            }
            if (format === "hsv") {
                formattedString = this.toHsvString();
            }

            return formattedString || this.toHexString();
        },
        clone: function() {
            return tinycolor(this.toString());
        },

        _applyModification: function(fn, args) {
            var color = fn.apply(null, [this].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function() {
            return this._applyModification(lighten, arguments);
        },
        brighten: function() {
            return this._applyModification(brighten, arguments);
        },
        darken: function() {
            return this._applyModification(darken, arguments);
        },
        desaturate: function() {
            return this._applyModification(desaturate, arguments);
        },
        saturate: function() {
            return this._applyModification(saturate, arguments);
        },
        greyscale: function() {
            return this._applyModification(greyscale, arguments);
        },
        spin: function() {
            return this._applyModification(spin, arguments);
        },

        _applyCombination: function(fn, args) {
            return fn.apply(null, [this].concat([].slice.call(args)));
        },
        analogous: function() {
            return this._applyCombination(analogous, arguments);
        },
        complement: function() {
            return this._applyCombination(complement, arguments);
        },
        monochromatic: function() {
            return this._applyCombination(monochromatic, arguments);
        },
        splitcomplement: function() {
            return this._applyCombination(splitcomplement, arguments);
        },
        triad: function() {
            return this._applyCombination(triad, arguments);
        },
        tetrad: function() {
            return this._applyCombination(tetrad, arguments);
        }
    };

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (typeof color == "object") {
            var newColor = {};
            for (var i in color) {
                if (color.hasOwnProperty(i)) {
                    if (i === "a") {
                        newColor[i] = color[i];
                    }
                    else {
                        newColor[i] = convertToPercentage(color[i]);
                    }
                }
            }
            color = newColor;
        }

        return tinycolor(color, opts);
    };

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
    function inputToRGB(color) {

        var rgb = { r: 0, g: 0, b: 0 };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;

        if (typeof color == "string") {
            color = stringInputToObject(color);
        }

        if (typeof color == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            }
            else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            }
            else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }

            if (color.hasOwnProperty("a")) {
                a = color.a;
            }
        }

        a = boundAlpha(a);

        return {
            ok: ok,
            format: color.format || format,
            r: mathMin(255, mathMax(rgb.r, 0)),
            g: mathMin(255, mathMax(rgb.g, 0)),
            b: mathMin(255, mathMax(rgb.b, 0)),
            a: a
        };
    }


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b){
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, l = (max + min) / 2;

        if(max == min) {
            h = s = 0; // achromatic
        }
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }

            h /= 6;
        }

        return { h: h, s: s, l: l };
    }

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;

        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);

        function hue2rgb(p, q, t) {
            if(t < 0) t += 1;
            if(t > 1) t -= 1;
            if(t < 1/6) return p + (q - p) * 6 * t;
            if(t < 1/2) return q;
            if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        }

        if(s === 0) {
            r = g = b = l; // achromatic
        }
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, v = max;

        var d = max - min;
        s = max === 0 ? 0 : d / max;

        if(max == min) {
            h = 0; // achromatic
        }
        else {
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
        return { h: h, s: s, v: v };
    }

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {

        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);

        var i = Math.floor(h),
            f = h - i,
            p = v * (1 - s),
            q = v * (1 - f * s),
            t = v * (1 - (1 - f) * s),
            mod = i % 6,
            r = [v, q, p, p, t, v][mod],
            g = [t, v, v, q, p, p][mod],
            b = [p, p, t, v, v, q][mod];

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {

        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];

        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        }

        return hex.join("");
    }

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {

        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];

        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        }

        return hex.join("");
    }

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {

        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];

        return hex.join("");
    }

// `equals`
// Can be called with any tinycolor input
    tinycolor.equals = function (color1, color2) {
        if (!color1 || !color2) { return false; }
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };

    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: mathRandom(),
            g: mathRandom(),
            b: mathRandom()
        });
    };


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

    function desaturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function saturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function greyscale(color) {
        return tinycolor(color).desaturate(100);
    }

    function lighten (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    function brighten(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var rgb = tinycolor(color).toRgb();
        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
        return tinycolor(rgb);
    }

    function darken (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
    function spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

    function complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }

    function triad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function tetrad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
            tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
        ];
    }

    function analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;

        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [tinycolor(color)];

        for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }

    function monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;

        while (results--) {
            ret.push(tinycolor({ h: h, s: s, v: v}));
            v = (v + modification) % 1;
        }

        return ret;
    }

// Utility Functions
// ---------------------

    tinycolor.mix = function(color1, color2, amount) {
        amount = (amount === 0) ? 0 : (amount || 50);

        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();

        var p = amount / 100;

        var rgba = {
            r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
            g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
            b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
            a: ((rgb2.a - rgb1.a) * p) + rgb1.a
        };

        return tinycolor(rgba);
    };


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
    };

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;

        out = false;

        wcag2Parms = validateWCAG2Parms(wcag2);
        switch (wcag2Parms.level + wcag2Parms.size) {
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;

    };

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size ;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors ;
        level = args.level;
        size = args.size;

        for (var i= 0; i < colorList.length ; i++) {
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }

        if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
            return bestColor;
        }
        else {
            args.includeFallbackColors=false;
            return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
        }
    };


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };

// Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = { };
        for (var i in o) {
            if (o.hasOwnProperty(i)) {
                flipped[o[i]] = i;
            }
        }
        return flipped;
    }

// Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);

        if (isNaN(a) || a < 0 || a > 1) {
            a = 1;
        }

        return a;
    }

// Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) { n = "100%"; }

        var processPercent = isPercentage(n);
        n = mathMin(max, mathMax(0, parseFloat(n)));

        // Automatically convert percentage into number
        if (processPercent) {
            n = parseInt(n * max, 10) / 100;
        }

        // Handle floating point rounding errors
        if ((Math.abs(n - max) < 0.000001)) {
            return 1;
        }

        // Convert into [0, 1] range if it isn't already
        return (n % max) / parseFloat(max);
    }

// Force a number between 0 and 1
    function clamp01(val) {
        return mathMin(1, mathMax(0, val));
    }

// Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    }

// Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf('%') != -1;
    }

// Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? '0' + c : '' + c;
    }

// Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) {
            n = (n * 100) + "%";
        }

        return n;
    }

// Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
// Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return (parseIntFromHex(h) / 255);
    }

    var matchers = (function() {

        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";

        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    })();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {

        color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        }
        else if (color == 'transparent') {
            return { r: 0, g: 0, b: 0, a: 0, format: "name" };
        }

        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if ((match = matchers.rgb.exec(color))) {
            return { r: match[1], g: match[2], b: match[3] };
        }
        if ((match = matchers.rgba.exec(color))) {
            return { r: match[1], g: match[2], b: match[3], a: match[4] };
        }
        if ((match = matchers.hsl.exec(color))) {
            return { h: match[1], s: match[2], l: match[3] };
        }
        if ((match = matchers.hsla.exec(color))) {
            return { h: match[1], s: match[2], l: match[3], a: match[4] };
        }
        if ((match = matchers.hsv.exec(color))) {
            return { h: match[1], s: match[2], v: match[3] };
        }
        if ((match = matchers.hsva.exec(color))) {
            return { h: match[1], s: match[2], v: match[3], a: match[4] };
        }
        if ((match = matchers.hex8.exec(color))) {
            return {
                r: parseIntFromHex(match[1]),
                g: parseIntFromHex(match[2]),
                b: parseIntFromHex(match[3]),
                a: convertHexToDecimal(match[4]),
                format: named ? "name" : "hex8"
            };
        }
        if ((match = matchers.hex6.exec(color))) {
            return {
                r: parseIntFromHex(match[1]),
                g: parseIntFromHex(match[2]),
                b: parseIntFromHex(match[3]),
                format: named ? "name" : "hex"
            };
        }
        if ((match = matchers.hex4.exec(color))) {
            return {
                r: parseIntFromHex(match[1] + '' + match[1]),
                g: parseIntFromHex(match[2] + '' + match[2]),
                b: parseIntFromHex(match[3] + '' + match[3]),
                a: convertHexToDecimal(match[4] + '' + match[4]),
                format: named ? "name" : "hex8"
            };
        }
        if ((match = matchers.hex3.exec(color))) {
            return {
                r: parseIntFromHex(match[1] + '' + match[1]),
                g: parseIntFromHex(match[2] + '' + match[2]),
                b: parseIntFromHex(match[3] + '' + match[3]),
                format: named ? "name" : "hex"
            };
        }

        return false;
    }

    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {"level":"AA", "size":"small"};
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") {
            level = "AA";
        }
        if (size !== "small" && size !== "large") {
            size = "small";
        }
        return {"level":level, "size":size};
    }

// Node: Export function
    if (typeof module !== "undefined" && module.exports) {
        module.exports = tinycolor;
    }
// AMD/requirejs: Define the module
    else if (typeof define === 'function' && define.amd) {
        define(function () {return tinycolor;});
    }
// Browser: Expose to window
    else {
        window.tinycolor = tinycolor;
    }

})(Math);
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Fullarm').controller('PageTopCtrl', PageTopCtrl);

    /** @ngInject */
    function PageTopCtrl($scope, $uibModal, RequestFactory, constant, MonitoramentoService, PageTopService,
                         OrdemServicoService, OcorrenciaAtualService, LoginService, ConfigService, TrocaIdiomaFactory) {

        $scope.user = MonitoramentoService.getNomeUsuarioLogado();
        $scope.userLogin = MonitoramentoService.getLoginUsuarioLogado();
        $scope.plataforma = MonitoramentoService.getPlataformaDescricao();
        $scope.url = MonitoramentoService.getUrl();
        $scope.permissao_evento_manual = MonitoramentoService.getPermissaoEventoManual();
        $scope.permissao_relatorios = permissoes.relatorios;
        $scope.permissao_solicitar_os  = MonitoramentoService.getPermissaoSolicitarOs();
        $scope.login = "";
        $scope.password = "";
        $scope.tipo_acao = "";
        $scope.idiomaAtual = userOption.idioma;
        $scope.isCondHouse = is_condhouse;


        $('#modal-troca-usuario').iziModal({
            width: '20%',
            transitionIn: 'fadeInUp',
            transitionOut: 'fadeOutDown'
        });

        $('#modal-legenda_tecla_atalho').iziModal({
            width: '65%',
            transitionIn: 'fadeInUp',
            transitionOut: 'fadeOutDown'
        });

        $('#modal-troca-idioma').iziModal({
            width: '20%',
            transitionIn: 'fadeInUp',
            transitionOut: 'fadeOutDown'
        });

        $(document).on('click', '.solicitarOs', function (e) {
            e.stopPropagation();
            $scope.abreModalOs();
        });

        $(document).on('keypress', '#password', function (e) {
            if(ConfigService.getTeclasAtalhoAtivo()) {
                if (e.keyCode === 13) {
                    event.preventDefault();
                    if ($scope.tipo_acao === "sair") {
                        $scope.deslogarUsuario();
                    } else {
                        $scope.trocarUsario();
                    }
                } else if (e.keyCode === 9) {
                    event.preventDefault();
                    $("#btnTrocarUsuario").attr("tabindex", -1).focus();
                }
            }
        });

        $(document).on('keypress', '#login', function (e) {
            if (e.keyCode === 13) {
                event.preventDefault();
                $("#password").focus();
            }
        });

        $(document).on('click', '#btnTrocarUsuario', function (e) {
            $scope.trocarUsario();
        });

        $(document).on('click', '#btnLogout', function (e) {
            $scope.deslogarUsuario();
        });

        $(document).on('keydown', function (e) {

            if (e.ctrlKey && e.keyCode === 71 && !angular.isUndefined(OcorrenciaAtualService.getSistema()) && OcorrenciaAtualService.getSistema() > 0) {
                e.preventDefault();
                $scope.abreModalOs();
            }else if(e.keyCode === 27){

            }else if(e.altKey && e.keyCode === 13){
                e.preventDefault();
                $scope.abreModalTeclaTalho();
            }else if(e.altKey && e.keyCode === 36){ // ALT + HOME
                e.preventDefault();
                window.open($scope.url, '_blank');
            }else if(e.altKey && e.keyCode === 34){  // ALT + PgDn
                e.preventDefault();
                $scope.abreModalTrocaUsuario("troca");
            }else if(e.altKey && e.keyCode === 35){ // ALT + END
                e.preventDefault();
                $scope.abreModalTrocaUsuario("sair");
            }
        });

        $scope.deslogarUsuario = function () {
            var data = {
                username: $("#login").val(),
                password: $("#password").val()
            };
            LoginService.deslogar(data);
        };

        $scope.trocarUsario = function () {
            var data = {
                username: $("#login").val(),
                password: $("#password").val()
            };
            LoginService.trocaUsuario(data);
        };

        $scope.abreModalOs = function(){
            OrdemServicoService.abreModalOrdemDeServico();
        };

        $scope.abreModalTeclaTalho = function(){
            setTimeout(function () {
                $('#modal-legenda_tecla_atalho').iziModal('open');
            }, 100);
        };

        $scope.abreModalTrocaUsuario = function(tipo){
            $scope.tipo_acao = tipo;
            setTimeout(function () {
                if(tipo === "sair"){
                    $('#login').val($scope.userLogin);
                    $('#password').val('');
                    $('#login').prop('disabled', true);
                    $('#btnTrocarUsuario').hide();
                    $('#btnLogout').show();
                }else{
                    $('#password').val('');
                    $('#login').val('');
                    $('#login').prop('disabled', false);
                    $('#btnTrocarUsuario').show();
                    $('#btnLogout').hide();
                }
                $('#modal-troca-usuario').iziModal('open');
            }, 100);
        };

        $scope.abreModalTrocaIdioma = function () {
            setTimeout(function () {
                $('#modal-troca-idioma').iziModal('open');
            }, 100);
        };

        $(document).on('click', '#portugues', function (e) {
            e.stopPropagation();
            Pace.restart();
            TrocaIdiomaFactory.alterarIdioma('pt-BR', function (success) {
                window.location.reload();
            }, function (error) {

            });
            $('#modal-troca-idioma').iziModal('close');
        });

        $(document).on('click', '#espanhol', function (e) {
            e.stopPropagation();
            Pace.restart();
            TrocaIdiomaFactory.alterarIdioma('es', function (success) {
                window.location.reload();
            }, function (error) {

            });
            $('#modal-troca-idioma').iziModal('close');
        });

        $(document).on('click', '#ingles', function (e) {
            e.stopPropagation();
            Pace.restart();
            TrocaIdiomaFactory.alterarIdioma('en', function (success) {
                window.location.reload();
            }, function (error) {

            });
            $('#modal-troca-idioma').iziModal('close');
        });

    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      replace:true,
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/*! pace 1.0.0 */
(function(){var a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X=[].slice,Y={}.hasOwnProperty,Z=function(a,b){function c(){this.constructor=a}for(var d in b)Y.call(b,d)&&(a[d]=b[d]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a},$=[].indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(b in this&&this[b]===a)return b;return-1};for(u={catchupTime:100,initialRate:.03,minTime:250,ghostTime:100,maxProgressPerFrame:20,easeFactor:1.25,startOnPageLoad:!0,restartOnPushState:!0,restartOnRequestAfter:500,target:"body",elements:{checkInterval:100,selectors:["body"]},eventLag:{minSamples:10,sampleCount:3,lagThreshold:3},ajax:{trackMethods:["GET"],trackWebSockets:!0,ignoreURLs:[]}},C=function(){var a;return null!=(a="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance.now():void 0)?a:+new Date},E=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,t=window.cancelAnimationFrame||window.mozCancelAnimationFrame,null==E&&(E=function(a){return setTimeout(a,50)},t=function(a){return clearTimeout(a)}),G=function(a){var b,c;return b=C(),(c=function(){var d;return d=C()-b,d>=33?(b=C(),a(d,function(){return E(c)})):setTimeout(c,33-d)})()},F=function(){var a,b,c;return c=arguments[0],b=arguments[1],a=3<=arguments.length?X.call(arguments,2):[],"function"==typeof c[b]?c[b].apply(c,a):c[b]},v=function(){var a,b,c,d,e,f,g;for(b=arguments[0],d=2<=arguments.length?X.call(arguments,1):[],f=0,g=d.length;g>f;f++)if(c=d[f])for(a in c)Y.call(c,a)&&(e=c[a],null!=b[a]&&"object"==typeof b[a]&&null!=e&&"object"==typeof e?v(b[a],e):b[a]=e);return b},q=function(a){var b,c,d,e,f;for(c=b=0,e=0,f=a.length;f>e;e++)d=a[e],c+=Math.abs(d),b++;return c/b},x=function(a,b){var c,d,e;if(null==a&&(a="options"),null==b&&(b=!0),e=document.querySelector("[data-pace-"+a+"]")){if(c=e.getAttribute("data-pace-"+a),!b)return c;try{return JSON.parse(c)}catch(f){return d=f,"undefined"!=typeof console&&null!==console?console.error("Error parsing inline pace options",d):void 0}}},g=function(){function a(){}return a.prototype.on=function(a,b,c,d){var e;return null==d&&(d=!1),null==this.bindings&&(this.bindings={}),null==(e=this.bindings)[a]&&(e[a]=[]),this.bindings[a].push({handler:b,ctx:c,once:d})},a.prototype.once=function(a,b,c){return this.on(a,b,c,!0)},a.prototype.off=function(a,b){var c,d,e;if(null!=(null!=(d=this.bindings)?d[a]:void 0)){if(null==b)return delete this.bindings[a];for(c=0,e=[];c<this.bindings[a].length;)e.push(this.bindings[a][c].handler===b?this.bindings[a].splice(c,1):c++);return e}},a.prototype.trigger=function(){var a,b,c,d,e,f,g,h,i;if(c=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],null!=(g=this.bindings)?g[c]:void 0){for(e=0,i=[];e<this.bindings[c].length;)h=this.bindings[c][e],d=h.handler,b=h.ctx,f=h.once,d.apply(null!=b?b:this,a),i.push(f?this.bindings[c].splice(e,1):e++);return i}},a}(),j=window.Pace||{},window.Pace=j,v(j,g.prototype),D=j.options=v({},u,window.paceOptions,x()),U=["ajax","document","eventLag","elements"],Q=0,S=U.length;S>Q;Q++)K=U[Q],D[K]===!0&&(D[K]=u[K]);i=function(a){function b(){return V=b.__super__.constructor.apply(this,arguments)}return Z(b,a),b}(Error),b=function(){function a(){this.progress=0}return a.prototype.getElement=function(){var a;if(null==this.el){if(a=document.querySelector(D.target),!a)throw new i;this.el=document.createElement("div"),this.el.className="pace pace-active",document.body.className=document.body.className.replace(/pace-done/g,""),document.body.className+=" pace-running",this.el.innerHTML='<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>',null!=a.firstChild?a.insertBefore(this.el,a.firstChild):a.appendChild(this.el)}return this.el},a.prototype.finish=function(){var a;return a=this.getElement(),a.className=a.className.replace("pace-active",""),a.className+=" pace-inactive",document.body.className=document.body.className.replace("pace-running",""),document.body.className+=" pace-done"},a.prototype.update=function(a){return this.progress=a,this.render()},a.prototype.destroy=function(){try{this.getElement().parentNode.removeChild(this.getElement())}catch(a){i=a}return this.el=void 0},a.prototype.render=function(){var a,b,c,d,e,f,g;if(null==document.querySelector(D.target))return!1;for(a=this.getElement(),d="translate3d("+this.progress+"%, 0, 0)",g=["webkitTransform","msTransform","transform"],e=0,f=g.length;f>e;e++)b=g[e],a.children[0].style[b]=d;return(!this.lastRenderedProgress||this.lastRenderedProgress|0!==this.progress|0)&&(a.children[0].setAttribute("data-progress-text",""+(0|this.progress)+"%"),this.progress>=100?c="99":(c=this.progress<10?"0":"",c+=0|this.progress),a.children[0].setAttribute("data-progress",""+c)),this.lastRenderedProgress=this.progress},a.prototype.done=function(){return this.progress>=100},a}(),h=function(){function a(){this.bindings={}}return a.prototype.trigger=function(a,b){var c,d,e,f,g;if(null!=this.bindings[a]){for(f=this.bindings[a],g=[],d=0,e=f.length;e>d;d++)c=f[d],g.push(c.call(this,b));return g}},a.prototype.on=function(a,b){var c;return null==(c=this.bindings)[a]&&(c[a]=[]),this.bindings[a].push(b)},a}(),P=window.XMLHttpRequest,O=window.XDomainRequest,N=window.WebSocket,w=function(a,b){var c,d,e,f;f=[];for(d in b.prototype)try{e=b.prototype[d],f.push(null==a[d]&&"function"!=typeof e?a[d]=e:void 0)}catch(g){c=g}return f},A=[],j.ignore=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("ignore"),c=b.apply(null,a),A.shift(),c},j.track=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("track"),c=b.apply(null,a),A.shift(),c},J=function(a){var b;if(null==a&&(a="GET"),"track"===A[0])return"force";if(!A.length&&D.ajax){if("socket"===a&&D.ajax.trackWebSockets)return!0;if(b=a.toUpperCase(),$.call(D.ajax.trackMethods,b)>=0)return!0}return!1},k=function(a){function b(){var a,c=this;b.__super__.constructor.apply(this,arguments),a=function(a){var b;return b=a.open,a.open=function(d,e){return J(d)&&c.trigger("request",{type:d,url:e,request:a}),b.apply(a,arguments)}},window.XMLHttpRequest=function(b){var c;return c=new P(b),a(c),c};try{w(window.XMLHttpRequest,P)}catch(d){}if(null!=O){window.XDomainRequest=function(){var b;return b=new O,a(b),b};try{w(window.XDomainRequest,O)}catch(d){}}if(null!=N&&D.ajax.trackWebSockets){window.WebSocket=function(a,b){var d;return d=null!=b?new N(a,b):new N(a),J("socket")&&c.trigger("request",{type:"socket",url:a,protocols:b,request:d}),d};try{w(window.WebSocket,N)}catch(d){}}}return Z(b,a),b}(h),R=null,y=function(){return null==R&&(R=new k),R},I=function(a){var b,c,d,e;for(e=D.ajax.ignoreURLs,c=0,d=e.length;d>c;c++)if(b=e[c],"string"==typeof b){if(-1!==a.indexOf(b))return!0}else if(b.test(a))return!0;return!1},y().on("request",function(b){var c,d,e,f,g;return f=b.type,e=b.request,g=b.url,I(g)?void 0:j.running||D.restartOnRequestAfter===!1&&"force"!==J(f)?void 0:(d=arguments,c=D.restartOnRequestAfter||0,"boolean"==typeof c&&(c=0),setTimeout(function(){var b,c,g,h,i,k;if(b="socket"===f?e.readyState<2:0<(h=e.readyState)&&4>h){for(j.restart(),i=j.sources,k=[],c=0,g=i.length;g>c;c++){if(K=i[c],K instanceof a){K.watch.apply(K,d);break}k.push(void 0)}return k}},c))}),a=function(){function a(){var a=this;this.elements=[],y().on("request",function(){return a.watch.apply(a,arguments)})}return a.prototype.watch=function(a){var b,c,d,e;return d=a.type,b=a.request,e=a.url,I(e)?void 0:(c="socket"===d?new n(b):new o(b),this.elements.push(c))},a}(),o=function(){function a(a){var b,c,d,e,f,g,h=this;if(this.progress=0,null!=window.ProgressEvent)for(c=null,a.addEventListener("progress",function(a){return h.progress=a.lengthComputable?100*a.loaded/a.total:h.progress+(100-h.progress)/2},!1),g=["load","abort","timeout","error"],d=0,e=g.length;e>d;d++)b=g[d],a.addEventListener(b,function(){return h.progress=100},!1);else f=a.onreadystatechange,a.onreadystatechange=function(){var b;return 0===(b=a.readyState)||4===b?h.progress=100:3===a.readyState&&(h.progress=50),"function"==typeof f?f.apply(null,arguments):void 0}}return a}(),n=function(){function a(a){var b,c,d,e,f=this;for(this.progress=0,e=["error","open"],c=0,d=e.length;d>c;c++)b=e[c],a.addEventListener(b,function(){return f.progress=100},!1)}return a}(),d=function(){function a(a){var b,c,d,f;for(null==a&&(a={}),this.elements=[],null==a.selectors&&(a.selectors=[]),f=a.selectors,c=0,d=f.length;d>c;c++)b=f[c],this.elements.push(new e(b))}return a}(),e=function(){function a(a){this.selector=a,this.progress=0,this.check()}return a.prototype.check=function(){var a=this;return document.querySelector(this.selector)?this.done():setTimeout(function(){return a.check()},D.elements.checkInterval)},a.prototype.done=function(){return this.progress=100},a}(),c=function(){function a(){var a,b,c=this;this.progress=null!=(b=this.states[document.readyState])?b:100,a=document.onreadystatechange,document.onreadystatechange=function(){return null!=c.states[document.readyState]&&(c.progress=c.states[document.readyState]),"function"==typeof a?a.apply(null,arguments):void 0}}return a.prototype.states={loading:0,interactive:50,complete:100},a}(),f=function(){function a(){var a,b,c,d,e,f=this;this.progress=0,a=0,e=[],d=0,c=C(),b=setInterval(function(){var g;return g=C()-c-50,c=C(),e.push(g),e.length>D.eventLag.sampleCount&&e.shift(),a=q(e),++d>=D.eventLag.minSamples&&a<D.eventLag.lagThreshold?(f.progress=100,clearInterval(b)):f.progress=100*(3/(a+3))},50)}return a}(),m=function(){function a(a){this.source=a,this.last=this.sinceLastUpdate=0,this.rate=D.initialRate,this.catchup=0,this.progress=this.lastProgress=0,null!=this.source&&(this.progress=F(this.source,"progress"))}return a.prototype.tick=function(a,b){var c;return null==b&&(b=F(this.source,"progress")),b>=100&&(this.done=!0),b===this.last?this.sinceLastUpdate+=a:(this.sinceLastUpdate&&(this.rate=(b-this.last)/this.sinceLastUpdate),this.catchup=(b-this.progress)/D.catchupTime,this.sinceLastUpdate=0,this.last=b),b>this.progress&&(this.progress+=this.catchup*a),c=1-Math.pow(this.progress/100,D.easeFactor),this.progress+=c*this.rate*a,this.progress=Math.min(this.lastProgress+D.maxProgressPerFrame,this.progress),this.progress=Math.max(0,this.progress),this.progress=Math.min(100,this.progress),this.lastProgress=this.progress,this.progress},a}(),L=null,H=null,r=null,M=null,p=null,s=null,j.running=!1,z=function(){return D.restartOnPushState?j.restart():void 0},null!=window.history.pushState&&(T=window.history.pushState,window.history.pushState=function(){return z(),T.apply(window.history,arguments)}),null!=window.history.replaceState&&(W=window.history.replaceState,window.history.replaceState=function(){return z(),W.apply(window.history,arguments)}),l={ajax:a,elements:d,document:c,eventLag:f},(B=function(){var a,c,d,e,f,g,h,i;for(j.sources=L=[],g=["ajax","elements","document","eventLag"],c=0,e=g.length;e>c;c++)a=g[c],D[a]!==!1&&L.push(new l[a](D[a]));for(i=null!=(h=D.extraSources)?h:[],d=0,f=i.length;f>d;d++)K=i[d],L.push(new K(D));return j.bar=r=new b,H=[],M=new m})(),j.stop=function(){return j.trigger("stop"),j.running=!1,r.destroy(),s=!0,null!=p&&("function"==typeof t&&t(p),p=null),B()},j.restart=function(){return j.trigger("restart"),j.stop(),j.start()},j.go=function(){var a;return j.running=!0,r.render(),a=C(),s=!1,p=G(function(b,c){var d,e,f,g,h,i,k,l,n,o,p,q,t,u,v,w;for(l=100-r.progress,e=p=0,f=!0,i=q=0,u=L.length;u>q;i=++q)for(K=L[i],o=null!=H[i]?H[i]:H[i]=[],h=null!=(w=K.elements)?w:[K],k=t=0,v=h.length;v>t;k=++t)g=h[k],n=null!=o[k]?o[k]:o[k]=new m(g),f&=n.done,n.done||(e++,p+=n.tick(b));return d=p/e,r.update(M.tick(b,d)),r.done()||f||s?(r.update(100),j.trigger("done"),setTimeout(function(){return r.finish(),j.running=!1,j.trigger("hide")},Math.max(D.ghostTime,Math.max(D.minTime-(C()-a),0)))):c()})},j.start=function(a){v(D,a),j.running=!0;try{r.render()}catch(b){i=b}return document.querySelector(".pace")?(j.trigger("start"),j.go()):setTimeout(j.start,50)},"function"==typeof define&&define.amd?define(function(){return j}):"object"==typeof exports?module.exports=j:D.startOnPageLoad&&j.start()}).call(this);
/*! pace 1.0.2 */
(function(){var a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X=[].slice,Y={}.hasOwnProperty,Z=function(a,b){function c(){this.constructor=a}for(var d in b)Y.call(b,d)&&(a[d]=b[d]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a},$=[].indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(b in this&&this[b]===a)return b;return-1};for(u={catchupTime:100,initialRate:.03,minTime:250,ghostTime:100,maxProgressPerFrame:20,easeFactor:1.25,startOnPageLoad:!0,restartOnPushState:!0,restartOnRequestAfter:500,target:"body",elements:{checkInterval:100,selectors:["body"]},eventLag:{minSamples:10,sampleCount:3,lagThreshold:3},ajax:{trackMethods:["GET"],trackWebSockets:!0,ignoreURLs:[]}},C=function(){var a;return null!=(a="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance.now():void 0)?a:+new Date},E=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,t=window.cancelAnimationFrame||window.mozCancelAnimationFrame,null==E&&(E=function(a){return setTimeout(a,50)},t=function(a){return clearTimeout(a)}),G=function(a){var b,c;return b=C(),(c=function(){var d;return d=C()-b,d>=33?(b=C(),a(d,function(){return E(c)})):setTimeout(c,33-d)})()},F=function(){var a,b,c;return c=arguments[0],b=arguments[1],a=3<=arguments.length?X.call(arguments,2):[],"function"==typeof c[b]?c[b].apply(c,a):c[b]},v=function(){var a,b,c,d,e,f,g;for(b=arguments[0],d=2<=arguments.length?X.call(arguments,1):[],f=0,g=d.length;g>f;f++)if(c=d[f])for(a in c)Y.call(c,a)&&(e=c[a],null!=b[a]&&"object"==typeof b[a]&&null!=e&&"object"==typeof e?v(b[a],e):b[a]=e);return b},q=function(a){var b,c,d,e,f;for(c=b=0,e=0,f=a.length;f>e;e++)d=a[e],c+=Math.abs(d),b++;return c/b},x=function(a,b){var c,d,e;if(null==a&&(a="options"),null==b&&(b=!0),e=document.querySelector("[data-pace-"+a+"]")){if(c=e.getAttribute("data-pace-"+a),!b)return c;try{return JSON.parse(c)}catch(f){return d=f,"undefined"!=typeof console&&null!==console?console.error("Error parsing inline pace options",d):void 0}}},g=function(){function a(){}return a.prototype.on=function(a,b,c,d){var e;return null==d&&(d=!1),null==this.bindings&&(this.bindings={}),null==(e=this.bindings)[a]&&(e[a]=[]),this.bindings[a].push({handler:b,ctx:c,once:d})},a.prototype.once=function(a,b,c){return this.on(a,b,c,!0)},a.prototype.off=function(a,b){var c,d,e;if(null!=(null!=(d=this.bindings)?d[a]:void 0)){if(null==b)return delete this.bindings[a];for(c=0,e=[];c<this.bindings[a].length;)e.push(this.bindings[a][c].handler===b?this.bindings[a].splice(c,1):c++);return e}},a.prototype.trigger=function(){var a,b,c,d,e,f,g,h,i;if(c=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],null!=(g=this.bindings)?g[c]:void 0){for(e=0,i=[];e<this.bindings[c].length;)h=this.bindings[c][e],d=h.handler,b=h.ctx,f=h.once,d.apply(null!=b?b:this,a),i.push(f?this.bindings[c].splice(e,1):e++);return i}},a}(),j=window.Pace||{},window.Pace=j,v(j,g.prototype),D=j.options=v({},u,window.paceOptions,x()),U=["ajax","document","eventLag","elements"],Q=0,S=U.length;S>Q;Q++)K=U[Q],D[K]===!0&&(D[K]=u[K]);i=function(a){function b(){return V=b.__super__.constructor.apply(this,arguments)}return Z(b,a),b}(Error),b=function(){function a(){this.progress=0}return a.prototype.getElement=function(){var a;if(null==this.el){if(a=document.querySelector(D.target),!a)throw new i;this.el=document.createElement("div"),this.el.className="pace pace-active",document.body.className=document.body.className.replace(/pace-done/g,""),document.body.className+=" pace-running",this.el.innerHTML='<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>',null!=a.firstChild?a.insertBefore(this.el,a.firstChild):a.appendChild(this.el)}return this.el},a.prototype.finish=function(){var a;return a=this.getElement(),a.className=a.className.replace("pace-active",""),a.className+=" pace-inactive",document.body.className=document.body.className.replace("pace-running",""),document.body.className+=" pace-done"},a.prototype.update=function(a){return this.progress=a,this.render()},a.prototype.destroy=function(){try{this.getElement().parentNode.removeChild(this.getElement())}catch(a){i=a}return this.el=void 0},a.prototype.render=function(){var a,b,c,d,e,f,g;if(null==document.querySelector(D.target))return!1;for(a=this.getElement(),d="translate3d("+this.progress+"%, 0, 0)",g=["webkitTransform","msTransform","transform"],e=0,f=g.length;f>e;e++)b=g[e],a.children[0].style[b]=d;return(!this.lastRenderedProgress||this.lastRenderedProgress|0!==this.progress|0)&&(a.children[0].setAttribute("data-progress-text",""+(0|this.progress)+"%"),this.progress>=100?c="99":(c=this.progress<10?"0":"",c+=0|this.progress),a.children[0].setAttribute("data-progress",""+c)),this.lastRenderedProgress=this.progress},a.prototype.done=function(){return this.progress>=100},a}(),h=function(){function a(){this.bindings={}}return a.prototype.trigger=function(a,b){var c,d,e,f,g;if(null!=this.bindings[a]){for(f=this.bindings[a],g=[],d=0,e=f.length;e>d;d++)c=f[d],g.push(c.call(this,b));return g}},a.prototype.on=function(a,b){var c;return null==(c=this.bindings)[a]&&(c[a]=[]),this.bindings[a].push(b)},a}(),P=window.XMLHttpRequest,O=window.XDomainRequest,N=window.WebSocket,w=function(a,b){var c,d,e;e=[];for(d in b.prototype)try{e.push(null==a[d]&&"function"!=typeof b[d]?"function"==typeof Object.defineProperty?Object.defineProperty(a,d,{get:function(){return b.prototype[d]},configurable:!0,enumerable:!0}):a[d]=b.prototype[d]:void 0)}catch(f){c=f}return e},A=[],j.ignore=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("ignore"),c=b.apply(null,a),A.shift(),c},j.track=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("track"),c=b.apply(null,a),A.shift(),c},J=function(a){var b;if(null==a&&(a="GET"),"track"===A[0])return"force";if(!A.length&&D.ajax){if("socket"===a&&D.ajax.trackWebSockets)return!0;if(b=a.toUpperCase(),$.call(D.ajax.trackMethods,b)>=0)return!0}return!1},k=function(a){function b(){var a,c=this;b.__super__.constructor.apply(this,arguments),a=function(a){var b;return b=a.open,a.open=function(d,e){return J(d)&&c.trigger("request",{type:d,url:e,request:a}),b.apply(a,arguments)}},window.XMLHttpRequest=function(b){var c;return c=new P(b),a(c),c};try{w(window.XMLHttpRequest,P)}catch(d){}if(null!=O){window.XDomainRequest=function(){var b;return b=new O,a(b),b};try{w(window.XDomainRequest,O)}catch(d){}}if(null!=N&&D.ajax.trackWebSockets){window.WebSocket=function(a,b){var d;return d=null!=b?new N(a,b):new N(a),J("socket")&&c.trigger("request",{type:"socket",url:a,protocols:b,request:d}),d};try{w(window.WebSocket,N)}catch(d){}}}return Z(b,a),b}(h),R=null,y=function(){return null==R&&(R=new k),R},I=function(a){var b,c,d,e;for(e=D.ajax.ignoreURLs,c=0,d=e.length;d>c;c++)if(b=e[c],"string"==typeof b){if(-1!==a.indexOf(b))return!0}else if(b.test(a))return!0;return!1},y().on("request",function(b){var c,d,e,f,g;return f=b.type,e=b.request,g=b.url,I(g)?void 0:j.running||D.restartOnRequestAfter===!1&&"force"!==J(f)?void 0:(d=arguments,c=D.restartOnRequestAfter||0,"boolean"==typeof c&&(c=0),setTimeout(function(){var b,c,g,h,i,k;if(b="socket"===f?e.readyState<2:0<(h=e.readyState)&&4>h){for(j.restart(),i=j.sources,k=[],c=0,g=i.length;g>c;c++){if(K=i[c],K instanceof a){K.watch.apply(K,d);break}k.push(void 0)}return k}},c))}),a=function(){function a(){var a=this;this.elements=[],y().on("request",function(){return a.watch.apply(a,arguments)})}return a.prototype.watch=function(a){var b,c,d,e;return d=a.type,b=a.request,e=a.url,I(e)?void 0:(c="socket"===d?new n(b):new o(b),this.elements.push(c))},a}(),o=function(){function a(a){var b,c,d,e,f,g,h=this;if(this.progress=0,null!=window.ProgressEvent)for(c=null,a.addEventListener("progress",function(a){return h.progress=a.lengthComputable?100*a.loaded/a.total:h.progress+(100-h.progress)/2},!1),g=["load","abort","timeout","error"],d=0,e=g.length;e>d;d++)b=g[d],a.addEventListener(b,function(){return h.progress=100},!1);else f=a.onreadystatechange,a.onreadystatechange=function(){var b;return 0===(b=a.readyState)||4===b?h.progress=100:3===a.readyState&&(h.progress=50),"function"==typeof f?f.apply(null,arguments):void 0}}return a}(),n=function(){function a(a){var b,c,d,e,f=this;for(this.progress=0,e=["error","open"],c=0,d=e.length;d>c;c++)b=e[c],a.addEventListener(b,function(){return f.progress=100},!1)}return a}(),d=function(){function a(a){var b,c,d,f;for(null==a&&(a={}),this.elements=[],null==a.selectors&&(a.selectors=[]),f=a.selectors,c=0,d=f.length;d>c;c++)b=f[c],this.elements.push(new e(b))}return a}(),e=function(){function a(a){this.selector=a,this.progress=0,this.check()}return a.prototype.check=function(){var a=this;return document.querySelector(this.selector)?this.done():setTimeout(function(){return a.check()},D.elements.checkInterval)},a.prototype.done=function(){return this.progress=100},a}(),c=function(){function a(){var a,b,c=this;this.progress=null!=(b=this.states[document.readyState])?b:100,a=document.onreadystatechange,document.onreadystatechange=function(){return null!=c.states[document.readyState]&&(c.progress=c.states[document.readyState]),"function"==typeof a?a.apply(null,arguments):void 0}}return a.prototype.states={loading:0,interactive:50,complete:100},a}(),f=function(){function a(){var a,b,c,d,e,f=this;this.progress=0,a=0,e=[],d=0,c=C(),b=setInterval(function(){var g;return g=C()-c-50,c=C(),e.push(g),e.length>D.eventLag.sampleCount&&e.shift(),a=q(e),++d>=D.eventLag.minSamples&&a<D.eventLag.lagThreshold?(f.progress=100,clearInterval(b)):f.progress=100*(3/(a+3))},50)}return a}(),m=function(){function a(a){this.source=a,this.last=this.sinceLastUpdate=0,this.rate=D.initialRate,this.catchup=0,this.progress=this.lastProgress=0,null!=this.source&&(this.progress=F(this.source,"progress"))}return a.prototype.tick=function(a,b){var c;return null==b&&(b=F(this.source,"progress")),b>=100&&(this.done=!0),b===this.last?this.sinceLastUpdate+=a:(this.sinceLastUpdate&&(this.rate=(b-this.last)/this.sinceLastUpdate),this.catchup=(b-this.progress)/D.catchupTime,this.sinceLastUpdate=0,this.last=b),b>this.progress&&(this.progress+=this.catchup*a),c=1-Math.pow(this.progress/100,D.easeFactor),this.progress+=c*this.rate*a,this.progress=Math.min(this.lastProgress+D.maxProgressPerFrame,this.progress),this.progress=Math.max(0,this.progress),this.progress=Math.min(100,this.progress),this.lastProgress=this.progress,this.progress},a}(),L=null,H=null,r=null,M=null,p=null,s=null,j.running=!1,z=function(){return D.restartOnPushState?j.restart():void 0},null!=window.history.pushState&&(T=window.history.pushState,window.history.pushState=function(){return z(),T.apply(window.history,arguments)}),null!=window.history.replaceState&&(W=window.history.replaceState,window.history.replaceState=function(){return z(),W.apply(window.history,arguments)}),l={ajax:a,elements:d,document:c,eventLag:f},(B=function(){var a,c,d,e,f,g,h,i;for(j.sources=L=[],g=["ajax","elements","document","eventLag"],c=0,e=g.length;e>c;c++)a=g[c],D[a]!==!1&&L.push(new l[a](D[a]));for(i=null!=(h=D.extraSources)?h:[],d=0,f=i.length;f>d;d++)K=i[d],L.push(new K(D));return j.bar=r=new b,H=[],M=new m})(),j.stop=function(){return j.trigger("stop"),j.running=!1,r.destroy(),s=!0,null!=p&&("function"==typeof t&&t(p),p=null),B()},j.restart=function(){return j.trigger("restart"),j.stop(),j.start()},j.go=function(){var a;return j.running=!0,r.render(),a=C(),s=!1,p=G(function(b,c){var d,e,f,g,h,i,k,l,n,o,p,q,t,u,v,w;for(l=100-r.progress,e=p=0,f=!0,i=q=0,u=L.length;u>q;i=++q)for(K=L[i],o=null!=H[i]?H[i]:H[i]=[],h=null!=(w=K.elements)?w:[K],k=t=0,v=h.length;v>t;k=++t)g=h[k],n=null!=o[k]?o[k]:o[k]=new m(g),f&=n.done,n.done||(e++,p+=n.tick(b));return d=p/e,r.update(M.tick(b,d)),r.done()||f||s?(r.update(100),j.trigger("done"),setTimeout(function(){return r.finish(),j.running=!1,j.trigger("hide")},Math.max(D.ghostTime,Math.max(D.minTime-(C()-a),0)))):c()})},j.start=function(a){v(D,a),j.running=!0;try{r.render()}catch(b){i=b}return document.querySelector(".pace")?(j.trigger("start"),j.go()):setTimeout(j.start,50)},"function"==typeof define&&define.amd?define(["pace"],function(){return j}):"object"==typeof exports?module.exports=j:D.startOnPageLoad&&j.start()}).call(this);
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('Fullarm.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('Fullarm.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('Fullarm.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function ($) {
    // jQuery autoGrowInput plugin by James Padolsey
    // See related thread: http://stackoverflow.com/questions/931207/is-there-a-jquery-autogrow-plugin-for-text-fields
    $.fn.autoGrowInput = function (o) {

        o = $.extend({
            maxWidth: 1000,
            minWidth: 0,
            comfortZone: 70
        }, o);

        this.filter('input:text').each(function () {
            var minWidth = o.minWidth || $(this).width(),
                val = '',
                input = $(this),
                testSubject = $('<tester/>').css({
                    position: 'absolute',
                    top: -9999,
                    left: -9999,
                    width: 'auto',
                    fontSize: input.css('fontSize'),
                    fontFamily: input.css('fontFamily'),
                    fontWeight: input.css('fontWeight'),
                    letterSpacing: input.css('letterSpacing'),
                    whiteSpace: 'nowrap'
                }),
                check = function () {

                    if (val === (val = input.val())) {
                        return;
                    }

                    // Enter new content into testSubject
                    var escaped = val.replace(/&/g, '&amp;').replace(/\s/g, '&nbsp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                    testSubject.html(escaped);

                    // Calculate new width + whether to change
                    var testerWidth = testSubject.width(),
                        newWidth = (testerWidth + o.comfortZone) >= minWidth ? testerWidth + o.comfortZone : minWidth,
                        currentWidth = input.width(),
                        isValidWidthChange = (newWidth < currentWidth && newWidth >= minWidth)
                            || (newWidth > minWidth && newWidth < o.maxWidth);

                    // Animate width
                    if (isValidWidthChange) {
                        input.width(newWidth);
                    }

                };

            testSubject.insertAfter(input);

            $(this).bind('keyup keydown blur update', check);

            check();
        });

        return this;

    };

})(jQuery);
angular.module('de.devjs.angular.spotlight', [])
    .directive('spotlightOverlay', ['$timeout', '$http', '$compile', 'AngularSpotlight', function ($timeout, $http, $compile, AngularSpotlight) {

        const KEY = {
            UP: 38,
            DOWN: 40,
            ESC: 27,
            ENTER: 13
        };

        var $ngSpotlightOverlay;

        return {
            restrict: 'E',
            replace: true,
            controller: controller(),
            link: link,
            templateUrl: 'spotlight/directive/spotlightOverlayTemplate.html'
        };

        function controller() {
            return ['$scope', function ($scope) {
                $scope.searchInputInfo = AngularSpotlight.getSearchInputInfoSearching();
                $scope.spotlightPlaceholder = AngularSpotlight.getSpotlightPlaceholder();

                $scope.search = function () {
                    if ($scope.searchTerm.length > 0) {
                        AngularSpotlight.search($scope.searchTerm)
                            .then(function setSearchResult(resp) {
                                $scope.searchResults = resp;
                                $scope.searchResultsCount = $scope.searchResults
                                    .map(function (category) {
                                        return category.items.length;
                                    })
                                    .reduce(function (prev, cur) {
                                        return prev + cur;
                                    }, 0);

                                setSearchInputInfo();
                                selectItemAtIndex(0);
                            });
                    }
                };

                $scope.getIconForType = function (type) {
                    return AngularSpotlight.getIconDescriptorForType(type);
                };

                $scope.showResultItem = function (categoryName, idx) {
                    var indexToSelect = 0;

                    for (var i = 0; i < $scope.searchResults.length; i++) {
                        if ($scope.searchResults[i].name !== categoryName) {
                            indexToSelect += $scope.searchResults[i].items.length;
                        } else {
                            break;
                        }
                    }

                    selectItemAtIndex(indexToSelect + idx);

                    $ngSpotlightOverlay
                        .find('input')
                        .focus()
                        .select();
                };

                /**
                 * Handle Keyboard events
                 * @param $event
                 */
                $scope.handleKeyDown = function ($event) {
                    switch ($event.keyCode) {
                        case KEY.UP:
                            $event.preventDefault();
                            selectPreviousEntry();
                            break;
                        case KEY.DOWN:
                            $event.preventDefault();
                            selectNextEntry();
                            break;
                        case KEY.ESC:
                            resetSearch();
                            break;
                        case KEY.ENTER:
                            $scope.openResultItem();
                            break;
                    }
                };

                $scope.openResultCategory = function() {
                    console.log($scope.selectedCategory);
                };

                $scope.openResultItem = function () {
                    if($scope.selectedItem.href) {
                        window.location.href = $scope.selectedItem.href;
                        $ngSpotlightOverlay.hide();
                    }
                };

                function resetSearch() {
                    $scope.selectedItem = undefined;
                    $scope.searchResultsCount = 0;
                    $scope.searchResults = [];
                    $scope.searchInputInfo = undefined;
                    $scope.searchTerm = "";
                }

                function selectPreviousEntry() {
                    var idx = getSelectedItemIndex();
                    if (idx - 1 >= 0) {
                        selectItemAtIndex(idx - 1)
                    }
                }

                function selectNextEntry() {
                    var idx = getSelectedItemIndex();
                    if (idx + 1 < $scope.searchResultsCount) {
                        selectItemAtIndex(idx + 1);
                    }
                }

                function selectItemAtIndex(idx) {
                    var currentItemIndex = 0;
                    $scope.searchResults.forEach(function (category) {
                        if (category.items.length > 0) {
                            category.items.forEach(function (item) {
                                var isActive = currentItemIndex === (idx || 0);
                                item.active = isActive;
                                currentItemIndex++;

                                if (isActive) {
                                    $scope.selectedItem = item;
                                    $scope.selectedCategory = category;
                                    setSearchInputInfo(category.name);
                                }
                            });
                        }
                    });
                    $scope.selectedItemIndex = idx;
                }

                function setSearchInputInfo(categoryName) {
                    if ($scope.searchTerm.length === 0) {
                        $scope.searchInputInfo = AngularSpotlight.getSearchInputInfoSearching();
                    } else if ($scope.searchResultsCount === 0) {
                        $scope.searchInputInfo = AngularSpotlight.getSearchInputInfoNoResults();
                    } else if ($scope.selectedItem) {
                        $scope.searchInputInfo = $scope.selectedItem.name + " - " + categoryName;
                    }
                }

                function getSelectedItemIndex() {
                    return $scope.selectedItemIndex || 0;
                }

                $scope.$watch('selectedItemIndex', function () {
                    $timeout(function () {
                        if ($scope.selectedItemIndex !== undefined) {
                            keepItemVisible();
                        }
                    }, 100);
                });

                function keepItemVisible() {
                    var activeItem = $ngSpotlightOverlay.find('li.ng-spotlight-results-list-item.active');
                    var resultsList = $ngSpotlightOverlay.find('.ng-spotlight-results-list');

                    var activeItemTop = activeItem.position().top;
                    var activeItemBottom = activeItem.position().top + activeItem.outerHeight();
                    var parentsHeight = resultsList.height();
                    var currentScrollTop = resultsList.scrollTop();

                    if (parentsHeight - activeItemBottom < 0) {
                        resultsList.scrollTop(currentScrollTop + Math.abs(parentsHeight - activeItemBottom));
                    }
                    if (activeItemTop < 0) {
                        var padding = 0;
                        if (activeItem.parent().find('li').index(activeItem) === 0) {
                            padding = $('.ng-spotlight-results-list-header:first').outerHeight();
                        }
                        resultsList.scrollTop(currentScrollTop + activeItemTop - padding);
                    }
                }
            }];
        }

        function link(scope, element) {
            $ngSpotlightOverlay = $(element);

            $('[data-toggle="ng-spotlight"]')
                .on('click', function (e) {
                    e.stopPropagation();
                    toggleOverlay();
                });

            $(document)
                .on('keydown', function (e) {
                    if (e.ctrlKey && e.keyCode === AngularSpotlight.getSpotlightToggleCtrlKey()) {
                        e.preventDefault();
                        toggleOverlay();
                    }
                })
                .on('click', function (e) {
                    if ($(e.target).closest('.ng-spotlight').length === 0) {
                        $ngSpotlightOverlay.hide();
                    } else {
                        $ngSpotlightOverlay
                            .find('input')
                            .focus();
                    }
                });

            function toggleOverlay() {
                $ngSpotlightOverlay.toggle();

                if ($ngSpotlightOverlay.is(':visible')) {
                    $ngSpotlightOverlay
                        .find('input')
                        .focus()
                        .select();
                }
            }

            $ngSpotlightOverlay
                .find('.ng-spotlight-input').autoGrowInput({
                    maxWidth: 400,
                    minWidth: 10,
                    comfortZone: 15
                });
        }
    }]);
angular.module('de.devjs.angular.spotlight')
    .directive('spotlightDetails', ['$compile', 'AngularSpotlight', function ($compile, AngularSpotlight) {

        function link(scope, element) {
            scope.getContentUrl = function() {
                return scope.templateUrl;
            };

            scope.$watch('selectedItem', function () {
                if (scope.selectedItem) {
                    var templateForType = AngularSpotlight.getTemplateForType(scope.selectedItem.type);

                    if(templateIsFile(templateForType)) {
                        scope.templateUrl = templateForType;
                        templateForType = angular.element('<div ng-include="getContentUrl()"></div>');
                    }

                    element.html(templateForType).show();
                    $compile(element.contents())(scope);
                }
            });

            function templateIsFile(templateForType) {
                return new RegExp('\.html?$').test(templateForType);
            }
        }


        return {
            restrict: "E",
            link: link
        };
    }]);
angular.module('de.devjs.angular.spotlight').run(['$templateCache', function($templateCache) {
    $templateCache.put('spotlight/directive/spotlightOverlayTemplate.html',
        "<div class=\"ng-spotlight ng-spotlight-overlay\" ng-keydown=\"handleKeyDown($event)\">\n    <div class=\"ng-spotlight-searchbar\">\n        <div class=\"ng-spotlight-icon\">\n            <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"  viewBox=\"0 0 283.753 284.51\" enable-background=\"new 0 0 283.753 284.51\" xml:space=\"preserve\">\n            <path d=\"M281.394,264.378l0.135-0.135L176.24,158.954c30.127-38.643,27.45-94.566-8.09-130.104\n\tc-38.467-38.467-100.833-38.467-139.3,0c-38.467,38.467-38.466,100.833,0,139.299c35.279,35.279,90.644,38.179,129.254,8.748\n\tl103.859,103.859c0.01,0.01,0.021,0.021,0.03,0.03l1.495,1.495l0.134-0.134c2.083,1.481,4.624,2.36,7.375,2.36\n\tc7.045,0,12.756-5.711,12.756-12.756C283.753,269.002,282.875,266.462,281.394,264.378z M47.388,149.612\n\tc-28.228-28.229-28.229-73.996,0-102.225c28.228-28.229,73.996-28.228,102.225,0.001c28.229,28.229,28.229,73.995,0,102.224\n\tC121.385,177.841,75.617,177.841,47.388,149.612z\"/>\n            </svg>\n        </div>\n\n        <input class=\"ng-spotlight-input\" ng-class=\"{'empty': searchTerm.length === 0}\" type=\"text\" placeholder=\"{{spotlightPlaceholder}}\" ng-model=\"searchTerm\" ng-change=\"search()\" ng-model-options=\"{debounce: 250}\"/>\n\n        <div class=\"ng-spotlight-input-after\" ng-if=\"searchInputInfo.length > 0  && searchTerm.length > 0\">&mdash; {{searchInputInfo}}</div>\n        <div class=\"ng-spotlight-results-icon\" ng-if=\"searchTerm.length > 0\">\n            <img ng-if=\"getIconForType(selectedItem.type).type == 'url'\" class=\"ng-spotlight-item-icon\" ng-src=\"{{getIconForType(selectedItem.type).data}}\" width=\"32\" height=\"32\">\n            <div ng-if=\"getIconForType(selectedItem.type).type == 'css'\" class=\"ng-spotlight-item-icon {{getIconForType(selectedItem.type).data}}\"></div>\n        </div>\n    </div>\n    <div class=\"ng-spotlight-results-panel\" ng-if=\"searchTerm && searchTerm.length > 0 && searchResultsCount > 0\" >\n        <div class=\"ng-spotlight-results-list\" ng-keydown=\"handleKeyDown($event)\">\n            <ul>\n                " +
        "<li class=\"ng-spotlight-results-category\" ng-repeat=\"searchResult in searchResults\" ng-dblclick=\"openResultCategory()\">\n                    " +
        "<div class=\"ng-spotlight-results-list-header\">{{searchResult.name}}</div>\n                    <ul>\n                        <li class=\"ng-spotlight-results-list-item\"\n                            " +
        "ng-repeat=\"resultItem in searchResult.items\"\n                            " +
        "ng-class=\"{'active': resultItem.active === true}\"\n                            " +
        "ng-click=\"showResultItem(searchResult.name, $index)\"\n                            " +
        "ng-dblclick=\"openResultItem()\">\n\n                            " +
        "<img ng-if=\"getIconForType(resultItem.type).type == 'url'\" class=\"ng-spotlight-item-icon\" ng-src=\"{{getIconForType(resultItem.type).data}}\">\n                            " +
        "<div ng-if=\"getIconForType(resultItem.type).type == 'css'\" class=\"ng-spotlight-item-icon {{getIconForType(resultItem.type).data}}\"></div>\n\n                            " +
        "{{resultItem.name}}\n\n                            <span class=\"info\" ng-if=\"resultItem.info\">\n                                &ndash; {{resultItem.info}}\n                            </span>\n                        </li>\n                    </ul>\n                </li>\n            </ul>\n        </div>\n        <div class=\"ng-spotlight-results-detail\">\n            <spotlight-details></spotlight-details>\n        </div>\n    </div>\n</div>");
}]);
angular.module('de.devjs.angular.spotlight')
    .provider("AngularSpotlight", function () {
        var _iconConfig = iconConfig();
        var _detailsTemplateConfig = detailsTemplateConfig();
        var _defaultSpotlightConfig = defaultSpotlightConfig();

        // === LE PUBLIC API ====================
        return {
            search: function () {
                throw "You have to implement a search function using AngularSpotlightProvider!";
            },
            addIcons: _iconConfig.addIcons,
            addTemplates: _detailsTemplateConfig.addTemplates,
            setSearchInputInfoSearching: _defaultSpotlightConfig.setSearchInputInfoSearching,
            setSearchInputInfoNoResults: _defaultSpotlightConfig.setSearchInputInfoNoResults,
            setSpotlightPlaceholder: _defaultSpotlightConfig.setSpotlightPlaceholder,
            setSpotlightToggleCtrlKey: _defaultSpotlightConfig.setSpotlightToggleCtrlKey,
            $get: ['$http', '$q', function ($http, $q) {
                var that = this;
                return {
                    search: that.search($http, $q),
                    getIconDescriptorForType: _iconConfig.getIconForType,
                    getTemplateForType: _detailsTemplateConfig.getTemplateForType,
                    getSearchInputInfoSearching: _defaultSpotlightConfig.getSearchInputInfoSearching,
                    getSearchInputInfoNoResults: _defaultSpotlightConfig.getSearchInputInfoNoResults,
                    getSpotlightPlaceholder: _defaultSpotlightConfig.getSpotlightPlaceholder,
                    getSpotlightToggleCtrlKey: _defaultSpotlightConfig.getSpotlightToggleCtrlKey
                };
            }]
        };

        // === LE HELPER ====================
        function iconConfig() {
            var icons = {
                'default': 'fa fa-sitemap'
            };

            function addIcons(iconDescriptors) {
                Object.keys(iconDescriptors)
                    .forEach(function (iconKey) {
                        icons[iconKey.toLowerCase()] = iconDescriptors[iconKey];
                    });
            }

            function getIconForType(type) {
                var icon = icons[(type || 'default').toLowerCase()] || icons['default'];

                return {
                    data: icon,
                    type: guessType(icon)
                };

                function guessType(icon) {
                    var icon = icon.toLowerCase();
                    if (icon.indexOf('http') === 0 || icon.indexOf('data:') === 0) {
                        return 'url';
                    } else {
                        return 'css';
                    }
                }
            }

            return {
                addIcons: addIcons,
                getIconForType: getIconForType
            }
        }

        function detailsTemplateConfig() {
            var detailsTemplates = {
                'default': '<div class="ng-spotlight-results-detail-default"><img ng-if="getIconForType(selectedItem.type).type == \'url\'" class="ng-spotlight-item-icon" ng-src="{{getIconForType(selectedItem.type).data}}" width="64" height="64"><div ng-if="getIconForType(selectedItem.type).type == \'css\'" class="ng-spotlight-item-icon {{getIconForType(selectedItem.type).data}}"></div><div class="name">{{selectedItem.name}}</div></div>'
            };

            function addTemplates(templateDescriptors) {
                Object.keys(templateDescriptors)
                    .forEach(function (templateKey) {
                        detailsTemplates[templateKey.toLowerCase()] = templateDescriptors[templateKey];
                    });
            }

            function getTemplateForType(type) {
                return detailsTemplates[(type || 'default').toLowerCase()] || detailsTemplates['default'];
            }

            return {
                addTemplates: addTemplates,
                getTemplateForType: getTemplateForType
            }
        }

        function defaultSpotlightConfig() {
            const KEY_SPACE = 32;
            var searchInputInfoSearching = 'Suchend ...';
            var searchInputInfoNoResults = 'Keine Ergebnisse';
            var spotlightPlaceholder = 'Spotlight-Suche';
            var spotlightToggleCtrlKey = KEY_SPACE;

            function setSearchInputInfoSearching(text) {
                searchInputInfoSearching = text;
            }

            function getSearchInputInfoSearching() {
                return searchInputInfoSearching;
            }

            function setSearchInputInfoNoResults(text) {
                searchInputInfoNoResults = text;
            }

            function getSearchInputInfoNoResults() {
                return searchInputInfoNoResults;
            }

            function setSpotlightPlaceholder(text) {
                spotlightPlaceholder = text;
            }

            function getSpotlightPlaceholder() {
                return spotlightPlaceholder;
            }

            function setSpotlightToggleCtrlKey(key_code) {
                spotlightToggleCtrlKey = key_code;
            }

            function getSpotlightToggleCtrlKey() {
                return spotlightToggleCtrlKey;
            }

            return {
                setSearchInputInfoSearching: setSearchInputInfoSearching,
                getSearchInputInfoSearching: getSearchInputInfoSearching,
                setSearchInputInfoNoResults: setSearchInputInfoNoResults,
                getSearchInputInfoNoResults: getSearchInputInfoNoResults,
                setSpotlightPlaceholder: setSpotlightPlaceholder,
                getSpotlightPlaceholder: getSpotlightPlaceholder,
                setSpotlightToggleCtrlKey: setSpotlightToggleCtrlKey,
                getSpotlightToggleCtrlKey: getSpotlightToggleCtrlKey
            }
        }
    });

(function ($) {
    // jQuery autoGrowInput plugin by James Padolsey
    // See related thread: http://stackoverflow.com/questions/931207/is-there-a-jquery-autogrow-plugin-for-text-fields
    $.fn.autoGrowInput = function (o) {

        o = $.extend({
            maxWidth: 1000,
            minWidth: 0,
            comfortZone: 70
        }, o);

        this.filter('input:text').each(function () {
            var minWidth = o.minWidth || $(this).width(),
                val = '',
                input = $(this),
                testSubject = $('<tester/>').css({
                    position: 'absolute',
                    top: -9999,
                    left: -9999,
                    width: 'auto',
                    fontSize: input.css('fontSize'),
                    fontFamily: input.css('fontFamily'),
                    fontWeight: input.css('fontWeight'),
                    letterSpacing: input.css('letterSpacing'),
                    whiteSpace: 'nowrap'
                }),
                check = function () {

                    if (val === (val = input.val())) {
                        return;
                    }

                    // Enter new content into testSubject
                    var escaped = val.replace(/&/g, '&amp;').replace(/\s/g, '&nbsp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                    testSubject.html(escaped);

                    // Calculate new width + whether to change
                    var testerWidth = testSubject.width(),
                        newWidth = (testerWidth + o.comfortZone) >= minWidth ? testerWidth + o.comfortZone : minWidth,
                        currentWidth = input.width(),
                        isValidWidthChange = (newWidth < currentWidth && newWidth >= minWidth)
                            || (newWidth > minWidth && newWidth < o.maxWidth);

                    // Animate width
                    if (isValidWidthChange) {
                        input.width(newWidth);
                    }

                };

            testSubject.insertAfter(input);

            $(this).bind('keyup keydown blur update', check);

            check();
        });

        return this;

    };

})(jQuery);
angular.module('de.devjs.angular.spotlight', [])
    .directive('spotlightOverlay', ['$timeout', '$http', '$compile', 'AngularSpotlight', function ($timeout, $http, $compile, AngularSpotlight) {

        const KEY = {
            UP: 38,
            DOWN: 40,
            ESC: 27,
            ENTER: 13
        };

        var $ngSpotlightOverlay;

        return {
            restrict: 'E',
            replace: true,
            controller: controller(),
            link: link,
            templateUrl: 'spotlight/directive/spotlightOverlayTemplate.html'
        };

        function controller() {
            return ['$scope', function ($scope) {
                $scope.searchInputInfo = AngularSpotlight.getSearchInputInfoSearching();
                $scope.spotlightPlaceholder = AngularSpotlight.getSpotlightPlaceholder();

                $scope.search = function () {
                    if ($scope.searchTerm.length > 0) {
                        AngularSpotlight.search($scope.searchTerm)
                            .then(function setSearchResult(resp) {
                                $scope.searchResults = resp;
                                $scope.searchResultsCount = $scope.searchResults
                                    .map(function (category) {
                                        return category.items.length;
                                    })
                                    .reduce(function (prev, cur) {
                                        return prev + cur;
                                    }, 0);

                                setSearchInputInfo();
                                selectItemAtIndex(0);
                            });
                    }
                };

                $scope.getIconForType = function (type) {
                    return AngularSpotlight.getIconDescriptorForType(type);
                };

                $scope.showResultItem = function (categoryName, idx) {
                    var indexToSelect = 0;

                    for (var i = 0; i < $scope.searchResults.length; i++) {
                        if ($scope.searchResults[i].name !== categoryName) {
                            indexToSelect += $scope.searchResults[i].items.length;
                        } else {
                            break;
                        }
                    }

                    selectItemAtIndex(indexToSelect + idx);

                    $ngSpotlightOverlay
                        .find('input')
                        .focus()
                        .select();
                };

                /**
                 * Handle Keyboard events
                 * @param $event
                 */
                $scope.handleKeyDown = function ($event) {
                    switch ($event.keyCode) {
                        case KEY.UP:
                            $event.preventDefault();
                            selectPreviousEntry();
                            break;
                        case KEY.DOWN:
                            $event.preventDefault();
                            selectNextEntry();
                            break;
                        case KEY.ESC:
                            resetSearch();
                            break;
                        case KEY.ENTER:
                            $scope.openResultItem();
                            break;
                    }
                };

                $scope.openResultCategory = function () {
                    console.log($scope.selectedCategory);
                };

                $scope.openResultItem = function () {
                    if ($scope.selectedItem.href) {
                        window.location.href = $scope.selectedItem.href;
                        $ngSpotlightOverlay.hide();
                    }
                };

                function resetSearch() {
                    $scope.selectedItem = undefined;
                    $scope.searchResultsCount = 0;
                    $scope.searchResults = [];
                    $scope.searchInputInfo = undefined;
                    $scope.searchTerm = "";
                }

                function selectPreviousEntry() {
                    var idx = getSelectedItemIndex();
                    if (idx - 1 >= 0) {
                        selectItemAtIndex(idx - 1)
                    }
                }

                function selectNextEntry() {
                    var idx = getSelectedItemIndex();
                    if (idx + 1 < $scope.searchResultsCount) {
                        selectItemAtIndex(idx + 1);
                    }
                }

                function selectItemAtIndex(idx) {
                    var currentItemIndex = 0;
                    $scope.searchResults.forEach(function (category) {
                        if (category.items.length > 0) {
                            category.items.forEach(function (item) {
                                var isActive = currentItemIndex === (idx || 0);
                                item.active = isActive;
                                currentItemIndex++;

                                if (isActive) {
                                    $scope.selectedItem = item;
                                    $scope.selectedCategory = category;
                                    setSearchInputInfo(category.name);
                                }
                            });
                        }
                    });
                    $scope.selectedItemIndex = idx;
                }

                function setSearchInputInfo(categoryName) {
                    if ($scope.searchTerm.length === 0) {
                        $scope.searchInputInfo = AngularSpotlight.getSearchInputInfoSearching();
                    } else if ($scope.searchResultsCount === 0) {
                        $scope.searchInputInfo = AngularSpotlight.getSearchInputInfoNoResults();
                    } else if ($scope.selectedItem) {
                        $scope.searchInputInfo = $scope.selectedItem.name + " - " + categoryName;
                    }
                }

                function getSelectedItemIndex() {
                    return $scope.selectedItemIndex || 0;
                }

                $scope.$watch('selectedItemIndex', function () {
                    $timeout(function () {
                        if ($scope.selectedItemIndex !== undefined) {
                            keepItemVisible();
                        }
                    }, 100);
                });

                function keepItemVisible() {
                    var activeItem = $ngSpotlightOverlay.find('li.ng-spotlight-results-list-item.active');
                    var resultsList = $ngSpotlightOverlay.find('.ng-spotlight-results-list');

                    var activeItemTop = activeItem.position().top;
                    var activeItemBottom = activeItem.position().top + activeItem.outerHeight();
                    var parentsHeight = resultsList.height();
                    var currentScrollTop = resultsList.scrollTop();

                    if (parentsHeight - activeItemBottom < 0) {
                        resultsList.scrollTop(currentScrollTop + Math.abs(parentsHeight - activeItemBottom));
                    }
                    if (activeItemTop < 0) {
                        var padding = 0;
                        if (activeItem.parent().find('li').index(activeItem) === 0) {
                            padding = $('.ng-spotlight-results-list-header:first').outerHeight();
                        }
                        resultsList.scrollTop(currentScrollTop + activeItemTop - padding);
                    }
                }
            }];
        }

        function link(scope, element) {
            $ngSpotlightOverlay = $(element);

            $(document).on('click', '#buscaSistema', function (e) {
                e.stopPropagation();
                toggleOverlay();
            });

            $(document).on('keydown', function (e) {
                if (e.ctrlKey && e.keyCode === AngularSpotlight.getSpotlightToggleCtrlKey()) {
                    e.preventDefault();
                    toggleOverlay();
                }else if(e.keyCode === 27){
                    $ngSpotlightOverlay.hide();
                }
            });

            $(document).on('click', function (e) {
                if ($(e.target).closest('.ng-spotlight').length === 0) {
                    $ngSpotlightOverlay.hide();
                } else {
                    $ngSpotlightOverlay.find('input').focus();
                }
            });

            function toggleOverlay() {
                $ngSpotlightOverlay.toggle();

                if ($ngSpotlightOverlay.is(':visible')) {
                    $ngSpotlightOverlay.find('input').focus().select();
                }
            }

            $ngSpotlightOverlay
                .find('.ng-spotlight-input').autoGrowInput({
                maxWidth: 400,
                minWidth: 10,
                comfortZone: 15
            });
        }
    }]);
angular.module('de.devjs.angular.spotlight')
    .directive('spotlightDetails', ['$compile', 'AngularSpotlight', function ($compile, AngularSpotlight) {

        function link(scope, element) {
            scope.getContentUrl = function () {
                return scope.templateUrl;
            };

            scope.$watch('selectedItem', function () {
                if (scope.selectedItem) {
                    var templateForType = AngularSpotlight.getTemplateForType(scope.selectedItem.type);

                    if (templateIsFile(templateForType)) {
                        scope.templateUrl = templateForType;
                        templateForType = angular.element('<div ng-include="getContentUrl()"></div>');
                    }

                    element.html(templateForType).show();
                    $compile(element.contents())(scope);
                }
            });

            function templateIsFile(templateForType) {
                return new RegExp('\.html?$').test(templateForType);
            }
        }


        return {
            restrict: "E",
            link: link
        };
    }]);
angular.module('de.devjs.angular.spotlight').run(['$templateCache', function ($templateCache) {
    $templateCache.put('spotlight/directive/spotlightOverlayTemplate.html',
        "<div class=\"ng-spotlight ng-spotlight-overlay\" ng-keydown=\"handleKeyDown($event)\">\n    <div class=\"ng-spotlight-searchbar\">\n        <div class=\"ng-spotlight-icon\">\n            <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"  viewBox=\"0 0 283.753 284.51\" enable-background=\"new 0 0 283.753 284.51\" xml:space=\"preserve\">\n            <path d=\"M281.394,264.378l0.135-0.135L176.24,158.954c30.127-38.643,27.45-94.566-8.09-130.104\n\tc-38.467-38.467-100.833-38.467-139.3,0c-38.467,38.467-38.466,100.833,0,139.299c35.279,35.279,90.644,38.179,129.254,8.748\n\tl103.859,103.859c0.01,0.01,0.021,0.021,0.03,0.03l1.495,1.495l0.134-0.134c2.083,1.481,4.624,2.36,7.375,2.36\n\tc7.045,0,12.756-5.711,12.756-12.756C283.753,269.002,282.875,266.462,281.394,264.378z M47.388,149.612\n\tc-28.228-28.229-28.229-73.996,0-102.225c28.228-28.229,73.996-28.228,102.225,0.001c28.229,28.229,28.229,73.995,0,102.224\n\tC121.385,177.841,75.617,177.841,47.388,149.612z\"/>\n            </svg>\n        </div>\n\n        <input class=\"ng-spotlight-input\" ng-class=\"{'empty': searchTerm.length === 0}\" type=\"text\" placeholder=\"{{spotlightPlaceholder | translate}}\" ng-model=\"searchTerm\" ng-change=\"search()\" ng-model-options=\"{debounce: 250}\"/>\n\n        <div class=\"ng-spotlight-input-after\" ng-if=\"searchInputInfo.length > 0  && searchTerm.length > 0\">&mdash; {{searchInputInfo | translate}}</div>\n        <div class=\"ng-spotlight-results-icon\" ng-if=\"searchTerm.length > 0\">\n            <img ng-if=\"getIconForType(selectedItem.type).type == 'url'\" class=\"ng-spotlight-item-icon\" ng-src=\"{{getIconForType(selectedItem.type).data}}\" width=\"32\" height=\"32\">\n            <div ng-if=\"getIconForType(selectedItem.type).type == 'css'\" class=\"ng-spotlight-item-icon {{getIconForType(selectedItem.type).data}}\"></div>\n        </div>\n    </div>\n    <div class=\"ng-spotlight-results-panel\" ng-if=\"searchTerm && searchTerm.length > 0 && searchResultsCount > 0\" >\n        <div class=\"ng-spotlight-results-list\" ng-keydown=\"handleKeyDown($event)\">\n            <ul>\n                " +
        "<li class=\"ng-spotlight-results-category\" ng-repeat=\"searchResult in searchResults\" ng-dblclick=\"openResultCategory()\">\n                    " +
        "<div class=\"ng-spotlight-results-list-header\">{{searchResult.name}}</div>\n                    <ul>\n                        <li class=\"ng-spotlight-results-list-item\"\n                            " +
        "ng-repeat=\"resultItem in searchResult.items\"\n                            " +
        "ng-class=\"{'active': resultItem.active === true}\"\n                            " +
        "ng-click=\"showResultItem(searchResult.name, $index)\"\n                            " +
        "ng-dblclick=\"openResultItem()\">\n\n                            " +
        "<img ng-if=\"getIconForType(resultItem.type).type == 'url'\" class=\"ng-spotlight-item-icon\" ng-src=\"{{getIconForType(resultItem.type).data}}\">\n                            " +
        "<div ng-if=\"getIconForType(resultItem.type).type == 'css'\" class=\"ng-spotlight-item-icon {{getIconForType(resultItem.type).data}}\"></div>\n\n                            " +
        "{{resultItem.name}}\n\n                            <span class=\"info\" ng-if=\"resultItem.info\">\n                                &ndash; {{resultItem.info}}\n                            </span>\n                        </li>\n                    </ul>\n                </li>\n            </ul>\n        </div>\n        <div class=\"ng-spotlight-results-detail\">\n            <spotlight-details></spotlight-details>\n        </div>\n    </div>\n</div>");
}]);
angular.module('de.devjs.angular.spotlight').provider("AngularSpotlight", function () {
    var _iconConfig = iconConfig();
    var _detailsTemplateConfig = detailsTemplateConfig();
    var _defaultSpotlightConfig = defaultSpotlightConfig();

    // === LE PUBLIC API ====================
    return {
        search: function () {
            throw "You have to implement a search function using AngularSpotlightProvider!";
        },
        addIcons: _iconConfig.addIcons,
        addTemplates: _detailsTemplateConfig.addTemplates,
        setSearchInputInfoSearching: _defaultSpotlightConfig.setSearchInputInfoSearching,
        setSearchInputInfoNoResults: _defaultSpotlightConfig.setSearchInputInfoNoResults,
        setSpotlightPlaceholder: _defaultSpotlightConfig.setSpotlightPlaceholder,
        setSpotlightToggleCtrlKey: _defaultSpotlightConfig.setSpotlightToggleCtrlKey,
        $get: ['$http', '$q', function ($http, $q) {
            var that = this;
            return {
                search: that.search($http, $q),
                getIconDescriptorForType: _iconConfig.getIconForType,
                getTemplateForType: _detailsTemplateConfig.getTemplateForType,
                getSearchInputInfoSearching: _defaultSpotlightConfig.getSearchInputInfoSearching,
                getSearchInputInfoNoResults: _defaultSpotlightConfig.getSearchInputInfoNoResults,
                getSpotlightPlaceholder: _defaultSpotlightConfig.getSpotlightPlaceholder,
                getSpotlightToggleCtrlKey: _defaultSpotlightConfig.getSpotlightToggleCtrlKey
            };
        }]
    };

    // === LE HELPER ====================
    function iconConfig() {
        var icons = {
            'default': 'fa fa-sitemap'
        };

        function addIcons(iconDescriptors) {
            Object.keys(iconDescriptors)
                .forEach(function (iconKey) {
                    icons[iconKey.toLowerCase()] = iconDescriptors[iconKey];
                });
        }

        function getIconForType(type) {
            var icon = icons[(type || 'default').toLowerCase()] || icons['default'];

            return {
                data: icon,
                type: guessType(icon)
            };

            function guessType(icon) {
                var icon = icon.toLowerCase();
                if (icon.indexOf('http') === 0 || icon.indexOf('data:') === 0) {
                    return 'url';
                } else {
                    return 'css';
                }
            }
        }

        return {
            addIcons: addIcons,
            getIconForType: getIconForType
        }
    }

    function detailsTemplateConfig() {
        var detailsTemplates = {
            'default': '<div class="ng-spotlight-results-detail-default"><img ng-if="getIconForType(selectedItem.type).type == \'url\'" class="ng-spotlight-item-icon" ng-src="{{getIconForType(selectedItem.type).data}}" width="64" height="64"><div ng-if="getIconForType(selectedItem.type).type == \'css\'" class="ng-spotlight-item-icon {{getIconForType(selectedItem.type).data}}"></div><div class="name">{{selectedItem.name}}</div></div>'
        };

        function addTemplates(templateDescriptors) {
            Object.keys(templateDescriptors)
                .forEach(function (templateKey) {
                    detailsTemplates[templateKey.toLowerCase()] = templateDescriptors[templateKey];
                });
        }

        function getTemplateForType(type) {
            return detailsTemplates[(type || 'default').toLowerCase()] || detailsTemplates['default'];
        }

        return {
            addTemplates: addTemplates,
            getTemplateForType: getTemplateForType
        }
    }

    function defaultSpotlightConfig() {
        const KEY_SPACE = 32;
        var searchInputInfoSearching = 'Suchend ...';
        var searchInputInfoNoResults = 'Keine Ergebnisse';
        var spotlightPlaceholder = 'Spotlight-Suche';
        var spotlightToggleCtrlKey = KEY_SPACE;

        function setSearchInputInfoSearching(text) {
            searchInputInfoSearching = text;
        }

        function getSearchInputInfoSearching() {
            return searchInputInfoSearching;
        }

        function setSearchInputInfoNoResults(text) {
            searchInputInfoNoResults = text;
        }

        function getSearchInputInfoNoResults() {
            return searchInputInfoNoResults;
        }

        function setSpotlightPlaceholder(text) {
            spotlightPlaceholder = text;
        }

        function getSpotlightPlaceholder() {
            return spotlightPlaceholder;
        }

        function setSpotlightToggleCtrlKey(key_code) {
            spotlightToggleCtrlKey = key_code;
        }

        function getSpotlightToggleCtrlKey() {
            return spotlightToggleCtrlKey;
        }

        return {
            setSearchInputInfoSearching: setSearchInputInfoSearching,
            getSearchInputInfoSearching: getSearchInputInfoSearching,
            setSearchInputInfoNoResults: setSearchInputInfoNoResults,
            getSearchInputInfoNoResults: getSearchInputInfoNoResults,
            setSpotlightPlaceholder: setSpotlightPlaceholder,
            getSpotlightPlaceholder: getSpotlightPlaceholder,
            setSpotlightToggleCtrlKey: setSpotlightToggleCtrlKey,
            getSpotlightToggleCtrlKey: getSpotlightToggleCtrlKey
        }
    }
});

$(function() {
    var style = $('#angular-theme');

    $('.btn-theme').on('click', function(e) {
        e.stopPropagation();

        var theme = $(this).data('theme');
        var cssForTheme = getCssForTheme(theme);
        style.attr('href', cssForTheme.style);
        $('body').css('background-image', 'url(' + cssForTheme.background + ')')
    });

    function getCssForTheme(name) {
        var theme = {
            material: {
                style: 'css/materialTheme.min.css',
                background: 'img/materialBackground.png'
            },
            dark: {
                style: 'css/darkTheme.min.css',
                background: 'img/background.jpg'
            },
            light: {
                style: 'css/lightTheme.min.css',
                background: 'img/background.jpg'
            }
        };

        return theme[name] || theme['material'];
    }
});
(function () {
    angular.module('de.devjs.angular.spotlight.example', ['de.devjs.angular.spotlight'])
        .config(function configuration(AngularSpotlightProvider) {

            spotlightConfig();
            function spotlightConfig() {
                var toggleKey = 66; // Letter B
                AngularSpotlightProvider.setSearchInputInfoSearching("Searching ...");
                AngularSpotlightProvider.setSearchInputInfoNoResults("No Results");
                AngularSpotlightProvider.setSpotlightPlaceholder("Spotlight Search");
                AngularSpotlightProvider.setSpotlightToggleCtrlKey(toggleKey); // Ctrl + toggleKey
            }

            searchOrchestrationGithubWiki();

            function searchOrchestrationGithubWiki() {
                AngularSpotlightProvider.search = function ($http, $q) {
                    return function (term) {
                        var wikipedia = $http.jsonp('https://en.wikipedia.org/w/api.php?callback=JSON_CALLBACK&format=json&action=query&list=search&srsearch=' + term);

                        return $q.all([wikipedia])
                            .then(function (responses) {
                                var searchResults = [];

                                processWikiSearch(responses[0], searchResults);

                                return searchResults;
                            });

                        function processWikiSearch(resp, searchResults) {
                            if (resp.data.query) {
                                resp.data.query.search.forEach(function (result) {
                                    var resultItem = extractWikipediaData(result);
                                    var key = resultItem.name[0].toUpperCase();
                                    var category = searchResults.filter(function (result) {
                                        return result.name === key;
                                    })[0];

                                    if (category) {
                                        category.items.push(resultItem);
                                    } else {
                                        category = {name: key, items: []};
                                        category.items.push(resultItem);
                                        searchResults.push(category);
                                    }
                                });
                            }

                            function extractWikipediaData(result) {
                                return {
                                    name: result.title,
                                    description: jQuery('<div>' + result.snippet + '</div>').text(),
                                    timestamp: result.timestamp,
                                    size: result.size,
                                    wordcount: result.wordcount,
                                    type: 'wikipedia',
                                    href: '#/abc'
                                }
                            }
                        }
                    }
                };

                addCustomIcons();
                addCustomTemplates();
            }

            function addCustomTemplates() {
                AngularSpotlightProvider.addTemplates({
                    'wikipedia': 'templates/wikipedia.html',
                    'vcard': '<div class="ng-spotlight-results-detail-vcard">\
                                        <div class="profile-image"><span class="fa fa-user"></span></div>\
                                        <ul>\
                                            <li class="name">{{selectedItem.name}}</li>\
                                            <li ng-if="selectedItem.phone"><span class="fa fa-phone"></span> {{selectedItem.phone}}</li>\
                                            <li ng-if="selectedItem.email"><span class="fa fa-envelope"></span> {{selectedItem.email}}</li>\
                                            <li ng-if="selectedItem.fax"><span class="fa fa-print"></span> {{selectedItem.fax}}</li>\
                                            <li ng-if="selectedItem.www"><span class="fa fa-globe"></span> <a href="#" ng-href="{{selectedItem.www}}" target="_blank">{{selectedItem.www}}</a></li>\
                                        </ul>\
                                    </div>'
                });
            }

            function addCustomIcons() {
                AngularSpotlightProvider.addIcons({
                    'wikipedia': 'data:image/svg+xml;utf8,<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" width="32" height="32" id="svg2" version="1.1" inkscape:version="0.48.2 r9819" sodipodi:docname="wikipedia.svg" inkscape:export-xdpi="90" inkscape:export-ydpi="90"> <defs id="defs4"> <linearGradient id="linearGradient3806"> <stop id="stop3808" offset="0" style="stop-color:#f8f8f8;stop-opacity:1;" /> <stop id="stop3810" offset="1" style="stop-color:#f0f0f0;stop-opacity:1;" /> </linearGradient> <linearGradient inkscape:collect="always" xlink:href="#linearGradient3806" id="linearGradient3804" gradientUnits="userSpaceOnUse" x1="16" y1="1022.3622" x2="16" y2="1051.3622" /> </defs> <sodipodi:namedview id="base" pagecolor="#ffffff" bordercolor="#666666" borderopacity="1.0" inkscape:pageopacity="0.0" inkscape:pageshadow="2" inkscape:zoom="13.78438" inkscape:cx="14.323861" inkscape:cy="14.486647" inkscape:document-units="px" inkscape:current-layer="layer1" showgrid="false" inkscape:window-width="1021" inkscape:window-height="678" inkscape:window-x="190" inkscape:window-y="242" inkscape:window-maximized="0" inkscape:snap-bbox="true" inkscape:snap-bbox-edge-midpoints="true" showguides="true" inkscape:guide-bbox="true" /> <metadata id="metadata7"> <rdf:RDF> <cc:Work rdf:about=""> <dc:format>image/svg+xml</dc:format> <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" /> <dc:title /> </cc:Work> </rdf:RDF> </metadata> <g inkscape:label="Layer 1" inkscape:groupmode="layer" id="layer1" transform="translate(0,-1020.3622)"> <rect style="fill:#e8e8e8;fill-opacity:1;stroke:none" id="rect3796" width="32" height="32" x="0" y="1020.3622" rx="4" ry="4" /> <path id="path3798" d="M 16,1036.3622 1.15625,1051.206 c 0.723,0.723 1.73575,1.1562 2.84375,1.1562 l 24,0 c 1.108,0 2.12075,-0.4332 2.84375,-1.1562 L 16,1036.3622 z" style="fill:#d8d8d8;fill-opacity:1;stroke:none" inkscape:connector-curvature="0" /> <rect ry="3" rx="3" y="1021.3622" x="1" height="30" width="30" id="rect3800" style="fill:#ffffff;fill-opacity:1;stroke:none" /> <rect style="fill:url(#linearGradient3804);fill-opacity:1;stroke:none" id="rect3802" width="30" height="29" x="1" y="1022.3622" rx="3" ry="3" /> <g id="g2993" transform="matrix(0.21772207,0,0,0.21772207,4,1029.3577)"> <path id="path2995" d="m 42.980315,14.456693 c 0,0 -1.452756,-2.976378 -1.948819,-3.968504 C 37.700788,3.8976377 37.771654,3.543307 34.405512,3.0826771 33.448819,2.9763779 32.952756,2.8346456 32.952756,2.3740157 l 0,-2.09055114 0.283465,-0.21259842 c 6.094488,0 19.665354,0 19.665354,0 l 0.496063,0.17716535 0,2.09055111 c 0,0.46063 -0.318897,0.7086614 -1.027559,0.7086614 L 50.952756,3.2598425 C 47.338583,3.543307 47.940945,4.9960629 50.314961,9.7795274 L 73.02756,56.232283 73.807087,56.444881 93.968505,8.6102361 C 94.677166,6.6614172 94.570867,5.3149605 93.68504,4.4999999 92.76378,3.7204724 92.125985,3.2598425 89.787402,3.1535433 L 87.90945,3.047244 c -0.248032,0 -0.46063,-0.070866 -0.673229,-0.2480314 C 87.023623,2.6574803 86.917324,2.4803149 86.917324,2.2322834 l 0,-1.98425191 0.283464,-0.21259842 22.783462,0 0.24803,0.21259842 0,1.98425191 c 0,0.5314961 -0.31889,0.8149606 -0.92126,0.8149606 -3.01181,0.1417323 -5.20866,0.7795276 -6.62598,1.9488189 -1.45276,1.1338583 -2.58661,2.7637795 -3.366141,4.8543306 0,0 -18.531497,42.4133855 -24.874016,56.5157475 -2.444882,4.641732 -4.818898,4.216535 -6.944882,-0.141733 C 63.070867,57.118109 50.598426,29.374015 50.598426,29.374015 L 42.980315,14.456693 z" style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none" inkscape:connector-curvature="0" /> <path id="path2997" d="m 79.37008,0.03543307 c 0,0 -12.791339,-0.03543307 -18.496064,0 l -0.283464,0.21259842 0,1.98425191 c 0,0.2480315 0.106299,0.4251969 0.283464,0.6023622 0.212599,0.1417323 0.425197,0.2125984 0.673229,0.2125984 l 0.92126,0.1062993 c 2.338582,0.1062992 3.401574,0.7086614 3.720472,1.0984251 0.566929,0.6732284 0.814961,1.4173229 -0.531496,4.3582677 L 41.740158,56.303149 41.137796,56.161416 c 0,0 -17.149607,-36.141731 -22.110237,-48.2244082 -0.496063,-1.2401575 -0.744094,-2.1968504 -0.744094,-2.7637795 0,-1.2047244 1.098425,-1.8779528 3.330708,-1.984252 l 2.586615,-0.1062992 c 0.673228,0 1.027559,-0.2480315 1.027559,-0.8149606 l 0,-1.98425194 -0.248032,-0.17716535 c 0,0 -20.515748,-0.03543307 -24.7322835,0 L 0,0.28346456 0,2.3740157 C 0,2.7637795 0.46062993,2.9763779 1.4173228,3.0826771 4.0393701,3.2244094 5.7401575,3.6496062 6.5551182,4.3582676 7.4055119,5.031496 8.2559056,6.8031495 9.4251969,9.566929 15.625984,24.519685 28.877953,51.23622 35.326772,66.437007 c 1.84252,4.145669 4.181102,4.783464 7.015748,-0.141732 4.889764,-9.1063 18.177166,-36.885827 18.177166,-36.885827 L 71.007875,9.8503935 c 1.204724,-2.0905511 2.409449,-3.9330708 2.976378,-4.7834644 1.098425,-1.5590551 1.73622,-1.8779528 4.712598,-2.0196851 0.602362,0 0.92126,-0.2480314 0.92126,-0.8149606 l 0,-1.98425191 -0.248031,-0.21259842 z" style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none" inkscape:connector-curvature="0" /> </g> </g> </svg>',
                    'github': 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="438.5" height="438.5" viewBox="0 0 438.5 438.5" xml:space="preserve"><path d="M409.1 114.6c-19.6-33.6-46.2-60.2-79.8-79.8C295.7 15.2 259.1 5.4 219.3 5.4c-39.8 0-76.5 9.8-110.1 29.4 -33.6 19.6-60.2 46.2-79.8 79.8C9.8 148.2 0 184.9 0 224.6c0 47.8 13.9 90.7 41.8 128.9 27.9 38.2 63.9 64.6 108.1 79.2 5.1 1 8.9 0.3 11.4-2 2.5-2.3 3.7-5.1 3.7-8.6 0-0.6 0-5.7-0.1-15.4 -0.1-9.7-0.1-18.2-0.1-25.4l-6.6 1.1c-4.2 0.8-9.5 1.1-15.8 1 -6.4-0.1-13-0.8-19.8-2 -6.9-1.2-13.2-4.1-19.1-8.6 -5.9-4.5-10.1-10.3-12.6-17.6l-2.9-6.6c-1.9-4.4-4.9-9.2-9-14.6 -4.1-5.3-8.2-8.9-12.4-10.8l-2-1.4c-1.3-1-2.6-2.1-3.7-3.4 -1.1-1.3-2-2.7-2.6-4 -0.6-1.3-0.1-2.4 1.4-3.3 1.5-0.9 4.3-1.3 8.3-1.3l5.7 0.9c3.8 0.8 8.5 3 14.1 6.9 5.6 3.8 10.2 8.8 13.8 14.8 4.4 7.8 9.7 13.8 15.8 17.8 6.2 4.1 12.4 6.1 18.7 6.1 6.3 0 11.7-0.5 16.3-1.4 4.6-1 8.8-2.4 12.8-4.3 1.7-12.8 6.4-22.6 14-29.4 -10.8-1.1-20.6-2.9-29.3-5.1 -8.7-2.3-17.6-6-26.8-11.1 -9.2-5.1-16.9-11.5-23-19.1 -6.1-7.6-11.1-17.6-15-30 -3.9-12.4-5.9-26.6-5.9-42.8 0-23 7.5-42.6 22.6-58.8 -7-17.3-6.4-36.7 2-58.2 5.5-1.7 13.7-0.4 24.6 3.9 10.9 4.3 18.8 8 23.8 11 5 3 9.1 5.6 12.1 7.7 17.7-4.9 36-7.4 54.8-7.4s37.1 2.5 54.8 7.4l10.8-6.8c7.4-4.6 16.2-8.8 26.3-12.6 10.1-3.8 17.8-4.9 23.1-3.1 8.6 21.5 9.3 40.9 2.3 58.2 15 16.2 22.6 35.8 22.6 58.8 0 16.2-2 30.5-5.9 43 -3.9 12.5-8.9 22.5-15.1 30 -6.2 7.5-13.9 13.9-23.1 19 -9.2 5.1-18.2 8.9-26.8 11.1 -8.7 2.3-18.4 4-29.3 5.1 9.9 8.6 14.8 22.1 14.8 40.5v60.2c0 3.4 1.2 6.3 3.6 8.6 2.4 2.3 6.1 3 11.3 2 44.2-14.7 80.2-41.1 108.1-79.2 27.9-38.2 41.8-81.1 41.8-128.9C438.5 184.9 428.7 148.2 409.1 114.6z"></path></svg>',
                    'vcard': 'fa fa-user'
                });
            }
        });
})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Fullarm.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

angular.module("Fullarm").factory("AcaoUsuarioFactory", function(RequestFactory){
    return{
        inserirLogTentativaContato: function(objetoTentativaContato, s, e) {
            var URL  = '/api/v1/ocorrencias/contato/iniciar';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, objetoTentativaContato, s,e);
        },

        inserirLogFinalizarContato: function(objetoResultado, s, e) {
            var URL  = '/api/v1/ocorrencias/contato/finalizar';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, objetoResultado, s,e);
        },

        inserirLogAcaoUsuario: function(data, s, e) {
            var URL  = '/api/v1/ocorrencias/log/acao/usuario';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e);
        },
    };
});
angular.module('Fullarm').factory('AutomacaoFactory', function (RequestFactory) {
    return{
        enviarComandoDispositivo:function (param, s, e) {
            var URL  = '/api/v1/comando';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, param, s,e);
        }
    }
});
angular.module("Fullarm").factory("ChatFactory", function(RequestFactory, constant){

    return{
        enviarMenssagemPush:function(data, s, e) {
            var URL  = '/api/v1/ocorrencias/sistema/'+data.sistema+'/push/conversa/'+data.id_conversa;
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e);
        },

        salvarArquivoConversa:function(data, sistema, s, e) {
            var URL  = '/api/v1/ocorrencias/sistema/'+sistema+'/arquivo';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e);
        },

        bucaConversaPorId: function (id, sistema, s, e) {
            var URL  = '/api/v1/ocorrencias/sistema/'+sistema+'/chat/conversa/'+id+'/busca';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s,e);
        },

        bucaConversaPorIds: function (ids, sistema, s, e) {
            var URL  = '/api/v1/ocorrencias/sistema/'+sistema+'/chat/conversas/'+ids+'/busca';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s,e);
        },

        bucaConversasPorOcorrencia: function (id, s, e) {
            var URL  = '/api/v1/conversas/ocorrencia/'+id;
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s,e);
        },

        updateConfigChat:function(data, s, e){
            var URL  = '/api/v1/login-monitoramento-config/'+data.id;
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e);
        },

        adicionaParticipanteConversa:function(idConversa, s, e){
            var URL  = '/api/v1/conversa/grupo-conversa/add/'+idConversa;
            var METODO = "POST";
            RequestFactory.createRequest(URL, METODO, s,e);
        }


    };
});
angular.module("Fullarm").factory("ComentarioOcorrenciaFactory", function(RequestFactory){

    return{
        listarMensagemPadrao:function(s, e) {
            var URL  = '/api/v1/mensagem/busca_monitoramento';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

    };
});

angular.module("Fullarm").factory("EventoManualFactory", function(RequestFactory){

    return{
        gerarEventoManual:function (dados, s, e) {
            var URL  = '/api/v1/eventos/manual';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, dados , s,e);
        }
    };
});

angular.module("Fullarm").factory("GrupoAtendimentoFactory", function(RequestFactory){

    return{
        listarGrupoAtendimento:function(login, s, e){
            var URL  = '/api/v1/grupo-atendimento/busca/login/'+login;
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

        listarLoginsPorGruposAtendimento:function(grupos, s, e){
            var URL  = '/api/v1/grupo-atedimento/'+grupos+'/buscar';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },
    };
});

angular.module("Fullarm").factory("HistoricoEventosFactory", function($q, $http, RequestFactory){
    return{
        listarHistorico: function (id_sistema, limite, rastreados, s, e) {
            var URL  = rastreados ? '/api/v1/historico/eventos/rastreados/'+id_sistema+'/'+limite : '/api/v1/historico/eventos/'+id_sistema+'/'+limite;
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        }
    };
});

angular.module("Fullarm").factory("EdicaoSistemaFactory", function(RequestFactory, constant){

    return{
        getSistemaEdicao:function (idSistema, s, e) {
            var URL  = '/api/v1/ocorrencia/edicao/sistema/'+idSistema;
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s,e);
        },

        editarSistema:function (dados, s, e) {
            var URL  = '/api/v1/ocorrencia/editar/sistema/'+dados.idSistema;
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, dados, s,e);
        },

        iniciarManutencao: function (dados, sistema, s,e) {
            var URL = '/api/v1/sistema/'+sistema+'/manutencao/configurar';
            var METODO = 'POST';
            RequestFactory.createRequestWithParams(URL, METODO, dados, s,e);
        },

        prorrogarManutencao: function (dados, sistema, s,e) {
            var URL = '/api/v1/sistema/'+sistema+'/manutencao/prorrogar';
            var METODO = 'POST';
            RequestFactory.createRequestWithParams(URL, METODO, dados, s,e);
        },

        revogarManutencao: function (sistema, dados, s,e) {
            var URL = '/api/v1/sistema/' + sistema + '/manutencao/revogar';
            var METODO = 'POST';
            RequestFactory.createRequestWithParams(URL, METODO, dados, s,e);
        }

    };
});
angular.module("Fullarm").factory("LembreteFactory", function(RequestFactory){
        return{
            buscaOcorrenciasEmEspera: function (idLogin, s, e) {
                var URL  = '/api/v1/ocorrencias/em_espera/busca/login/'+idLogin;
                var METODO = "GET";
                RequestFactory.createRequest(URL, METODO, s,e)
            },
        }
});

angular.module("Fullarm").factory("LocalizacaoFactory", function(){
    return{
        getLocalizacao: function (objEvento, options) {

            window.open(options.url+'/localizacao/lat/'+objEvento.latitude+'/long/'+objEvento.longitude+'/descricao/'+objEvento.descricao+'',
                'popUpWindow',
                'height='+options.height+',' +
                'width='+options.width+',' +
                'left='+options.left+',' +
                'top='+options.top+',' +
                'resizable=yes,' +
                'scrollbars=yes,' +
                'toolbar=yes,' +
                'menubar=no,' +
                'location=no,' +
                'directories=no,' +
                'status=yes'
            );
        }
    };
});

angular.module("Fullarm").factory("LogDeErroFactory", function($http, RequestFactory){
    return{

        listarLogsDeErro:function(login_id, s, e){
            var URL  = '/api/v1/logs/mqtt/busca'+login_id;
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

        inserirLogDeErro:function (msg, s, e) {
            var URL  = '/api/v1/logs/mqtt';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, msg, s, e);
        }
    };
});

angular.module("Fullarm").factory("LogFactory", function(RequestFactory){
    return{
        listarLogsPorOcorrencia: function (idOcorrencia, offset, limit, s, e) {
            var URL  = '/api/v1/ocorrencias/busca/logs/'+idOcorrencia+'/'+offset+'/'+limit;
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s,e)
        },

        inserirMensagemLog: function(objetoLog, s, e) {
            var URL  = '/api/v1/ocorrencias/log';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, objetoLog, s,e);
        },

        enviarNotificacoesLog: function(objetoLog, s, e) {
            var URL  = '/api/v1/ocorrencia/log/notificacao';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, objetoLog, s,e);
        },

        enviarNotificacoesStatus: function(objetoStatus, s, e) {
            var URL  = '/api/v1/ocorrencia/status/notificacao';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, objetoStatus, s,e);
        },
    };
});
angular.module("Fullarm").factory("LoginFactory", function(RequestFactory){
    return{
        trocaUsuario: function (data, s, e) {
            var URL  = '/monitoramento/troca/usuario';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e)
        },

        deslogaUsuario: function (s, e) {
            var URL  = '/monitoramento/logout';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s,e)
        },

        checaLoginUsuario: function (data, s, e) {
            var URL  = '/monitoramento/logout/check';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e)
        },

        logaUsuario: function (data, s, e) {
            var URL  = '/monitoramento/login';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e)
        },

        buscarLoginsPorRotasDoSistema: function(id_sistema, s, e){
            var URL  = '/api/v1/sistema/'+id_sistema+'/rota/logins';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s,e)
        }

    };
});
angular.module("Fullarm").factory("OrdemServicoFactory", function($http, RequestFactory){
    return{

        listarProblemasOrdemServico:function(s, e){
            var URL  = '/api/v1/fullcontrol/buscar/problemas/';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

        cadastrarSolicitacaoOrdemDeServico:function (objOrdemServico, idSistema, s, e) {
            var URL  = '/api/v1/fullcontrol/'+idSistema+'/os/';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, objOrdemServico, s, e);
        }
    };
});

angular.module("Fullarm").factory("PainelFactory", function(RequestFactory){
    return{
        enviarComando:function (param, s,e) {
            var URL  = '/api/v1/comando';
            var METODO = "POST";
            var data = param;
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e);
        }
    };
});




angular.module("Fullarm").factory("MotivosAlarmeFactory", function(RequestFactory){

    return{

        listarMotivosAlarme:function(s, e){
            var URL  = '/api/v1/motivo-alarme/busca_monitoramento';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

        inserirlogMotivoAlarme:function (s, e, log) {
            var URL  = '/api/v1/ocorrencias/log';
            var METODO = "POST";
            var data = log;
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e);
        }

    };
});

angular.module("Fullarm").factory("OcorrenciasFactory", function($http, RequestFactory){
    return{

        listarOcorrencias:function(login_id, s, e){
            var URL  = '/api/v1/ocorrencias/busca/login/'+login_id;
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

        listarOcorrenciaPorId:function(idOcorrencia,s, e){
            var URL  = '/api/v1/ocorrencias/busca/'+idOcorrencia;
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

        listarOcorrenciasJson:function(login_id, s, e){
            $http.get('app/ocorrencias.json').then(function (ocorrencias) {

            });
        },

        listarNovaOcorrenciaPorId:function(idOcorrencia,s, e){
            var URL  = '/api/v1/ocorrencias/'+idOcorrencia+'/atualizacao';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

        cancelarSolicitacaoRonda: function (params, s, e) {
            var URL  = '/api/v1/ocorrencias/solicitacao/ronda/cancelar';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, params, s, e);
        },

        notificarTrocaDeStatus: function (params, s, e) {
            var URL  = '/api/v1/ocorrencia/status/notificacao';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, params, s, e);
        }
    };
});

angular.module("Fullarm").factory("PostergarHorarioFactory", function($http, RequestFactory){
    return{
        updateHorario:function(objPostergar, idSistema, s, e){
            var URL  = '/api/v1/sistema/'+idSistema+'/horario_ativo/'+objPostergar.id+'/postergar';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, objPostergar, s, e);
        },

    };
});
angular.module('Fullarm').factory('RastreadosFactory', function (RequestFactory, $http, constant, $q) {
        return{
            buscarPosicaoVeiculo:function(idVeiculo, $horas, s, e) {
                var URL  = '/api/v1/veiculo/'+ idVeiculo +'/posicoes/horas/' + $horas ;
                var METODO = "GET";
                RequestFactory.createRequest(URL, METODO, s, e);
            },
            buscarPosicaoVeiculoPorSistema:function(idSistema, s, e) {
                var URL  = '/api/v1/sistema/'+idSistema+'/veiculo/posicoes' ;
                var METODO = "GET";
                RequestFactory.createRequest(URL, METODO, s, e);
            },
            buscarEnderecoDoSistema:function(idSistema, s, e) {
                var URL  = '/api/v1/sistema/'+idSistema+'/endereco' ;
                var METODO = "GET";
                RequestFactory.createRequest(URL, METODO, s, e);
            },
            buscarEnderecoPorLatLong:function(lat,long, s, e) {
                var URL  = '/api/v1/endereco/latitude/'+lat+'/longitude/' + long ;
                var METODO = "GET";
                RequestFactory.createRequest(URL, METODO, s, e);
            },
            buscarPosicaoVeiculoPorSistemaV2:function(idSistema) {
                return $http({
                    url : constant.BASE_URL + '/api/v1/sistema/' + idSistema + '/veiculo/posicoes',
                    method : "GET",
                });
            },
            buscarEnderecoDoSistemaV2:function(idSistema) {
                return $http({
                    url : constant.BASE_URL + '/api/v1/sistema/' + idSistema + '/endereco',
                    method : "GET",
                });
            },
            buscarPosicaoTodosVeiculosEPosicaoSistema: function(idSistema){

                var deferred = $q.defer();
                $q.all([
                    this.buscarPosicaoVeiculoPorSistemaV2(idSistema),
                    this.buscarEnderecoDoSistemaV2(idSistema),
                ]).then(function(result){   
                    
                    deferred.resolve({
                        sistema: result[1].data,
                        veiculos:result[0].data
                    });
                }, function(error) {
                    deferred.reject( new Error('generic'));
                })

                return  deferred.promise;
            }

        };
});
angular.module('Fullarm').factory('ProvidenciasFactory', function (RequestFactory) {
    return{
        listaProvidenciasMonitoramento:function (s, e) {
            var URL  = '/api/v1/monitoramento/providencias/sft-monitoramento/busca';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s,e)
        },
    };
});
angular.module("Fullarm").factory("StatusFactory", function(RequestFactory){
    return{
        alterarStatusOcorrencia: function(objetoLog, s, e) {
            var URL  = '/api/v1/ocorrencias/status';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, objetoLog, s,e);
        },

        postergarObservacao: function (data, s, e) {
            var URL  = '/ocorrencias/'+data.id_ocorrencia+'/observacao/postergar';
            var METODO = "PUT";
            RequestFactory.createRequestWithParams(URL, METODO, data, s,e);
        },
    };
});
angular.module('Fullarm').factory('TrocaIdiomaFactory', function (RequestFactory) {
    return{
        alterarIdioma:function(idioma, s, e) {
            var data = {
                'idioma' : idioma
            };
            var URL  = '/api/v1/user/lang';
            var METODO = "POST";
            RequestFactory.createRequestWithParams(URL, METODO, data, s, e);
        },
    };
});



angular.module("Fullarm").factory("CameraFactory", function(RequestFactory){

    return{

        listarCamerasPorSistema: function (idSistema, s, e) {
            var URL  = '/api/v1/sistema/'+idSistema+'/cameras';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        }
    };
});

angular.module('Fullarm').service('encodeCamera', function () {

	var _arrayBufferToBase64 = function ( buffer ) {
		var binary = _arrayBufferToString( buffer );
		return window.btoa( binary );
	}

	var _arrayBufferToString = function ( buffer ) {
		var string = '';
		var bytes = new Uint8Array( buffer );
		var len = bytes.byteLength;
		for (var i = 0; i < len; i++) {
			string += String.fromCharCode( bytes[ i ] );
		}

		return string;
	}

	var _make_base_auth = function (user, password) { 
        var tok = user + ':' + password; 
        var hash = btoa(tok); 
        return "Basic " + hash; 
    }

	return {
		arrayBufferToBase64: _arrayBufferToBase64,
		arrayBufferToString: _arrayBufferToString,
		make_base_auth:      _make_base_auth
	}
});
angular.module('Fullarm').factory('VeiculosProximosFactory', function (RequestFactory) {
        return{
            buscarPosicaoVeiculo:function(idVeiculo, $horas, s, e) {
                var URL  = '/api/v1/veiculo/'+ idVeiculo +'/posicoes/horas/' + $horas ;
                var METODO = "GET";
                RequestFactory.createRequest(URL, METODO, s, e);
            },
            buscarPosicaoVeiculosProximosPorLatLong:function(latitude, longitude, s, e) {
                var URL  = '/api/v1/monitoramento/frota/latitude/'+latitude+'/longitude/'+longitude;
                var METODO = "GET";
                RequestFactory.createRequest(URL, METODO, s, e);
            },
            buscarEnderecoDoSistema:function(idSistema, s, e) {
                var URL  = '/api/v1/sistema/'+idSistema+'/endereco' ;
                var METODO = "GET";
                RequestFactory.createRequest(URL, METODO, s, e);
            },
            buscarEnderecoPorLatLong:function(lat,long, s, e) {
                var URL  = '/api/v1/endereco/latitude/'+lat+'/longitude/' + long ;
                var METODO = "GET";
                RequestFactory.createRequest(URL, METODO, s, e);
            },

        };
});
angular.module("Fullarm").factory("VideosHlsFactory", function(RequestFactory){

    return{

        listarCamerasOocorrencia: function (idSistema, tipoVideo, s, e) {
            var URL  = '/api/v1/ocorrencias/sistema/'+idSistema+'/cameras/tipo/'+tipoVideo;
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

        buscarHlsVideoPorId: function (videoHls, s, e) {

            var URL  = '/api/v1/camera-hls/'+videoHls.id;
            var METODO = "GET";
            if(videoHls.modelo == 29 || videoHls.modelo == 30){
                RequestFactory.createRequest(URL, METODO, s, e);
            }else{
                s({data : videoHls})
            }
        },

        buscarUltimaHoraDeGravacao: function (videoHls, s, e) {
            var URL  = '/api/v1/camera/'+videoHls.id_gravacao +'/gravacoes/ultimahora';
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

        setCamerasEmEstacao:function (id_login, id_sistema, id_ocorrencia, s, e) {
            var URL  = '/api/v1/login/'+id_login+'/cameras/sistema/'+id_sistema+'/ocorrencia/'+id_ocorrencia;
            var METODO = "POST";
            RequestFactory.createRequest(URL, METODO, s, e);
        },

        iniciaGravacaoPorIdSistemaEporOcorrencia:function(id_sistema, id_ocorrencia, s, e){
            var URL  = '/api/v1/sistema/'+id_sistema+'/ocorrencia/'+id_ocorrencia+'/camera/desktop/gravacoes';
            var METODO = "POST";
            RequestFactory.createRequest(URL, METODO, s, e);
        }


    };
});

angular.module('Fullarm').factory('ViaturasFactory', function (RequestFactory) {
    return{
        buscarViaturasPorLoginsDaRota:function(logins, lat, long, s, e) {
            var URL  = '/api/v1/viatura/logins/'+ logins +'/rota/lat/'+lat+'/long/'+long;
            var METODO = "GET";
            RequestFactory.createRequest(URL, METODO, s, e);
        }
    };
});

/**
 * @author Fullarm
 * created on 27.08.2018
 */
(function () {

    'use strict';
    angular.module('Fullarm').controller('ContatosController', function ($scope, OcorrenciaAtualService, ContatosService) {

        $scope.informaResultadoContato = function (mensagem, objContato, complemento, abrirWhatsapp) {
            objContato.mensagem = mensagem;
            objContato.complemento = angular.isUndefined(complemento) ? "" : complemento;
            objContato.id_ocorrencia = OcorrenciaAtualService.getIdOcorrenciaAtual();
            objContato.abrirWhatsapp = abrirWhatsapp || false;
            timeOutInserirResultadoContato(objContato);
        };

        $scope.tratarInclusaoTentativaContato = function (telefone) {
            $("#text_log").focus();
            timeOutInserirTentativaContato(telefone);
        };

        var timeOutInserirTentativaContato = (function () {
            'use strict';
            var timeWindow = 500;
            var timeout;
            var timeOutInserirTentativaContato = function (telefone) {
                ContatosService.inserirTentativaContato(OcorrenciaAtualService.getIdOcorrenciaAtual(), telefone.id, function(){
                    telefone.chamada_aberta = 1;
                });
            };
            return function(telefone) {
                var context = this;
                var args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function(){
                    timeOutInserirTentativaContato.apply(context, args);
                }, timeWindow);
            };
        }());

        var timeOutInserirResultadoContato = (function () {
            'use strict';
            var timeWindow = 500;
            var timeout;
            var timeOutInserirResultadoContato = function (objContato) {
                ContatosService.inserirResultadoContato(objContato,function(){
                    if ( objContato.abrirWhatsapp ){
                       objContato.telefones.map(function(telefone){
                            if( telefone.chamada_aberta == 1 && telefone.whatsapp){
                                var complemento = objContato.complemento || '';
                                window.open(`https://web.whatsapp.com/send?phone=${telefone.ddi}${telefone.numero}&text=${encodeURI(complemento)}`)
                            }
                           
                        })
                       
                    }
                   
                   
                });
            };
            return function(objContato) {
                var context = this;
                var args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function(){
                    timeOutInserirResultadoContato.apply(context, args);
                }, timeWindow);
            };
        }());

        $scope.mostrarWhatsappBtn = function(contato){
             var contatoComWhatsapp = contato.telefones.filter( function(telefone){
                return telefone.chamada_aberta == 1 && telefone.whatsapp
            })
            return contatoComWhatsapp.length > 0;
        }

    });
})();

/**
 * @author Fullarm
 * created on 27.08.2018
 */
(function () {

    'use strict';
    angular.module('Fullarm').controller('AnotacoesTemporariasController', function ($scope, $filter) {

        $('#modal-anotacao').iziModal({
            headerColor: '#26A69A',
            width: '50%',
            overlayColor: 'rgba(0, 0, 0, 0.5)',
            fullscreen: true,
            transitionIn: 'fadeInUp',
            transitionOut: 'fadeOutDown'
        });


        $scope.ampliaTextoAnotacao = function(objAnotacao){

            var pre_subtitle    = $filter('translate')('ocorrencias_modal_anotacoes_subtitle');
            var subtitle        = objAnotacao.data_expira;

            $("#corpo_modal_anotacao").html((objAnotacao.anotacao));
            $("#corpo_modal_anotacao_providencia").html((objAnotacao.providencia));
            $("#subititle_modal_anotacao").html(pre_subtitle+" "+subtitle);

            setTimeout(function () {
                $('#modal-anotacao').iziModal('open');
            }, 100);
        };
    });
})();
/**
 * @author Fullarm
 * created on 25.09.2019
 */
(function () {
    'use strict';

    angular.module('Fullarm').controller('AutomacaoController', function ($scope, AutomacaoService, $uibModal, constant, ToastMessageService) {
        $scope.permissaoComandoPortao = permissoes.enviar_comando_portao;
        $scope.permissaoComandoDispositivo = permissoes.enviar_comando_dispositivo;
        $scope.portaoAberto = false;
        $scope.tipo_pgm = constant.TIPO_PGM;
        $scope.comandos_pgm = constant.COMANDOS_PGM;
        $scope.comandos_sonoff = constant.COMANDOS_SONOFF;
        $scope.comandos_ewelink = constant.COMANDOS_EWELINK;

        $scope.acaoEnviarComandoDispositivo = function(comando, item){
            if(!item.permissao_enviar_comando){
                ToastMessageService.showWarningMenssageWebCenter("usuario_sem_permissao_comando");
                return;
            }
            AutomacaoService.enviaComandoDispositivo(comando, item)
        };

        $scope.enviarComandoPortao = function(itens){
            itens.id = itens.id_portao;
            AutomacaoService.enviaComandoDispositivo(itens.comando, itens);
            $scope.modalComandoAbrirPortao.close();
        };

        $scope.openModalComandoPortao = function (_id, _page, _comando, _permissao_enviar_comando) {
            if(!_permissao_enviar_comando){
                ToastMessageService.showWarningMenssageWebCenter("usuario_sem_permissao_comando");
                return;
            }
            $scope.itens = {
                id_portao: _id,
                comando: _comando,
                dispositivo:"portao"
            };
            $scope.modalComandoAbrirPortao = $uibModal.open({
                animation: true,
                templateUrl: _page,
                size: 'sm',
                scope:$scope,
                resolve: {
                    itens: function () {
                        return $scope.itens;
                    }
                }
            });
        };
    });
})();
(function () {
    'use strict';

    angular.module('Fullarm').controller('ModuloFullcondController', function ($scope,FullcondService) {
       $scope.openPopup = function(link){
           if(link){
            window.open (link, 'popup','toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=350,height=470');
           }
       }
    });

})();
angular.module("Fullarm").factory("FullcondFactory", function($q, $http,constant){

    function loadDefault(usuario, promise){
        usuario.fotoCarregada = true;
        promise.resolve("/assets/img/person.svg");
    }
    return{
        buscarContatosFullcondPorSistema:function(idSistema) {

            var deferred = $q.defer();

            $http({
                url : constant.BASE_URL + '/api/v1/ocorrencia/sistema/' + idSistema + '/fullcond/pessoas',
                method : "GET",
            }).then(function(resp){
                deferred.resolve(resp.data)
            }, function(e){
                deferred.reject(e)
            });

            return deferred.promise;
        },

        buscarFoto:function(usuario) {

            var deferred = $q.defer();

            if( usuario.uriFoto == null){
                loadDefault(usuario, deferred);
            } else{
            
                $http({
                    url : constant.BASE_URL + '/api/v1/ocorrencia/sistema/' + usuario.idSistema + '/fullcond/usuario/foto?uri=' + (usuario.uriFoto||''),
                    method : "GET",
                }).then(function(resp){

                   var data = resp.data;
                
                    if( data.foto_valida){
                        usuario.fotoCarregada = true;
                        deferred.resolve(data.foto)
                    }

                    loadDefault(usuario, deferred);
                    
                }, function(e){
                    loadDefault(usuario, deferred);
                });
            }

            return deferred.promise;
        }
    };
});

(function () {
    'use strict';

    
    angular.module('Fullarm').service('FullcondService', function (FullcondFactory,constant) {


        var _scope = {};
        var $this;
        return{
            setScope: function (scope) {
                $this = this;
                _scope = scope;
            },
            loadContacts: function(idSistema){

                _scope.moduloFullcondLoadindData = true
                _scope.moduloFullcondContatos = {
                    'interfones': [],
                    'usuarios': []
                }

                FullcondFactory.buscarContatosFullcondPorSistema(idSistema)
                .then(function(contatos){
                    const interfones = contatos.filter(function(contato){
                        return contato.tipo == constant.FULLCOND_TIPO.INTERFONE;
                    });

                    const usuarios = contatos
                    .filter(function(contato){
                        return contato.tipo == constant.FULLCOND_TIPO.PESSOA;
                    })
                    .map(function(usuario){
                        usuario.idSistema = idSistema;
                        usuario.foto = "/assets/img/person.svg";
                        usuario.fotoCarregada = false;
                        return usuario;
                    })

                    _scope.moduloFullcondContatos = {
                            'interfones': interfones,
                            'usuarios':usuarios
                    }
                    setTimeout(function(){
                        $this.loadFotos( _scope.moduloFullcondContatos.usuarios);
                    },500)
                    _scope.moduloFullcondLoadindData = false;
                }, function(){
                    _scope.moduloFullcondLoadindData = false;
                })
                
            },
            loadFotos: function(usuarios){

                angular.forEach(usuarios, function(usuario){
                    if( !usuario.fotoCarregada ){
                        FullcondFactory.buscarFoto(usuario)
                        .then(function(foto){
                            usuario.foto = foto;
                        })
                    }
                });
            }
        }
        
    });

})();

/**
 * @author Fullarm
 * created on 27.08.2018
 */
(function () {

    'use strict';
    angular.module('Fullarm').controller('InformacoesDoLocalController', function ($scope, EdicaoSistemaService) {

        $scope.loadingData = true;
        var idListener = 'informacoesDoLocal.' + $scope.screenLoadedId;
        
        $scope.sistemaEnderecoObservacao = "";
        $scope.sistemaEnderecoComplemento = "";

        $scope.setInfoSistema = function(idSistema){

            $scope.loadingData = true;

            $scope.idSistemaEdicao = idSistema;

            EdicaoSistemaService.buscarSistemaParaEdicao(idSistema, function (result) {

                $scope.sistemaEnderecoObservacao = result.data.observacao;
                $scope.sistemaEnderecoComplemento = result.data.complemento;

                $scope.loadingData = false;

                if( $scope.postLoadCallback ){
                    $scope.postLoadCallback(result.data)
                }
                
            }, function (error) {
                $scope.loadingData = false;
            });
        };

        $scope.editarInformacoesSistema = function(idSistema, observacao, complemento){

            var dados = {
                complemento: complemento,
                observacao: observacao,
                idSistema: idSistema
            };

            EdicaoSistemaService.editarInformacoesLocalSistema(dados).then(function(){

                if( $scope.postSaveCallback ){
                    $scope.postSaveCallback()
                }

                if($scope.createLog){
                    EdicaoSistemaService.insereLogPosAlteracaoSistema();
                }

            }, function () {

            });
        };

        $scope.formClose = function(){
            if ( $scope.formCloseCallback ){
                $scope.formCloseCallback();
            }
        };

        var unbind = $scope.$on(idListener + '.loadData', function(event, idSistema){
            $scope.setInfoSistema(idSistema);
        });

        $scope.$on('$destroy', unbind);

        
    });
})();
/**
 * @author Fullarm
 * created on 03.09.2018
 */
(function () {

    'use strict';
    angular.module('Fullarm').controller('MotivosAlarmeController', function ($scope, StatusService, MotivosAlarmeService, LogService, CarregamentoOcorrenciaService) {

        $scope.cancelarFinalizacao = function (){
            MotivosAlarmeService.exibirMotivosAlarme(false);
            LogService.exibeLog(true);
        };

        $scope.finalizarOcorrencia =  function (existeEventoTabelaHorario) {
            if(!existeEventoTabelaHorario){
                CarregamentoOcorrenciaService.finalizaOcorrencia();
                return;
            }
            MotivosAlarmeService.validaHorarios();
        };

        $scope.setarMotivoAlarme = function(motivo){
            MotivosAlarmeService.setMensagemMotivo(motivo);
        };

    });
})();

/**
 * @author Fullarm
 * created on 03.09.2018
 */
(function () {

    angular.module('Fullarm').controller('ProvidenciasController', function ($scope, $filter) {
        $('#modal-providencia').iziModal({
            headerColor: '#26A69A',
            width: '50%',
            overlayColor: 'rgba(0, 0, 0, 0.5)',
            fullscreen: true,
            transitionIn: 'fadeInUp',
            transitionOut: 'fadeOutDown'
        });

        $scope.ampliaProvidencia = function(text, tipo){

            var pre_subtitle    = $filter('translate')('ocorrencias_modal_providencias_subtitle');
            var subtitle        = $filter('translate')(tipo);

            $("#corpo_modal_providencia").html((text));
            $("#subititle_modal_providencia").html(pre_subtitle+" "+subtitle);

            setTimeout(function () {
                $('#modal-providencia').iziModal('open');
            }, 100);
        };

        //$("#modal-providencia").iziModal('setTitle',$filter('translate')('ocorrencia_label_providencias'));

    });
})();

/**
 * @author Fullarm
 * created on 27.08.2018
 */
(function () {

angular.module('Fullarm').controller('RastreadosController', function ($scope, RastreadosService, RastreadosFactory, OcorrenciaAtualService, $timeout, $uibModal, $window, $q) {

    $scope.qtdHorasSelecionada = 0;
    $scope.descricaoVeiculoSelecionado = '';
    $scope.todosVeiculosSelecionado = true;

    $scope.carregarVeiculoEspecifico = function (veiculo) {
        $scope.mostrarRastreadoSelecionado = true;
        $scope.todosVeiculosSelecionado = false;
        $scope.veiculoAtual = veiculo;
        $scope.rastreados = $scope.rastreados.map(function(rastreado){
            rastreado.selecionado = rastreado.id == veiculo.id;
            return rastreado;
        })
        $scope.buscarLocalizacaoPorIntervaloDeHoras(veiculo, 0);
    };

    $scope.ultimaPosicaoTodos = function () {
        $scope.mostrarRastreadoSelecionado = false;
        $scope.todosVeiculosSelecionado = true;
        $scope.rastreados = $scope.rastreados.map(function(rastreado){
            rastreado.selecionado = false;
            return rastreado;
        });

        buscarUltimaPosicaoDeVeiculos();
    };

    $scope.buscarLocalizacaoPorIntervaloDeHoras = function (veiculo, horas) {
        $scope.qtdHorasSelecionada = horas;
        RastreadosService.startSpinMapa();
        RastreadosFactory.buscarPosicaoVeiculo(veiculo.id,horas, function (data) {
            var posicoes = data.data;
            $scope.descricaoVeiculoSelecionado = posicoes.length > 0 ? posicoes[0].descricao : '';
            RastreadosService.setMarkersRotas(posicoes);
            RastreadosService.stopSpinMapa();
        },function (error) {
            RastreadosService.stopSpinMapa();
        });
    };

    $scope.getIconePorTipoRastreado = function(tipo){
        return RastreadosService.getIconePorTipoRastreado(tipo);
    }

    var buscarUltimaPosicaoDeVeiculos = function () {

        var idSistema = OcorrenciaAtualService.getSistema();
        var idSistemaIsValid = !angular.isUndefined(idSistema)
        
        if( idSistemaIsValid ){
            RastreadosService.startSpinMapa();
            RastreadosService.buscarUltimaPosicaoDeVeiculos(idSistema);
        }
    };


});
})();

/**
 * @author Fullarm
 * created on 31.08.2018
 */
(function () {
    'use strict';

    angular.module('Fullarm').controller('PainelController', function ($scope, PainelService, ToastMessageService, $uibModal, painelConstants) {
        var setoresInibir = [];
        var setoresCamerasInibir = [];
        var param = {};

        $scope.comandoSirene = 0;
        $scope.tempoAcionamento = $scope.painel.tempo_acionamento_sirene;
        $scope.exibeBotaoArmar = false;
        $scope.exibeBotaoArmarStay = false;
        $scope.exibeBotaoDesarmar = false;
        $scope.idPainelVirtualComando = "";
        $scope.modeloPainelVirtualComando = "";
        $scope.idPainelFisicoComando = "";
        $scope.setaPosteriorVisivel  = true;
        $scope.checagem = true;
        $scope.modeloCentralSelecionada = [];
        $scope.armeStay = false;
        $scope.modalLegenda = null;

        $(document).off('click', "#btnArmeSetoresAbertos");
        $(document).on('click', "#btnArmeSetoresAbertos", function(){
            $scope.checagem = false;
            if($('#rbInibirSetoresAbertos').prop('checked')){
                angular.forEach($scope.setoresAbertos, function (setor) {
                    setor.selected = true;
                    $scope.selecionarSetorParaInibir(setor)
                })
            }

            if($scope.armeStay){
                $scope.armarParticaoStay($scope.modeloCentral, $scope.fabricante);
            }else{
                $scope.armarParticao($scope.modeloCentral);
            }
            $scope.limpaVariaveisComando();
        });

        $(document).on('click', "#btnCancelarArmeSetoresAbertos", function(){
            $scope.limpaVariaveisComando();
        });


        $scope.getTotalPaineis = function(paineis){
            return Object.keys(paineis).length;
        }

        $scope.limpaVariaveisComando = function(){
            PainelService.fecharModalSetoresAbertos();
            $scope.checagem = true;
            setoresInibir = [];
            setoresCamerasInibir = [];
            PainelService.esvaziaSetoresAbertos();
        };

        $scope.rigthPainel = function(idAtual){
            var proximoId = $("#"+idAtual).next().attr('id');
            if(!angular.isUndefined(proximoId)){
                $scope.setaPosteriorVisivel = true;
                PainelService.setPainelAtual(proximoId);
            }else{
                $scope.setaPosteriorVisivel = false;
            }
        };

        $scope.leftPainel = function(idAtual){
            var idAnterior = $("#"+idAtual).prev().attr('id');
            if(!angular.isUndefined(idAnterior)){
                $scope.setaPosteriorVisivel = false;
                PainelService.setPainelAtual(idAnterior);
            }else{
                $scope.setaPosteriorVisivel = true;
            }
        };

        $scope.selecionarSetorParaInibir = function (setor) {
            var numero = setor.numero;
            
            if(setor.tipo_setor == 1 && setor.selected && !setoresInibir.includes(numero)){
                setoresInibir.push(numero);
            } 

            if(setor.tipo_setor == 1 && !setor.selected && setoresInibir.includes(numero)){
                setoresInibir = setoresInibir.filter(function(n){ return n != numero});
            } 
            
            if(setor.tipo_setor == 2 && setor.selected && !setoresCamerasInibir.includes(numero)) {
                setoresCamerasInibir.push(numero)
            }

            if(setor.tipo_setor == 2 && !setor.selected && setoresCamerasInibir.includes(numero)) {
                setoresCamerasInibir = setoresCamerasInibir.filter(function(n){ return n != numero});
            }
            
        };

        $scope.armarParticao = function(modeloCentral){
            $scope.armeStay = false;
            var inibirSetores = setoresInibir.length > 0 || setoresCamerasInibir.length > 0;
            param = {
                "idPainelVirtual": $scope.idPainelVirtualComando,
                "comando": $scope.verificaComandoArme(modeloCentral, inibirSetores , $scope.checagem)
            };
            if( inibirSetores ){
                param.setores = setoresInibir;
                param.setoresCameras = setoresCamerasInibir;
            }
            PainelService.enviarComandosParaPainel(param);
            $scope.esvaziaSetoresInibir();
            $scope.modalComandoPainel.close();
        };

        $scope.desarmarParticao = function(){
            param = {
                "idPainelVirtual": $scope.idPainelVirtualComando,
                "comando": 2
            };
            PainelService.enviarComandosParaPainel(param);
            $scope.esvaziaSetoresInibir();
            $scope.modalComandoPainel.close();
        };

        $scope.armarParticaoStay = function(modeloCentral, fabricante){
            $scope.armeStay = true;
            var inibirSetores = setoresInibir.length > 0 || setoresCamerasInibir.length > 0;
            param = {
                "idPainelVirtual": $scope.idPainelVirtualComando,
                "comando": $scope.verificaComandoArmeStay(modeloCentral, inibirSetores, fabricante, $scope.checagem)
            };
            if( inibirSetores ){
                param.setores = setoresInibir;
                param.setoresCameras = setoresCamerasInibir;
            }
            PainelService.enviarComandosParaPainel(param);
            $scope.esvaziaSetoresInibir();
            $scope.modalComandoPainel.close();
        };

        $scope.verificaComandoArme = function(modeloCentral, inibindo, checagem){

            if(modeloCentral && inibindo && modeloCentral.arme_inibindo_setores){
                return checagem ? painelConstants.Comandos.ARMAR_INIBINDO_SETORES : painelConstants.Comandos.ARMAR_INIBINDO_SETORES_SEM_CHECAGEM;
            }else {
                return checagem ? painelConstants.Comandos.ARMAR : painelConstants.Comandos.ARMAR_SEM_CHECAGEM
            }
        };

        $scope.verificaComandoArmeStay = function(modeloCentral, inibindo, fabricante, checagem){

            if(inibindo && modeloCentral.arme_inibindo_setores){
                return checagem ? painelConstants.Comandos.ARMAR_STAY_INIBINDO_SETORES : painelConstants.Comandos.ARMAR_STAY_INIBINDO_SETORES_SEM_CHECAGEM;
            }else{
                return checagem ? painelConstants.Comandos.ARMAR_STAY : painelConstants.Comandos.ARMAR_STAY_SEM_CHECAGEM;
            }
        };

        $scope.enviarComandoSirene = function(comando){
            if(comando == 56 && ($scope.tempoAcionamento <= 0 || $scope.tempoAcionamento == 0 || $scope.tempoAcionamento == "" || $scope.tempoAcionamento == null)){
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_label_tempo_acionamento_validacao');
                return;
            }
            var data = {
                "idPainel": $scope.idPainelFisicoComando,
                "comando": comando,
                "tempoAcionamento": comando == 56 ? $scope.tempoAcionamento : 0
            };

            PainelService.enviarComandosParaSirene(data, function(sucess){
                ToastMessageService.showSuccessMenssage(sucess.data.msg, "");
                PainelService.insereLogPosComandoSirene(data);
                if(comando == 56){
                    $scope.modalTempoAcionamento.close();
                }else{
                    $scope.modalComandoSirene.close();
                }
            }, function (error) {
                ToastMessageService.showErrorMenssage(error);
            });
        };

        $scope.preparaAberturaModalComandoPainel = function (pv) {
            if(!pv.permissao_enviar_comando){
                ToastMessageService.showWarningMenssageWebCenter("usuario_sem_permissao_comando");
                return;
            }
            $scope.idPainelVirtualComando = pv.id;
            $scope.modeloPainelVirtualComando = pv.painel.modelo;

            if(!pv.painel.conectado){
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_label_desconectado_validacao');
                return;
            }
            if(!$scope.permissao_enviar_comandos){
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_label_permissao_comando_validacao');
                return;
            }
            $scope.openModalComandoPainel(pv);
        };

        $scope.esvaziaSetoresInibir = function(){
            $('input:checkbox').attr('checked',false);
            setoresInibir = [];
            setoresCamerasInibir = [];
        };

        $scope.changeTempoAcionamento = function(tempo){
            $scope.tempoAcionamento = tempo;
        };

        $scope.openModalComandoPainel = function (pv) {
            $scope.statusParticaoModal = pv.armado;
            $scope.modeloCentral = pv.painel.comandos_disponiveis;
            if($scope.modeloCentral){
                $scope.modeloCentral.id = pv.painel.modelo;
                $scope.fabricante = pv.painel.fabricante;
                $scope.modalComandoPainel = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/pages/modals/comandoPainelModal.html',
                    size: 'sm',
                    scope:$scope
                });
            }
        };

        $scope.abrirLegenda = function () {
            $scope.modalLegenda = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/pages/InformacoesOcorrencia/Painel/legendas-setores.html',
                    size: 'lg',
                    scope:$scope
                })
        };

        $scope.fecharLegenda = function () {
            if($scope.modalLegenda){
                $scope.modalLegenda.close();
             }
          };

        $scope.openModalTempoAcionamento = function (pv) {
            var statusPainel = pv.painel.conectado;
            var idPainelFisico = pv.painel.id;

            $scope.idPainelFisicoComando = idPainelFisico;

            if(!pv.permissao_enviar_comando){
                ToastMessageService.showWarningMenssageWebCenter("usuario_sem_permissao_comando");
                return;
            }
            if(!statusPainel){
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_label_desconectado_validacao');
                return;
            }
            $scope.modalTempoAcionamento = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/modals/tempoAcionamentoModal.html',
                size: 'md',
                backdrop : 'static',
                scope:$scope
            });
        };

        $scope.openModalComandoSirene = function(pv){
            var statusPainel = pv.painel.conectado;
            var idPainelFisico = pv.painel.id;

            if(!pv.permissao_enviar_comando){
                ToastMessageService.showWarningMenssageWebCenter("usuario_sem_permissao_comando");
                return;
            }
            $scope.idPainelFisicoComando = idPainelFisico;
            if(!statusPainel){
                ToastMessageService.showWarningMenssageWebCenter('ocorrencia_label_desconectado_validacao');
                return;
            }
            $scope.modalComandoSirene = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/modals/desacionarSireneModal.html',
                size: 'sm',
                scope:$scope
            });
        };
    });
})();

/**
 * @author Fullarm
 * created on 20.03.2018
 */
(function () {
    'use strict';
    angular.module('Fullarm').controller('VideosFrameController', function ($scope, VideoFrameService, VideosService) {

        $scope.imagemCarregada = function (camera) {
            return camera.imagemCarregada = true;
        };

        $scope.setCamAtual = function(camera){
            VideosService.inserirLogVisualizacaoVideo(camera.descricao);
            VideoFrameService.setCamAtual(camera);
        };

        $scope.erroCarregarImagem = function (camera) {
            camera.thumb = "assets/img/fullarm/canBroker_FullArm.png";
            return camera.imagemCarregada = true;
        };
    });
})();



/**
 * @author Fullarm
 * created on 20.03.2018
 */
(function () {
    'use strict';
    angular.module('Fullarm').controller('VideosGenericController', function ($scope, VideosService) {

    });
})();



/**
 * @author Fullarm
 * created on 20.03.2018
 */
(function () {
    'use strict';
    angular.module('Fullarm').controller('VideosHlsController', function ($scope, VideosService) {

        $scope.playerReady = function (videoGular) {
            VideosService.setVideoGular(videoGular);
        };

        $scope.setTipoReproducao = function (tipoReproducao) {
            switch (tipoReproducao){
                case 1 :
                    VideosService.setVideoAovivo();
                    break;
                case 2 :
                    VideosService.buscarUltimaHoraDeGravacao();
                    break;
            }
        };

        $scope.changeSliderCallback = function (event) {
            VideosService.changeVideoGravacao(event.from);
        };

        $scope.onCompleteVideo = function() {
            VideosService.setProximoVideo();
        };

        $scope.setHlsCamInfo = function(hls) {
            VideosService.inserirLogVisualizacaoVideo(hls.descricao);
            VideosService.setHlsCamInfo(hls);
        };
    });
})();



/**
 * @author Fullarm
 * created on 27.08.2018
 */
(function () {

angular.module('Fullarm').controller('VeiculosProximosController', function ($scope, $filter, VeiculosProximosService) {
        $scope.mapaVeiculos = false;
        $scope.listaVeiculos = true;
        $scope.btnMapaLabel = "ocorrencias_label_ver_no_mapa";
        $scope.exibeAmpliarVeicProx = true;

        $scope.mudaBotaoMapaVeicProx = function (){
            $scope.exibeAmpliarVeicProx = !$scope.exibeAmpliarVeicProx;
            VeiculosProximosService.resizeMapa();
        };

        $scope.buscaMapaVaiculosProximos=function(){
            VeiculosProximosService.removeMapaVeiculosProximos();
            setTimeout(function(){
                VeiculosProximosService.setaPosicoesMapa();
            },1000);

        };

        $scope.alteraLayoutVeiculos = function(){
            if($scope.btnMapaLabel === "ocorrencias_label_ver_no_mapa"){
                $scope.btnMapaLabel = "ocorrencias_label_ver_na_lista";
                $scope.mapaVeiculos = true;
                $scope.listaVeiculos = false;
                $scope.buscaMapaVaiculosProximos();
            }else{
                $scope.btnMapaLabel = "ocorrencias_label_ver_no_mapa";
                $scope.mapaVeiculos = false;
                $scope.listaVeiculos = true;
            }
        };
});
})();

/**
 * @author Fullarm
 * created on 27.08.2018
 */
(function () {

angular.module('Fullarm').controller('FpatrolController', function ($scope, $filter, constant, OcorrenciasService, OcorrenciaAtualService, MapaService) {
        $scope.mostraMapaFpatrol = false;
        $scope.exibeAmpliarFpatrol = true;

        $scope.mudaBotaoAmpliar = function(){
            $scope.exibeAmpliarFpatrol = !$scope.exibeAmpliarFpatrol;
        };

        $scope.alteraLayoutFpatrol = function() {
            $scope.mostraMapaFpatrol = !$scope.mostraMapaFpatrol;
            MapaService.removeMap('leaflet-map-fpatrol');
            setTimeout(function () {
                if($scope.mostraMapaFpatrol){
                    MapaService.setMapPositions();
                    var buttonProps = {
                        id:'btnSolicitar_',
                        label: $filter('translate')('ocorrencia_label_solicitar_patrulha'),
                        class:'btn-solicitar-map',
                        action: $scope.enviarSolicitacao,
                        exibir: $scope.ocorrenciaAtual.status_ocorrencia == constant.STATUS.EM_ATENDIMENTO || $scope.ocorrenciaAtual.status_ocorrencia == constant.STATUS.RONDA_FINALIZADA
                    };
                    MapaService.setButtonProps(buttonProps);
                    MapaService.setButtonMapExists(true);
                }else{
                    MapaService.setButtonMapExists(false);
                }
            },100);
        };

        $scope.enviarSolicitacao = function(data, e){
            e.target.innerHTML = 'loading...';
            e.target.disabled = true;
            $scope.preparaAlteracaoStatusParaRonda(data.login_id);
        };

        $scope.preparaAlteracaoStatusParaRonda = function (login) {
            $("#btnsolicitar_"+login).text('loading...');
            $("#btnsolicitar_"+login).prop('disabled', true);
            OcorrenciasService.solicitarRonda(OcorrenciaAtualService.getIdOcorrenciaAtual(), login).then(function(){
                $("#btnsolicitar_"+login).text($filter('translate')('ocorrencia_label_solicitar_patrulha'));
                $("#btncancelar_"+login).prop('disabled', false);
                if($scope.mostraMapaFpatrol){
                    $scope.mostraMapaFpatrol = false;
                    MapaService.removeMap('leaflet-map-fpatrol');
                }
            });
        };

        $scope.preparaRetirarSolicitacaoRonda = function (login) {
            $("#btncancelar_"+login).text('loading...');
            $("#btncancelar_"+login).prop('disabled', true);
            OcorrenciasService.retirarSolicitacaoRonda(OcorrenciaAtualService.getIdOcorrenciaAtual(), login).then(function(){
                $("#btncancelar_"+login).text($filter('translate')('ocorrencia_label_cancelar_patrulha'));
                $("#btnsolicitar_"+login).prop('disabled', false);
            });
        };
});
})();
angular.module('Fullarm').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/ComentarioOcorrencia/comentarioOcorrencia.html','<div ba-panel="" ba-panel-title="{{\'ocorrencia_label_comentario_log\' | translate}}" ba-panel-class="viewportComentario with-scroll feed-panel"><div ng-controller="ComentarioOcorrenciaController"><textarea ng-disabled="!exibeComentarioOcorrencia" id="text_log" placeholder="{{\'ocorrencia_text_area_mensagem_padrao\' | translate}}" cols="40" ng-keypress="abrirModalMensagensPadrao($event)" class="form-control" ng-model="mensagemPadraoSelecionada">\n        </textarea><div><div class="checkbox"><label class="custom-checkbox" style="float: left; margin-left: 8px"><input id="mostrar_log_cliente" ng-disabled="!exibeBotoesLogCliente || !exibeComentarioOcorrencia" type="checkbox" ng-model="mostrarCliente"> <span>{{\'ocorrencia_botao_mostrar_log_cliente\' | translate}}</span></label> <label class="custom-checkbox" style="float: right; margin-right: 8px"><input id="push_log_cliente" ng-disabled="!exibeBotoesLogCliente || !exibeComentarioOcorrencia" type="checkbox" ng-checked="false" ng-model="pushCliente"> <span>{{\'ocorrencia_botao_push_log_cliente\' | translate}}</span></label></div></div><br><div id="modalMensagensPadrao" data-izimodal-title="{{\'ocorrencia_label_mensagem_padrao\' | translate}}"><select class="form-control" id="select_msg_padrao" ng-model="mySelectedValues" ng-options="msg.descricao for msg in mensagensPadrao"><option value=""></option></select></div><div><button id="btnInserirComentario" ng-disabled="!exibeComentarioOcorrencia" style="margin-left: 5px !important;" type="button" class="btn btn-default btnBlack" ng-click="tratarInclusaoDoComentario()">{{\'ocorrencia_botao_gerar_log\' | translate}}</button> <span class="btnLogFinalizar" ng-show="existeContatoEmAndamento" style="color: rgb(222, 83, 65);">{{\'ocorrencia_label_mensagem_chamada_aberta\' | translate}}</span></div></div></div>');
$templateCache.put('app/pages/HistoricoEventos/historicoEventos.html','<div ng-controller="HistoricoEventosController" id="divHistorico"><div class="table-responsive" id="tableHistoricoResponsive"><table class="table table-striped"><tr class="thCabecalhoGrid"><th>{{\'ocorrencia_label_codigo\' | translate}}</th><th ng-show="!exibeHistoricoRastreados">{{\'ocorrencia_label_setor\' | translate}}</th><th ng-show="exibeHistoricoRastreados"></th><th>{{\'ocorrencia_label_descricao\' | translate}}</th><th class="textAlineRight">{{\'ocorrencia_label_data_hora\' | translate}}</th></tr><tr ng-repeat="item in historicoEventos | orderBy: \'-data_hora_order\'"><td class="textAlineLeft">{{ item.dados.qualificador+\'\'+item.dados.codigo }}</td><td ng-show="!exibeHistoricoRastreados" align="left">{{ item.dados.argumento }}</td><td ng-show="exibeHistoricoRastreados" align="left"></td><td align="left"><div class="overflow-tip bluebox descricao-historico"><span>{{ item.chave_descricao }}</span></div></td><td align="right">{{ item.data_hora }}</td></tr><tr><td></td><td></td><td></td><td></td></tr></table></div><br><div class="col-lg-12"><div class="col-lg-6"><button ng-show="!exibeHistoricoRastreados && existeEventosRastreados && totalEventosPainel > 0" class="btn btn-default btnBlack" ng-click="buscarHistoricoPaginado(idSistema, 0, true)">{{\'ocorrencia_label_rastreados\' | translate}}</button> <button ng-show="exibeHistoricoRastreados && existeEventosRastreados && totalEventosPainel > 0" class="btn btn-default btnBlack" ng-click="buscarHistoricoPaginado(idSistema, 0, false)">{{\'ocorrencias_label_voltar\' | translate}}</button></div><div class="col-lg-6" style="padding-right: 7px !important;"><button id="BotaoMostrarMais" button-processing="" style="float: right; margin-left: 15px;" ng-show="exibeBotaoMostrarMais" class="btn btn-default btnBlack" ng-click="buscarHistoricoPaginado(idSistema, 5, exibeHistoricoRastreados)">{{\'ocorrencia_botao_mostrar_mais\' | translate}}</button> <button id="BotaoMostrarMenos" button-processing="" style="float: right" ng-show="exibeBotaoMostrarMenos" class="btn btn-default btnBlack" ng-click="buscarHistoricoPaginado(idSistema, 0, exibeHistoricoRastreados)">{{\'ocorrencia_botao_mostrar_menos\' | translate}}</button></div></div></div>');
$templateCache.put('app/pages/LogsOcorrencia/logsOcorrencia.html','<div id="div_log" ba-panel="" ba-panel-title="{{\'ocorrencia_label_logs_ocorrencia\' | translate}}" ba-panel-class="viewportLogs feed-panel" class="paddingRight0" ng-show="exibeLogsOcorrencia"><div id="preloader" class="preloader-log" ng-show="!$logsFinishedLoading"><div></div></div><div class="log-fixed" id="scroll_log" when-scrolled-log="carregarMais()" ng-controller="LogsOcorrenciaController"><div class="feed-message" ng-repeat="item in logsOcorrencia | orderBy: \'-data_hora_order\'"><div class="text-block text-message divLogsOcorrencia"><div class="message-header"><a title="{{\'ocorrencia_label_mostrar_localizacao\' | translate}}" ng-hide="(!item.localizacao.valido) || item.tipo_log != \'EVENTO\' && item.tipo_log != \'EVENTO_FULLTRACK\' && item.tipo_log != \'EVENTO_CAMERA\'" ng-click="abrirModalLocalizacao(item.localizacao)"><i class="fa fa-map-marker marker-log"></i></a> <a title="{{\'ocorrencia_label_local_nao_encontrado\' | translate}}" ng-show="(!item.localizacao.valido && item.localizacao.valido != null)"><i style="color: orangered !important;" class="fa fa-map-marker marker-log"></i></a> <span class="author" title="{{ item.mensagem.chave_descricao}}">{{ item.mensagem.chave_descricao | limitTo:50}} {{item.mensagem.chave_descricao.length > 50 ? \'...\' : \'\'}}</span> <a ng-click="ampliarTextoLog(item.mensagem.chave_descricao)"><u class="linkLerMais">{{item.mensagem.chave_descricao.length > 50 ? \'ocorrencia_label_ler_mais\' : \'\' | translate}}</u></a> <i ng-if="item.regra_exibicao.mostrar_icone_evento" class="fas fa-bell log-icon"></i> <i ng-if="item.regra_exibicao.mostrar_icone_log_usuario" class="fas fa-comment-dots log-icon"></i> <i ng-if="item.regra_exibicao.mostrar_icone_em_buffer" class="fas fa-layer-group log-icon"></i> <i ng-if="item.status === 2" class="fas fa-edit log-icon"></i> <i ng-if="item.status === 3" class="fas fa-user-clock log-icon"></i> <i ng-if="item.status === 5" class="fas fa-exchange-alt log-icon"></i> <i ng-if="item.status === 1" class="fas fa-desktop log-icon"></i> <i ng-if="item.status === 6" class="fas fa-car log-icon"></i> <i ng-if="item.status === 7" class="fas fa-route log-icon"></i> <i ng-if="item.status === 8" class="fas fa-map-pin log-icon"></i> <i ng-if="item.status === 9" class="fas fa-check-square log-icon"></i> <i style="cursor: pointer; margin-left: 7px;" ng-if="item.dados.tem_imagem" ng-click="abrirPopupWindow(item.dados)" class="fas fa-camera log-icon"></i> <i style="cursor: pointer; margin-left: 7px;" ng-if="item.tem_imagem_ronda" ng-click="abrirImagemRonda(item.imagem_ronda)" class="fas fa-camera log-icon"></i> <i style="cursor: pointer" ng-if="item.dados.tem_video" ng-click="abrirPopupWindowPreAlarme(item.dados)" class="fas fa-film log-icon"></i> <i style="cursor: pointer" ng-if="item.tipo_log === \'IMAGEM_DISPARO\'" ng-click="abrirImagemDisparo(item.dados)" class="fas fa-camera log-icon"></i> <i style="cursor: pointer" ng-if="item.tipo_log === \'VIDEO_PRE_ALARME\'" ng-click="abrirVideoPreAlarme(item.dados.url_video)" class="fas fa-film log-icon"></i></div><div class="message-time"><div class="post-time" ng-if="item.regra_exibicao.mostrar_operador_e_data_hora"><span>{{\'ocorrencia_label_operador\' | translate}}:</span><span class="operador-log">{{ item.mensagem.argumentos.desc_login | limitTo: limit_desc_login }} - {{item.data_hora}}</span></div><div class="post-time" ng-if="item.regra_exibicao.mostrar_somente_data_hora"><span>{{\'ocorrencia_label_data_hora\' | translate}}: <span class="operador-log">{{item.data_hora}}</span></span></div><div style="margin-top: 5px;" class="message-content line-clamp" ng-class="{\'line-clamp-1\' : true}"></div></div><div class="message-time" ng-if="item.tipo_log === \'LOG_USUARIO\' && item.mostrar_cliente"><div class="post-time"><span style="color: rgb(33, 150, 243)">{{\'ocorrencia_label_log_enviado_cliente\' | translate}}</span></div><div style="margin-top: 5px;" class="message-content line-clamp" ng-class="{\'line-clamp-1\' : true}"></div></div></div><div ng-if="item.regra_exibicao.mostar_imagem_regra_antiga"><u ng-click="abrirImagemDisparo(item.dados)" class="link_visualizar">{{\'ocorrencia_acao_visualizar\' | translate}}</u></div><div ng-if="item.regra_exibicao.mostar_imagem_regra_nova"><u ng-click="abrirPopupWindow(item.dados)" class="link_visualizar">{{\'ocorrencia_acao_visualizar\' | translate}}</u></div><div ng-if="item.regra_exibicao.mostar_video_regra_antiga"><u ng-click="abrirVideoPreAlarme(item.dados.url_video)" class="link_visualizar">{{\'ocorrencia_acao_visualizar\' | translate}}</u></div><div ng-if="item.regra_exibicao.mostar_video_regra_nova"><u ng-click="abrirPopupWindowPreAlarme(item.dados)" class="link_visualizar">{{\'ocorrencia_acao_visualizar\' | translate}}</u></div><div ng-if="item.tem_imagem_ronda"><u ng-click="abrirImagemRonda(item.imagem_ronda)" class="link_visualizar">{{\'ocorrencia_acao_visualizar\' | translate}}</u></div></div></div></div>');
$templateCache.put('app/pages/Monitoramento/chat.html','<div class="floating-chat" ng-show="exibeIconeChat" ng-controller="ChatController"><img id="load-image" ng-if="!mensagemCarregada" src="assets/img/progress_bar.gif" width="80" height="80" alt="Loading" class="loadMessage"> <i class="fa fa-comments" style="color: #2196f3; font-size: 40px !important;" aria-hidden="true"></i><div class="divUsers"><ul class="contacts"><li class="contact" ng-repeat="item in conversas" id="{{item.id_conversa}}" data-ng-style="idConversaClicada== item.id_conversa && {\'background-color\':\'rgb(48, 51, 58)\'}" ng-click="carregaConversaSelecionada(item.id_conversa, item.foto, item.nome, item.cliente_com_permissao)"><img id="imgLogin" ng-src="{{item.foto || \'assets/img/no_image.png\'}}" onerror="this.onerror=null;this.src=\'assets/img/no_image.png\';" style="cursor: default"> <strong id="login_descricao">{{item.nome}}<i style="font-size: 14px !important; position: absolute; right: 15px;" ng-class="{\'fa fa-car\':item.tipo_login_origem == 1, \'fa fa-user\': item.tipo_login_origem == 2}" title="{{item.tipo_login_origem == 1 ? \'ocorrencias_label_tipo_destinatario_fpatrol\' : \'ocorrencias_label_tipo_destinatario_cliente\' | translate }}"></i></strong><div id="not_{{item.id_conversa}}"></div></li></ul></div><div class="chat"><div class="header"><img src="{{imagemHeader}}" onerror="this.onerror=null; this.src=\'assets/img/no_image.png\';" ng-show="mostraCorpoMensagem"> <span class="title">{{mostraCorpoMensagem ? loginConversaAtual : ""}}</span> <button id="btnConfig" ng-click="openModalConfigChat()" type="button"><i id="iConfig" class="fa fa-cog"></i></button> <button id="btnClose" ng-click="minimizarChat()"><i id="iClose" class="fa fa-times" aria-hidden="true" ng-click="closeElement()"></i></button></div><div class="img-chat" ng-show="mostrarPreImagem"><header class="img-header"><button id="btnCloseImg"><i ng-click="fecharPreImagem()" id="iCloseImg" class="fa fa-times" aria-hidden="true" style="color: rgb(255, 255, 255);"></i></button> <span>{{\'ocorrencia_label_pre_visualizar\' | translate}}</span></header><div class="content-top body-img"><img class="pre-img" src="{{srcPremImg}}"></div><footer class="foot-img"><input type="text" id="taImagemChat" ng-model="textoImagem" autofocus="autofocus" class="text-box" placeholder="{{\'ocorrencia_label_adicionar_legenda\' | translate}}"> <button id="btnPreImagem" ng-click="enviarImagemMensagem()"><i style="font-size: 35px" class="ion ion-android-send green-icon"></i></button></footer></div><ul class="messages corpoChat" id="conteudo" ng-show="mostraCorpoMensagem"></ul><div class="footer corpoChat" ng-if="mostraCorpoMensagem"><div ng-style="{\'border\': $root.fundoIsLight ? \'1px black solid\' : \'none\' }" class="text-box" ng-model="texto" contenteditable="true" disabled="true" id="txb_{{ocorrenciaAtual.id_ocorrencia}}"></div><label style="cursor: pointer; margin-top: 10px;" for="file"><i class="fa fa-image btnsChat" ng-style="{\'color\': $root.fundoIsLight ? \'#000\' : \'#fff\' }"></i></label> <input style="display: none;" type="file" ng-model="file" name="file" id="file" base-sixty-four-input="" required="" onload="onLoad" accept="image/*"><ng-audio-recorder id="audioInput" audio-model="recordedInput" class="chatAudioRecord" time-limit="180"><div ng-if="recorder.isAvailable"><button ng-style="{\'color\': $root.fundoIsLight ? \'#000\' : \'#fff\'}" ng-click="recorder.startRecord()" ng-if="recorder.status.isRecording === false"><i class="fa fa-microphone"></i></button> <button id="btnStop" ng-click="recorder.stopRecord()" ng-if="recorder.status.isRecording === true"><i style="color:green" class="fa fa-microphone icon-gravando-audio"></i></button></div></ng-audio-recorder><button id="sendMessage" ng-click="enviarMensagemTexto()"><i class="fa fa-send" ng-style="{\'color\': fundoIsLight ? \'#000\' : \'#fff\' }"></i></button></div><div class="chat-desabilitadado" ng-if="mostraChatDesabilitado">{{\'ocorrencias_label_chat_desabilitado\' | translate}}</div></div></div><script src="app/theme/components/chat/chat.js"></script>');
$templateCache.put('app/pages/Monitoramento/monitoramento.html','<div id="preloader" ng-show="!$dadosFinishedLoading"><div></div></div><div class="layout-monitoramento"><div ng-include="\'app/theme/examples/index.html\'" include-replace=""></div><page-top></page-top><div class="lista-ocorrencias" ng-include="\'app/pages/Ocorrencias/ocorrencias_status.html\'"></div><div class="info-empresa-monitoramento" ng-show="exibirInformacoesOcorrencia"><div class="widgets" id="descricaoEmpresa"><div ba-panel=""><strong style="color: #999">{{\'ocorrencias_label_empresa\' | translate}}:</strong> <strong style="margin-right: 5px">{{ ocorrenciaAtual.sistema.desc_monitoramento != null ? ocorrenciaAtual.sistema.desc_monitoramento : \'ESTA\xC7\xC3O DE MONITORAMENTO\'}}</strong> <strong style="color: #999">{{\'ocorrencia_label_cliente\' | translate}}:</strong> <strong>{{ocorrenciaAtual.referencia_sistema != null ? ocorrenciaAtual.referencia_sistema + " / " : " "}} {{ ocorrenciaAtual.sistema.cliente.nome != null ? ocorrenciaAtual.sistema.cliente.nome + \' - \' : \'\'}}</strong> <label>{{ ocorrenciaAtual.sistema.endereco.endereco_extenso }}</label></div></div><div ng-include="\'app/pages/InformacoesOcorrencia/CabecalhoOcorrencia/cabecalhoOcorrencia.html\'" include-replace=""></div><div ng-include="\'app/pages/InformacoesOcorrencia/informacoesOcorrencia.html\'" include-replace=""></div></div><div class="anotacoes-temporarias" ng-show="exibirInformacoesOcorrencia"><div class="tabset-group"><div ba-panel="" ba-panel-class="tabs-panel feed-panel anotacao" ba-panel-title="{{\'ocorrencia_label_anotacoes\' | translate}}"><div ng-include="\'app/pages/InformacoesOcorrencia/AnotacoesTemporarias/anotacoesTemporarias.html\'"></div></div></div></div><div class="log-ocorrencia" ba-panel-class="feed-panel logs" ng-show="exibirInformacoesOcorrencia"><div ng-include="\'app/pages/ComentarioOcorrencia/comentarioOcorrencia.html\'"></div><div ng-include="\'app/pages/LogsOcorrencia/logsOcorrencia.html\'"></div><div ng-include="\'app/pages/InformacoesOcorrencia/MotivosAlarme/motivosAlarme.html\'"></div></div><div class="btn-info-monitoramento" ng-show="exibirInformacoesOcorrencia"><div class="tabset-group"><div ba-panel="" ba-panel-class="tabs-panel"><div class="div-botoes-inferior"><button id="btnAtenderOcorrencia" button-processing="" class="botoes-black botao" ng-style="{\'width\': existeTempoExecucao ? \'50%\' : \'100%\'}" ng-disable="!botao_atender" ng-class="{\'disabled\': !botao_atender}" ng-click="preparaAlteracaoStatusParaAtendimento()"></button> <button id="btnObservarOcorrencia" button-processing="" class="botoes-black botao" ng-disable="!botao_observar" ng-class="{\'disabled\': !botao_observar}" ng-click="preparaAlteracaoStatusParaObservacao()"><span>{{\'ocorrencia_acao_observar\' | translate}}</span></button> <button id="btnFinalizarOcorrencia" class="botao-finalizar botao" ng-disable="!botao_finalizar || ocorrenciaAtual.status_ocorrencia == 1" ng-class="{\'disabled\': !botao_finalizar || ocorrenciaAtual.status_ocorrencia == 1}" ng-click="preparaFinalizacaoOcorrencia()"><span>{{existeEventoTabelaHorario ? \'ocorrencia_label_postergar_finalizar\' : \'ocorrencia_botao_finalizar\' | translate}}</span></button></div></div></div></div><div id="modal-imagem-disparo" data-izimodal-group="group1" class="iziModal_options"><img id="imagem_disparo" width="100%" height="100%" src=""></div><div style="display:none;" id="modal-providencia" data-izimodal-fullscreen="true" data-izimodal-title="{{\'ocorrencia_label_providencias\' | translate}}"><div style="padding: 20px;"><p style="text-align: center; font-weight: bold" id="subititle_modal_providencia"></p><hr><span style="margin-left: 10px;" id="corpo_modal_providencia"></span><hr></div></div><div style="display:none;" id="modal-anotacao" data-izimodal-fullscreen="true" data-izimodal-title="{{\'ocorrencia_label_anotacoes\' | translate}}"><div style="padding: 20px;"><br><p style="color:floralwhite; text-align: center; font-weight: bold; font-size: 1.8vh !important" id="subititle_modal_anotacao"></p><hr><span id="label_anotacao" style="color:#FF9800; font-weight: bold;">{{\'ocorrencia_label_anotacao\' | translate}}:</span> <span id="corpo_modal_anotacao" style="color:floralwhite; text-align: justify">{{corpo_modal_anotacao}}</span><br><br><span id="label_anotacao_providencia" style="color:#FF9800; font-weight: bold;">{{\'ocorrencia_label_anotacao_providencia\' | translate}}:</span> <span id="corpo_modal_anotacao_providencia" style="color:floralwhite; text-align: justify"></span><hr></div></div><div style="display:none;" id="modal-log" data-izimodal-fullscreen="true"><div style="padding: 20px;"><p style="text-align: center; color:floralwhite; font-weight: bold" id="subititle_modal_log"></p><hr><p style="margin-left: 10px; color:floralwhite;" id="corpo_modal_log"></p><hr></div></div><div id="modal-postergar" style="display: none" data-izimodal-fullscreen="true"><fieldset class="scheduler-border"><legend class="scheduler-border" id="legendTitle"></legend><div class="control-group"><span id="span_horario"></span> <label style="margin-left: 25px;" id="lblTolerancia"></label><span id="span_tolerancia"></span></div></fieldset><label id="lbl_postergar_para"></label><div class="input-group date" id="datetimepicker3"><input type="time" id="hora_postergar" class="form-control"> <span class="input-group-addon" style="padding: 6px 12px;"><span class="glyphicon glyphicon-time" style="top: 3px; left: -7px;"></span></span></div><br><label>{{\'ocorrencia_label_comentario\' | translate}}:</label> <textarea id="comentario_postergar" cols="40" class="form-control"></textarea><br><button type="button" class="btn btn-default btnBlack floatRigth" id="btnPostergarHorario">{{\'ocorrencia_label_postergar\' | translate}}</button></div><div id="modal-descricao-evento" style="display: none" data-izimodal-fullscreen="false" data-izimodal-title="{{\'ocorrencia_label_evento_manual\' | translate}}"><label>{{\'ocorrencia_label_descricao\' | translate}}:</label><div class="input-group date"><input placeholder="{{\'ocorrencia_label_evento_manual\' | translate}}" type="text" id="descricao_evento" class="form-control"></div><div class="buttons-desc-evento"><button type="button" class="btn btn-default btnBlack floatRigth" id="btnEnviarEventoManual" style="margin-left: 10px;">{{\'ocorrencia_label_confirmar\' | translate}}</button> <button type="button" class="btn btn-default btnBlack floatRigth" id="btnCancelarEventoManual">{{\'ocorrencia_botao_cancelar\' | translate}}</button></div></div><div id="modal-troca-usuario" style="display: none; position:fixed;top:-60%;bottom:0;left:0;right:-70%;margin:auto; height: 250px !important;" data-izimodal-fullscreen="false" data-izimodal-title="{{\'ocorrencias_modal_troca_usuario_title\' | translate}}"><div style="padding: 5%; height: 200px;"><label>Login:</label> <input id="login" type="text" class="form-control"><br><label>{{\'ocorrencia_label_senha\' | translate}}:</label> <input id="password" type="password" class="form-control"><br><button style="display: none" type="button" class="btn btn-default btnBlack floatRigth" id="btnTrocarUsuario">{{\'ocorrencia_label_trocar_usuario\' | translate}}</button> <button style="display: none" type="button" class="btn btn-default btnBlack floatRigth" id="btnLogout">{{\'ocorrencia_label_sair\' | translate}}</button></div></div><div uib-dropdown-menu="" style="display: none; bottom: auto; left: auto" class="top-dropdown-menu" id="modal-troca-idioma"><div class="msg-list"><a class="clearfix" style="cursor: pointer" id="portugues" ng-if="$root.idiomaAtual != \'pt-BR\'"><div class="img-area"><img style="border-radius: 0" ng-class="\'photo-msg-item\'" src="../../../../assets/img/pt-BR_novo.png"></div><div class="msg-area" style="padding-top: 5%"><div class="idioma-desc"><strong>{{\'ocorrencia_label_idioma_portugues\' | translate}}</strong></div></div></a> <a class="clearfix" style="cursor: pointer" id="espanhol" ng-if="idiomaAtual != \'es\'"><div class="img-area"><img style="border-radius: 0" ng-class="\'photo-msg-item\'" src="../../../../assets/img/es_novo.png"></div><div class="msg-area" style="padding-top: 5%"><div class="idioma-desc"><strong>{{\'ocorrencia_label_idioma_espanhol\' | translate}}</strong></div></div></a> <a class="clearfix" style="cursor: pointer" id="ingles" ng-if="idiomaAtual != \'en\'"><div class="img-area"><img style="border-radius: 0" ng-class="\'photo-msg-item\'" src="../../../../assets/img/en_novo.png"></div><div class="msg-area" style="padding-top: 5%"><div class="idioma-desc"><strong>{{\'ocorrencia_label_idioma_ingles\' | translate}}</strong></div></div></a></div></div><div id="modal-lembrete"><div id="lembrete"></div></div><div id="modal-legenda_tecla_atalho" style="display: none;" data-izimodal-fullscreen="false" data-izimodal-title="{{\'ocorrencia_label_teclas_atalho\' | translate}}"><div style="padding: 5px" class="legendas_teclas_atalho"><fieldset style="width: 98.5%; float: left"><legend><b>{{\'ocorrencia_label_configuracao\' | translate}}</b></legend><table class="table-atalho-atendimentos" style="width: 69%"><tr><td>{{\'ocorrencia_label_teclas_atalho\' | translate}}:</td><td align="center"><input id="rbTeclaAtalhoAtivo" data-on="{{\'ocorrencia_label_habilitado\' | translate}}" data-off="{{\'ocorrencia_label_desabilitado\' | translate}}" type="checkbox" data-toggle="toggle" data-width="30" data-height="30" data-style="slow"></td></tr><tr><td>{{\'ocorrencia_label_carregamento_ocorrencia\' | translate}}:</td><td align="center"><input id="rbCarregamentoOcorrencia" data-on="{{\'ocorrencia_label_habilitado\' | translate}}" data-off="{{\'ocorrencia_label_desabilitado\' | translate}}" type="checkbox" data-toggle="toggle" data-width="30" data-height="30" data-style="slow"></td></tr><tr><td>{{\'ocorrencia_label_carregamento_finalizar\' | translate}}:</td><td align="center"><input id="rbBotaoFinalizarAtivo" data-on="{{\'ocorrencia_label_habilitado\' | translate}}" data-off="{{\'ocorrencia_label_desabilitado\' | translate}}" type="checkbox" data-toggle="toggle" data-width="30" data-height="30" data-style="slow"></td></tr></table></fieldset><fieldset style="width: 20.5%; height: 134px; float: left"><legend><b>{{\'ocorrencia_label_menu_usuario\' | translate}}</b></legend><table class="table-atalho-atendimentos"><tr><td width="65%">{{plataforma}}:</td><td align="left">ALT+HOME</td></tr><tr><td>{{\'ocorrencia_label_teclas_atalho\' | translate}}:</td><td align="left">ALT+ENTER</td></tr><tr><td>{{\'ocorrencia_label_trocar_usuario\' | translate}}:</td><td align="left">ALT+PgDn</td></tr><tr><td>{{\'ocorrencia_label_sair\' | translate}}:</td><td align="left">ALT+END</td></tr></table></fieldset><fieldset style="width: 20.5%; height: 134px; float: left"><legend><b>{{\'ocorrencia_label_botoes_atendimento\' | translate}}</b></legend><table class="table-atalho-atendimentos"><tr><td>{{\'ocorrencia_acao_atender\' | translate}}:</td><td align="center">CTRL+A</td></tr><tr><td>{{\'ocorrencia_acao_observar\' | translate}}:</td><td align="center">CTRL+O</td></tr><tr><td>{{\'ocorrencia_acao_finalizar\' | translate}}:</td><td align="center">CTRL+S</td></tr><tr><td></td><td></td></tr></table></fieldset><fieldset style="width: 56%; height: 134px; float: left"><legend><b>Status</b></legend><table class="table-atalho-atendimentos"><tr><td>{{\'ocorrencia_status_novos\' | translate}}:</td><td align="center">SHIFT+F1</td><td>{{\'ocorrencia_status_ronda_no_local\' | translate}}:</td><td align="center">SHIFT+F6</td></tr><tr><td>{{\'ocorrencia_status_em_atendimento\' | translate}}:</td><td align="center">SHIFT+F2</td><td>{{\'ocorrencia_status_ronda_finalizada\' | translate}}:</td><td align="center">SHIFT+F7</td></tr><tr><td>{{\'ocorrencia_status_aguardando_ronda\' | translate}}:</td><td align="center">SHIFT+F4</td><td>{{\'ocorrencia_status_em_observacao\' | translate}}:</td><td align="center">SHIFT+F8</td></tr><tr><td>{{\'ocorrencia_status_roda_a_caminho\' | translate}}:</td><td align="center">SHIFT+F5</td></tr></table></fieldset><fieldset style="width: 98.5%;"><legend><b>{{\'ocorrencia_label_outros_atalhos\' | translate}}</b></legend><table class="table-atalho-atendimentos"><tr><td width="5%"><i class="fas fa-arrow-up"></i></td><td width="45%">Up:</td><td>{{\'ocorrencia_label_ocorrencia_anteior\' | translate}}</td></tr><tr><td width="5%"><i class="fas fa-arrow-down"></i></td><td width="45%">Down:</td><td>{{\'ocorrencia_label_proxima_ocorrencia\' | translate}}</td></tr><tr><td width="5%"><i class="fas fa-arrow-left"></i></td><td width="45%">Left:</td><td>{{\'ocorrencia_label_aba_esquerda\' | translate}}</td></tr><tr><td width="5%"><i class="fas fa-arrow-right"></i></td><td width="45%">Rigth:</td><td>{{\'ocorrencia_label_aba_direita\' | translate}}</td></tr><tr><td width="5%"><i class="fas fa-exchange-alt"></i></td><td width="45%">Tab:</td><td>{{\'ocorrencia_label_ir_para_comentario\' | translate}}</td></tr><tr><td width="5%"><i class="fas fa-level-down-alt fa-rotate-90"></i></td><td width="45%">{{\'ocorrencia_label_enter_comentario\' | translate}}:</td><td>{{\'ocorrencia_label_insere_comentario\' | translate}}</td></tr><tr><td width="5%"><i class="fas fa-level-down-alt fa-rotate-90"></i></td><td width="45%">{{\'ocorrencia_label_enter_tela_finalizacao\' | translate}}:</td><td>{{\'ocorrencia_label_finaliza_ou_cancela\' | translate}}</td></tr><tr><td width="5%" style="padding-right: 5px;"><i style="font-size: 8px;" class="fas fa-arrow-left"></i><i style="font-size: 8px" class="fas fa-arrow-right"></i></td><td width="45%">{{\'ocorrencia_label_left_rigth_finalizacao\' | translate}}:</td><td>{{\'ocorrencia_label_botoes_cancelar_finalizar\' | translate}}</td></tr></table></fieldset></div></div><div id="modal-comando-portao" style="display: none; background-color: white !important; text-align: center"><button id="btnAbrirPortalModal" class="btn btn-default" style="border: none !important;"><img alt="" class="portao" src="assets/img/aberto.png"><p style="color: green">{{\'ocorrencia_label_abrir\' | translate}}</p></button> <button id="btnFecharPortalModal" class="btn btn-default" style="border: none !important;"><img alt="" class="portao" src="assets/img/fechado.png"><p style="color:red">{{\'ocorrencia_label_fechar\' | translate}}</p></button></div><div id="modal-tempo-acionamento" style="display: none" data-izimodal-fullscreen="true" data-izimodal-title="{{\'ocorrencia_label_acionamento_sirene\' | translate}}"><fieldset class="scheduler-border"><legend class="scheduler-border">{{\'ocorrencia_label_tempo_acionamento\' | translate}}</legend><div class="control-group"><div class="col-lg-12"><div class="col-lg-4"><input id="tempo_acionamento" class="form-control" type="number" min="1"></div><div class="col-lg-2"><button style="margin-left: 15px" type="button" class="btn btn-default btnBlack" id="btnEnviarComandoSirene">{{\'ocorrencia_label_enviar\' | translate}}</button></div></div></div></fieldset></div><div id="modal-comando-sirene" style="display: none; background-color: #eeeeee !important; text-align: center"><button id="btnDesacionarSirene" class="btn btn-default" style="border: none !important;"><i style="font-size: 35px" class="icon ion-speakerphone icones-ion gray-icon"></i><p style="color: gray">{{\'Desligar Sirene\' | translate}}</p></button></div><div id="modal-comando-painel" style="display: none; background-color: #eeeeee !important; text-align: center"><button id="btnArmarPainel" class="btn btn-default" style="border: none !important;"><i style="font-size: 35px; color:red" class="icon ion-locked icones-ion"></i><p style="color: red">{{\'ocorrencia_botao_armar_painel\' | translate}}</p></button> <button id="btnArmarStay" class="btn btn-default" style="border: none !important;"><i style="font-size: 35px; color:#ffc900" class="icon ion-locked icones-ion"></i><p style="color: #ffc900">{{\'ocorrencia_botao_armar_painel_stay\' | translate}}</p></button> <button id="btnDesarmarPainel" class="btn btn-default" style="border: none !important;"><i style="font-size: 35px; color:green" class="icon ion-locked icones-ion"></i><p style="color: green">{{\'ocorrencia_botao_desarmar_painel\' | translate}}</p></button></div><div ng-include="\'app/pages/Monitoramento/chat.html\'"></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/informacoesOcorrencia.html','<div ng-controller="InformacoesOcorrenciaController" id="info_ocorrencias"><div id="informacoesOcorrenciaGeral" ba-panel="" ba-panel-class="tabs-panel tabsInformacoes"><div class="panel-heading"><ul class="nav nav-tabs"><li ng-repeat="(key, tab) in ocorrenciaTabs" class="{{tab.classe}} infos" ng-if="tab.exibir" id="tab_{{tab.id}}"><a style="cursor: pointer" data-target="#corpo_tab_{{tab.id}}" data-toggle="tab" ng-click="acaoTabSelecionada(tab.id, key)">{{tab.titulo}}</a></li></ul></div><div class="geral panel-body"><div class="tab-content"><div ng-repeat="(key, tab) in ocorrenciaTabs" id="corpo_tab_{{tab.id}}" ng-if="tab.exibir" class="{{tab.classe_corpo}}"><div ng-include="tab.caminho" ng-dynamic-controller="tab.controller" include-replace=""></div></div></div></div></div></div>');
$templateCache.put('app/pages/modals/advertenciasModal.html','<div class="modal-content"><div class="modal-header bg-primary_alert"><i class="ion-checkmark modal-icon"></i><span>{{itens.title}}</span></div><div class="modal-body text-center" style="padding:15px !important;"><strong style="font-size: 24px !important;">{{itens.observacao}}</strong></div><div class="modal-footer"><button type="button" class="btn bg-primary_alert" ng-click="$close()">OK</button></div></div>');
$templateCache.put('app/pages/modals/aguradarObservacaoModal.html','<div tabindex="-1" class="modal-os" role="dialog" style="background-color: rgba(54, 55, 57, 0.97)"><div class="modal-dialog" role="document" style="padding-bottom: 10px;"><div class="modal-header"><h5>{{\'ocorrencia_label_tempo_observacao\' | translate}}</h5><button type="button" class="close" data-dismiss="modal" ng-click="modalObservacao.dismiss()" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><label style="color: white">{{\'ocorrencia_label_aguardar_observcao\' | translate}}:</label><div class="input-group date" style="margin-top: 10px"><input type="time" value="00:15" ng-keyup="hablitaBotaoAguardarObservacao()" min="1" id="tempo_observcao" class="form-control"> <span class="input-group-addon" style="padding: 6px 12px;"><span class="glyphicon glyphicon-time" style="top: 3px; left: -7px;"></span></span></div></div><div class="modal-footer" style="padding:15px 10px 0 0"><button class="btn btn-default" ng-click="modalObservacao.dismiss()">{{\'ocorrencia_botao_cancelar\' | translate}}</button> <button id="btnEnviarTempoObs" button-processing="" class="btn btn-primary" ng-click="aguardarEmObservacao ()">{{\'ocorrencia_label_confirmar\' | translate}}</button></div></div></div>');
$templateCache.put('app/pages/modals/chatConfigModal.html','<div class="modal-content" id="configChatModal"><div class="modal-header"><div class="col-lg-12"><div class="col-lg-1"><i class="ion-ios-cog modal-icon"></i></div><div class="col-lg-10"><span>{{\'ocorrencias_label_configuracao_chat\' | translate}}</span></div><div class="col-lg-1"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="modal-body"><div class="conteudo-chat-config"><label>{{\'ocorrencias_label_font_size\' | translate}}:</label><select ng-model="tamanhoFonte" ng-change="alteraFonte()" id="font_size" class="form-control"><option value="12" ng-selected="font_size_chat === \'12\'">12</option><option value="16" ng-selected="font_size_chat === \'16\'">16</option><option value="24" ng-selected="font_size_chat === \'24\'">24</option></select><br><label>{{\'ocorrencias_label_cor_mensagem\' | translate}}:</label> <input id="cor_msg" ng-change="alteraCorMensagem()" ng-model="corMsg" type="color" name="head" value="{{cor_mensagem_chat}}" class="form-control"><br><label>{{\'ocorrencias_label_cor_fundo_chat\' | translate}}:</label> <input id="cor_fundo" type="color" ng-change="alteraCorFundoChat()" ng-model="corFundoChat" name="head" value="{{cor_fundo_chat}}" class="form-control"><br><label>{{\'ocorrencias_label_cor_fundo_mensagem\' | translate}}:</label> <input id="cor_msg_fundo" type="color" ng-change="alteraCorFundoMsg()" ng-model="corMsgFundo" name="head" value="{{cor_fundo_mensagem_chat}}" class="form-control"><br><button type="button" id="btnCancelConfig" ng-click="cancelarConfiguracao()" class="btn btn-default btnBlack"><i class="fa fa-close"></i> {{\'ocorrencia_botao_cancelar\' | translate}}</button> <button type="button" id="btnSaveConfig" ng-click="salvarConfiguracao()" class="btn btn-default btnBlack floatRigth"><i class="fa fa-save"></i> {{\'ocorrencia_botao_salvar\' | translate}}</button></div></div></div>');
$templateCache.put('app/pages/modals/chavesModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>{{itens.title}}</span></div><div class="modal-body text-center" style="padding:5px !important;"><label>Obs:</label> <strong>{{itens.observacao}}</strong></div><div class="modal-body text-center" style="padding:5px !important;"><label>{{\'ocorrencias_modal_numero_chaveiro\' | translate}}</label> <strong>{{itens.numero}}</strong></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$close()">OK</button></div></div>');
$templateCache.put('app/pages/modals/comandoAbrirPortaoModal.html','<div class="modal-content"><div class="modal-body text-center" style="padding:15px !important;"><button id="btnAbrirPortalModal" ng-click="enviarComandoPortao(itens)" class="btn btn-default" style="border: none !important;"><img alt="" class="portao" src="assets/img/aberto.png"><p style="color: green">{{\'ocorrencia_label_abrir\' | translate}}</p></button></div></div>');
$templateCache.put('app/pages/modals/comandoFecharPortaoModal.html','<div class="modal-content"><div class="modal-body text-center" style="padding:15px !important;"><button id="btnFecharPortalModal" ng-click="enviarComandoPortao(itens)" class="btn btn-default" style="border: none !important;"><img alt="" class="portao" src="assets/img/fechado.png"><p class="red-icon">{{\'ocorrencia_label_fechar\' | translate}}</p></button></div></div>');
$templateCache.put('app/pages/modals/comandoPainelModal.html','<div id="modalComandoPainel" class="modal-content"><div class="modal-body text-center"><button ng-show="!statusParticaoModal && modeloCentral.arme" id="btnArmarPainel" ng-click="armarParticao(modeloCentral)" class="btn btn-default btnComandosPainel"><i class="icon ion-locked iconesComandosPainel red-icon"></i><p class="red-icon">{{\'ocorrencia_botao_armar_painel\' | translate}}</p></button> <button ng-show="!statusParticaoModal && modeloCentral.arme_stay" id="btnArmarStay" ng-click="armarParticaoStay(modeloCentral, fabricante)" class="btn btn-default btnComandosPainel"><i class="icon ion-locked iconesComandosPainel yellow-icon"></i><p class="yellow-icon">{{\'ocorrencia_botao_armar_painel_stay\' | translate}}</p></button> <button ng-show="statusParticaoModal && modeloCentral.desarme" id="btnDesarmarPainel" ng-click="desarmarParticao()" class="btn btn-default btnComandosPainel"><i class="icon ion-locked iconesComandosPainel green-icon"></i><p class="green-icon">{{\'ocorrencia_botao_desarmar_painel\' | translate}}</p></button></div></div>');
$templateCache.put('app/pages/modals/confirmRevogacaoManutencaoModal.html','<div tabindex="-1" class="modal-os" role="dialog" style="background-color: rgba(54, 55, 57, 0.97)"><div class="modal-dialog" role="document" style="padding-bottom: 10px;"><div class="modal-header"><h5>{{\'ocorrencia_label_confirma_revogacao\' | translate}}</h5><button type="button" class="close" data-dismiss="modal" ng-click="modalConfirm.dismiss()" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><h5 style="color: white">{{ocorrenciaAtual.sistema.descricao ? ocorrenciaAtual.sistema.descricao : titleModal}}</h5></div><div class="modal-footer" style="padding:15px 10px 0 0"><button button-processing="" class="btn btn-primary" ng-click="revogarManutencaoConfirm()">{{\'ocorrencia_label_sim\' | translate}}</button> <button class="btn btn-default" ng-click="modalConfirm.dismiss()">{{\'ocorrencia_label_nao\' | translate}}</button></div></div></div>');
$templateCache.put('app/pages/modals/desacionarSireneModal.html','<div class="modal-content" id="modalDesligarSirene"><div class="modal-body"><button id="btnDesacionarSirene" ng-click="enviarComandoSirene(57)" class="btn btn-default"><i class="icon ion-speakerphone iconesComandosPainel gray-icon"></i><p class="gray-icon">{{\'ocorrencia_tooltip_desligar\' | translate}}</p></button></div></div>');
$templateCache.put('app/pages/modals/edicaoSistemaModal.html','<div tabindex="-1" class="modal-os" role="dialog" style="background-color: rgba(54, 55, 57, 0.97)"><div class="modal-dialog" role="document" style="padding-bottom: 10px;"><div class="modal-header"><h5>{{titleModal}}</h5><button type="button" class="close" data-dismiss="modal" ng-click="modalEdicaoClose()" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div ng-if="permissao_editar_sistema && exibirEdicao" ng-controller="InformacoesDoLocalController"><div ng-include="\'app/pages/InformacoesOcorrencia/InformacoesDoLocal/form_info_local.html\'" ng-init="showCancelButton=true"></div></div><fieldset ng-if="permissao_colocar_sistema_em_manutencao_fullcenter && !exibirEdicao" style="width: 100%; padding-top: 10px"><legend><b style="color: white; font-size: 16px">{{\'ocorrencia_label_manutencao_title\' | translate}}</b></legend><div class="col-lg-12"><div class="col-lg-12" ng-show="!habilitarProrrogar"><div class="form-group"><div class="form-group"><div style="margin-bottom: 5px" class="input-group date"><input type="time" value="01:00" min="01" id="tempo_manutencao" class="form-control"> <span class="input-group-addon" style="padding: 6px 12px;"><span class="glyphicon glyphicon-time" style="top: 3px; left: -7px;"></span></span></div><span>{{\'ocorrencia_label_exemplo_manutencao\' | translate}}</span></div><div class="form-group"><button ng-show="!isProrrogacao" id="btn-iniciar-manutencao" ng-click="iniciarManutencao()" class="btn btn-primary btn-large" type="button"><i class="glyphicon glyphicon-time"></i> <span>{{\'ocorrencia_label_iniciar_manutencao\' | translate}}</span></button> <button ng-show="isProrrogacao" id="btn-prorrogar-manutencao" ng-click="prorrogarManutencao()" class="btn btn-primary btn-large" type="button"><i class="glyphicon glyphicon-time"></i> <span>{{\'ocorrencia_label_prorrogar_manutencao\' | translate}}</span></button></div></div></div><div class="col-lg-12" ng-show="habilitarProrrogar"><div class="col-lg-6"><div class="form-group"><button id="prorrogar" ng-click="habilitarFormProrrogacaoComOcorrencia()" type="submit" class="btn btn-primary btn-block"><i class="glyphicon glyphicon-wrench"></i> <span class="hidden-xs">{{\'ocorrencia_label_prorrogar_manutencao\' | translate}}</span></button></div></div><div class="col-lg-6"><div class="form-group"><button id="revogar" button-processing="" ng-click="modalConfirmOpen()" type="submit" class="btn btn-danger btn-block"><i class="glyphicon glyphicon-wrench"></i> <span class="hidden-xs">{{\'ocorrencia_label_revogar_manutencao\' | translate}}</span></button></div></div></div><div class="col-lg-12" ng-show="habilitarProrrogar"><div class="form-group"><button style="pointer-events: none;" type="button" class="btn btn-default btn-block"><i class="fa fa-hourglass-half hidden-md">{{\'ocorrencia_label_tempo_restante\' | translate}} :</i> <span id="countdownEdicao" aria-hidden="true"></span></button></div></div></div></fieldset></div></div></div>');
$templateCache.put('app/pages/modals/feriadoModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>{{itens.title}}</span></div><div class="modal-body text-center" style="padding:5px !important;"><label>{{\'ocorrencia_label_descricao\' | translate}}</label> <strong>{{itens.descricao}}</strong></div><div class="modal-body text-center" style="padding:5px !important;"><label>{{\'ocorrencia_label_tipo\' | translate}}</label> <strong>{{itens.tipo}}</strong></div><div class="modal-body text-center" style="padding:5px !important;"><label>{{\'ocorrencia_label_anual\' | translate}}</label> <strong>{{itens.anual == 0 ? \'N\xE3o\' : \'Sim\'}}</strong></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$close()">OK</button></div></div>');
$templateCache.put('app/pages/modals/insertModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Gerar Ocorr\xEAncia</h4></div><div class="modal-body"><div class="form-group"><label for="qtd" style="color: #7d7d7d !important;">Quantidade de Ocorr\xEAncias</label> <input type="number" class="form-control" id="qtd" placeholder=""></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="inserirOcorrencia(); $dismiss();">Gerar</button></div></div>');
$templateCache.put('app/pages/modals/osModal.html','<div id="modal-os" tabindex="-1" class="modal-os" role="dialog" style="background-color: rgba(54, 55, 57, 0.97) !important;"><div class="modal-dialog modal-lg" role="document"><div class="modal-header"><h5>{{\'ocorrencia_label_ordem_servico\' | translate}}</h5><button type="button" class="close" data-dismiss="modal" id="modal-os-close" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div><label>{{\'ocorrencia_label_problema\' | translate}}:</label><select class="form-control" id="selectProblemas" style="width:100%;" ng-model="problemasValues"><option ng-repeat="option in problemas_fullcontrol" value="{{option.id}}">{{option.descricao}}</option></select><label>{{\'ocorrencia_label_descricao\' | translate}}:</label> <textarea id="descricaoServico" cols="40" class="form-control"></textarea></div><div class="modal-footer" style="margin-top: 15px"><button type="button" class="btn btn-default btnBlack floatRigth" button-processing="" id="btnSolicitarOrdemServico">{{\'ocorrencia_label_enviar\' | translate}}</button></div></div></div></div>');
$templateCache.put('app/pages/modals/painelModal.html','<div class="modal-content"><div id="div_painel_particao" class="modal-header btn-success"><i class="ion-checkmark modal-icon"></i><span>{{itens.title}}</span></div><div class="modal-body text-center">{{itens.observacao}}</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$close()">OK</button></div></div>');
$templateCache.put('app/pages/modals/painelModalDesarmado.html','<div class="modal-content"><div id="div_painel_particao" class="modal-header btn-danger"><i class="ion-checkmark modal-icon"></i><span>{{itens.title}}</span></div><div class="modal-body text-center">{{itens.observacao}}</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$close()">OK</button></div></div>');
$templateCache.put('app/pages/modals/setoresAbertosModal.html','<div class="modal-header header-setores"><div class="col-md-12"><span>{{comandoArmeStay ? \'ocorrencia_botao_armar_painel_stay\' : \'ocorrencia_botao_armar_painel\' | translate}}</span></div><div class="col-md-12 header-subtitle"><span>{{comandoArmeStay ? \'Setores externos abertos\' : \'setores_abertos\' | translate}}</span></div></div><div class="modal-body body-setores"><div class="col-md-12 toogleSetores"><div class="col-md-6"><p>{{\'ocorrencia_label_inibir_os_setores\' | translate}}</p></div><div class="col-md-6" style="text-align: right"><input id="rbInibirSetoresAbertos" type="checkbox" data-toggle="toggle" data-style="slow" data-onstyle="success"></div></div><div class="col-md-12"><md-content><md-list><md-list-item ng-repeat="item in setoresAbertos"><div class="md-list-item-text" layout="column"><p style="color: #4d4d4c">{{ item.descricao }}</p></div></md-list-item></md-list></md-content></div></div><div class="modal-footer footer-setores"><div class="col-md-12"><div class="col-md-6"><button id="btnCancelarArmeSetoresAbertos" class="btn btn-secondary btn-block" type="button">{{\'ocorrencia_botao_cancelar\' | translate}}</button></div><div class="col-md-6"><button id="btnArmeSetoresAbertos" class="btn btn-danger btn-block" type="button">{{comandoArmeStay ? \'ocorrencia_botao_armar_painel_stay\' : \'ocorrencia_botao_armar_painel\' | translate}}</button></div></div></div>');
$templateCache.put('app/pages/modals/sistemaModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>{{itens.title}}</span></div><div class="modal-body text-center">{{itens.observacao}}</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$close()">OK</button></div></div>');
$templateCache.put('app/pages/modals/teclasAtalhoConfigModal.html','<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>$Title$</title></head><body>$END$</body></html>');
$templateCache.put('app/pages/modals/tempoAcionamentoModal.html','<div id="modalTempoAcionamento" class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{\'ocorrencia_label_acionamento_sirene\' | translate}}</h4></div><div class="modal-body"><fieldset class="scheduler-border"><legend class="scheduler-border">{{\'ocorrencia_label_tempo_acionamento\' | translate}}</legend><div class="control-group"><div class="col-lg-12"><div class="col-lg-8"><input ng-model="tempoAcionamento" ng-change="changeTempoAcionamento(tempoAcionamento)" class="form-control" type="number" min="1"></div><div class="col-lg-2"><button ng-click="enviarComandoSirene(56)" style="" type="button" class="btn btn-default btnBlack">{{\'ocorrencia_label_enviar\' | translate}}</button></div></div></div></fieldset></div></div>');
$templateCache.put('app/pages/Ocorrencias/ocorrencias.html','<div class="ocorrencia-item" ng-click="carregarInformacoesOcorrencia(item.id_ocorrencia, item.botoes, key)"><div class="notification"><div ng-class="{\'notification--num notification-color-red\': prioridade == \'ocorrencia_label_prioridade_alta\', \'notification--num notification-color-yellow\': prioridade == \'ocorrencia_label_prioridade_media\', \'notification--num notification-color-blue\': prioridade == \'ocorrencia_label_prioridade_baixa\'}"><span id="{{item.id_ocorrencia}}">{{item.quantidade_eventos}}</span></div></div><div><p><strong ng-style="{color: prioridade == \'ocorrencia_label_prioridade_alta\' ? \'#de5341\' : prioridade == \'ocorrencia_label_prioridade_media\' ? \'#dfb81c\' : \'#2196F3\'}">{{item.evento_maior_prioridade}}</strong></p><p>{{\'ocorrencia_label_cliente\'|translate}}: <strong class="strong_sistema">{{ item.nome_cliente }}</strong></p><p>{{\'ocorrencia_label_sistema\'|translate}}: <strong class="strong_sistema">{{ item.descricao_sistema }}</strong></p><p>{{\'ocorrencia_label_tipo\'|translate}}: <strong class="strong_sistema" style="margin-right: 5px;">{{item.tipo_descricao | translate}}</strong> <strong ng-style="{color: prioridade == \'ocorrencia_label_prioridade_alta\' ? \'#de5341\' : prioridade == \'ocorrencia_label_prioridade_media\' ? \'#dfb81c\' : \'#2196F3\'}">{{prioridade | translate}}</strong></p></div></div>');
$templateCache.put('app/pages/Ocorrencias/ocorrencias_prioridade.html','<div ba-panel="" ba-panel-class="tabs-panel with-scroll_novas" ng-init="prioridade = \'ocorrencia_label_prioridade_alta\'" ng-repeat="(key, item) in ocorrenciasPrioridade.alta" id="{{item.id_ocorrencia}}" style="cursor: pointer; margin-left: 2px;" class="div_ocorrencia" ng-class="{\'item-selecionado\' : ocorrenciaAtual.id_ocorrencia == item.id_ocorrencia}"><div ng-include="\'app/pages/Ocorrencias/ocorrencias.html\'" include-replace=""></div></div><div ba-panel="" ba-panel-class="tabs-panel with-scroll" ng-init="prioridade = \'ocorrencia_label_prioridade_media\'" ng-repeat="(key, item) in ocorrenciasPrioridade.media" id="{{item.id_ocorrencia}}" style="cursor: pointer; margin-left: 2px;" class="div_ocorrencia" ng-class="{\'item-selecionado\' : ocorrenciaAtual.id_ocorrencia == item.id_ocorrencia}"><div ng-include="\'app/pages/Ocorrencias/ocorrencias.html\'" include-replace=""></div></div><div ba-panel="" ba-panel-class="tabs-panel with-scroll" ng-init="prioridade = \'ocorrencia_label_prioridade_baixa\'" ng-repeat="(key, item) in ocorrenciasPrioridade.baixa" id="{{item.id_ocorrencia}}" style="cursor: pointer; margin-left: 2px;" class="div_ocorrencia" ng-class="{\'item-selecionado\' : ocorrenciaAtual.id_ocorrencia == item.id_ocorrencia}"><div ng-include="\'app/pages/Ocorrencias/ocorrencias.html\'" include-replace=""></div></div>');
$templateCache.put('app/pages/Ocorrencias/ocorrencias_status.html','<div ng-controller="OcorrenciasController" style="height: 100%"><div class="tabset-group"><div class="principal-panel" ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset active="$root.tab_status_superior" class="tabs-left"><uib-tab select="descarregaTela(1)" id="tab_status_em_espera"><uib-tab-heading><i class="fas fa-hourglass-start status-tab" ng-style="{\'color\': ocorrencias.em_espera.quantidade > 0 ? \'rgb(222, 83, 65)\' : \'\' }"></i> <span class="contador" ng-style="{\'color\': ocorrencias.em_espera.quantidade > 0 ? \'rgb(222, 83, 65)\' : \'\' }">{{ocorrencias.em_espera.quantidade > 0 ? ocorrencias.em_espera.quantidade : 0}}</span><div class="div-status"><span>{{\'ocorrencia_status_novos\' | translate}}</span></div></uib-tab-heading><div ng-if="ocorrencias.em_espera.quantidade > 0" ng-init="ocorrenciasPrioridade = ocorrencias.em_espera" ng-include="\'app/pages/Ocorrencias/ocorrencias_prioridade.html\'"></div></uib-tab><uib-tab select="descarregaTela(2)" id="tab_status_em_atendimento"><uib-tab-heading><i class="fas fa-edit" ng-style="{\'color\': cor_status_atendimento}"></i> <span class="contador" ng-style="{\'color\': cor_status_atendimento}">{{ocorrencias.em_atendimento.quantidade > 0 ? ocorrencias.em_atendimento.quantidade : 0}}</span><div class="div-status"><span>{{\'ocorrencia_status_em_atendimento\' | translate}}</span></div></uib-tab-heading><div ng-if="ocorrencias.em_atendimento.quantidade > 0" ng-init="ocorrenciasPrioridade = ocorrencias.em_atendimento" ng-include="\'app/pages/Ocorrencias/ocorrencias_prioridade.html\'"></div></uib-tab><uib-tab select="descarregaTela(6)" ng-if="permissao_fpatrol" id="tab_status_aguardando_ronda"><uib-tab-heading><i class="fas fa-car" ng-style="{\'color\': cor_status_aguardando_ronda}"></i> <span class="contador" ng-style="{\'color\': cor_status_aguardando_ronda}">{{ocorrencias.aguardando_ronda.quantidade > 0 ? ocorrencias.aguardando_ronda.quantidade : 0}}</span><div class="div-status"><span>{{\'ocorrencia_status_aguardando_ronda\' | translate}}</span></div></uib-tab-heading><div ng-if="ocorrencias.aguardando_ronda.quantidade > 0" ng-init="ocorrenciasPrioridade = ocorrencias.aguardando_ronda" ng-include="\'app/pages/Ocorrencias/ocorrencias_prioridade.html\'"></div></uib-tab><uib-tab select="descarregaTela(7)" ng-if="permissao_fpatrol" id="tab_status_a_caminho"><uib-tab-heading><i class="fas fa-route" ng-style="{\'color\': cor_status_ronda_a_caminho}"></i> <span class="contador" ng-style="{\'color\': cor_status_ronda_a_caminho}">{{ocorrencias.ronda_a_caminho.quantidade > 0 ? ocorrencias.ronda_a_caminho.quantidade : 0}}</span><div class="div-status"><span>{{\'ocorrencia_status_roda_a_caminho\' | translate}}</span></div></uib-tab-heading><div ng-if="ocorrencias.ronda_a_caminho.quantidade > 0" ng-init="ocorrenciasPrioridade = ocorrencias.ronda_a_caminho" ng-include="\'app/pages/Ocorrencias/ocorrencias_prioridade.html\'"></div></uib-tab><uib-tab select="descarregaTela(8)" ng-if="permissao_fpatrol" id="tab_status_no_local"><uib-tab-heading><i class="fas fa-map-pin" ng-style="{\'color\': cor_status_ronda_no_local}"></i> <span class="contador" ng-style="{\'color\': cor_status_ronda_no_local}">{{ocorrencias.ronda_no_local.quantidade > 0 ? ocorrencias.ronda_no_local.quantidade : 0}}</span><div class="div-status"><span>{{\'ocorrencia_status_ronda_no_local\' | translate}}</span></div></uib-tab-heading><div ng-if="ocorrencias.ronda_no_local.quantidade > 0" ng-init="ocorrenciasPrioridade = ocorrencias.ronda_no_local" ng-include="\'app/pages/Ocorrencias/ocorrencias_prioridade.html\'"></div></uib-tab><uib-tab select="descarregaTela(9)" ng-if="permissao_fpatrol" id="tab_status_ronda_fim"><uib-tab-heading><i class="fas fa-check-square" ng-style="{\'color\': cor_status_ronda_finalizada}"></i> <span class="contador" ng-style="{\'color\': cor_status_ronda_finalizada}">{{ocorrencias.ronda_finalizada.quantidade > 0 ? ocorrencias.ronda_finalizada.quantidade : 0}}</span><div class="div-status"><span>{{\'ocorrencia_status_ronda_finalizada\' | translate}}</span></div></uib-tab-heading><div ng-if="ocorrencias.ronda_finalizada.quantidade > 0" ng-init="ocorrenciasPrioridade = ocorrencias.ronda_finalizada" ng-include="\'app/pages/Ocorrencias/ocorrencias_prioridade.html\'"></div></uib-tab><uib-tab select="descarregaTela(3)" id="tab_status_em_observacao"><uib-tab-heading><i class="fas fa-user-clock" ng-style="{\'color\': cor_status_observacao}"></i> <span class="contador" ng-style="{\'color\': cor_status_observacao}">{{ocorrencias.em_observacao.quantidade > 0 ? ocorrencias.em_observacao.quantidade : 0}}</span><div class="div-status"><span>{{\'ocorrencia_status_em_observacao\' | translate}}</span></div></uib-tab-heading><div ng-if="ocorrencias.em_observacao.quantidade > 0" ng-init="ocorrenciasPrioridade = ocorrencias.em_observacao" ng-include="\'app/pages/Ocorrencias/ocorrencias_prioridade.html\'"></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/theme/examples/index.html','<body ng-app="de.devjs.angular.spotlight.example"><spotlight-overlay></spotlight-overlay></body>');
$templateCache.put('app/theme/templates/busca_sistemas.html','<div ng-controller="EventoManualController" class="ng-spotlight-results-detail-wikipedia"><div class="title">{{selectedItem.name}}</div><div style="text-align: center; margin-top: 5%;"><button ng-if="permissoesMonitoramento.editar_sistema_fullcenter && permissoesMonitoramento.editar_sistema_fullcenter_sem_ocorrencia" type="button" class="btn btn-primary btn-with-icon" ng-click="abrirModalEdicaoSistemaSemOcorrencia(selectedItem.id)"><i style="margin-right: 5px" class="glyphicon glyphicon-pencil"></i>{{\'ocorrencia_label_editar_sistema\' | translate}}</button></div><div class="description">{{selectedItem.description}}</div><strong ng-if="selectedItem.painel_virtual.length > 0">{{\'ocorrencia_search_selecionar_particao\'|translate}}</strong> <strong ng-if="selectedItem.painel_virtual.length == 0">{{\'ocorrencia_search_nao_ha_particao\'|translate}}</strong><br><br><div class="footer"><div ng-repeat="item in selectedItem.painel_virtual" ng-if="selectedItem.painel_virtual.length > 0"><dl ng-if="item.ativo"><dt><button type="button" class="btn btn-default btn-with-icon" ng-click="abrirModalDescricaoEvento(selectedItem.id, item.id)"><i style="margin-right: 5px" class="glyphicon glyphicon-modal-window"></i>{{item.id}} - {{item.descricao}}</button></dt></dl></div></div></div>');
$templateCache.put('app/modules/login/login.html','<div class="login-fc"><div class="name-app">{{customData.appname}}</div><div class="body"><form class="form"><div class="group"><input class="username" ng-model="user" type="text" placeholder="{{\'login_fullcenter_user\' | translate}}"> <span class="username-ico fa fa-envelope"></span></div><span ng-if="warningMessages.username" class="warningMessages">{{warningMessages.username}}</span><div class="group">{{typeInputPassword}} <input ng-hide="showPassword" class="password" ng-model="password" type="password" placeholder="{{\'login_fullcenter_password\' | translate}}"> <input ng-show="showPassword" class="password" ng-model="password" type="text" placeholder="{{\'login_fullcenter_password\' | translate}}"> <span class="password-ico" ng-click="showHidePassword()"><i class="fa" ng-class="{ \'fa-eye\': !showPassword, \'fa-eye-slash\': showPassword }"></i></span></div><span ng-if="warningMessages.password" class="warningMessages">{{warningMessages.password}}</span><div class="login-btns"><button type="button" data-loading-text="{{\'login_fullcenter_loading\' | translate}}" class="btn btn-primary btn-flat" ng-click="login(user,password)" autocomplete="off">{{\'login_fullcenter_login\' | translate}}</button></div></form></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/Automacao/automacao.html','<div style="padding: 2px;" ng-controller="AutomacaoController"><div ba-panel-class="feed-panel with-scroll divAutomacao"><div class="col-lg-12 col-md-12"><div ng-if="mostraPgm && permissaoComandoDispositivo"><div class="div-portao" style="margin-top: 0 !important;"><span>{{\'ocorrencia_label_automacao\' | translate}}</span></div><md-content><md-list ng-style="{ \'max-height\' : !mostraPortao ? \'100%\' : \'200px\', \'margin-top\' : \'13px\' }"><md-list-item ng-repeat="item in dispositivos" ng-if="item.dispositivo != \'portao\' && item.permissao_visualizar"><div class="md-list-item-text" layout="column"><p>{{item.descricao}}</p><label ng-if="item.dispositivo == \'pgm\' && item.on_off">{{item.ligada ? \'ocorrencia_label_ligada\' : \'ocorrencia_label_desligada\' | translate}}</label> <label ng-if="item.dispositivo == \'Rele\' && item.on_off">{{item.ligado ? \'ocorrencia_label_ligada\' : \'ocorrencia_label_desligada\' | translate}}</label> <label ng-if="item.dispositivo == \'sonoff\'">{{!item.conectado ? \'Offline\' : item.ligado ? \'ocorrencia_label_ligada\' : \'ocorrencia_label_desligada\' | translate}}</label> <label ng-if="item.dispositivo == \'dispositivo\'">{{!item.conectado ? \'Offline\' : item.ligado ? \'ocorrencia_label_ligada\' : \'ocorrencia_label_desligada\' | translate}}</label></div><md-icon class="icon_pgm_{{item.id}}" md-list-icon="" ng-if="item.dispositivo == \'pgm\' && item.tipo_pgm == tipo_pgm.LIGA_DESLIGA"><button uib-tooltip="{{\'ocorrencia_tooltip_desligar\' | translate }}" id="btnPgmDesligar" ng-disabled="!item.ligada && item.on_off" type="button" class="btn btn-default btnBlack" ng-click="acaoEnviarComandoDispositivo(comandos_pgm.DESLIGA, item)"><i class="far fa-lightbulb"></i></button></md-icon><md-icon class="icon_pgm_{{item.id}}" md-list-icon="" ng-if="item.dispositivo == \'pgm\' && item.tipo_pgm == tipo_pgm.LIGA_DESLIGA"><button uib-tooltip="{{\'ocorrencia_tooltip_ligar\' | translate }}" id="btnPgmLigar" ng-disabled="item.ligada && item.on_off" type="button" class="btn btn-default btnBlack" ng-click="acaoEnviarComandoDispositivo(comandos_pgm.LIGA, item)"><i style="color: #f3c305" class="fas fa-lightbulb"></i></button></md-icon><md-icon class="icon_pgm_{{item.id}}" style="padding-left: 25px" md-list-icon="" ng-if="item.dispositivo == \'pgm\' && item.tipo_pgm == tipo_pgm.INVERTER"><button uib-tooltip="{{ !item.ligada ? \'ocorrencia_tooltip_ligar\' : \'ocorrencia_tooltip_desligar\' | translate }}" id="btnPgmInverter" type="button" class="btn btn-default btnBlack" ng-click="acaoEnviarComandoDispositivo(item.ligada ? comandos_pgm.DESLIGA : comandos_pgm.LIGA, item)"><i ng-style="{\'color\': item.ligada ? \'#f3c305\' : \'\'}" class="fas fa-lightbulb"></i></button></md-icon><md-icon class="icon_rele_{{item.id}}" style="padding-left: 25px" md-list-icon="" ng-if="item.dispositivo == \'Rele\' && item.tipo_pgm == tipo_pgm.INVERTER"><button uib-tooltip="{{ !item.ligado ? \'ocorrencia_tooltip_ligar\' : \'ocorrencia_tooltip_desligar\' | translate }}" id="btnReleInverter" type="button" class="btn btn-default btnBlack" ng-click="acaoEnviarComandoDispositivo(item.ligado ? comandos_pgm.DESLIGA : comandos_pgm.LIGA, item)"><i ng-style="{\'color\': item.ligado ? \'#f3c305\' : \'\'}" class="fas fa-lightbulb"></i></button></md-icon><md-icon class="icon_pgm_{{item.id}}" style="padding-left: 25px" md-list-icon="" ng-if="item.dispositivo == \'pgm\' && item.tipo_pgm == tipo_pgm.SEMPRE_ACIONAR"><button uib-tooltip="{{\'ocorrencia_tooltip_ativar\' | translate }}" id="btnPgmSempreAcionar" type="button" class="btn btn-default btnBlack" ng-click="acaoEnviarComandoDispositivo(comandos_pgm.LIGA, item)"><i class="far fa-lightbulb"></i></button></md-icon><md-icon class="icon_sonoff_{{item.id}}" md-list-icon="" ng-if="item.dispositivo == \'sonoff\'"><button uib-tooltip="{{\'ocorrencia_tooltip_desligar\' | translate }}" id="btnSonoffDesligar" ng-disabled="!item.ligado" type="button" class="btn btn-default btnBlack" ng-click="acaoEnviarComandoDispositivo(comandos_sonoff.DESLIGA, item)"><i class="far fa-lightbulb"></i></button></md-icon><md-icon class="icon_sonoff_{{item.id}}" md-list-icon="" ng-if="item.dispositivo == \'sonoff\'"><button uib-tooltip="{{\'ocorrencia_tooltip_ligar\' | translate }}" id="btnSonoffLigar" ng-disabled="item.ligado" type="button" class="btn btn-default btnBlack" ng-click="acaoEnviarComandoDispositivo(comandos_sonoff.LIGA, item)"><i style="color: #f3c305" class="fas fa-lightbulb"></i></button></md-icon><md-icon class="icon_dispositivo_{{item.id}}" md-list-icon="" ng-if="item.dispositivo == \'dispositivo\'"><button uib-tooltip="{{\'ocorrencia_tooltip_desligar\' | translate }}" ng-disabled="!item.ligado" id="btnEwelinkDesligar" type="button" class="btn btn-default btnBlack" ng-click="acaoEnviarComandoDispositivo(comandos_ewelink.DESLIGA, item)"><i class="far fa-lightbulb"></i></button></md-icon><md-icon class="icon_dispositivo_{{item.id}}" md-list-icon="" ng-if="item.dispositivo == \'dispositivo\'"><button uib-tooltip="{{\'ocorrencia_tooltip_ligar\' | translate }}" id="btnEwelinkLigar" type="button" class="btn btn-default btnBlack" ng-disabled="item.ligado" ng-click="acaoEnviarComandoDispositivo(comandos_ewelink.LIGA, item)"><i style="color: #f3c305" class="fas fa-lightbulb"></i></button></md-icon><span class="blink_me" style="display: none" id="pgm_{{item.id}}">{{\'executando\' | translate}}</span> <span class="blink_me" style="display: none" id="rele_{{item.id}}">{{\'executando\' | translate}}</span> <span class="blink_me" style="display: none" id="sonoff_{{item.id}}">{{\'executando\' | translate}}</span> <span class="blink_me" style="display: none" id="dispositivo_{{item.id}}">{{\'executando\' | translate}}</span><md-divider></md-divider></md-list-item></md-list></md-content></div><div class="col-lg-12" ng-if="mostraPortao && permissaoComandoPortao"><div class="div-portao"><span>{{\'ocorrencia_label_portao\' | translate}}</span></div><div class="col-lg-12 div-botao-portao"><button ng-repeat="item in dispositivos" ng-if="item.dispositivo == \'portao\' && item.permissao_visualizar" class="btn btn-default" ng-click="openModalComandoPortao(item.id, (item.aberto ? \'app/pages/modals/comandoFecharPortaoModal.html\' : \'app/pages/modals/comandoAbrirPortaoModal.html\'), (item.aberto ? 10 : 9), item.permissao_enviar_comando)" uib-tooltip="{{item.aberto ? \'ocorrencia_label_fechar\' : \'ocorrencia_label_abrir\' | translate }}"><img ng-if="!item.aberto" alt="{{item.descricao}}" class="portao" src="assets/img/fechado.png"> <img ng-if="item.aberto" alt="{{item.descricao}}" class="portao" src="assets/img/aberto.png"><p>{{item.descricao}}</p><p class="icon_portao_{{item.id}}">{{item.aberto ? \'ocorrencia_setor_aberto\' : \'ocorrencia_setor_fechado\' | translate}}</p><p class="blink_me" style="display: none" id="portao_{{item.id}}">{{\'executando\' | translate}}</p></button></div></div></div></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/AnotacoesTemporarias/anotacoesTemporarias.html','<div class="divAnotacaoTemporaria table-responsive" ng-controller="AnotacoesTemporariasController"><table class="table table-responsive" ng-show="ocorrenciaAtual.sistema.anotacoes_temporarias.length > 0" style="display: table;"><tbody><tr ng-repeat="item in ocorrenciaAtual.sistema.anotacoes_temporarias"><td class="textAlineLeft"><div class="overflow-tip bluebox descricao-anotacao"><span><span>{{descricaoHistorico}} - {{item.anotacao}}</span></span></div></td><td class="textAlineLeft"><div class="overflow-tip bluebox descricao-anotacao"><span><span>{{item.providencia}}</span></span></div></td><td class="textAlineRight"><a href="" class="msg" uib-dropdown-toggle="" ng-click="ampliaTextoAnotacao(item)"><i class="fa_key fa-search"></i></a></td></tr></tbody></table><div class="infoAnotacao" ng-show="ocorrenciaAtual.sistema.anotacoes_temporarias.length <= 0"><strong>{{\'ocorrencia_label_nao_contem_anotacao\' | translate}}</strong></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/CabecalhoOcorrencia/cabecalhoOcorrencia.html','<div class="widgets"><div ba-panel="" ba-panel-class="info-ocorrencia"><div class="panel-heading" style="padding: 0"><div class="col-lg-12 info-ocorrencia-wrapper"><div class="col-lg-7"><h3 class="panel-title">{{\'ocorrencias_label_informacoes_ocorrencia\' | translate}}</h3></div><div class="col-lg-5 info-ocorrencia-botoes"><button ng-if="permissao_colocar_sistema_em_manutencao_fullcenter && !ocorrenciaAtual.sistema.em_manutencao" type="button" class="btn btn-success btn-with-icon" ng-click="abrirModalManutencaoSistema(false)"><i style="margin-right: 5px" class="glyphicon glyphicon-wrench"></i> {{\'ocorrencia_label_habilitar_manutencao\' | translate}}</button> <button ng-if="permissao_colocar_sistema_em_manutencao_fullcenter && ocorrenciaAtual.sistema.em_manutencao" ng-click="habilitarFormProrrogacaoComOcorrencia()" type="submit" class="btn btn-primary btn-with-icon"><i class="glyphicon glyphicon-wrench"></i> <span class="hidden-xs">{{\'ocorrencia_label_prorrogar_manutencao\' | translate}}</span></button> <button ng-if="permissao_colocar_sistema_em_manutencao_fullcenter && ocorrenciaAtual.sistema.em_manutencao" type="submit" ng-click="modalConfirmOpen()" class="btn btn-danger btn-with-icon"><i class="glyphicon glyphicon-wrench"></i> <span class="hidden-xs">{{\'ocorrencia_label_revogar_manutencao\' | translate}}</span></button> <button ng-show="exibeBtnAguardarEmObservacao" class="btn btn-warning btn-with-icon" ng-click="modalObservacaoOpen()"><i class="glyphicon glyphicon-time"></i> {{\'ocorrencia_label_aguardar\' | translate}}</button></div></div></div><div ng-style="{\'padding\':\'6px\', \'background-color\' : ocorrenciaAtual.evento_maior_prioridade.dados.prioridade == 1 ? \'#de5341\' : ocorrenciaAtual.evento_maior_prioridade.dados.prioridade == 2 ? \'#dfb81c\' : \'#2196F3\'}"><span class="contact-id" title="{{ocorrenciaAtual.evento_maior_prioridade.mensagem.chave_descricao}}">{{ocorrenciaAtual.evento_maior_prioridade.dados.conta != null ? ocorrenciaAtual.evento_maior_prioridade.dados.conta + " / " : " " | uppercase}} {{ ocorrenciaAtual.evento_maior_prioridade.dados.codigo | uppercase}} - {{ ocorrenciaAtual.evento_maior_prioridade.mensagem.chave_descricao | uppercase}}</span></div><div class="info-atendimento"><p class="lbChaveCabecalho">{{\'ocorrencia_label_status\' | translate}}: <strong class="lbConteudoCabecalho">{{ ocorrenciaAtual.status_descricao | translate }}</strong></p><p class="lbChaveCabecalho">{{\'ocorrencia_label_data_hora_disparo\' | translate}}: <strong class="lbConteudoCabecalho">{{ ocorrenciaAtual.data_hora_ocorrencia | date:\'DD/MM/YYYY HH:mm:s\' }}</strong></p><p class="">{{ ocorrenciaAtual.prioridade == \'alta\' ? \'ocorrencia_label_prioridade_alta\' : ocorrenciaAtual.prioridade == \'media\' ? \'ocorrencia_label_prioridade_media\' : \'ocorrencia_label_prioridade_baixa\' | translate}}</p></div><div class="info-atendimento" style="float: left; width: 100%" ng-show="ocorrenciaAtual.status_ocorrencia > 1 && ocorrenciaAtual.id_operador_atendendo > 0"><p class="lbChaveCabecalho">{{\'ocorrencia_label_iniciado_em\' | translate }} <strong class="lbConteudoCabecalho" ng-show="ocorrenciaAtual.status_ocorrencia > 1">{{ocorrenciaAtual.data_hora_inicio_atendimento == "" ? ocorrenciaAtual.data_hora_ocorrencia : ocorrenciaAtual.data_hora_inicio_atendimento | date:\'DD/MM/YYYY HH:mm:s\'}} {{"ocorrencia_label_por" | translate }}:<strong style="color: #de5341; margin-left: 5px">{{ocorrenciaAtual.nome_operador_primeiro_atendimento != "" && ocorrenciaAtual.nome_operador_primeiro_atendimento != null ? ocorrenciaAtual.nome_operador_primeiro_atendimento : ocorrenciaAtual.nome_operador_atendendo}}</strong></strong></p><p class="lbChaveCabecalho">{{ocorrenciaAtual.status_ocorrencia == 3 ? \'ocorrencia_label_observacao_por\' : \'ocorrencia_label_atendimento_por\' | translate }}: <strong class="lbConteudoCabecalho"><strong style="color: #de5341">{{ocorrenciaAtual.nome_operador_atendendo}}</strong></strong></p></div></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/Contatos/contatos.html','<div ng-controller="ContatosController"><input type="text" id="busca_contato" ng-model="nomeContatoBusca" placeholder="{{\'ocorrencia_search_buscar_contato\'|translate}}" class="form-control txt-pesquisar-contato"><div id="divContatoGeral" ba-panel="" ba-panel-class="with-scroll contatoGeral"><div style="margin-bottom: 20px" ng-repeat="(key, item) in contatos | filter: {\'nome\' : nomeContatoBusca}"><div class="senhas-contato"><fieldset class="fs-contato-superior"><fieldset class="fs-contato-inferior"><strong class="lbChave">{{\'Nome\' | translate}}:</strong><strong style="color: #de5341">{{item.nome}}</strong></fieldset><fieldset class="fs-contato-inferior"><strong class="lbChave">{{\'ocorrencia_label_anotacao_observacao\' | translate}}:</strong><strong class="lbConteudo">{{item.observacao}}</strong></fieldset><fieldset class="fs-contato-inferior"><strong class="lbChave">{{\'ocorrencia_label_funcao_contato\' | translate}}:</strong><strong class="lbConteudo">{{item.funcao}}</strong></fieldset></fieldset><fieldset class="fs-contato-superior"><fieldset class="fs-contato-inferior"><strong class="lbChave">{{\'ocorrencia_label_senha\' | translate}}:</strong><strong class="lbConteudo">{{item.senha_pergunta}}</strong></fieldset><fieldset class="fs-contato-inferior"><strong class="lbChave">{{\'ocorrencia_label_senha_resposta\' | translate}}:</strong><strong class="lbConteudo">{{item.contra_senha_resposta}}</strong></fieldset><fieldset class="fs-contato-inferior"><strong class="lbChave">{{\'ocorrencia_label_senha_coacao\' | translate}}:</strong><strong class="lbConteudo">{{item.senha_coacao_resposta}}</strong></fieldset></fieldset></div><div ba-panel="" ng-hide="item.contem_chamada_aberta"><table class="table table-striped table-telefones"><thead><tr><th style="text-align: left">{{\'ocorrencia_label_numero\' | translate}}</th><th style="text-align: left">{{\'ocorrencia_label_operadora\' | translate}}</th><th style="text-align: right"></th></tr></thead><tbody><tr ng-repeat="(key, telefone) in item.telefones"><td style="text-align: left">{{telefone.ddi}} - {{telefone.numero}}</td><td style="text-align: left">{{telefone.descricao_operadora != undefined && telefone.descricao_operadora != null ? telefone.descricao_operadora : ""}}</td><td style="text-align: right"><button button-processing="" ng-show="!item.contem_chamada_aberta && ocorrenciaAtual.atendendo" type="button" class="btn btn-default btnBlack" ng-click="tratarInclusaoTentativaContato(telefone)">{{\'ocorrencia_botao_iniciar_contato\' | translate}}</button></td></tr></tbody></table></div><div class="button-wrapper divResultadoContato" ng-show="item.contem_chamada_aberta && ocorrenciaAtual.atendendo"><textarea id="complemento_contato" placeholder="{{\'ocorrencia_text_area_mensagem_contato\' | translate}}..." cols="40" class="form-control" ng-model="taComplemento">\n                </textarea><br><button button-processing="" type="button" class="btn btn-default btnBlack" ng-click="informaResultadoContato(\'ocorrencia_mensagem_contato_sucesso\', item, taComplemento)">{{\'ocorrencia_label_sucesso\' | translate}}</button> <button button-processing="" type="button" class="btn btn-default btnBlack" ng-click="informaResultadoContato(\'ocorrencia_mensagem_contato_sem_resposta\', item, taComplemento)">{{\'ocorrencia_label_sem_resposta\' | translate}}</button> <button button-processing="" type="button" class="btn btn-default btnBlack" ng-click="informaResultadoContato(\'ocorrencia_mensagem_contato_ocupado\', item, taComplemento)">{{\'ocorrencia_label_ocupado\' | translate}}</button> <button button-processing="" type="button" class="btn btn-default btnBlack" ng-click="informaResultadoContato(\'ocorrencia_mensagem_contato_caixa_postal\', item, taComplemento)">{{\'ocorrencia_label_caixa_postal\' | translate}}</button> <button button-processing="" type="button" class="btn btn-default btnBlack" ng-click="informaResultadoContato(\'ocorrencia_mensagem_contato_numero_nao_existe\', item, taComplemento)">{{\'ocorrencia_label_numero_nao_existe\' | translate}}</button> <button button-processing="" type="button" class="btn btn-default btnBlack" ng-click="informaResultadoContato(\'ocorrencia_mensagem_iniciar_contato_whatsapp\', item, taComplemento, true)" ng-show="mostrarWhatsappBtn(item)">{{\'ocorrencia_label_iniciar_contato_whatsapp\' | translate}}</button></div></div></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/Fullcond/fullcond.html','<div class="fullcond-module-content" ng-controller="ModuloFullcondController"><div class="preloader-content" ng-show="moduloFullcondLoadindData"></div><div class="modulo" ng-hide="moduloFullcondLoadindData"><div class="titulo">{{\'ocorrencia_fullcond_titulo_interfone\' | translate}}</div><div class="info" ng-show="moduloFullcondContatos.interfones.length < 1">{{\'ocorrencia_fullcond_nao_ha_interfones_cadastrados\' | translate}}</div><div class="interfones"><div class="interfone" ng-repeat="interfone in moduloFullcondContatos.interfones"><div class="interfone-body"><div class="interfone-body-icone"><img class="icone" src="/assets/img/intercom.svg"> <span class="call" ng-click="openPopup(interfone.urlChamada)"><i class="ion ion-ios-telephone"></i></span></div><div><br></div><div class="interfone-body-content"><div class="nome">{{interfone.nome}}</div><div class="extra">{{interfone.extra}}</div></div></div></div></div><div class="titulo">{{\'ocorrencia_fullcond_titulo_usuarios\' | translate}}</div><div class="info" ng-show="moduloFullcondContatos.usuarios.length < 1">{{\'ocorrencia_fullcond_nao_ha_usuarios_cadastrados\' | translate}}</div><div class="buscar-usuarios" ng-hide="moduloFullcondContatos.usuarios.length < 1"><input class="buscar-usuarios-input" type="text" ng-model="criteria" placeholder="{{\'ocorrencia_fullcond_buscar_usuarios\'| translate}}"></div><div class="usuarios"><div class="usuario" ng-repeat="usuario in moduloFullcondContatos.usuarios | filter: criteria"><div class="usuario-body"><div class="usuario-body-foto"><img ng-hide="usuario.fotoCarregada" class="loading" src="/assets/img/progress_bar.gif"> <img ng-show="usuario.fotoCarregada" ng-src="{{usuario.foto}}"></div><div class="usuario-body-content"><div><div class="nome">{{usuario.nome}}</div><div class="extra">{{usuario.extra}}</div></div><div class="controles"><span class="call" ng-click="openPopup(usuario.urlChamada)"><i class="ion ion-ios-telephone"></i></span></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/InformacoesDoLocal/form_info_local.html','<fieldset style="width: 100%; padding-top: 10px"><div class="preloader-content" ng-show="loadingData" style="padding: 5%"></div><legend ng-hide="loadingData"><b style="color: white">{{\'ocorrencia_informacoes_local_titulo_endereco\' | translate}}</b></legend><div ng-hide="loadingData" class="form-group"><div class="form-group"><label>{{\'ocorrencia_informacoes_local_observacao\' | translate}}:</label> <textarea ng-disabled="!permissoesMonitoramento.editar_sistema_fullcenter" cols="10" rows="10" id="sistema_observacao" ng-model="sistemaEnderecoObservacao" class="form-control"></textarea></div><div class="form-group"><label>{{\'ocorrencia_informacoes_local_complemento\' | translate}}:</label> <textarea ng-disabled="!permissoesMonitoramento.editar_sistema_fullcenter" cols="10" rows="10" id="sistema_complemento" ng-model="sistemaEnderecoComplemento" class="form-control"></textarea></div><button ng-show="permissoesMonitoramento.editar_sistema_fullcenter" button-processing="" type="button" class="btn btn-default btnBlack floatRigth" id="btnSalvarEdicaoSistema" style="margin-left: 10px;" ng-click="editarInformacoesSistema(idSistemaEdicao, sistemaEnderecoObservacao, sistemaEnderecoComplemento)">{{\'ocorrencia_informacoes_local_salvar\' | translate}}</button> <button ng-show="permissoesMonitoramento.editar_sistema_fullcenter && showCancelButton" type="button" class="btn btn-default btnBlack floatRigth" id="btnCancelarInfoSistema" ng-click="formClose()">{{\'ocorrencia_botao_cancelar\' | translate}}</button></div></fieldset>');
$templateCache.put('app/pages/InformacoesOcorrencia/InformacoesDoLocal/tab.html','<div style="padding: 10px;"><div ng-include="\'app/pages/InformacoesOcorrencia/InformacoesDoLocal/form_info_local.html\'" ng-controller="InformacoesDoLocalController"></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/MotivosAlarme/motivosAlarme.html','<div ba-panel="" ba-panel-title="{{!tipoEventoDisparo || (tipoEventoDisparo && motivosAlarme.length <= 0) ? \'ocorrencia_botao_finalizar\' : \'ocorrencia_label_motivo_disparo\' | translate}}" ba-panel-class="motivo-alarme with-scroll feed-panel" class="paddingRight0" ng-show="exibeMotivosAlarme" ng-controller="MotivosAlarmeController"><div style="padding: 10px;" ng-controller="MotivosAlarmeController"><div ng-show="tipoEventoDisparo && motivosAlarme.length > 0" class="form-group has-success col-lg-12 col-md-12"><strong>{{\'ocorrencia_label_info_motivo_disparo\' | translate}}</strong><br></div><div class="form-group has-success" ng-repeat="item in motivosAlarme" ng-show="tipoEventoDisparo"><label><input type="radio" name="rbMotivoAlarme" id="{{item.id}}" ng-click="setarMotivoAlarme(item.descricao)">{{ item.descricao }}</label></div><br><div ng-show="!tipoEventoDisparo || (tipoEventoDisparo && motivosAlarme.length <= 0)" class="form-group has-success"><strong>{{\'ocorrencia_label_pergunta_finalizar\' | translate}}</strong></div><div><button ng-if="existeEventoTabelaHorario" id="btnFinalizarMotivoAlarme" type="button" ng-click="finalizarOcorrencia(existeEventoTabelaHorario)" class="btn btn-default btnBlack btnConfirmaFinalizar">{{\'ocorrencia_label_postergar_finalizar\' | translate}}</button> <button ng-if="!existeEventoTabelaHorario" button-processing="" id="btnFinalizarMotivoAlarme" type="button" ng-click="finalizarOcorrencia(existeEventoTabelaHorario)" class="btn btn-default btnBlack btnConfirmaFinalizar">{{\'ocorrencia_acao_finalizar\' | translate}}</button> <button id="btnCancelarMotivoAlarme" type="button" ng-click="cancelarFinalizacao()" class="btn btn-default btnBlack">{{\'ocorrencia_botao_cancelar\' | translate}}</button></div></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/Painel/legendas-setores.html','<div class="painel-setor-status-legenda"><div class="titulo">{{\'ocorrencia_setores_legenda\' | translate}}</div><hr><table><tbody><tr><td><div class="setor-status-list-item sensor-generico"><img title="{{\'ocorrencia_setores_outros\' | translate}}" src="assets/img/sensor-tipo-1.png"></div></td><td><span class="descricao">{{\'ocorrencia_setores_outros\'| translate}}</span></td><td><div class="setor-status-list-item sensor-ivp"><img title="{{\'ocorrencia_setores_ivp\' | translate}}" src="assets/img/sensor-tipo-2.png"></div></td><td><span class="descricao">{{\'ocorrencia_setores_ivp\'| translate}}</span></td><td><div class="setor-status-list-item sensor-magnetico"><img title="{{\'ocorrencia_setores_magnetico\' | translate}}" src="assets/img/sensor-tipo-3.png"></div></td><td><span class="descricao">{{\'ocorrencia_setores_magnetico\'| translate}}</span></td><td><div class="setor-status-list-item sensor-optico"><img title="{{\'ocorrencia_setores_optico\' | translate}}" src="assets/img/sensor-tipo-4.png"></div></td><td><span class="descricao">{{\'ocorrencia_setores_optico\'| translate}}</span></td><td><div class="setor-status-list-item sensor-camera"><img title="{{\'ocorrencia_painel_legenda_sensor_camera\' | translate}}" src="assets/img/sensor-tipo-5.png"></div></td><td><span class="descricao">{{\'ocorrencia_painel_legenda_sensor_camera\' | translate}}</span></td></tr><tr><td><div class="setor-status-list-item sensor-com-fio"><i title="{{\'ocorrencia_painel_legenda_sensor_com_fio\' | translate}}" class="icon ion-network"></i></div></td><td><span class="descricao">{{\'ocorrencia_painel_legenda_sensor_com_fio\' | translate}}</span></td><td><div class="setor-status-list-item sensor-sem-fio"><i title="{{\'ocorrencia_painel_legenda_sensor_sem_fio\' | translate}}" class="icon ion-android-wifi"></i></div></td><td><span class="descricao">{{\'ocorrencia_painel_legenda_sensor_sem_fio\' | translate}}</span></td><td><div class="setor-status-list-item setor-interno"><i title="{{\'ocorrencia_setores_interno\' | translate}}" class="icon ion-home"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_interno\' | translate}}</span></td><td><div class="setor-status-list-item setor-perimetro"><i title="{{\'ocorrencia_setores_perimetro\' | translate}}" class="icon ion-android-walk"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_perimetro\' | translate}}</span></td><td><div class="setor-status-list-item setor-24h"><i title="{{\'ocorrencia_setores_setor_24\' | translate}}" class="icon ion-clock"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_setor_24\' | translate}}</span></td></tr><tr><td><div class="setor-status-list-item setor-silencioso"><i title="{{\'ocorrencia_setores_silencioso\' | translate}}" class="icon ion-volume-mute"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_silencioso\' | translate}}</span></td><td><div class="setor-status-list-item setor-fechado"><i title="{{\'ocorrencia_setor_fechado\'| translate}}" class="ion-ios-checkmark-empty"></i></div></td><td><span class="descricao">{{\'ocorrencia_setor_fechado\'| translate}}</span></td><td><div class="setor-status-list-item setor-aberto"><i title="{{\'ocorrencia_setor_aberto\'| translate}}" class="ion-ios-close-empty"></i></div></td><td><span class="descricao">{{\'ocorrencia_setor_aberto\'| translate}}</span></td><td><div class="setor-status-list-item setor-disparo"><i title="{{\'ocorrencia_setores_disparado\' | translate}}" class="icon ion-alert-circled"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_disparado\' | translate}}</span></td><td><div class="setor-status-list-item setor-memoria"><i title="{{\'ocorrencia_setores_memoria\' | translate}}" class="icon ion-alert-circled"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_memoria\' | translate}}</span></td></tr><tr><td><div class="setor-status-list-item setor-inibido"><i title="{{\'ocorrencia_setores_inibido\' | translate}}" class="icon ion-eye-disabled"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_inibido\' | translate}}</span></td><td><div class="setor-status-list-item setor-tamper"><span title="{{\'ocorrencia_setores_tamper\' | translate}}">T</span></div></td><td><span class="descricao">{{\'ocorrencia_setores_tamper\' | translate}}</span></td><td><div class="setor-status-list-item setor-curto"><i title="{{\'ocorrencia_setores_curto\' | translate}}" class="icon ion-flash"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_curto\' | translate}}</span></td><td><div class="setor-status-list-item setor-falha-supervisao"><i title="{{\'ocorrencia_setores_falha_supervisao\'| translate}}" class="icon ion-android-alert"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_falha_supervisao\'| translate}}</span></td><td><div class="setor-status-list-item nivel-sinal"><img title="{{\'ocorrencia_setores_sinal\'| translate}}" src="assets/img/sinal-5.png"></div></td><td><span class="descricao">{{\'ocorrencia_setores_sinal\'| translate}}</span></td></tr><tr><td><div class="setor-status-list-item setor-bateria-fraca"><i title="{{\'ocorrencia_setores_bateria_fraca\' | translate}}" class="icon ion-battery-empty"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_bateria_fraca\' | translate}}</span></td><td><div class="setor-status-list-item setor-bateria-carregada"><i title="{{\'ocorrencia_setores_bateria_carregada\' | translate}}" class="icon ion-battery-half"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_bateria_carregada\' | translate}}</span></td><td><div class="setor-status-list-item sensor-temperatura"><i title="{{\'ocorrencia_setores_temperatura\' | translate}}" class="icon ion-thermometer"></i></div></td><td><span class="descricao">{{\'ocorrencia_setores_temperatura\' | translate}}</span></td><td><div class="setor-status-list-item sensor-camera"><img title="{{\'ocorrencia_painel_legenda_sensor_camera_analitico_on\' | translate}}" src="assets/img/status_analitico_on.png"></div></td><td><span class="descricao">{{\'ocorrencia_painel_legenda_sensor_camera_analitico_on\' | translate}}</span></td><td><div class="setor-status-list-item sensor-camera"><img title="{{\'ocorrencia_painel_legenda_sensor_camera_analitico_off\' | translate}}" src="assets/img/status_analitico_off.png"></div></td><td><span class="descricao">{{\'ocorrencia_painel_legenda_sensor_camera_analitico_off\' | translate}}</span></td></tr></tbody></table><hr><div class="botao-fechar"><button class="btn" ng-click="fecharLegenda()">{{\'modulo_painel_modal_legenda_fechar\'| translate}}</button></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/Painel/painel.html','<div class="paine-module-content" ng-controller="PainelController"><div ng-repeat="(key, pv) in paineisVirtuais" ng-show="painelAtual == pv.id" id="{{pv.id}}" ng-swipe-left="rigthPainel(pv.id)" ng-swipe-right="leftPainel(pv.id)"><div><div class="painel-info"><div class="header"><div id="painel_left" class="setas" title="{{\'ocorrencia_tooltip_anterior\' | translate}}" ng-class="{\'visivel\':(painelVirtualLength > 1) && $index > 0 && $index < painelVirtualLength}" ng-click="leftPainel(pv.id)"><span>&laquo;</span></div><div>{{\'ocorrencia_label_painel\' | translate}} {{$index+1}} / {{ getTotalPaineis(paineisVirtuais) }}</div><div id="painel_right" class="setas" title="{{\'ocorrencia_tooltip_proximo\' | translate}}" ng-class="{\'visivel\':(painelVirtualLength > 1) && $index < painelVirtualLength - 1}" ng-click="rigthPainel(pv.id)"><span>&raquo;</span></div></div><div class="painel-detalhes"><div class="status"><div class="icone-conexao"><i ng-class="{true: \'icon ion-radio-waves painel-conectado\', false: \'icon ion-radio-waves painel-desconectado\'}[pv.painel.conectado]"></i></div><div class="descricao"><span ng-style="{\'color\': !pv.painel.conectado ? \'gray\' : \'green\'}">{{pv.painel.conectado ? \'ocorrencia_informacao_painel_conectado\' : \'ocorrencia_informacao_painel_desconectado\' | translate}}</span></div></div><div class="descricoes"><div class="pf-descricao">{{pv.painel.descricao}}</div><div class="pf-modelo-fabricante">{{pv.painel.modelo_descricao}}</div><div class="pf-modelo-fabricante">{{pv.painel.fabricante_descricao}}</div><div class="keepalive" ng-show="pv.keep_alive != \'\' && pv.keep_alive != undefined"><strong>{{\'ocorrencia_label_ultimo_keep_alive\' | translate}}:</strong> {{pv.keep_alive}}</div></div></div></div><table class="setores-table" ng-show="pv.setores.length > 0"><caption>{{\'ocorrencia_label_setores\' | translate}} <span class="botao-legenda" title="{{\'ocorrencia_setores_legenda\' | translate}}" ng-click="abrirLegenda()"><i class="ion-help-circled"></i></span></caption><thead><tr><th scope="col">{{\'ocorrencia_label_setor\' | translate}}</th><th scope="col">{{\'ocorrencia_label_descricao\' | translate}}</th><th scope="col"></th><th scope="col">{{\'ocorrencia_label_inibir_setor\' | translate}}</th></tr></thead><tbody><tr class="lista-de-setores" ng-repeat="setor in pv.setores" ng-class="{\'inativo\': setor.tipo_hardware == 5 && !setor.ativo}"><td>{{setor.numero.toString().padStart(3, 0)}}</td><td>{{setor.descricao}}</td><td><div class="status-setor-camera-inativo" ng-show="setor.tipo_hardware == 5 && !setor.ativo">{{\'modulo_painel_setor_camera_inativo\'| translate}}</div><div class="setor-status-list" ng-hide="setor.tipo_hardware == 5 && !setor.ativo"><div class="setor-status-list-item setor-fechado" ng-if="!setor.aberto && setor.tipo_hardware != 5"><i title="{{\'ocorrencia_setor_fechado\'| translate}}" class="ion-ios-checkmark-empty"></i></div><div class="setor-status-list-item setor-aberto" ng-if="setor.aberto && setor.tipo_hardware != 5"><i title="{{\'ocorrencia_setor_aberto\'| translate}}" class="ion-ios-close-empty"></i></div><div class="setor-status-list-item setor-tamper" ng-if="setor.tamper"><span title="{{\'ocorrencia_setores_tamper\' | translate}}">T</span></div><div class="setor-status-list-item setor-falha-supervisao" ng-show="(pv.painel.modelo == 8 || pv.painel.modelo == 34) && !setor.online"><i title="{{\'ocorrencia_setores_falha_supervisao\'| translate}}" class="icon ion-android-alert"></i></div><div class="setor-status-list-item setor-curto" ng-if="setor.curto"><i title="{{\'ocorrencia_setores_curto\' | translate}}" class="icon ion-flash"></i></div><div class="setor-status-list-item sensor-generico" ng-show="setor.tipo_hardware == 1"><img title="{{\'ocorrencia_setores_outros\' | translate}}" src="assets/img/sensor-tipo-1.png"></div><div class="setor-status-list-item sensor-ivp" ng-show="setor.tipo_hardware == 2"><img title="{{\'ocorrencia_setores_ivp\' | translate}}" src="assets/img/sensor-tipo-2.png"></div><div class="setor-status-list-item sensor-magnetico" ng-show="setor.tipo_hardware == 3"><img title="{{\'ocorrencia_setores_magnetico\' | translate}}" src="assets/img/sensor-tipo-3.png"></div><div class="setor-status-list-item sensor-optico" ng-show="setor.tipo_hardware == 4"><img title="{{\'ocorrencia_setores_optico\' | translate}}" src="assets/img/sensor-tipo-4.png"></div><div class="setor-status-list-item sensor-camera" ng-show="setor.tipo_hardware == 5"><img title="{{\'ocorrencia_painel_legenda_sensor_camera\' | translate}}" src="assets/img/sensor-tipo-5.png"></div><div class="setor-status-list-item sensor-camera" ng-show="setor.tipo_hardware == 5 && setor.status_analitico == 2"><img title="{{\'ocorrencia_painel_legenda_sensor_camera_analitico_off\' | translate}}" src="assets/img/status_analitico_off.png"></div><div class="setor-status-list-item sensor-camera" ng-show="setor.tipo_hardware == 5 && setor.status_analitico == 1"><img title="{{\'ocorrencia_painel_legenda_sensor_camera_analitico_on\' | translate}}" src="assets/img/status_analitico_on.png"></div><div class="setor-status-list-item nivel-sinal" ng-show="(pv.painel.modelo == 8 || pv.painel.modelo == 34) && (setor.sinal == 0 || setor.sinal == 1 || setor.sinal == 2 || setor.sinal == 3 || setor.sinal == 4 || setor.sinal == 5)"><img title="{{\'ocorrencia_setores_sinal\' | translate}} {{setor.sinal}}" ng-src="assets/img/sinal-{{setor.sinal}}.png"></div><div class="setor-status-list-item setor-disparo" ng-if="setor.memoria && pv.armado"><i title="{{\'ocorrencia_setores_disparado\' | translate}}" class="icon ion-alert-circled"></i></div><div class="setor-status-list-item setor-memoria" ng-if="setor.memoria && !pv.armado"><i title="{{\'ocorrencia_setores_memoria\' | translate}}" class="icon ion-alert-circled"></i></div><div class="setor-status-list-item setor-inibido" ng-if="setor.inibido"><i title="{{\'ocorrencia_setores_inibido\' | translate}}" class="icon ion-eye-disabled"></i></div><div class="setor-status-list-item setor-bateria-fraca" ng-if="(pv.painel.modelo == 8 || pv.painel.modelo == 34) && setor.bateria_fraca"><i title="{{\'ocorrencia_setores_bateria_fraca\' | translate}}" class="icon ion-battery-empty"></i></div><div class="setor-status-list-item setor-bateria-carregada" ng-if="(pv.painel.modelo == 8 || pv.painel.modelo == 34) && !setor.bateria_fraca"><i title="{{\'ocorrencia_setores_bateria_carregada\' | translate}}" class="icon ion-battery-half"></i></div><div class="setor-status-list-item sensor-temperatura" ng-if="(pv.painel.modelo == 8 || pv.painel.modelo == 34) && setor.temperatura != \'\'"><i title="{{\'ocorrencia_setores_temperatura\' | translate}}" class="icon ion-thermometer"></i> <span>{{setor.temperatura.toString().substring(0, 2)}}</span></div><div class="setor-status-list-item setor-24h" ng-if="setor.setor_24_horas"><i title="{{\'ocorrencia_setores_setor_24\' | translate}}" class="icon ion-clock"></i></div><div class="setor-status-list-item setor-silencioso" ng-if="setor.silencioso"><i title="{{\'ocorrencia_setores_silencioso\' | translate}}" class="icon ion-volume-mute"></i></div><div class="setor-status-list-item setor-interno" ng-if="setor.stay"><i title="{{\'ocorrencia_setores_interno\' | translate}}" class="icon ion-home"></i></div><div class="setor-status-list-item setor-perimetro" ng-if="!setor.stay"><i title="{{\'ocorrencia_setores_perimetro\' | translate}}" class="icon ion-android-walk"></i></div><div class="setor-status-list-item sensor-com-fio" ng-if="setor.tipo == 1"><i title="{{\'ocorrencia_painel_legenda_sensor_com_fio\' | translate}}" class="icon ion-network"></i></div><div class="setor-status-list-item sensor-sem-fio" ng-if="setor.tipo == 2"><i title="{{\'ocorrencia_painel_legenda_sensor_sem_fio\' | translate}}" class="icon ion-android-wifi"></i></div></div></td><td><div class="inibir-setor" ng-show="permissao_enviar_comandos && pv.painel.comandos_disponiveis.arme_inibindo_setores" ng-hide="setor.tipo_hardware == 5 && !setor.ativo"><input id="ch{{setor.numero}}" class="chb_setor" ng-click="selecionarSetorParaInibir(setor)" type="checkbox" ng-model="setor.selected"></div></td></tr></tbody></table><div class="painel-comandos"><div class="header">{{\'ocorrencia_label_comandos\' | translate}}</div><div class="botoes" ng-if="permissao_enviar_comandos && pv.permissao_visualizar"><div class="botao-comando btnPainelDesconectado" ng-show="!pv.painel.conectado" ng-click="preparaAberturaModalComandoPainel(pv)"><div class="botao-comando-body"><div class="botao-comando-body-icone"><i class="icone ion-locked icones-ion desconectado"></i></div><div class="botao-comando-body-descricao-status"><span class="descricao">{{pv.descricao}}</span> <span class="status"><strong class="desconectado">{{\'ocorrencia_informacao_painel_desconectado\' | translate}}</strong></span></div></div></div><div class="botao-comando btnModalDisparado" ng-show="(pv.tipo_arme == 4 || pv.tipo_arme == 6 || pv.tipo_arme == 7 || pv.tipo_arme == 8) && pv.armado" ng-click="preparaAberturaModalComandoPainel(pv)"><div class="botao-comando-body"><div class="botao-comando-body-icone"><i class="icone ion-speakerphone blink"></i></div><div class="botao-comando-body-descricao-status"><span class="descricao">{{pv.descricao}}</span> <span class="status"><strong class="disparado">{{\'ocorrencia_setores_disparado\' | translate}}</strong></span></div></div></div><div class="botao-comando btnComandoParticao" ng-hide="(pv.tipo_arme == 4 || pv.tipo_arme == 6 || pv.tipo_arme == 7 || pv.tipo_arme == 8) && pv.armado || !pv.painel.conectado" ng-click="preparaAberturaModalComandoPainel(pv)"><div class="botao-comando-body"><div class="botao-comando-body-icone"><i class="icone" ng-class="{ \'ion ion-locked\': pv.armado, \'ion ion-unlocked\':!pv.armado, \'desconectado\':!pv.painel.conectado, \'armado\': (pv.armado && (pv.tipo_arme == 1 || pv.tipo_arme == 0)), \'armado-stay\':(pv.armado && pv.tipo_arme == 3), \'desarmado\':(!pv.armado && pv.painel.conectado) }"></i></div><div class="botao-comando-body-descricao-status"><span class="descricao">{{pv.descricao}}</span> <span class="status"><strong ng-class="{ \'desconectado\': !pv.painel.conectado, \'armado\':(pv.armado && (pv.tipo_arme == 1 || pv.tipo_arme == 0)), \'armado-stay\': (pv.armado && pv.tipo_arme == 3), \'desarmado\' : (!pv.armado && pv.painel.conectado) }">{{ executando ? \'executando\' : ((pv.armado && pv.tipo_arme != 3) && pv.painel.conectado) ? \'ocorrencia_informacao_particao_armada\' : ((pv.armado && pv.tipo_arme == 3) && pv.painel.conectado) ? \'ocorrencia_informacao_particao_armada_stay\' : (!pv.armado && !pv.painel.conectado) ? \'ocorrencia_informacao_status_desconhecido\' : (!pv.armado && pv.painel.conectado) ? \'ocorrencia_informacao_particao_desarmada\' : \'\' | translate}}</strong></span></div></div></div><div class="botao-comando btnAcionarSirene" ng-show="!pv.sirene_acionada && pv.painel.comandos_disponiveis.acionamento_sirene" type="button" ng-click="openModalTempoAcionamento(pv)"><div class="botao-comando-body"><div class="botao-comando-body-icone"><img src="assets/img/siren-gray.png"></div><div class="botao-comando-body-descricao-status"><span class="descricao">{{\'ocorrencia_label_sirene\' | translate}}</span> <span class="status"><strong class="desligado">{{\'ocorrencia_label_desligada\' | translate}}</strong></span></div></div></div><div class="botao-comando btnAbrirModalDesacionarSirene" ng-show="pv.sirene_acionada && pv.painel.comandos_disponiveis.acionamento_sirene" type="button" ng-click="openModalComandoSirene(pv)"><div class="botao-comando-body"><div class="botao-comando-body-icone"><img class="sirene_pulse" src="assets/img/siren-red.png"></div><div class="botao-comando-body-descricao-status"><span class="descricao">{{\'ocorrencia_label_sirene\' | translate}}</span> <span class="status"><strong class="ligado">{{\'ocorrencia_label_ligada\' | translate}}</strong></span></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/Providencias/providencias.html','<div style="padding: 10px;" ng-controller="ProvidenciasController"><div id="divProvidenciasGeral" class="table-responsive table-responsive-providencia"><table class="table table-striped"><tr class="thCabecalhoGrid"><th style="text-align: left; font-weight: bold">{{\'ocorrencia_label_tipo_evento\' | translate}}</th><th style="text-align: left; font-weight: bold">{{\'ocorrencia_label_providencia_como_agir\' | translate}}</th><th style="text-align: left; font-weight: bold">{{\'ocorrencias_label_ampliar\' | translate}}</th></tr><tr ng-repeat="item in providencias"><td class="textAlineLeft">{{item.tipo | translate}}</td><td class="textAlineLeft"><div class="overflow-tip bluebox descricao-providencia"><span><span>{{item.descricao}}</span></span></div></td><td class="textAlineRight"><a href="" class="msg" uib-dropdown-toggle="" ng-click="ampliaProvidencia(item.descricao, item.tipo)"><i class="fa_key fa-search"></i></a></td></tr></table></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/VeiculosProximos/veiculosProximos.html','<div class="col-md-12 tabset-group" ng-controller="VeiculosProximosController"><div style="height: 20px; margin-right: 5px;"><button ng-if="exibeVeiculosProximos" type="button" class="btn btn-default btnBlack ng-binding" style="float: right;" ng-click="alteraLayoutVeiculos(\'mapa\')">{{btnMapaLabel | translate}}</button></div><br><div ba-panel-class="feed-panel with-scroll" ng-if="listaVeiculos"><div style="text-align: center; padding: 20px" ng-if="!exibeVeiculosProximos">{{\'ocorrencia_label_nao_existe_veiculo_proximo\' | translate}}</div><div id="divVeiculosProximosGeral" class="div-veiculos-proximos"><table ng-if="exibeVeiculosProximos" class="table table-condensed tableVeiculos" ng-repeat="(key, item) in veiculosProximos" ng-style="{ \'background-color\' : (key % 2 == 0) ? \'rgba(33, 40, 46, 0.7);\' : \'rgb(38, 40, 44)\', \'padding\': \'2px\' }"><tbody><tr><td class="textAlineLeft" style="width: 32%;"><i class="fa fa-car" style="margin-right: 2px;" ng-show="item.tipo_veiculo != 7"></i> <i class="fa fa-user" style="margin-right: 2px;" ng-show="item.tipo_veiculo == 7"></i> <span style="color: rgb(222, 83, 65) !important; font-weight: bold">{{item.descricao}}</span></td><td></td><td class="textAlineLeft titulo">{{\'ocorrencias_label_identificador\' | translate}}:</td><td class="textAlineLeft">{{item.placa}}</td></tr><tr><td class="textAlineLeft titulo" ng-if="item.tipo_veiculo != 7">{{"ocorrencia_label_nome_motorista" | translate}}:</td><td class="textAlineLeft titulo" ng-if="item.tipo_veiculo == 7">{{"ocorrencia_label_usuario" | translate}}:</td><td class="textAlineLeft">{{item.nome_motorista}}</td><td class="textAlineLeft titulo">{{"ocorrencia_label_contato_motorista" | translate}}:</td><td class="textAlineLeft">{{item.contato_motorista == 0 ? \'ocorrencia_label_contato_nao_cadastrado\' : item.contato_motorista | translate}}</td></tr><tr ng-if="item.tipo_veiculo != 7"><td class="textAlineLeft titulo">{{"ocorrencia_label_status" | translate}}:</td><td class="textAlineLeft">{{item.status}}</td><td class="textAlineLeft titulo">{{"ocorrencia_label_velocidade" | translate}}:</td><td class="textAlineLeft">{{item.velocidade}} Km/h</td></tr><tr><td class="textAlineLeft titulo">{{\'ocorrencia_label_data_localizacao\' | translate}}:</td><td class="textAlineLeft">{{item.data_gps}}</td><td class="textAlineLeft titulo">{{\'ocorrencia_label_data_comunicacao\' | translate}}:</td><td class="textAlineLeft">{{item.data_enviado}}</td></tr><tr><td colspan="4" class="textAlineLeft"><span style="color: #999; font-weight: bold;">{{\'ocorrencia_label_endereco\' | translate}}:</span><div class="img-content" ng-show="!enderecoCarregado"><span us-spinner="{radius:10, width:6, length: 15}" spinner-on="!enderecoCarregado"></span></div><span style="font-weight: normal !important;" id="end_{{key}}">{{item.endereco}}</span></td></tr></tbody></table></div></div><div ng-show="mapaVeiculos" ng-include="\'app/pages/InformacoesOcorrencia/VeiculosProximos/veiculosProximosMapa.html\'"></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/VeiculosProximos/veiculosProximosMapa.html','<div id="veic-prox-map" ba-panel="" ba-panel-class="feed-panel" ng-class="!exibeAmpliarVeicProx ? \'map-veiculos-proximos\' : \'\'"><i ng-if="exibeAmpliarVeicProx" class="fas fa-expand-arrows-alt btn-expand-mapa-veic-prox" title="{{\'ocorrencia_label_expandir\' | translate}}" ng-click="mudaBotaoMapaVeicProx()"></i> <i ng-if="!exibeAmpliarVeicProx" class="fas fa-compress-arrows-alt btn-expand-mapa-veic-prox" title="{{\'ocorrencia_label_encolher\' | translate}}" ng-click="mudaBotaoMapaVeicProx()"></i><div class="col-lg-12 mapa_veiculos"><div id="veiculos-spin-loader" class="map-spin-loader" ng-show="mapaVeiculosIsLoader"><img src="assets/img/progress_bar.gif" alt="loader"></div><div class="col-lg-12"><div ba-panel="" class="" ng-class="exibeAmpliarVeicProx ? \'viewport100 veiculo_tittle\' :\'veiculo_tittle_full\'"><div id="leaflet-map-proximos" ng-class="exibeAmpliarVeicProx ? \'leaflet-map\' : \'leaflet-map-full-veic-prox\'"></div></div></div></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/VideosFrame/videosFrame.html','<div class="row" ng-show="cameraAtual" style="display: block"><div ng-show="!showLoading"><img class="dguard-iframe" ng-src="{{imgLive}}" ng-show="frameSet" style="padding: 15px;"><iframe class="dguard-iframe" ng-src="{{videoAtual}}" scrolling="no" ng-show="!frameSet"></iframe></div><span us-spinner="{radius:40, width:10, length: 20}" spinner-on="showLoading"></span><div class="col col-lg-12 col-md-12 btns_ao_vivo_gravacao" ng-show="false"><div class="col col-lg-offset-1 col-lg-4"><button class="btn btn-block" ng-class="{\'btn-danger\': frameSet, \'btn-default\': !frameSet}" ng-click="setFrameAovivo(true)">Frame</button></div><div ng-class="{\'col col-lg-offset-2 col-lg-2\': !frameSet , \'col col-lg-offset-2 col-lg-4\': frameSet}"><button class="btn btn-block" ng-class="{\'btn-danger\': !frameSet , \'btn-default\': frameSet}" ng-click="setFrameAovivo(false)" ng-show="cameraAtual.video_link!=\'\'">Live</button></div><div class="col col-lg-2"><button class="btn btn-block btn-default" ng-click="autorizarCamera()" ng-show="!frameSet">Autorizar Live</button></div></div></div><div class="col-lg-12 cameras-hls"><div class="col-lg-3 col-md-6 item-camera" ng-repeat="camera in cameras"><div class="kameleon-icon with-round-bg primary inline-icon" ng-click="setCamAtual(camera)"><div class="img-content" ng-show="camera.imagemCarregada"><img ng-src="{{camera.thumb || \'assets/img/fullarm/canBroker_FullArm.png\'}}" image-onload="imagemCarregada(camera)" image-fail-load="erroCarregarImagem(camera)"><p>{{camera.descricao | limitTo : 20}}{{camera.descricao.length > 20 ? \'...\' : \'\'}}</p></div><div class="img-content" ng-show="!camera.imagemCarregada"><span us-spinner="{radius:10, width:6, length: 15}" spinner-on="!camera.imagemCarregada"></span> <img ng-src="assets/img/fullarm/canBroker_FullArm.png"><p>{{camera.descricao | limitTo : 20}}{{camera.descricao.length > 20 ? \'...\' : \'\'}}</p></div></div></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/Fpatrol/fpatrol.html','<div class="col-md-12 tabset-group" ng-controller="FpatrolController"><div ng-if="exibeBotaoMapaFpatrol" style="height: 20px; margin-right: 5px;"><button type="button" class="btn btn-default btnBlack ng-binding" style="float: right;" ng-click="alteraLayoutFpatrol()">{{mostraMapaFpatrol ? \'ocorrencias_label_ver_na_lista\' : \'ocorrencias_label_ver_no_mapa\' | translate}}</button></div><div ba-panel="" ba-panel-class="feed-panel with-scroll" class="fpatrol-panel-superior" ng-if="!mostraMapaFpatrol"><div id="preloader-viaturas" class="div-veiculos-proximos" ng-if="$viaturasFinishedLoading"><span ng-show="mostrarMensagemLoading" class="span-preloader-viaturas">{{\'ocorrencia_label_cadastro_alterado\' | translate}}</span></div><div ng-if="!$viaturasFinishedLoading" id="divLoginsRonda" class="div-veiculos-proximos"><div style="text-align: center; padding: 20px" ng-if="!exibeViaturas">{{\'ocorrencia_label_nao_existe_viatura_vinculada\' | translate}}</div><div ng-if="exibeViaturas" ng-repeat="(key, item) in viaturas" class="div-viaturas"><div class="col-lg-12"><div class="col-lg-3"><i class="fa fa-car icon-fpatrol"></i> <span>{{item.descricao}} - {{item.placa}}</span></div><div class="col-lg-3"><i class="fa fa-user icon-fpatrol"></i> <span>{{item.login_descricao}}</span></div><div class="col-lg-3" style="text-align: left"><span>{{\'ocorrencia_label_status\' | translate}}:</span> <span ng-class="{\'green-icon\':item.status_ronda == 0 || item.status_ronda == 2, \'red-icon\':item.status_ronda == 1}">{{item.status_ronda == 1 ? \'ocorrencia_label_operador_ocupado\' : item.status_ronda == 2 ? \'ocorrencia_label_operador_solicitado\' : \'ocorrencia_label_operador_disponivel\' | translate}}</span></div><div class="col-lg-3" style="text-align: right"><button id="btnsolicitar_{{item.login_id}}" class="btn btn-default btnBlack ng-binding btns-solicitacao-patrulha" style="padding: 4px 4px !important;" ng-show="ocorrenciaAtual.status_ocorrencia != 6 || (ocorrenciaAtual.login_operador_externo_atual != item.login_id)" ng-disabled="!botao_solicitar_ronda || (ocorrenciaAtual.login_operador_externo_atual == item.login_id)" ng-click="preparaAlteracaoStatusParaRonda(item.login_id)" title="{{(ocorrenciaAtual.status_ocorrencia == 1 || ocorrenciaAtual.status_ocorrencia == 3) ? \'ocorrencia_tooltip_deve_estar_em_atendimento\' : \'\' | translate}}">{{\'ocorrencia_label_solicitar_patrulha\' | translate}}</button> <button id="btncancelar_{{item.login_id}}" class="btn btn-default btnBlack ng-binding btns-solicitacao-patrulha" style="padding: 4px 4px !important;" ng-disabled="!ocorrenciaAtual.atendendo" ng-show="ocorrenciaAtual.status_ocorrencia == 6 && (ocorrenciaAtual.login_operador_externo_atual == item.login_id)" ng-click="preparaRetirarSolicitacaoRonda(item.login_id)">{{\'ocorrencia_label_cancelar_patrulha\' | translate}}</button></div></div><div class="col-lg-12 div-mapa-status" ng-show="ocorrenciaAtual.login_operador_externo_atual == item.login_id"><span style="font-size: medium" ng-style="{\'color\': (ocorrenciaAtual.login_operador_externo_atual == item.login_id) && ocorrenciaAtual.status_ocorrencia >= 6 ? \'#41f341f2\' : \'#bbb\'}"><i class="fas fa-car" title="{{\'ocorrencia_status_aguardando_ronda\' | translate}}"></i></span> <span style="font-size: large" ng-style="{\'color\': (ocorrenciaAtual.login_operador_externo_atual == item.login_id) && ocorrenciaAtual.status_ocorrencia > 6 ? \'#41f341f2\' : \'#bbb\'}">--------------------</span> <span style="font-size: medium" ng-style="{\'color\': (ocorrenciaAtual.login_operador_externo_atual == item.login_id) && ocorrenciaAtual.status_ocorrencia >= 7 ? \'#41f341f2\' : \'#bbb\'}"><i class="fas fa-route" title="{{\'ocorrencia_status_roda_a_caminho\' | translate}}"></i></span> <span style="font-size: large" ng-style="{\'color\': (ocorrenciaAtual.login_operador_externo_atual == item.login_id) && ocorrenciaAtual.status_ocorrencia > 7 ? \'#41f341f2\' : \'#bbb\'}">--------------------</span> <span style="font-size: medium" ng-style="{\'color\': (ocorrenciaAtual.login_operador_externo_atual == item.login_id) && ocorrenciaAtual.status_ocorrencia >= 8 ? \'#41f341f2\' : \'#bbb\'}"><i class="fas fa-map-pin" title="{{\'ocorrencia_status_ronda_no_local\' | translate}}"></i></span> <span style="font-size: large" ng-style="{\'color\': (ocorrenciaAtual.login_operador_externo_atual == item.login_id) && ocorrenciaAtual.status_ocorrencia == 9 ? \'#41f341f2\' : \'#bbb\'}">--------------------</span> <span style="font-size: medium" ng-style="{\'color\': (ocorrenciaAtual.login_operador_externo_atual == item.login_id) && ocorrenciaAtual.status_ocorrencia == 9 ? \'#41f341f2\' : \'#bbb\'}"><i class="fas fa-check-square" title="{{\'ocorrencia_status_ronda_finalizada\' | translate}}"></i></span></div><br><div class="col-lg-12"><hr></div></div></div></div><div ng-if="mostraMapaFpatrol" ng-include="\'app/pages/InformacoesOcorrencia/Fpatrol/fpatrolMapa.html\'"></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/Fpatrol/fpatrolMapa.html','<div id="fpatrol-map" ba-panel="" ba-panel-class="feed-panel with-scroll"><i ng-if="exibeAmpliarFpatrol" class="fas fa-expand-arrows-alt btn-expand-mapa-veic-prox" title="{{\'ocorrencia_label_expandir\' | translate}}" ng-click="mudaBotaoAmpliar()"></i> <i ng-if="!exibeAmpliarFpatrol" class="fas fa-compress-arrows-alt btn-expand-mapa-veic-prox" title="{{\'ocorrencia_label_encolher\' | translate}}" ng-click="mudaBotaoAmpliar()"></i><div class="col-lg-12 mapa_veiculos"><div id="veiculos-spin-loader" class="map-spin-loader" ng-show="mapaIsLoader"><img src="assets/img/progress_bar.gif" alt="loader"></div><div class="col-lg-12"><div ba-panel="" class="viewport100" ng-class="exibeAmpliarFpatrol ? \'panel_map_fpatrol\' : \'panel_full_map_fpatrol\'"><div id="leaflet-map-fpatrol" ng-class="exibeAmpliarFpatrol ? \'map-fpatrol\' : \'map-full-fpatrol\'"></div></div></div></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/VideosGeneric/VideosGeneric.html','<div ba-panel-class="feed-panel with-scroll videos"><div class="preloader-content" ng-if="videosFinishedLoading"></div><div style="text-align: center; padding: 20px" ng-if="!exibeCameras && !videosFinishedLoading && ocorrenciaAtual.video_ativo">{{\'nenhum_registro_encontrado\' | translate}}</div><div ng-include="\'app/pages/InformacoesOcorrencia/VideosFrame/videosFrame.html\'" ng-if="tipoVideo == 1 && exibeCameras" ng-controller="VideosFrameController"></div><div ng-include="\'app/pages/InformacoesOcorrencia/VideosHls/videosHls.html\'" ng-if="tipoVideo == 2 && exibeCameras" ng-controller="VideosHlsController"></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/VideosHls/videosHls.html','<div class="row" ng-show="videoAtual" style="display: block"><div class="col-lg-12 col-md-12" style="padding:0px !important;"><div class="videogular-container"><videogular vg-theme="config.theme" vg-player-ready="playerReady($API)" vg-complete="onCompleteVideo()" vg-auto-play="config.autoPlay"><vg-media vg-src="config.sources" vg-hls=""></vg-media><vg-buffering></vg-buffering><vg-controls><vg-play-pause-button></vg-play-pause-button><vg-time-display ng-show="tipoReproducao == 2">{{ currentTime | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-scrub-bar ng-show="tipoReproducao == 2"><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display ng-show="tipoReproducao == 2">{{ timeLeft | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-fullscreen-button></vg-fullscreen-button></vg-controls></videogular></div><div ng-show="tipoReproducao == 2"><ion-slider id="slider" type="single" values="content" disable="false" on-change="changeSliderCallback" step="1"></ion-slider></div></div><div class="col col-lg-12 col-md-12 btns_ao_vivo_gravacao"><div class="col col-lg-offset-1 col-lg-4"><button class="btn btn-block" ng-class="{\'btn-danger\': tipoReproducao == 1 , \'btn-default\': tipoReproducao == 2}" ng-click="setTipoReproducao(1)">Ao vivo</button></div><div class="col col-lg-offset-2 col-lg-4"><button class="btn btn-block" ng-class="{\'btn-danger\': tipoReproducao == 2 , \'btn-default\': tipoReproducao == 1}" ng-click="setTipoReproducao(2)" ng-show="videoAtual.tem_gravacao">Grava\xE7\xF5es</button></div></div></div><div class="col-lg-12 cameras-hls"><div class="col-lg-3 col-md-6 item-camera" ng-repeat="video in videosHls"><div class="kameleon-icon with-round-bg primary inline-icon" ng-click="setHlsCamInfo(video)"><img ng-src="{{video.thumb || \'assets/img/fullarm/canBroker_FullArm.png\'}}" src="assets/img/theme/icon/kameleon/Shop.svg"><p>{{video.descricao | limitTo : 20}}{{camera.descricao.length > 20 ? \'...\' : \'\'}}</p></div></div></div>');
$templateCache.put('app/pages/InformacoesOcorrencia/Rastreados/rastreados.html','<div class="tab-rastreados-content" ba-panel-class="tabs-panel with-scroll" ng-controller="RastreadosController"><div class="mapa_veiculos"><div id="ratreados-spin-loader" class="map-spin-loader" ng-show="mapaRastreadosIsLoader"><img src="assets/img/progress_bar.gif" alt="loader"></div><div class="rastreado-selecionado" ng-if="mostrarRastreadoSelecionado"><span class="desc-rastreado-selecionado">{{descricaoVeiculoSelecionado}}</span><ul class="filtro-posicoes"><li ng-click="buscarLocalizacaoPorIntervaloDeHoras(veiculoAtual, 0)"><button type="button" ng-class="{\'btn btn-primary btn-with-icon btn-pos\': qtdHorasSelecionada == 0, \'btn btn-default btn-with-icon btn-pos\' : qtdHorasSelecionada != 0}">{{\'ultima_posicao\' | translate}}</button></li><li ng-click="buscarLocalizacaoPorIntervaloDeHoras(veiculoAtual, 1)"><button type="button" ng-class="{\'btn btn-primary btn-with-icon btn-pos\': qtdHorasSelecionada == 1, \'btn btn-default btn-with-icon btn-pos\' : qtdHorasSelecionada != 1}"><i class="ion-search"></i> {{\'ultima_1_hora\'|translate}}</button></li><li ng-click="buscarLocalizacaoPorIntervaloDeHoras(veiculoAtual, 2)"><button type="button" ng-class="{\'btn btn-primary btn-with-icon btn-pos\': qtdHorasSelecionada == 2, \'btn btn-default btn-with-icon btn-pos\' : qtdHorasSelecionada != 2}"><i class="ion-search"></i> {{\'ultimas_2_horas\'|translate}}</button></li><li ng-click="buscarLocalizacaoPorIntervaloDeHoras(veiculoAtual, 3)"><button type="button" ng-class="{\'btn btn-primary btn-with-icon btn-pos\': qtdHorasSelecionada == 3, \'btn btn-default btn-with-icon btn-pos\' : qtdHorasSelecionada != 3}"><i class="ion-search"></i> {{\'ultimas_3_horas\'|translate}}</button></li></ul></div><div id="leaflet-map" class="leaflet-rastreados"></div></div><div class="lista-de-rastreados"><div class="rastreados"><div class="rastreado" ng-click="ultimaPosicaoTodos()" ng-class="{\'selecionado\': todosVeiculosSelecionado}"><i class="all-rastreados fa fa-map-marker"></i> <span class="item-desc">{{\'ocorrencia_label_todos_rastreados\' | translate}}<p></p></span></div><div class="rastreado" ng-repeat="veiculo in rastreados" ng-click="carregarVeiculoEspecifico(veiculo)" ng-class="{\'selecionado\': veiculo.selecionado}"><img ng-src="{{getIconePorTipoRastreado(veiculo.tipo)}}" class="item-icone"> <span class="item-desc">{{veiculo.placa}}<p></p></span></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside style="display: none;" class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="layout-header" ng-controller="PageTopCtrl" ng-class="isCondHouse ? \'page-top ch\' : \'page-top\'"><div class="logo"><a href="{{url}}" target="_blank" class="al-logo clearfix"><span ng-if="isCondHouse"><img src="../../../../assets/img/condhouse/cond_house.svg"> <b class="logo-fullarm"></b></span> <span ng-if="!isCondHouse"><img src="../../../../assets/img/fullarm-icon-30x30.png"> <b class="logo-fullarm">FullCenter</b></span></a></div><div class="controles"><span id="buscaSistema" ng-if="permissao_evento_manual" class="search buscaSistema"><i class="fas fa-search" data-toggle="ng-spotlight"></i> <label id="searchInput" class="buscaSistema">{{\'ocorrencia_search_buscar_sistema\' | translate}} (CTRL+F)</label></span> <span ng-if="permissao_solicitar_os" id="btnOs" class="search solicitarOs"><i class="fa fa-wrench fa-rotate-270" data-toggle="solicitar-os"></i> <label class="buscaSistema">{{\'ocorrencia_botao_gerar_os\' | translate}} (CTRL+G)</label></span> <span class="pulse-effect" id="div-countdown"><i class="glyphicon glyphicon-wrench"></i> <span>{{\'ocorrencias_label_sistema_manutencao\' | translate}}</span> <span id="countdown" aria-hidden="true"></span></span></div><div class="user-info"><ul class="sistema-info"><li uib-dropdown="" id="li_chaves"><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-key"></i></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header-chaves"><strong class="colorWhite">{{\'ocorrencia_informacao_chave_no_local\' | translate}}</strong></div><div class="table-responsive"><table class="table table-chaves"><thead><th>{{"ocorrencias_modal_numero_chaveiro" | translate}}</th><th>{{"ocorrencia_label_anotacao_observacao" | translate}}</th></thead><tbody id="listChaves"></tbody></table></div></div></li><li uib-dropdown="" id="li_feriado"><a href="" uib-dropdown-toggle=""><i class="fa fa-calendar"></i></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong class="colorWhite">{{\'ocorrencia_informacao_label_feriado\' | translate}}</strong></div><a class="colorWhite">{{\'ocorrencia_informacao_feriado\' | translate}}</a> <a class="colorWhite" id="descricao_feriado"></a></div></li><li uib-dropdown="" id="nivel_risco_alto"><a href="" uib-dropdown-toggle=""><i class="fa fa-level-up"></i></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong class="colorWhite">{{\'ocorrencia_label_nivel_risco\' | translate}}</strong></div><a style="color: red">{{\'ocorrencia_informacao_nivel_risco_alto\' | translate}}</a></div></li><li uib-dropdown="" id="nivel_risco_medio"><a href="" uib-dropdown-toggle=""><i class="fa fa-arrows-h"></i></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong class="colorWhite">{{\'ocorrencia_label_nivel_risco\' | translate}}</strong></div><a style="color: yellow">{{\'ocorrencia_informacao_nivel_risco_medio\' | translate}}</a></div></li><li uib-dropdown="" id="nivel_risco_baixo"><a href="" uib-dropdown-toggle="" class="dropdown-toggle_"><i class="fa fa-level-down"></i></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong class="colorWhite">{{\'ocorrencia_label_nivel_risco\' | translate}}</strong></div><a style="color: green">{{\'ocorrencia_informacao_nivel_risco_baixo\' | translate}}</a></div></li></ul><span class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><div id="div_login"><img ng-src="https://s3.amazonaws.com/fullarm-static/user.png"></div><div class="displayNome" id="tt_desconectado">{{\'ocorrencia_tooltip_mqtt_desconectado\' | translate}}</div></a><ul class="" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a><i class="fas fa-user"></i> {{user | limitTo:30}}</a></li><li><a class="signout" href="{{url}}" target="_blank"><i class="fas fa-home"></i> {{plataforma}}</a></li><li ng-if="permissao_relatorios"><a id="relatorios" href="{{url}}/relatorios" target="_blank"><i class="fas fa-list"></i> {{\'relatorios\' | translate}}</a></li><li ng-click="abreModalTeclaTalho()"><a class="signout"><i class="fas fa-keyboard-o"></i> {{\'ocorrencia_label_teclas_atalho\' | translate}}</a></li><li ng-click="abreModalTrocaUsuario(\'troca\')"><a class="signout"><i class="fas fa-exchange-alt"></i> {{\'ocorrencia_label_trocar_usuario\' | translate}}</a></li><li ng-click="abreModalTrocaIdioma()"><a class="signout"><img style="width: 20px; height: 20px; margin-right: 5px; border-radius: 0" src="../../../../assets/img/{{idiomaAtual != undefined ? idiomaAtual : \'pt-BR\'}}_novo.png"> {{\'ocorrencia_label_idioma\' | translate}}</a></li><li ng-click="abreModalTrocaUsuario(\'sair\')"><a class="signout"><i class="fas fa-power-off"></i> {{\'ocorrencia_label_sair\' | translate}}</a></li></ul></div></div><br></span></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#333" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/slider/popupImagensDisparo.html','<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.0/css/bootstrap.min.css"><script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script><script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.0/js/bootstrap.min.js"></script><style>\n        .carousel-inner > .item > img,\n        .carousel-inner > .item > a > img {\n            width: 100%;\n            margin: auto;\n        }\n    </style></head><body><div class="containerImagens"><br><ul class="nav nav-tabs"><li class="nav-item"><a id="home-tab" data-toggle="tab" href="#tab-imagens"></a></li><li class="nav-item"><a id="profile-tab" data-toggle="tab" href="#videosTab"></a></li></ul><div class="tab-content"><div class="tab-pane" id="tab-imagens"><div id="sliderImagens" class="carousel slide" data-ride="carousel"><ol class="carousel-indicators" id="indicators"></ol><div class="carousel-inner" role="listbox" id="slider"></div><a class="left carousel-control" href="#sliderImagens" role="button" data-slide="prev"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span></a> <a class="right carousel-control" href="#sliderImagens" role="button" data-slide="next"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></a></div><div id="uma-imagem"></div></div><div class="tab-pane" id="videosTab"><div id="sliderVideos" class="carousel slide" data-ride="carousel"><ol class="carousel-indicators" id="indicatorsVideos"></ol><div class="carousel-inner" role="listbox" id="vSlider"></div><a class="left carousel-control" href="#sliderVideos" role="button" data-slide="prev"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span></a> <a class="right carousel-control" href="#sliderVideos" role="button" data-slide="next"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></a></div><div id="um-video"></div></div></div></div></body><style>\n\n    .carousel-control {\n        width: 5% !important;\n    }\n\n    @media screen and (min-width: 768px){\n        .carousel-indicators {\n            bottom: -40px !important;\n        }\n    }\n\n    .tab-content{\n        margin-top: 10px !important;\n    }\n    .containerImagens{\n        width: 80%;\n        padding-right: 15px;\n        padding-left: 15px;\n        margin-right: auto;\n        margin-left: auto;\n    }\n    body{\n        background-color: #4e4e55;\n    }\n    body::before {\n        content: \'\';\n        position: fixed ;\n        width: 100% ;\n        height: 100% ;\n        top: 0 ;\n        left: 0 ;\n        background: url("/assets/img/fundo.jpg") no-repeat center center !important;\n        opacity: 0.05;\n        background-size: cover !important;\n        will-change: transform;\n        z-index: -1\n    }\n    a{\n        color: white !important;\n    }\n    .nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover {\n        color: #555;\n        cursor: default;\n        background-color: #000;\n        border: 1px solid #ddd;\n        border-bottom-color: transparent;\n    }\n    .nav-tabs>li>a:hover {\n        border-color: #2d2d2d #2d2d2d #2d2d2d !important;\n    }\n\n    .nav>li>a:focus, .nav>li>a:hover {\n        text-decoration: none;\n        background-color: #2d2d2d !important;\n    }\n    #um-video, #vSlider{\n        text-align: center;\n    }\n</style><script>\n    function desabilitaF5(e) {\n        if ((e.which || e.keyCode) == 116 || (e.which || e.keyCode) == 123)\n            e.preventDefault();\n    }\n    setTimeout(function () {\n        if($(\'#home-tab\').is(\':visible\')){\n            $(\'.nav-tabs a[href="#tab-imagens"]\').tab(\'show\');\n        }else{\n            $(\'.nav-tabs a[href="#videosTab"]\').tab(\'show\');\n        }\n    },100);\n    $(document).on("keydown", desabilitaF5);\n    document.addEventListener(\'contextmenu\', event => event.preventDefault());\n</script></html>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');}]);